/* hd-draw.js —— 绘画板（Draw）引擎
   2026-09-20 从 sections/design-canvas.liquid **纯搬迁**（原 L3043~L4205，含 DRAW BOARD 头、
   pfmDraw 状态、pfmGradients、以及 1099 行绘制引擎）。零行为变化。

   为什么外置：section 有 256KB 硬限，外置前余量只剩 5734 B，无法再加功能。

   🔴 依赖注入：本文件是 defer 加载 ⇒ 在 DOMContentLoaded **之前**执行，而 section 的内联脚本
      更早执行 ⇒ section 已把依赖写进 window.__hdDrawDeps。缺依赖直接不启动（不静默半死）。
   🔴 出口：window.__hdDraw（section 段外的 10 处引用改走它）
   🔴 画布取值：`canvas` 在 section 里是主 IIFE 变量、DOMContentLoaded 时才创建
      ⇒ 一律走 CV()（每次取最新），**不要**在文件加载期缓存它的值。
      `currentPlacement` 同理 ⇒ _cp()。

   ============ 2026-09-20 第 1 批（绘制辅助 / 吸管 / 橡皮）============
   + Stabilizer 线条防抖（0-10 默认 3：指数平滑 + 收笔补偿）
   + Symmetry 对称绘制（off/v/h/quad）—— 由「一个工具」改为「辅助开关」，对所有笔刷生效
   + Picker 画板内吸管（Fill 分类）
   + Erase 独立分类；顺带修复两个既有哑控件：#pfmEraseSize（橡皮粗细）与 Mirror 三档（原引擎从不读 __pfmMirrorMode）。
   🔴 控件一律直接读 DOM（不再走 window.__pfmXxx）—— 避免再出现「只写不读」的哑控件。 */
(function () {
  'use strict';
  var D = window.__hdDrawDeps || {};
  if (typeof D.q !== 'function') {
    try { console.error('[hd-draw] missing dependency window.__hdDrawDeps — draw board not started'); } catch (e) { }
    return;
  }
  var q = D.q;
  var saveState = D.saveState || function () { };
  var updateLayers = D.updateLayers || function () { };
  var applyControlStyle = D.applyControlStyle || function () { };
  function CV() {
    try { return (D.canvas ? D.canvas() : null) || window.__pfmCanvas || null; } catch (e) { return null; }
  }
  function _cp() {
    try { return D.currentPlacement ? D.currentPlacement() : 'front'; } catch (e) { return 'front'; }
  }

// ============= DRAW BOARD =============
var pfmDraw={tool:'',color:'#000',isGradient:false,gradientIndex:0,brushSize:4,isDrawing:false,
  lastX:0,lastY:0,sx:null,sy:null,startX:0,startY:0,snapshot:null,undoStack:[],redoStack:[],maxUndo:50,
  gradStart:null,smudgePrev:null,   /* 2026-09-20 第 2 批：渐变拖拽起点 / 涂抹上一采样点 */
  /* 2026-09-20 第 2 批 b：选区 —— mask 与 canvas 同分辨率（Uint8Array），bbox 供快速扫描 */
  selMask:null,selBBox:null,selDrag:null,selFloat:null,selLass:null,selPhase:0,
  /* 2026-10-04（乙批·绘制裁剪到选区）：`selClipOn` = 本次落笔是否已压入 clip 状态（**必须与 restore 配对**）；
     `selClipCache` = 掩码→Path2D 缓存（掩码引用不变就复用）；`mixCopy`/`smCopy` = putImageData 系裁剪用的副本缓冲。 */
  selClipOn:false,selClipCache:null,mixCopy:null,smCopy:null,
  /* 2026-10-03（甲批）：选区增强 —— selOp 加/减(""/add/sub) · selBase 按下时的选区快照 ·
     selOval 椭圆选框 · selMovePix 拖内部=移内容(true)/只移边界(false) */
  selOp:"",selBase:null,selOval:false,selMovePix:true,
  /* 2026-09-21 第 4 批：选区变换 / 内部剪贴板。xfRot/xfSx/xfSy 只在拖手柄期间有效，
     落定后立刻归零 —— 因为变换已经烘焙进 mask 与像素，留着会重复应用。 */
  selXf:null,xfRot:0,xfSx:1,xfSy:1,selClip:null,
  /* 2026-09-17: 撤销栈存 PNG 快照（见 pushUndo 注释）；undoBytes/undoBudget 是字节预算，undoLock 防异步重入。
     2026-10-03（甲）：快照改为 {blob,url,bytes} 容器（toBlob 异步编码），不再存 dataURL 字符串。 */
  undoBytes:0,undoBudget:31457280,undoLock:false,
  sizeRaw:12,ds:1,  /* 2026-09-13 B: sizeRaw=滑杆语义值(1-50)，ds=画布像素/显示像素
                       🔴 2026-10-04（乙·用户裁决）：默认 **4 → 12**。4 CSS px 在屏上只有 4px
                          （比指针还小 ⇒ 预览圈看不见；也把「跟笔宽走」的一批效果压成亚像素）。
                          三处默认值必须同时改：本行 · `_applyDrawSize()` 的 `|| 12` 兜底 ·
                          预设保存处 `_drawNum('pfmDrawBrushSize', 12)`。
                          ⚠️ snippet 的 markup 里 `#pfmDrawBrushSize` 的 `value="12"` 也要同步。 */
  fontFamily:'Arial',sprayInterval:null,sprayStamp:null,sprayStampColor:'',
  airTimer:null,airLastX:0,airLastY:0,airPuffSeed:0,   /* 2026-10-02（丙②）：喷枪的「停留积墨」定时器与状态 */
  mixAllLayers:true,   /* 2026-10-02（甲）：mixer / smudge 采样**可见图层合成**（PS Sample All Layers 的等效）。
                          设为 false ⇒ 退回"只采样当前层"（= PS / Krita 的默认）。 */
  sprayGradStamps:null,sprayGradKey:'',rainHue:0,pxPrev:null,
  brushOpacity:1,lastT:0,curW:0,
  /* 2026-09-25（用户裁决 甲+乙，3 层）：画板图层状态。
     layers[i]={cv,ctx,name}；active=当前绘制层（默认 2=上色，最顶层）。
     vis[i]/op[i]=该层显示与不透明度（写 CSS，浏览器负责合成）。
     layerUrl[i]=该层"当前内容"的快照对象（2026-10-03 甲前为 dataURL）—— 撤销时用来判断**哪层真的变了**，
     只重载变了的那层（通常 1 层）⇒ 撤销延迟与单层时相当。 */
  layers:null,active:2,vis:[true,true,true],op:[1,1,1],layerUrl:['','',''],
  /* 2026-10-01（甲·浮动文字对象）：非 null = 有一个尚未烘焙的文字对象。
     {on,x,y,w,h,drag,scl}；x/y 是**画布内部坐标的左上角**（不是基线）。
     2026-10-01（甲·第二批）：样式/对齐/底色**不在这里存**（直读 DOM，见 _paintTextOn 上方注释），
     只有「底色色值」因为来自 <input type=color> 而存一份。 */
  text:null, textBgColor:'#FFFFFF'};
var pfmDrawCtx, pfmDrawCanvas;

// ============= 画板图层（底稿 / 描线 / 上色）=============
/* 为什么：画板原本是**单张像素画布**，所有笔画烧在一起 ⇒ 用户要的"只删某一层的东西"做不到。
   方案：`#pfmDrawCanvas` 当**最顶层（上色）**（id 不变 ⇒ 事件/坐标/覆盖层同步全照旧），
   另加两张绝对定位画布 `#pfmLayerBase`（底稿）/`#pfmLayerLine`（描线）压在下面。
     · 绘制 = 只把 `pfmDrawCtx` 指到当前层 ⇒ 引擎其余代码零改动；
     · 显示 = 三张画布由浏览器叠加合成（display 控显隐、opacity 控透明度）；
     · 落产品 / 导出 = flatDraw() 按可见性+不透明度合成后 toDataURL；
     · 参考底图 = 移到独立垫层 #pfmDrawRefBack（见 modal 里的说明）。
   🔴 `pfmDrawCanvas` **永远**指 #pfmDrawCanvas（顶层）：它是事件目标、几何基准、
      以及与覆盖层共享 transform 的源头。**只有 pfmDrawCtx 会换层**。 */
var PFM_LAYER_NAMES = ['Base', 'Line', 'Colour'];
var PFM_LAYER_IDS = ['pfmLayerBase', 'pfmLayerLine', 'pfmDrawCanvas'];
function layerCount(){ return (pfmDraw.layers && pfmDraw.layers.length) || 0; }
function isLayered(){ return layerCount() > 1; }
function initDrawLayers(){
  var arr = [], i, el;
  for(i=0;i<PFM_LAYER_IDS.length;i++){
    el = document.getElementById(PFM_LAYER_IDS[i]);
    if(!el){ arr = null; break; }
    arr.push({cv:el, ctx:el.getContext('2d'), name:PFM_LAYER_NAMES[i]});
  }
  if(!arr || !arr.length){          /* 退化：单层（markup 未上线 / 半部署安全网） */
    pfmDraw.layers = pfmDrawCanvas ? [{cv:pfmDrawCanvas, ctx:pfmDrawCanvas.getContext('2d'), name:PFM_LAYER_NAMES[2]}] : null;
    pfmDraw.active = 0;
  } else {
    pfmDraw.layers = arr;
    if(!(pfmDraw.active >= 0 && pfmDraw.active < arr.length)) pfmDraw.active = arr.length - 1;
  }
  pfmDrawCtx = pfmDraw.layers ? pfmDraw.layers[pfmDraw.active].ctx : pfmDrawCtx;
  layerUISync();
}
function setActiveLayer(i){
  var n = layerCount(); if(!n) return;
  if(!(i >= 0 && i < n) || i === pfmDraw.active) return;
  pfmDraw.active = i;
  pfmDrawCtx = pfmDraw.layers[i].ctx;
  /* 换层 ⇒ 旧快照属于上一层（形状拖动预览的回滚用 putImageData）⇒ 必须重建，否则回滚会写错层 */
  try { pfmDraw.snapshot = pfmDrawCtx.getImageData(0,0,pfmDrawCanvas.width,pfmDrawCanvas.height); } catch(e){}
  layerUISync();
}
/* 合成：按可见性 + 不透明度把各层画进一张离屏画布（落产品 / 导出 / 撤销预算都用它） */
function flatDraw(){
  var n = layerCount();
  if(!n || !isLayered()) return pfmDrawCanvas;
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height, i;
  var oc = flatDraw._c || (flatDraw._c = document.createElement('canvas'));
  if(oc.width !== W || oc.height !== H){ oc.width = W; oc.height = H; }
  var g = oc.getContext('2d');
  g.clearRect(0,0,W,H);
  for(i=0;i<n;i++){
    if(pfmDraw.vis[i] === false) continue;
    g.globalAlpha = (typeof pfmDraw.op[i] === 'number') ? pfmDraw.op[i] : 1;
    g.drawImage(pfmDraw.layers[i].cv, 0, 0, W, H);
  }
  g.globalAlpha = 1;
  return oc;
}
function outUrl(){
  /* 2026-10-01（甲）：落产品 / 导出 / 预览三条路都经过这里 ⇒ **唯一收口**。
     有未提交的浮动文字就先烘焙，否则浮着的字（DOM 层）不会进图。 */
  if(pfmDraw.text) textCommit();
  return isLayered() ? flatDraw().toDataURL('image/png') : pfmDrawCanvas.toDataURL('image/png');
}
function setLayerVisible(i,on){
  if(!pfmDraw.layers || !pfmDraw.layers[i]) return;
  pfmDraw.vis[i] = !!on;
  /* 🔴 2026-09-26（用户报「选中 Colour 点隐藏，整个绘画区都没了」）：
     用 `opacity` 而**不是** `display:none`。原因：`pfmDraw.layers[2].cv` **就是** `#pfmDrawCanvas` ——
     它同时是「定义 wrap 高度」「承载全部指针事件」「坐标换算基准」的那一个元素
     ⇒ display:none 会让整个绘画区塌掉（实测 wrap 550 → 0、盒子 808 → 258、事件全丢）。
     opacity 保留布局与可绘制性 ⇒ 隐藏层上仍能继续画（只是看不见），这正是"画在隐藏层上"的语义。
     棋盘格/边框已下移到独立垫层 `#pfmDrawChecker` ⇒ 隐藏任何层都不会抹掉画布外框。 */
  pfmDraw.layers[i].cv.style.opacity = on ? '' : '0';
  layerUISync();
  /* 2026-09-26（用户：**不需要提示**）：原先在"隐藏的正好是当前层"时弹一句 toast
     （`<层名> layer hidden — press the ring button to show it again`）—— 用户明确不要，已移除。
     隐藏状态本身已足够可读（◉ → ○、该芯片变半透明），不再额外打扰。 */
}
function layerUISync(){
  var box = document.getElementById('pfmDrawLayers');
  if(!box) return;
  var n = layerCount();
  box.style.display = isLayered() ? 'flex' : 'none';   /* 单层退化 ⇒ 整组隐藏 */
  var chips = box.querySelectorAll('.pfm-dopt-chip[data-layer]'), i;
  for(i=0;i<chips.length;i++){
    var idx = parseInt(chips[i].getAttribute('data-layer'),10);
    var on = (idx === pfmDraw.active);
    chips[i].classList.toggle('sel', on);
    chips[i].style.display = (idx < n) ? '' : 'none';
    var vis = pfmDraw.vis[idx] !== false;
    chips[i].style.opacity = vis ? '' : '.45';
    chips[i].title = (PFM_LAYER_NAMES[idx] || '') + (vis ? '' : ' (hidden)');
  }
  var eye = document.getElementById('pfmLayerEye');
  if(eye){
    var av = pfmDraw.vis[pfmDraw.active] !== false;
    eye.textContent = av ? '◉' : '○';
    eye.title = av ? 'Hide this layer' : 'Show this layer';
  }
}
function bindLayerUI(){
  var box = document.getElementById('pfmDrawLayers');
  if(!box || box.getAttribute('data-bound')) return;
  box.setAttribute('data-bound','1');
  box.addEventListener('click', function(e){
    var t = e.target; if(!t || !t.closest) return;
    if(t.closest('#pfmLayerEye')){ setLayerVisible(pfmDraw.active, pfmDraw.vis[pfmDraw.active] === false); return; }
    var c = t.closest('.pfm-dopt-chip[data-layer]');
    if(!c) return;
    setActiveLayer(parseInt(c.getAttribute('data-layer'),10));
  });
}
/* 撤销条目 = 「各层快照 + 当前层」。pushUndo **只重新编码当前层**，其余层直接复用上一条
   的引用（同一层内容没变 ⇒ 同一个快照对象）⇒ 内存与耗时与单层时几乎相同。
   🔴 2026-10-03（甲）：层值不再是 dataURL 字符串，而是 `{blob,url,bytes,ready}` 快照容器 ——
      抬笔的 PNG 编码从**同步**改为**异步**（见 `_mkSnap`）。裸 dataURL 字符串仍被兼容。 */
function _mkSnap(cv){
  /* 2026-10-03（甲）：抬笔不再同步跑 PNG 编码。实测（`_probe_toblob_snap.js`，线上 1200x1200）：
       · `toDataURL('image/png')` 同步返回 **6.2ms**（CPU 4x 节流下 ~17ms），整段卡在抬笔那一帧
       · `toBlob(cb,'image/png')` 同步返回 **0ms**，且**位图抓取是同步的**
         （红块 -> toBlob -> 立刻整屏涂蓝，回调里解出的中心仍是纯红 ⇒ 不会被后续笔画污染）
     ⇒ 改用 toBlob：抬笔只付出"抓位图"的代价，编码在浏览器内部异步完成后回来补账。 */
  var s = { blob:null, url:'', bytes:0, ready:false };
  if(cv.toBlob){
    try{
      cv.toBlob(function(bl){
        if(!bl) return;
        s.blob = bl; s.bytes = bl.size; s.ready = true;
        pfmDraw.undoBytes = (pfmDraw.undoBytes || 0) + bl.size;   /* 甲：pushUndo 时字节数还未知 ⇒ 回调补账 */
        _undoTrim();
      }, 'image/png');
      return s;
    }catch(e){ /* 落到同步兜底 */ }
  }
  s.url = cv.toDataURL('image/png'); s.bytes = s.url.length * 0.75; s.ready = true;
  return s;
}
function _snapBytes(e){ var x = e && e.u && e.u[e.a]; return (x && x.bytes) ? x.bytes : 0; }
function _undoTrim(){
  while(pfmDraw.undoStack.length > pfmDraw.maxUndo ||
        (pfmDraw.undoBytes > pfmDraw.undoBudget && pfmDraw.undoStack.length > 8)){
    var dropped = pfmDraw.undoStack.shift();
    pfmDraw.undoBytes -= _snapBytes(dropped);
  }
  if(pfmDraw.undoBytes < 0) pfmDraw.undoBytes = 0;
}
function snapEntry(){
  var n = layerCount(), i;
  var prev = pfmDraw.undoStack[pfmDraw.undoStack.length-1];
  var arr = (prev && prev.u) ? prev.u.slice() : [];
  for(i=0;i<n;i++) if(!arr[i]) arr[i] = '';
  var a = pfmDraw.active;
  arr[a] = _mkSnap(pfmDraw.layers[a].cv);
  pfmDraw.layerUrl[a] = arr[a];
  return {u:arr, a:a};
}
function initUndoStack(){
  var n = layerCount()||1, arr = [], i, bytes = 0;
  pfmDraw.layerUrl = ['','',''];
  for(i=0;i<n;i++){
    var s = _mkSnap(pfmDraw.layers[i].cv);
    arr.push(s);
    pfmDraw.layerUrl[i] = s;
    bytes += s.bytes || 0;                 /* toBlob 分支同步为 0，回调里补账 */
  }
  pfmDraw.undoStack = [{u:arr, a:pfmDraw.active}];
  pfmDraw.redoStack = [];
  pfmDraw.undoBytes = bytes;
}
/* 应用一个撤销条目：**只重载快照真的变了的层**（通常 1 层）⇒ 与单层时的延迟相当。
   2026-10-03（甲）：层值可为 快照对象 / 裸 dataURL 字符串 / 空。
   🔴 快照**未就绪**（toBlob 回调还没来，实测窗口 <60ms，真人不可能在这期间按撤销）⇒ 该层
      **保持现状**并跳过，绝不清空 —— 安全降级：撤销一步"没反应"，再按一次即到上一状态。 */
function applyEntry(entry, done){
  if(!entry){ if(done) done(); return; }
  var n = layerCount()||1, jobs = [], i;
  for(i=0;i<n;i++){
    var u = entry.u[i] || '';
    if(u && u === (pfmDraw.layerUrl[i]||'')) continue;   /* 未变 ⇒ 跳过（省一次解码） */
    jobs.push([i,u]);
  }
  if(entry.a >= 0 && entry.a < n) setActiveLayer(entry.a);
  if(!jobs.length){ if(done) done(); return; }
  var left = jobs.length;
  function one(){ if(--left <= 0) { if(done) done(); } }
  for(i=0;i<jobs.length;i++){
    (function(idx, src){
      var L = pfmDraw.layers[idx];
      var url = '', revoke = false;
      if(!src){ url = ''; }
      else if(typeof src === 'string'){ url = src; }
      else if(src.url){ url = src.url; }
      else if(src.blob){ url = URL.createObjectURL(src.blob); revoke = true; }
      else { one(); return; }               /* 未就绪 ⇒ 保持现状，绝不清空该层 */
      pfmDraw.layerUrl[idx] = src;
      if(!url){ L.ctx.clearRect(0,0,L.cv.width,L.cv.height); one(); return; }
      var im = new Image();
      im.onload = function(){
        try{ L.ctx.clearRect(0,0,L.cv.width,L.cv.height); L.ctx.drawImage(im,0,0,L.cv.width,L.cv.height); }catch(e){}
        if(revoke){ try{ URL.revokeObjectURL(url); }catch(e){} }
        one();
      };
      im.onerror = function(){ if(revoke){ try{ URL.revokeObjectURL(url); }catch(e){} } one(); };
      im.src = url;
    })(jobs[i][0], jobs[i][1]);
  }
}
/* 2026-09-25（用户裁决 甲）：键盘 Delete / Backspace = 删除当前选区内容。
   业界（PS / Procreate / CSP / Krita）都把这组键当标配，而画板此前 **完全没接键盘**
   ⇒ 用户框选完按 Delete 毫无反应，误判成"不能选择、不能单独删"。
   ⚠️ 只在画板打开、焦点不在输入框、且**确有选区**时拦截；没有选区就不动像素、不 preventDefault。 */
function drawKeyHandler(e){
  var mc = document.getElementById('pfmDrawModal');
  if(!mc || getComputedStyle(mc).display === 'none') return;
  var t = e.target;
  if(t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
  if(e.key !== 'Delete' && e.key !== 'Backspace') return;
  if(!selHas()) return;
  e.preventDefault();
  selDelete();
  refreshProductPreview();
}
document.addEventListener('keydown', drawKeyHandler);
var pfmGradients=[
  ['#7C3AED','#EC4899'],
  ['#3B82F6','#06B6D4'],
  ['#F97316','#FBBF24'],
  ['#EF4444','#8B5CF6'],
  ['#10B981','#14B8A6'],
  ['#EC4899','#F59E0B'],
  ['#1E40AF','#7C3AED'],
  ['#F472B6','#FB923C'],
  ['#374151','#CBD5E1'],
  ['#7C3AED','#22D3EE'],
  ['#0F172A','#3B82F6'],
  ['#A3E635','#22D3EE'],
  ['#F43F5E','#FB923C'],
  ['#6366F1','#EC4899'],
  ['#111827','#7C3AED'],
  ['#22D3EE','#6366F1'],
  ['#0F172A','#9CA3AF']
];

// ============= 自定义渐变（2026-09-03）=============
(function(){
  var btn=q('pfmGradCustom'), panel=q('pfmGradCustomPanel'), ga=q('gcA'), gb=q('gcB'), prev=q('gcPrev');
  if(!btn||!panel||!ga||!gb||!prev) return;
  function refreshPrev(){ prev.style.background='linear-gradient(135deg,'+ga.value+','+gb.value+')'; }
  ga.addEventListener('input',refreshPrev);
  gb.addEventListener('input',refreshPrev);
  refreshPrev();
  /* 2026-09-30（用户裁决 甲）：面板已改为**独立窗口**（fixed 居中 + 遮罩，挂在 #pfmDrawModal 下）
     ⇒ 除「再点一次自定义芯片」外，再给三路关闭：✕ / 点遮罩 / Esc。
     三路都**只关窗、不新增色块** —— 色块只由 Apply 创建（Apply 后会自动关窗，见下方）。 */
  function gclose(){ panel.style.display='none'; }
  btn.addEventListener('click',function(e){
    e.stopPropagation();
    panel.style.display = (panel.style.display==='none') ? 'flex' : 'none';
  });
  var gov=q('pfmGradCustomOv'), gx=q('pfmGradCustomClose');
  if(gov) gov.addEventListener('click',gclose);
  if(gx) gx.addEventListener('click',gclose);
  /* 🔴 必须用**捕获阶段**注册（同色轮 #pfmWheelModal 的理由）：画板自己的 Esc 监听在 document
     冒泡阶段且注册更早 ⇒ 只有 capture 拦得住，否则按一次 Esc 会把渐变窗和整个画板一起关掉。 */
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape' || panel.style.display==='none') return;
    gclose(); e.stopImmediatePropagation(); e.stopPropagation(); e.preventDefault();
  },true);
  q('gcApply').addEventListener('click',function(){
    var a=ga.value, b=gb.value;
    var idx=pfmGradients.length;
    pfmGradients.push([a,b]);
    var d=document.createElement('div');
    d.className='pfm-dcolor pfm-dgradient';
    d.title='Custom '+a+' → '+b;
    d.setAttribute('data-grad',idx);
    d.style.background='linear-gradient(135deg,'+a+','+b+')';
    d.addEventListener('click',function(){
      pfmDraw.isGradient=true;
      pfmDraw.gradientIndex=parseInt(this.getAttribute('data-grad'),10);
      document.querySelectorAll('.pfm-dcolor').forEach(function(e2){e2.classList.remove('sel')});
      this.classList.add('sel');
    });
    var row=btn.parentNode;
    row.insertBefore(d,btn);
    d.click();
    panel.style.display='none';
  });
})();

function initDrawBoard(){
  pfmDrawCanvas = q('pfmDrawCanvas');
  pfmDrawCtx = pfmDrawCanvas.getContext('2d');
  /* 2026-09-25：建立 3 层（底稿/描线/上色）并接线图层芯片。缺元素时自动退化为单层。 */
  initDrawLayers();
  bindLayerUI();
  // Fill transparent background
  /* 2026-09-13 B: 画板内部尺寸已与显示尺寸解耦（不再固定 600）→ 禁止硬编码尺寸。
     曾因清空按钮把尺寸写死成 600×600，画布放大到 1200 后只清左上角 1/4，
     表现为「点了清空仍有残留、重复绘制越积越多」。 */
  pfmDrawCtx.clearRect(0,0,pfmDrawCanvas.width,pfmDrawCanvas.height);
  pfmDrawCtx.lineCap='round';
  pfmDrawCtx.lineJoin='round';
  pfmDraw.snapshot = pfmDrawCtx.getImageData(0,0,pfmDrawCanvas.width,pfmDrawCanvas.height);
  initUndoStack();   /* 2026-09-25：3 层 ⇒ 初始条目 = 各层 dataURL + 当前层 */
  bindDrawEvents();
  _textBind();      /* 2026-10-01（甲）：浮动文字对象（✓✕ / 拖框 / 卡片控件委托 / Esc） */
  _gridRestore();   /* 2026-09-20 第 3 批：恢复上次的网格开关与参数 */
  // Sketchpad preview mode: shrink-animate the modal toward the canvas area top-right, then show a small buttons-only widget
  var pfmDrawCompact=false, pfmCompactTimer=null;
  function pfmCornerTarget(){
    var area=q('pfmCanvasArea');
    if(!area) return {x:16,y:16};
    var r=area.getBoundingClientRect();
    return {x:Math.max(0,r.right-16),y:Math.max(0,r.top+16)};
  }
  function setDrawCompact(on,instant){
    if(pfmCompactTimer){clearTimeout(pfmCompactTimer);pfmCompactTimer=null;}
    pfmDrawCompact=on;
    if(pfmDraw) pfmDraw.compact=on;
    var modal=q('pfmDrawModal'), box=q('pfmDrawBox'), widget=q('pfmDrawWidget');
    if(!box) return;
    var ov=modal?modal.querySelector('.pfm-modal-overlay'):null;
    var pb=q('pfmDrawPreviewBtn'); if(pb){pb.textContent=on?'↩ Restore':'👁 Preview';pb.title=on?'Restore full drawing':'Preview in corner';}
    if(instant){
      box.style.display=on?'none':'';
      box.classList.remove('pfm-mini','pfm-anim');
      box.style.position='';box.style.right='';box.style.top='';box.style.transformOrigin='';
      if(ov) ov.style.display=on?'none':'';
      if(modal) modal.style.pointerEvents=on?'none':'';
      if(widget) widget.style.display=on?'flex':'none';
      return;
    }
    if(on){
      // 1) shrink + fade toward canvas top-right, 2) hide modal, 3) show widget
      var t=pfmCornerTarget();
      box.classList.add('pfm-anim');
      box.style.position='fixed';
      box.style.right=(window.innerWidth-t.x)+'px';
      box.style.top=t.y+'px';
      box.style.transformOrigin='top right';
      box.getBoundingClientRect(); // force reflow so the transform animates
      box.classList.add('pfm-mini');
      pfmCompactTimer=setTimeout(function(){
        pfmCompactTimer=null;
        box.style.display='none';
        box.classList.remove('pfm-mini','pfm-anim');
        box.style.position='';box.style.right='';box.style.top='';box.style.transformOrigin='';
        if(ov) ov.style.display='none';
        if(modal) modal.style.pointerEvents='none';
        if(widget) widget.style.display='flex';
        refreshProductPreview();
      },320);
    } else {
      // 1) show modal, 2) animate from tiny top-right back to full, 3) hide widget
      clearProductPreview();
      var t2=pfmCornerTarget();
      box.style.display='';
      if(ov) ov.style.display='';
      if(modal) modal.style.pointerEvents='';
      box.classList.add('pfm-anim');
      box.style.position='fixed';
      box.style.right=(window.innerWidth-t2.x)+'px';
      box.style.top=t2.y+'px';
      box.style.transformOrigin='top right';
      box.classList.add('pfm-mini');
      box.getBoundingClientRect();
      box.classList.remove('pfm-mini');
      pfmCompactTimer=setTimeout(function(){
        pfmCompactTimer=null;
        box.style.position='';box.style.right='';box.style.top='';box.style.transformOrigin='';
        box.classList.remove('pfm-anim');
      },320);
      if(widget) widget.style.display='none';
    }
  }
  q('pfmDrawPreviewBtn').addEventListener('click',function(){setDrawCompact(!pfmDrawCompact)});
  q('pfmDrawWidgetRestore').addEventListener('click',function(){setDrawCompact(false)});
  q('pfmDrawWidgetApply').addEventListener('click',function(){
    if(q('pfmDrawApply'))q('pfmDrawApply').click();
    var w=q('pfmDrawWidget'); if(w) w.style.display='none';
    pfmDrawCompact=false; if(pfmDraw) pfmDraw.compact=false;
  });
  pfmDraw.setDrawCompact=setDrawCompact;
}

// Live preview helpers: show the current sketch as a non-editable layer on the product
function clearProductPreview(){
  if(!CV()) return;
  CV().getObjects().filter(function(o){return o.isPreview}).forEach(function(o){CV().remove(o)});
  CV().renderAll();
}
/* 2026-09-13 B: 落位公共原语 —— 把画板内容 fit 进当前打印区（居中 contain）。
   ⚠️ Apply 与 Preview **必须共用**：此前两条路径各写一份落位代码，第一版只改了 Preview，
      结果 ✔Apply 仍按画布 80% 放置（实测 2400×2400，溢出打印区 1010×1346）。
   打印区取自 window.__pfmPrintArea()（本作用域看不到 printAreaSpecs，见 L301 暴露说明）。 */
function pfmFitToPrintArea(img, cw, ch){
  var _pas = (window.__pfmPrintArea ? window.__pfmPrintArea() : null) || {};
  var _spec = _pas[_cp()] || _pas['front'] || Object.values(_pas)[0];
  var paX, paY, paW, paH;
  if(_spec && _spec.width > 0 && _spec.height > 0){ paX=_spec.left; paY=_spec.top; paW=_spec.width; paH=_spec.height; }
  else { paW=cw*0.8; paH=ch*0.8; paX=(cw-paW)/2; paY=(ch-paH)/2; }
  var s=Math.min(paW/img.width, paH/img.height);
  img.set({originX:'left',originY:'top',left:paX+(paW-img.width*s)/2,top:paY+(paH-img.height*s)/2,scaleX:s,scaleY:s});
  return s;
}

function placeDrawOnProduct(markPreview){
  if(!CV() || !pfmDrawCanvas) return;
  var dataUrl = outUrl();   /* 2026-09-25（3 层）：落产品必须是**合成图**（按可见性/不透明度合并），不是单张画布 */
  fabric.Image.fromURL(dataUrl, function(img){
    if(!CV()) return;
    var cw=CV().width, ch=CV().height;
    pfmFitToPrintArea(img, cw, ch);   /* 2026-09-13 B: 落位 fit 打印区 */
    img.isPreview=!!markPreview;
    applyControlStyle(img);
    if(markPreview){
      // Force the preview layer to be selectable with visible control points
      img.set({selectable:true,evented:true,hasControls:true,hasBorders:true});
      CV().add(img);
      CV().renderAll();
      CV().discardActiveObject();
      CV().setActiveObject(img);
      CV().renderAll();
      setTimeout(function(){
        if(CV() && CV().getObjects().indexOf(img)>-1){
          CV().discardActiveObject();
          CV().setActiveObject(img);
          CV().renderAll();
        }
      },60);
    } else {
      CV().add(img);
      CV().renderAll();
      saveState();updateLayers();
    }
  });
}
function refreshProductPreview(){
  if(!pfmDraw || !pfmDraw.compact) return;
  clearProductPreview();
  placeDrawOnProduct(true);
}

function bindDrawEvents(){
  var c = pfmDrawCanvas;
  // Record snapshot on empty canvas for easy undo comparison
  c.addEventListener('mousedown',drawMouseDown);
  c.addEventListener('mousemove',drawMouseMove);
  c.addEventListener('mouseup',drawMouseUp);
  c.addEventListener('mouseleave',drawMouseUp);
  c.addEventListener('touchstart',drawTouchStart,{passive:false});
  c.addEventListener('touchmove',drawTouchMove,{passive:false});
  c.addEventListener('touchend',drawTouchEnd);
  c.addEventListener('touchcancel',drawTouchEnd);
  // 2026-09-04: 画板缩放绑定 — 滚轮/捏合缩放
  /* 2026-10-05（用户实测 + 真机取证）：原先绑在 #pfmDrawCanvas —— 选区手柄 / 对称轴抓手 / 文字框等覆盖层
     都是 canvas 的**兄弟节点**（不是子节点），滚轮压在它们的 28px 热区上时事件冒泡路径**不经过 canvas**
     ⇒ pfmDrawWheel 不触发 ⇒ 缩放静默失效（真机实测：手柄中心 → 不缩放；画布中央 → 缩放到 1.12）。
     改绑**共同父容器** `.pfm-draw-canvas-wrap`（覆盖全部层）：任意落点都冒泡到它 ⇒ 一律能缩放。
     ✅ 零副作用：pfmDrawWheel 全程用 pfmDrawCanvas.getBoundingClientRect() + e.clientX/Y 换算，
        不读 e.target / e.currentTarget ⇒ 换监听目标不影响任何计算。 */
  var _hdWheelHost = (c.closest ? c.closest('.pfm-draw-canvas-wrap') : null) || c.parentNode || c;
  _hdWheelHost.addEventListener('wheel',pfmDrawWheel,{passive:false});
  /* 2026-09-26（用户改口：双击容易出错）⇒ 复位改为**按钮** `#pfmDrawZoomReset`（图标行，仅缩放中显示）。
     原来的 `dblclick` 复位绑定已移除 —— 画得快时容易误触。 */
  var _zrb=q('pfmDrawZoomReset');
  if(_zrb) _zrb.addEventListener('click',function(e){ e.preventDefault(); pfmDrawZoomReset(); });
  selXfBind();   /* 2026-09-21 第 4 批：选区变换手柄（幂等） */
  symDragBind();  /* 2026-09-21 第 5 批：对称轴拖拽手柄（幂等） */
  _symStateLoad();/* 2026-09-21 第 5 批：恢复上次的轴位置（localStorage） */
  // Modal open
  /* 2026-09-16: 原先这里绑的 q('pfmBtnOpenDraw') 在死面板 #panel-draw（永不 display，
     Draw tab 直接开弹窗）→ 用户决定删；元素消失后这行会 TypeError 中断本 IIFE，故同步删除。 */
  q('pfmDrawCancel').addEventListener('click',function(){if(pfmDraw.setDrawCompact)pfmDraw.setDrawCompact(false);hideDrawModal();});
  q('pfmCloseDraw').addEventListener('click',function(){if(pfmDraw.setDrawCompact)pfmDraw.setDrawCompact(false);hideDrawModal();});
  // Apply to product
  q('pfmDrawApply').addEventListener('click',function(){
    if(!CV()) return;
    // If a preview layer exists, convert it in place (keeps user-adjusted position/size)
    var prevs=CV().getObjects().filter(function(o){return o.isPreview});
    if(prevs.length){
      var p=prevs[0];
      CV().getObjects().forEach(function(o){if(o!==p&&o.isPreview)CV().remove(o)});
      p.set({isPreview:false});
      applyControlStyle(p);
      CV().setActiveObject(p);CV().renderAll();saveState();updateLayers();
      hideDrawModal();
      return;
    }
    clearProductPreview();
    var dataUrl = outUrl();   /* 2026-09-25（3 层）：落产品必须是**合成图**（按可见性/不透明度合并），不是单张画布 */
    fabric.Image.fromURL(dataUrl, function(img){
      var cw=CV().width, ch=CV().height;
      pfmFitToPrintArea(img, cw, ch);   /* 2026-09-13 B: 原为 80% 画布落位（溢出打印区被裁）→ 改与 Preview 共用原语 */
      applyControlStyle(img);
      CV().add(img); CV().setActiveObject(img); CV().renderAll(); saveState(); updateLayers();
      hideDrawModal();
    });
  });
  // Tool selection
  document.querySelectorAll('.pfm-dtool[data-tool]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var t = this.dataset.tool;
      /* 🔴 2026-10-04（用户裁决）：维护「上一个真实工具」—— 吸管取色后自动切回它（见 `_pickPrevTool`）。
         非 picker = 就是它；picker = **保留进入前那个**（不覆盖，否则切回来会被记成 picker）。 */
      if(t === 'picker'){ if(pfmDraw.tool && pfmDraw.tool !== 'picker') _pickPrevTool = pfmDraw.tool; }
      else { _pickPrevTool = t; }
      if(pfmDraw.text) textCommit();   /* 2026-10-01（甲）：换工具 = 提交浮动文字 */
      pfmDraw.tool = t;
      document.querySelectorAll('.pfm-dtool[data-tool]').forEach(function(b){b.classList.remove('sel')});
      this.classList.add('sel');
      /* Show/hide text options
         2026-09-30（用户裁决 甲）：文本选项已是**浮层卡片**（absolute + snippet 的 `_placeCard()`），
         ⇒ 显隐 + 定位统一交给 snippet —— 引擎拿不到 `_placeCard()`，跨 IIFE 走暴露的钩子，同 `__pfmShowOpts` 先例。
         钩子缺失时回退旧写法（半部署安全网：snippet 是内联脚本、比 defer 的引擎先执行，正常不会缺）。 */
      if(window.__pfmShowTextOpts) window.__pfmShowTextOpts(t==='text');
      else { var _tx=q('pfmDrawTextOptions'); if(_tx) _tx.style.display = (t==='text') ? 'flex' : 'none'; }
    });
  });
  // Color picker
  q('pfmDrawColorPicker').addEventListener('input',function(){
    pfmDraw.color = this.value;
    pfmDraw.isGradient = false;
    document.querySelectorAll('.pfm-dcolor').forEach(function(el){el.classList.remove('sel')});
    document.querySelectorAll('.solid-color').forEach(function(el){
      if(el.dataset.color===pfmDraw.color) el.classList.add('sel');
    });
  });
  // Solid color swatches
  document.querySelectorAll('.solid-color').forEach(function(el){
    el.addEventListener('click',function(){
      pfmDraw.color = this.dataset.color;
      pfmDraw.isGradient = false;
      q('pfmDrawColorPicker').value = pfmDraw.color;
      document.querySelectorAll('.pfm-dcolor').forEach(function(e){e.classList.remove('sel')});
      this.classList.add('sel');
    });
  });
  // Gradient swatches
  document.querySelectorAll('.pfm-dgradient').forEach(function(el,idx){
    el.addEventListener('click',function(){
      pfmDraw.isGradient = true;
      pfmDraw.gradientIndex = parseInt(this.dataset.grad);
      document.querySelectorAll('.pfm-dcolor').forEach(function(e){e.classList.remove('sel')});
      this.classList.add('sel');
    });
  });
  // Brush size
  q('pfmDrawBrushSize').addEventListener('input',function(){
    /* 2026-09-13 B: 滑杆语义不变（1–50，用户看到的粗细与改前一致），内部按 ds 换算成画布像素 */
    pfmDraw.sizeRaw = parseInt(this.value) || 1;
    pfmDraw.brushSize = pfmDraw.sizeRaw * (pfmDraw.ds || 1);
    q('pfmDrawBrushSizeVal').textContent = this.value;
  });
  // 2026-09-12: Brush opacity（绘板自用）
  var _boEl = q('pfmDrawBrushOpacity');
  if(_boEl){
    _boEl.addEventListener('input',function(){
      var v = parseInt(this.value,10); if(isNaN(v)) v = 100;
      v = Math.max(0,Math.min(100,v));
      pfmDraw.brushOpacity = v/100;
      var bv = q('pfmDrawBrushOpacityVal'); if(bv) bv.textContent = v+'%';
    });
  }
  // Undo
  q('pfmDrawUndo').addEventListener('click',function(){drawUndo();refreshProductPreview();});
  // Redo
  q('pfmDrawRedo').addEventListener('click',function(){drawRedo();refreshProductPreview();});
  // Clear
  /* 2026-09-13 B: 原硬编码 600（曾把画布尺寸写死 ⇒ 只清左上角 1/4、残留越积越多）。
     🔴 2026-09-26（用户裁决 A + 前一条「删除只删我选中的那一层」）—— 当前语义：
       · **点 🗑** = 清**当前绘制层** + **移除参考底图**（其余两层保留）
       · **长按 🗑 600ms** = 清**全部层** + 移除参考底图
     长短按用 600ms 计时区分，与「画笔预设长按删除」同一套既有惯例。两者都 pushUndo。
     ⚠️ 参考底图的移除**只能**由这里触发（底图是 snippet 的 CSS background，引擎 clearRect 碰不到它，
        也不在任何图层里 —— 它是 #pfmDrawRefBack 垫层、且不进导出）
        —— snippet 已把 dropRef 暴露为 `window.__pfmRefDrop`，且不再自己挂 🗑 的 click。
     ⚠️ 已知限制：撤销栈**不含底图** ⇒ 点 🗑 后按撤销，笔画会回来、底图不会（需重新导入）。 */
  var _clrEl = q('pfmDrawClear'), _clrTimer = 0, _clrLong = false;
  function clearActiveLayer(){
    var i = pfmDraw.active, n = layerCount() || 1;
    try{ pfmDraw.layers[i].ctx.clearRect(0,0,pfmDraw.layers[i].cv.width,pfmDraw.layers[i].cv.height); }catch(e){}
    /* 2026-09-26（用户裁决 A）：底图**不是图层**，clearRect 天然碰不到它
       ⇒ 必须显式带上，否则「导入的图片删不掉」。 */
    if(window.__pfmRefDrop){ try{ window.__pfmRefDrop(); }catch(e){} }
    pushUndo(); refreshProductPreview();
    if(n > 1) _pickTip('Cleared ' + (PFM_LAYER_NAMES[i] || '') + ' layer');
  }
  function clearAllLayers(){
    var n = layerCount() || 1, i;
    for(i=0;i<n;i++){
      try{ pfmDraw.layers[i].ctx.clearRect(0,0,pfmDraw.layers[i].cv.width,pfmDraw.layers[i].cv.height); }catch(e){}
    }
    if(window.__pfmRefDrop){ try{ window.__pfmRefDrop(); }catch(e){} }
    pushUndo(); refreshProductPreview();
    _pickTip('Cleared all ' + n + ' layers');
  }
  if(_clrEl){
    _clrEl.addEventListener('pointerdown', function(){
      _clrLong = false; clearTimeout(_clrTimer);
      _clrTimer = setTimeout(function(){ _clrLong = true; clearAllLayers(); }, 600);
    });
    _clrEl.addEventListener('pointerup', function(){ clearTimeout(_clrTimer); });
    _clrEl.addEventListener('pointerleave', function(){ clearTimeout(_clrTimer); });
    _clrEl.addEventListener('click', function(){
      clearTimeout(_clrTimer);
      if(_clrLong){ _clrLong = false; return; }   /* 长按已在计时器里处理过，别重复清一次当前层 */
      clearActiveLayer();
    });
  }
  /* 2026-10-02（甲·①）：原本这里的「Text stroke toggle」段**已删**（按钮 + `pfmDraw.textStroke` 一并移除）。
     理由：`◉` 用的是**和填充同一个颜色**描边 ⇒ 对文字就是「把字加粗」
     （实测墨迹：基线 12357 → 只开 ◉ 约 +55%，只开 `B` +48.6%，同量级 ⇒ 用户判定「两个加粗重复」）。
     ⚠️ 别再用 `pfmDrawTextStroke` 这个 id 去找那个按钮 —— snippet 里也删了，
        找回是 null，`addEventListener` 会**抛异常打断本函数**（后面所有绑定一起失效）。 */
  /* 2026-09-20 第 2 批 b：选区操作按钮 */
  /* 2026-09-20 第 3 批：网格开关 / 预设开关 / 保存按钮（均为「开关型」，不切工具） */
  /* 2026-09-26（用户裁决「打开一个按钮，另外的就收起」）：顶行这些「展开一行/一个面板」的
     按钮**互斥**（手风琴）。只收 UI 展开态 —— 行内档位值一律不动（对称仍 Off / 混合仍 Normal /
     稳定器仍原值）⇒ 对绘制行为零影响。
     🔴 刻意**不含 `#pfmDrawImport`**：它导入的参考底图是**用户内容**，若也算作可"收起"的一项，
        收起就得把图删掉（破坏性）。导入按钮只负责导入，不参与互斥。
     🔴 Colour 不是单纯 `.sel`：它还带着 `#pfmDrawColors.open` ⇒ 收起时必须一并收尾。
        ⚠️ Grid 的覆盖层 `#pfmDrawGridLayer.on` 是**功能态**（用户选定的网格线显示），**不参与**
           互斥收尾 —— 见 2026-10-06（丙）说明。 */
  function _exclusivePanels(keepId){
    /* 2026-09-27（甲）：颜色拆成两个入口 ⇒ 两个都进互斥表（算同一个「颜色位」）。 */
    /* 2026-10-03（丙-5）：+ `pfmDrawGuideBtn`（辅助线）—— 它是顶行**功能键**，与网格/对称/混合/
       稳定器/颜色同一个"面板位"，互斥组必须一起收尾，否则会同时开着两条选项行。 */
    var ids=['pfmDrawGrid','pfmDrawSymBtn','pfmDrawBlendBtn','pfmDrawStabBtn','pfmDrawColorBtn','pfmDrawGradBtn','pfmDrawGuideBtn'], i;
    for(i=0;i<ids.length;i++){
      var id=ids[i]; if(id===keepId) continue;
      var b=document.getElementById(id);
      if(!b || !b.classList.contains('sel')) continue;      /* 本来就没展开 ⇒ 跳过（不做无谓重算） */
      b.classList.remove('sel');
      /* 2026-10-06（用户裁决 丙）：Grid 的 `#pfmDrawGridLayer.on` 是**功能态**（网格线显示），
         不是"展开态" ⇒ 绝不在互斥收尾里移除它。原实现会静默关掉网格、但 `#pfmGridSnap` 芯片
         仍亮 ⇒ `_snapPt()` 第一道门失败 ⇒ 落笔完全不吸（实测：点颜色/对称/混合/稳定器/辅助线
         任一键后，落笔点距格点 14.67px = 零吸附）。网格显示/隐藏只由网格键自身控制。 */
      if(id==='pfmDrawColorBtn' || id==='pfmDrawGradBtn'){
        var cc=document.getElementById('pfmDrawColors'); if(cc) cc.classList.remove('open');
      }
    }
    if(window.__pfmShowOpts) window.__pfmShowOpts(pfmDraw.tool);
  }
  window.__pfmExclusivePanels = _exclusivePanels;

  /* ============================================================
     🔴🔴 2026-10-04（用户：「保存功能呢？」→ 裁决「甲」）：**草稿自动保存 + 自动恢复**
     病灶：`Apply to Product` 只把画作放进设计台画布（**还在内存**）⇒ 刷新 / 关标签页**全没**。
     方案（全在引擎里；`snippet` 只剩 241 字节余量，写不进去）：
       · 保存：落笔结束节流 1.5s + 每 20s 兜底 + 关页前抢救 → 各层 `cv.toDataURL()` → localStorage
       · 恢复：等 `pfmDraw.layers` 就绪后**只恢复一次**（无感，不弹窗）
       · 容量：localStorage ~5MB。三级降级 ①PNG → ②JPEG .72 → ③只存可见层 → ④放弃（console 留痕）
     ⚠️ 本文件里 `var W` = **画布宽度**（不是 window）⇒ 一律写 `window`。
     ============================================================ */
  var DRAFT_KEY='hdxDrawDraft.v1', DRAFT_MAX=4*1024*1024, DRAFT_ON='hdxDrawDraft.t';
  var _draftPending=false, _draftRestored=false, _draftBusy=false;

  /* 打包三层：lvl 0=PNG 1=JPEG 2=JPEG且只存可见层 */
  function _draftPack(lvl){
    var L=pfmDraw.layers; if(!L || !L.length) return null;
    var imgs=[], total=0;
    for(var i=0;i<L.length;i++){
      if(lvl>=2 && !pfmDraw.vis[i]){ imgs.push(''); continue; }
      var u = lvl===0 ? L[i].cv.toDataURL('image/png') : L[i].cv.toDataURL('image/jpeg',0.72);
      imgs.push(u); total+=u.length;
    }
    if(total>DRAFT_MAX) return (lvl>=2)? null : _draftPack(lvl+1);
    return { v:1, t:Date.now(), active:pfmDraw.active, vis:pfmDraw.vis.slice(), op:pfmDraw.op.slice(), imgs:imgs };
  }

  function _draftSaveNow(){
    if(!pfmDraw.layers || _draftBusy) return;
    var d=_draftPack(0);
    if(!d){ try{ console.warn('[hd] 草稿过大，本次跳过保存（不影响绘制）'); }catch(e){} return; }
    _draftBusy=true;
    try{ window.localStorage.setItem(DRAFT_KEY, JSON.stringify(d)); }   /* ⚠️ 这里**不可**置 _draftRestored：一保存就置位会让恢复逻辑永远跳过（本轮踩过） */
    catch(e){
      var d2=_draftPack(2);
      if(d2){ try{ window.localStorage.setItem(DRAFT_KEY, JSON.stringify(d2)); }catch(e2){
        try{ console.warn('[hd] 草稿保存失败（配额），可考虑清理其它站点数据'); }catch(e3){}
      } } else { try{ console.warn('[hd] 草稿过大，保存失败'); }catch(e4){} }
    }
    _draftBusy=false;
  }
  window.__pfmDraftSave=_draftSaveNow;

  /* 节流保存：1.5s 内多次落笔只存一次 */
  function _draftSave(){
    if(_draftPending) return;
    _draftPending=true;
    setTimeout(function(){ _draftPending=false; try{ _draftSaveNow(); }catch(e){} },1500);
  }
  window.__pfmDraftTouch=_draftSave;

  /* 恢复：只做一次；等 layers 就绪 */
  function _draftTryRestore(){
    if(_draftRestored) return;
    var L=pfmDraw.layers; if(!L || !L.length) return;
    var raw=null; try{ raw=window.localStorage.getItem(DRAFT_KEY); }catch(e){ return; }
    if(!raw){ _draftRestored=true; return; }
    var d=null; try{ d=JSON.parse(raw); }catch(e){ return; }
    if(!d || !d.imgs || !d.imgs.length){ _draftRestored=true; return; }
    _draftRestored=true;                      /* 先置位，避免并发重复恢复 */
    var n=Math.min(d.imgs.length,L.length), left=n, any=false;
    for(var i=0;i<n;i++){ (function(idx,url){
      if(!url){ if(--left<=0) _draftAfter(d,any); return; }
      var im=new Image();
      im.onload=function(){
        try{ var cv=L[idx].cv, ctx=L[idx].ctx;
             ctx.clearRect(0,0,cv.width,cv.height); ctx.drawImage(im,0,0,cv.width,cv.height); any=true; }catch(e){}
        if(--left<=0) _draftAfter(d,any);
      };
      im.onerror=function(){ if(--left<=0) _draftAfter(d,any); };
      im.src=url;
    })(i,d.imgs[i]); }
    if(!n) _draftAfter(d,false);
  }
  function _draftAfter(d,any){
    try{
      if(d.vis) for(var i=0;i<d.vis.length && i<pfmDraw.vis.length;i++) pfmDraw.vis[i]=d.vis[i];
      if(d.op)  for(var j=0;j<d.op.length  && j<pfmDraw.op.length; j++) pfmDraw.op[j]=d.op[j];
      if(typeof d.active==='number' && d.active<pfmDraw.layers.length) pfmDraw.active=d.active;
      if(typeof layerUISync==='function') layerUISync();
      if(typeof setActiveLayer==='function') try{ setActiveLayer(pfmDraw.active); }catch(e){}
    }catch(e){}
    if(any){ try{ console.info('[hd] 已恢复上次未完成的绘制草稿'); }catch(e){} }
  }

  /* 兜底定时器：① 恢复检测 ② 每 20s 保存 */
  var _draftTick=setInterval(function(){
    try{ _draftTryRestore(); }catch(e){}
    try{ if(pfmDraw.layers) _draftSaveNow(); }catch(e){}
  },20000);
  /* 弹窗出现后尽快尝试恢复一次（不等到 20s） */
  var _draftBoot=setInterval(function(){
    try{ _draftTryRestore(); }catch(e){}
    if(_draftRestored){ clearInterval(_draftBoot); }
  },800);
  /* 关页/切后台前抢救 */
  try{
    window.addEventListener('pagehide',function(){ try{ _draftSaveNow(); }catch(e){} });
    window.addEventListener('visibilitychange',function(){ if(document.hidden){ try{ _draftSaveNow(); }catch(e){} } });
  }catch(e){}
  /* 落笔结束即触发节流保存（drawMouseUp 是收口；用事件捕获避免改原函数） */
  try{
    var _dc=document.getElementById('pfmDrawCanvas');
    var _bindDraft=function(){
      var c=document.getElementById('pfmDrawCanvas'); if(!c || c.__draftBound) return;
      c.__draftBound=true;
      c.addEventListener('mouseup',function(){ try{ _draftSave(); }catch(e){} });
      c.addEventListener('pointerup',function(){ try{ _draftSave(); }catch(e){} });
    };
    _bindDraft();
    var _bt=setInterval(function(){ _bindDraft(); if(document.getElementById('pfmDrawCanvas')) clearInterval(_bt); },900);
  }catch(e){}

  /* ============================================================
     🔴🔴 2026-10-04（用户：「功能性按钮，选中后，图标常量。比如网格，开了和关，按钮不一样」）
     —— 顶行功能键「按**功能实际状态**点亮」，新增独立的 `.on` 类（与"展开态 .sel"解耦）。
     · 病灶：网格的 `.sel` = 「网格开着」✅，但对称/混合/稳定器/辅助线的 `.sel` = 「那一行展开了」❌
       ⇒ 用户选了 H 档 / 非 Normal 模式后，键**仍然是灭的**；一收卡反而更灭。
     · 语义：`.on` = 「这个功能当前开着（非默认档）」，`.sel` 保持原义（行是否展开）不变。
     · 各键判据（读的都是既有的状态真源，不新造）：
         网格  #pfmDrawGridLayer 带 .on        （引擎自己的真源）
         对称  __pfmSymMode ≠ 'off'
         混合  chip[data-blend].sel 的值 ≠ 'normal'
         稳定器 #pfmDrawStabVal 数值 > 0
         辅助线 chip[data-assist].sel 的值 ≠ 'off'
     · 本函数**幂等**，可任意次调用。UI 侧零改动 —— 靠下面的 observer 自动跟随。
     ============================================================ */
  function _syncFuncKeys(){
    var set=function(id,on){ var e=document.getElementById(id); if(e){ if(on) e.classList.add('on'); else e.classList.remove('on'); } };
    var gl=document.getElementById('pfmDrawGridLayer');
    set('pfmDrawGrid', !!(gl && gl.classList.contains('on')));
    var sym=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-sym].sel');
    var sv=sym?sym.getAttribute('data-sym'):(window.__pfmSymMode||'off');
    set('pfmDrawSymBtn', !!(sv && sv!=='off'));
    var bl=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-blend].sel');
    var bv=bl?bl.getAttribute('data-blend'):(window.__pfmBlend||'normal');
    set('pfmDrawBlendBtn', !!(bv && bv!=='normal'));
    var sn=document.getElementById('pfmDrawStabVal');
    set('pfmDrawStabBtn', !!(sn && (parseInt(sn.textContent,10)||0) > 0));
    var as=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-assist].sel');
    var av=as?as.getAttribute('data-assist'):'off';
    set('pfmDrawGuideBtn', !!(av && av!=='off'));
  }
  window.__pfmSyncFuncKeys = _syncFuncKeys;

  /* 自动跟随：监听"参数卡内的 .sel 变化" + "网格覆盖层的 .on 变化"。
     ⚠️ 用 observer 而不是在每个赋值点插桩 —— 因为 snippet 只剩 241 字节（256KB 上限），
        在那里加调用会超限；observer 让 UI 侧**零改动**。 */
  function _bindFuncKeyObserver(){
    var opts=document.getElementById('pfmDrawOpts');
    var tryBind=function(){
      if(tryBind.done) return; tryBind.done=true;
      _syncFuncKeys();
      try{
        var mo=new MutationObserver(function(){ _syncFuncKeys(); });
        /* 参数卡内的 chip 选中态 */
        if(opts) mo.observe(opts,{attributes:true,subtree:true,attributeFilter:['class','style']});
        /* 网格覆盖层 + 稳定器数值 */
        ['pfmDrawGridLayer','pfmDrawStabVal'].forEach(function(id){
          var e=document.getElementById(id);
          if(e) mo.observe(e,{attributes:true,subtree:true,characterData:true,childList:true,attributeFilter:['class']});
        });
      }catch(e){}
    };
    if(document.getElementById('pfmDrawOpts')) tryBind();
    else {
      /* 弹窗还没建 ⇒ 等 DOM 出现再绑（最多试 40 次 × 250ms） */
      var n=0, t=setInterval(function(){ n++; if(document.getElementById('pfmDrawOpts')){ clearInterval(t); tryBind(); } else if(n>40) clearInterval(t); },250);
    }
  }
  _bindFuncKeyObserver();
  var _gb=q('pfmDrawGrid');
  if(_gb) _gb.addEventListener('click',function(){
    _exclusivePanels('pfmDrawGrid');                       /* 2026-09-26：先收其余同类，再 toggle 自己 */
    var el=document.getElementById('pfmDrawGridLayer');
    var on=!(el && el.classList.contains('on'));
    if(el) el.classList.toggle('on', on);
    this.classList.toggle('sel', on);
    _gridSync(); _gridStateSave();
    if(window.__pfmShowOpts) window.__pfmShowOpts(pfmDraw.tool);
  });
  /* 2026-09-26（用户裁决「甲」）：预设行已从选项区**搬到画板底栏**常驻显示（图层芯片 ⇢ 动作区 之间），
     所以「立方体按钮展开预设行」与「+ Save 按钮」都不再存在 —— 改为打开画板时渲染一次
     （见 showDrawModal 里的 presetsRender()），保存则走色块行尾那个「+」。 */
  var _sf=q('pfmSelFill'), _sd=q('pfmSelDup'), _sx=q('pfmSelDel'), _sn=q('pfmSelNone');
  /* ===== 2026-10-03（甲批）：选区增强的 UI 接线（加/减 · 椭圆 · 只移边界 · 边缘档位 + 5 个变形操作） =====
     🔴 全部"由状态派生高亮"（.sel 类），不自己维护第二份状态；不可用一律置灰（无提示通道）。 */
  var _soA=q('pfmSelAdd'), _soS=q('pfmSelSub'), _soV=q('pfmSelOval'), _soM=q('pfmSelMovePix');
  function _selOpSync(){
    if(_soA) _soA.classList.toggle('sel', pfmDraw.selOp==='add');
    if(_soS) _soS.classList.toggle('sel', pfmDraw.selOp==='sub');
    if(_soV) _soV.classList.toggle('sel', !!pfmDraw.selOval);
    if(_soM){ _soM.classList.toggle('sel', !!pfmDraw.selMovePix); _soM.textContent = pfmDraw.selMovePix ? 'Pixels' : 'Box'; }
  }
  if(_soA) _soA.addEventListener('click',function(){ pfmDraw.selOp = (pfmDraw.selOp==='add')?'':'add'; _selOpSync(); });
  if(_soS) _soS.addEventListener('click',function(){ pfmDraw.selOp = (pfmDraw.selOp==='sub')?'':'sub'; _selOpSync(); });
  if(_soV) _soV.addEventListener('click',function(){ pfmDraw.selOval=!pfmDraw.selOval; _selOpSync(); });
  if(_soM) _soM.addEventListener('click',function(){ pfmDraw.selMovePix=!pfmDraw.selMovePix; _selOpSync(); });
  _selOpSync();
  var _seR=q('pfmSelEdge');
  function _selEdgeN(){ return Math.max(1, Math.min(40, _drawNum('pfmSelEdge', 4))); }
  if(_seR) _seR.addEventListener('input',function(){ var l=q('pfmSelEdgeVal'); if(l) l.textContent=_selEdgeN(); });
  ['pfmSelGrow:grow','pfmSelShrink:shrink','pfmSelBorder:border','pfmSelSmooth:smooth'].forEach(function(pair){
    var kv=pair.split(':'), el=q(kv[0]);
    if(el) el.addEventListener('click',function(){ selMorph(kv[1], _selEdgeN()); refreshProductPreview(); });
  });
  var _ssi=q('pfmSelSimilar');
  if(_ssi) _ssi.addEventListener('click',function(){ selSimilar(); refreshProductPreview(); });
  if(_sf) _sf.addEventListener('click',function(){ selFill(); refreshProductPreview(); });
  if(_sd) _sd.addEventListener('click',function(){ selDuplicate(); refreshProductPreview(); });
  if(_sx) _sx.addEventListener('click',function(){ selDelete(); refreshProductPreview(); });
  if(_sn) _sn.addEventListener('click',function(){ selClear(); });
  /* 2026-09-21 第 4 批：全选 / 反选 / 剪切 / 粘贴 / 导出 */
  var _sa=q('pfmSelAll'), _si=q('pfmSelInvert'), _sc=q('pfmSelCut'), _sp=q('pfmSelPaste'), _se=q('pfmDrawExport');
  if(_sa) _sa.addEventListener('click',function(){ selAll(); });
  if(_si) _si.addEventListener('click',function(){ selInvert(); });
  if(_sc) _sc.addEventListener('click',function(){ selCutClip(); });
  if(_sp) _sp.addEventListener('click',function(){ selPasteClip(); });
  /* 2026-09-26（甲）：导出改为**先确认**（原来直接 selExportPng()）。 */
  if(_se) _se.addEventListener('click',function(){ _exportConfirmOpen(); });
  _bindExportConfirm();
  var _fr=q('pfmDrawFeather'), _fv=q('pfmDrawFeatherVal');
  if(_fr) _fr.addEventListener('input',function(){
    if(_fv) _fv.textContent=this.value;
    if(_featCache) _featCache.key='';            /* 半径变了 ⇒ 距离场必须重算 */
    if(selHas()) selRedraw();     /* 重绘蚂蚁线（羽化不动 mask，但顺手保持状态一致） */
  });
  q('pfmDrawFontFamily').addEventListener('change',function(){
    pfmDraw.fontFamily = this.value;
    hdFontLoad(this.value);   /* 2026-09-12: 预热（落字前会再校验一次，未就绪则不落） */
  });
}

/* 2026-09-13: 画板字体下拉 12 款 → 全量（与主设计台同源 window.__hdFontGroups）。
   字体库 asset 是 defer，可能晚于首次开板；用 data-hd-full 幂等，每次开板补一次。
   字体库未就绪时**原样保留内置 12 款**（不破坏原行为）。
   落字本身的字体就绪守卫 + 选择时预热已存在，此处只负责"给得出选项"。 */
function hdDrawFontsFill(){
  var sel=q('pfmDrawFontFamily'); if(!sel) return;
  if(sel.getAttribute('data-hd-full')==='1') return;
  var groups=window.__hdFontGroups;
  if(!groups||!groups.length) return;
  var keep=sel.value;
  var _seen={};   /* 2026-10-01：去重（★Popular 与 Sans/Display 等组有重叠 ⇒ 此前同一字体重复出现） */
  sel.innerHTML='';
  for(var i=0;i<groups.length;i++){
    var g=groups[i]; if(!g||!g.f||!g.f.length) continue;
    var og=document.createElement('optgroup'); og.label=g.g;
    var _added=0;
    for(var j=0;j<g.f.length;j++){
      var _nm=g.f[j], _k=String(_nm).toLowerCase();
      if(_seen[_k]) continue;
      _seen[_k]=1; _added++;
      var o=document.createElement('option');
      o.value="'"+_nm+"'";          /* 带单引号：含空格族名不带引号会被 ctx.font 拆成两个族 */
      o.textContent=_nm;
      og.appendChild(o);
    }
    if(_added) sel.appendChild(og);    /* 去重后若该组已全被前面的组占掉 ⇒ 不挂空 optgroup */
  }
  sel.setAttribute('data-hd-full','1');
  if(keep) sel.value=hdFontVal(keep);
  if(sel.value) pfmDraw.fontFamily=sel.value;
}

/* ===== 2026-09-22：画布**显示尺寸**重算（供颜色区收起/展开复用） =====
   🔴 为什么单抽：手机端「Colour」tab 展开/收起颜色区会改变画布上方区块高度
      （实测颜色区占 138px，是上方最大的一块），画布尺寸必须跟着重算，否则溢出。
   🔴🔴 **绝不碰 `pfmDrawCanvas.width/height`** —— 设 canvas.width 会**清空画布内容**、
      并毁掉撤销栈。内部尺寸恒 HW=1200，显示尺寸只靠 style 缩放 ⇒ **只改 style 即安全**。
   （`showDrawModal()` 自己会 clearRect + 重建 undoStack，所以**不能复用它**来重算尺寸。） */
/* 2026-09-26（结构性修正）：实测「画布以外的弹窗内容」占多高，取代原来猜的常量 300。
   🔴 为什么必须实测 —— 同一类错误 09-25 犯过一次、09-26 又复发：
      09-25 把上限写成 `视口高 − 300`（依据当时 chrome 实测 242 估的 300）。但实测各档
      「画布上方 chrome」= 333(桌面) / 223~309(窄屏)，而且**盒子下面还有底栏 36~91px**，
      两者相加早就超过 300 ⇒ 需要的高度 ≡ 上限 + 69px ⇒ 桌面恒定溢出：
        · 画布底部被盒子裁掉 33px ⇒ **看得见的画布比"能画的"少**（用户报「显示与实际不一致」）；
        · 底栏（Cancel/Preview/Apply + 图层芯片）整条被推到视口外，elementFromPoint 命不中。
      ⇒ 教训：**上限不能是猜的数字，必须由结构算出来**（布局一变自动跟上）。
   ⚠️ 结果按窗口尺寸做缓存键 ⇒ 同窗口内切工具/选项行显隐不会让画布跳动（保留 09-25 用户裁决的
      「用的时候固定大小」），只有窗口尺寸真的变了才重算。 */
function _drawBudgetH(){
  /* 2026-09-26（用户裁决 甲）：预算按「视口尺寸」缓存 —— 换工具 / 选项行显隐都不重算
     （保留用户裁决的「用的时候固定大小」）。
     ⚠️ 2026-09-28 起：参考图（缩略图条 + 控制行）**整块住进浮层卡片 `#pfmDrawRefCard`**
        （含空态：控制行常驻、只灰掉）⇒ 它是 `position:absolute`，被下面的循环跳过 ⇒
        **画布高度零代价、也不进缓存键**。（09-27 的「宽度让位」已删，勿再加回。） */
  var key = (window.innerWidth || 0) + 'x' + (window.innerHeight || 0);
  if(pfmDraw._budgetKey === key && pfmDraw._budgetH) return pfmDraw._budgetH;
  var box = q('pfmDrawBox');
  if(!box) return 300;
  var cv = pfmDrawCanvas, wrapEl = cv && cv.parentElement;
  var host = null, i, kids = box.children;
  for(i=0;i<kids.length;i++){ if(cv && kids[i].contains(cv)){ host = kids[i]; break; } }
  if(!host) host = box;
  var sum = 0, hs = host.children, flow = 0;
  for(i=0;i<hs.length;i++){
    var el = hs[i];
    var cs = getComputedStyle(el);
    if(cs.display === 'none') continue;
    if(cs.position === 'absolute' || cs.position === 'fixed') continue;  /* 脱流元素不占行 */
    flow++;                          /* 计行数 —— **含**画布那条分支（下面的 gap 需要它参与） */
    if(el === wrapEl || (cv && el.contains(cv))) continue;   /* 画布分支高度由 size 决定，不进 sum */
    sum += el.getBoundingClientRect().height
         + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
  }
  var g = getComputedStyle(host);
  /* 🔴 2026-09-26 关键修正：**补上 flex/grid 的 gap**。
     `.pfm-draw-container{display:flex;flex-direction:column;gap:10px}` ——
     原实现只累加子元素高度，5 条分支之间的 4 个 gap **完全没算** ⇒ 固定少算 40px
     （实测：桌面 maxH 1080 / 画布 822 ⇒ 引擎实际扣 258 = 真实 258 + 0；而原实现算出 218+8=226，
      少 32 = 40 的 gap − 原来那句 `+8` 的补偿）。
     旧实现靠 resize 末尾的「一次性溢出修正」事后补掉这 32px，而那一步会把**当时存在的任何溢出**
     （参考图行 48 / 调色盘 138）一起扣进画布 ⇒ 用户报「绘画区会变」，且因预算按视口缓存无法恢复。
     把 gap 算准后残差 ≈ 0 ⇒ 尺寸**完全由预算决定**，那一步已删除（见 resizeDrawCanvas）。 */
  var gap = parseFloat(g.rowGap || g.gap) || 0;
  if(gap > 0 && flow > 1) sum += gap * (flow - 1);
  sum += (parseFloat(g.paddingTop) || 0) + (parseFloat(g.paddingBottom) || 0)
       + (parseFloat(g.marginTop) || 0) + (parseFloat(g.marginBottom) || 0);
  if(host !== box){
    var b2 = getComputedStyle(box);
    sum += (parseFloat(b2.paddingTop) || 0) + (parseFloat(b2.paddingBottom) || 0);
  }
  pfmDraw._budgetKey = key;
  pfmDraw._budgetH = sum;
  return sum;
}
/* 把尺寸同时应用到主画布 + 3 张绝对定位层（参考墊层/底稿/描线），并保持水平居中 */
function _applyDrawSize(size, wrapEl){
  var cv = pfmDrawCanvas; if(!cv) return;
  pfmDraw._geo = null;   /* 尺寸/居中有变 ⇒ 失效几何缓存，下一次 _cvGeo() 重测 */
  cv.style.width = size + 'px';
  cv.style.height = size + 'px';
  var off = 0;
  if(wrapEl){ var cw = wrapEl.clientWidth; if(cw > size) off = Math.round((cw - size) / 2); }
  /* 2026-09-26：新增 `pfmDrawChecker`（棋盘格/边框垫层，wrap 第一个子元素）——
     与三张图层一同同步尺寸与居中 ⇒ 与画布严丝合缝，且天然垫在最下面。
     它的尺寸由这里驱动，CSS 里**不要**写死（见 hd-canvas.css 的 .pfm-draw-checker）。 */
  var mir = [document.getElementById('pfmDrawChecker'),
             document.getElementById('pfmDrawRefBack'),
             document.getElementById('pfmLayerBase'),
             document.getElementById('pfmLayerLine')];
  for(var i=0;i<mir.length;i++){
    var e = mir[i]; if(!e) continue;
    e.style.width = size + 'px';
    e.style.height = size + 'px';
    e.style.left = off + 'px';
    e.style.top = '0px';
  }
  /* 2026-09-26（用户裁决 乙）：把 wrap **裁到外框**（板面 = 绘画区）。
     ① 放大时图案超出外框的部分在这里被裁掉（否则会溢到框外的空白区，看起来"画到了框外"）；
     ② 外框两侧本来就有空白（桌面/平板实测 63~155px，因为画布是正方形、弹窗是宽的）——一并裁掉
        ⇒ 观感上"看得到的地方就是绘画区"。
     🔴 留 2px 余量：垫层的边框是 `outline`（画在盒外 1px），裁到零会把左右竖边框切掉。
     🔴 `clientWidth/Height` 不受 clip-path 影响（纯绘制层）⇒ 不会与上面的尺寸推导形成循环。 */
  if(wrapEl){
    var _cww = wrapEl.clientWidth, _cwh = wrapEl.clientHeight;
    var _cl = Math.max(0, off - 2);
    var _cr = Math.max(0, _cww - off - size - 2);
    var _cb = Math.max(0, _cwh - size - 2);
    var _cp = 'inset(0px ' + _cr + 'px ' + _cb + 'px ' + _cl + 'px)';
    wrapEl.style.clipPath = _cp;
    wrapEl.style.webkitClipPath = _cp;
  }
}
/* 2026-09-26（用户报「网格和绘画区不匹配」）：
   画布 CSS 带 `max-width:100%` ⇒ **容器宽度一变，画布就被浏览器直接压/放，没有任何 JS 事件**；
   而棋盘格垫层 / 网格 / 三张图层都是 JS 用 px 写死的尺寸 + 居中偏移 ⇒ 它们保持旧值。
   实测：视口 520→400 时画布 486→368，而网格仍是 486（比绘画区大且偏移）；
   反向（360→520）时画布不会自己长回去、且居中偏移也不更新（canvas x=96 vs 垫层 x=17）。
   ⇒ 观察**容器（wrap）的宽度**：一变就全量重算（resizeDrawCanvas 末尾本就同步全部覆盖层）。
   🔴 只认**宽度**变化（画布高度/内容行数变化不算，避免与"预算"逻辑互相触发）；`_roBusy` 防重入。
   **桌面零影响**：桌面是高度瓶颈，容器变宽不会改变画布尺寸，但重算结果同样幂等 ⇒ 数值不变。 */
function _observeCanvasSize(){
  if(pfmDraw._roAttached || !pfmDrawCanvas || !window.ResizeObserver) return;
  var wrap = pfmDrawCanvas.parentElement;
  if(!wrap) return;
  pfmDraw._roAttached = true;
  pfmDraw._roWrapW = wrap.clientWidth;
  try{
    new ResizeObserver(function(){
      if(pfmDraw._roBusy || !pfmDrawCanvas) return;
      var w = wrap.clientWidth;
      if(!w || Math.abs(w - (pfmDraw._roWrapW || 0)) <= 1) return;
      pfmDraw._roWrapW = w;
      pfmDraw._roBusy = true;
      try{ resizeDrawCanvas(); }catch(e){}
      pfmDraw._roBusy = false;
    }).observe(wrap);
  }catch(e){}
}
/* 2026-09-27（用户裁决「一起」）：**窗口尺寸变化 ⇒ 重算画布**。
   🔴 为什么必须补：`resizeDrawCanvas()` 的注释早写明「只有用户主动改窗口大小 / 旋转设备才会重算
      （物理必然）」，但实现里只有 `_observeCanvasSize()` 的 ResizeObserver —— 它只盯 **wrap 宽度**
      ⇒ 只改**高度**（手机横竖屏切换、把窗口拖矮/拖高）时画布完全不重算：
         · 转成横屏后画布可能比可视区高 ⇒ 下半截够不到（画布上是 touch-action:none，滚不动）；
         · 转成竖屏后画布偏大 ⇒ 内容溢出。
   ✅ 做法：rAF 合并（拖窗口时不逐帧重算）+ 只有「宽×高」真的变了才执行 + 画板没开时只失效缓存。
   ⚠️ 这不违反用户裁决的「用的时候固定大小」—— 它只在**窗口尺寸真的变了**时触发（物理必然）。
   幂等：`_vpBound` 守卫，重复调用无副作用。 */
/* 2026-09-27（用户裁决「一起」）：**同步布局后再算画布尺寸** —— 两条路径的公共收口。
   🔴 为什么需要：选项区（`.pfm-draw-opts`）与分类行的行显隐是 **snippet 用内联 style.display 设的**
      （`window.__pfmShowOpts`），**不是纯 CSS 断点** ⇒ 跨断点切换视口后它们保持上一种断点的值
      （手机 opts 6px ↔ 桌面 38px）。若在它们就位前算预算，`_drawBudgetH()` 会读到旧的块高度：
        · 窄→宽（390→1366）：画布 590 → **620**、内容溢出 28px；
        · 宽→窄：画布被算小 32px（用户报的「有时大有时小」）。
   ✅ 顺序：① 按当前选中工具显式调一次 `__pfmShowOpts`（同步、幂等）→ ② 清掉预算缓存 → ③ 重算。
   ⚠️ 只在「打开画板」与「窗口尺寸真的变了」这两个物理时刻调用 ⇒ 不破坏用户裁决的
      「用的时候固定大小」（切工具 / 开关面板仍走缓存，画布纹丝不动）。 */
function _syncLayoutThenResize(){
  if(window.__pfmShowOpts){
    try{
      /* 🔴 2026-10-02（甲·续4）：**放宽到全文档** —— 工具格现已分布在三个容器里：
         第 2 行平铺键（Erase / Fill）· 第 3 行（Pick）· 浮层卡（其余）。
         写死 `#pfmDrawTools` 时，当前工具住在前两处就**取不到** ⇒ 开板/改窗口尺寸后
         该工具的选项行**静默不恢复**（20:47 那次并发推送曾把这里的放宽整份回退掉）。 */
      var st = document.querySelector('.pfm-dtool[data-tool].sel');
      /* 2026-09-28（用户裁决 乙）：空态（**没选任何工具**）不要再兜底成 'brush' ——
         否则空白态一开板就弹出画笔的选项行，与「为空白」自相矛盾。 */
      window.__pfmShowOpts(st ? (st.getAttribute('data-tool') || '') : '');
    }catch(e){}
  }
  pfmDraw._budgetKey = null;
  resizeDrawCanvas();
}
function _observeViewport(){
  if(pfmDraw._vpBound) return;
  pfmDraw._vpBound = true;
  var last = (window.innerWidth || 0) + 'x' + (window.innerHeight || 0), raf = 0;
  window.addEventListener('resize', function(){
    if(raf) return;
    raf = requestAnimationFrame(function(){
      raf = 0;
      var now = (window.innerWidth || 0) + 'x' + (window.innerHeight || 0);
      if(now === last) return;
      last = now;
      var md = q('pfmDrawModal');
      if(!md || getComputedStyle(md).display === 'none'){   /* 画板没开：只失效缓存，下次 show 会算 */
        pfmDraw._budgetKey = null;
        return;
      }
      try{ _syncLayoutThenResize(); }catch(e){}
    });
  });
}
function resizeDrawCanvas(){
  if(!pfmDrawCanvas) return;
  _observeCanvasSize();   /* 幂等：只在首次真正挂上（画板打开时） */
  _observeViewport();     /* 2026-09-27：幂等：绑定窗口尺寸监听（转屏 / 拖窗口高度） */
  var box = q('pfmDrawBox');
  if(!box) return;
  /* 2026-09-25（用户报「画板左右还有一点不能画」）：
     🔴 原算式 `box.clientWidth - 44` 会让画布比它所在的 wrap **窄** ⇒ 左右各留一条
        露着 wrap 棋盘格、**看着像画布其实不能画**的空档（实测 9px；且窗口越宽越明显 ——
        因为 `min(600,…)` 的上限会先命中，宽屏下空档可达 64px）。
        那 44px 本来是给右上角 ✕ 关闭钮让位的，但 ✕ 是 `top:14px;right:14px` **只在顶部**，
        画布在工具条下方，根本不需要它。
     改为直接取 **wrap 的实测内容宽** ⇒ 画布与边框严丝合缝，左右不再有空档。
     最大尺寸由 `.pfm-draw-box` 的 max-width 天然封顶；纵向放不放得下由下面那个
     收敛循环负责（放不下会自动缩小）。 */
  var _wrapEl = pfmDrawCanvas.parentElement;
  var maxW = (_wrapEl && _wrapEl.clientWidth) ? _wrapEl.clientWidth
                                              : Math.min(600, box.clientWidth - 44);
  /* 2026-09-25（用户裁决 甲 + 预留：「画板要固定大小，不要又变化」）：
     🔴 **删掉原来的"按溢出收敛"循环**（每轮读 box.scrollHeight-clientHeight 缩画布）。
        它让尺寸变成**容器高度/内容高度的函数** ⇒ 窗口一变、色板一开合，画布就跟着变
        （实测同一宽度下 180 / 201 / 327 / 453 / 633 剧烈摆动）。
     ✅ 现在尺寸 = **min(容器宽, 视口高推出的上限)**，只依赖「容器宽 × 窗口高」两个量：
        · 换工具 / 选项行显隐 / 色板开合 ⇒ **完全无关 ⇒ 用的时候永不跳动**；
        · 只有用户主动改窗口大小 / 旋转设备才会重算（物理必然）。
     🔴 上限为什么不能省（不留上限会踩坑）：画布上有 `touch-action:none`（防落笔时页面跟着滚）
        ⇒ 一旦画布比弹窗可视区高，**手指按在画布上是滚不动的**，下半截在平板上够不到。
        实测不留上限时 761 高窗口只看得见 62% 画布。所以按视口高预留固定的"弹窗边距 + 常态 chrome"：
        · 桌面/横屏：弹窗上限 90vh，常态 chrome 实测 242px（toolbar+色板+滑杆行+底栏+间距），
          留 300 给常态 + 常见选项行（brush 默认开 stab/sym/blend ≈ +38）；
        · 手机/竖屏：弹窗上限 `calc(100vh-132px)`，chrome ≈164px，同样留 300。
        两种模式都留 300 ⇒ 手机端本来就受**宽度**约束（295 < 上限），不会被无谓压小。 */
  /* 2026-09-26：上限 = 盒子**实际可用高** − **实测预算**（不再用「视口高 − 300」这个猜的常量）。
     `maxHeight` 由 CSS 给出（桌面 90vh / 手机 calc(100vh-132px)），预算由 _drawBudgetH() 实测。 */
  var _maxH = parseFloat(getComputedStyle(box).maxHeight) || box.clientHeight || (window.innerHeight || 0);
  /* 🔴🔴 2026-09-27 21:37（用户裁决「乙」）：**取消「参考图行的宽度让位」** ——
     插入参考图后画布尺寸**不再缩小**。
     · 历史：09-26 23:20 这里曾把参考图行的高度从宽度上限里扣掉（画布 380→330），
       目的是"画布位置不变、盒子不溢出"。
     · 用户 09-27 报「插了参考图之后绘画区变小」（手机端实测 358→308，−50px）⇒ 用户裁决「乙」：
       **优先保证画布不变**，接受代价 = 盒子溢出、底栏（Apply）需要滚动才看得到。
     · 现在画布 = min(wrap 宽, 盒可用高 − 实测预算 − 2)，**与参考图行是否显示无关** ⇒ 手机 390 恒 358。
     ⚠️ 配套（**别改错方向**）：`_drawBudgetH()` 的缓存键**不含**参考图行状态（保持现状）——
        若把该行加进预算，`_cap` 会掉到 ≈312 < maxW 358 ⇒ 画布又会被压小（正是本次要消除的现象）。
     ⚠️ 溢出的内容交给**容器滚动**（`.pfm-draw-box{overflow:hidden auto}`）；画布上有 `touch-action:none`
        ⇒ 要在**工具栏/底栏区域**滑动才能滚动盒子（画布上滑不动，属既有约束）。
     🔴 不要把这段让位加回来：它的代价（画布缩小）用户已明确拒绝。 */
  /* 2026-09-26（用户裁决 甲）：尺寸**只**由「容器宽 / 盒子可用高 / 预算」决定。
     🔴 已删除原先末尾的「一次性实测溢出修正」（读 box.scrollHeight−clientHeight 再缩画布）：
        它分不清溢出是"预算估算误差"还是"后来出现的行占的高度"（参考图行 48 / 调色盘 138），
        把它们全扣进画布 ⇒ 用户报「上传参考图，绘画区会变」；又因预算按视口缓存，那 48px 再也回不来。
        现在 `_drawBudgetH()` 已把 flex gap 算准（残差 0）⇒ 不需要事后补偿；
        放不下的内容交给**容器滚动**（`.pfm-draw-box{overflow:hidden auto}`）—— 这正是用户要的语义。
     保留 2px 余量吸收 sub-pixel 取整，避免临界时冒出一条无意义的滚动条。
     🔴 不要把那段修正加回来：它会让「新增任何行/面板」都顺带把别的行高吃进画布。 */
  var _cap = Math.round(_maxH - _drawBudgetH() - 2);
  if (_cap < 200) _cap = 200;
  var size = Math.floor(Math.min(maxW, _cap));
  if(size<200) size=200;
  _applyDrawSize(size, _wrapEl);
  /* 2026-09-25（3 层）：主画布仍在文档流里（由 wrap 的 flex 居中，且它决定 wrap 的高度）；
     两张图层画布 + 参考垫层是**绝对定位** ⇒ 必须显式给尺寸，并在"画布比 wrap 窄"时跟着居中
     （矮屏触发高度上限时会出现这种情况，不居中就会左右错位）。 */
  /* 主画布 + 3 张绝对定位层的尺寸与居中：已并入 _applyDrawSize()（上面已调用） */
  /* 2026-09-13 B: 内部高分辨率与显示尺寸**解耦**。原实现内部=显示尺寸（桌面 600 / 手机 307），
     落产品要放大 4~7.8× → 印刷糊（effDpi 75~142）。现在内部固定 HW=1200、CSS 缩放到 size。
     getDrawPos 已按 CV().width/rect.width 换算 → 坐标自动正确。
     ⚠️ ds 必须是 HW/size（**除以显示尺寸**）：写成 HW/600 会让手机端线条细一半。 */
  pfmDraw.ds = 1200 / size;
  pfmDraw.brushSize = (pfmDraw.sizeRaw || 12) * pfmDraw.ds;   /* 🔴 2026-10-04（乙）：默认 4 → 12 */
  /* 尺寸变了 ⇒ 各覆盖层跟着重排（这些函数均为幂等，重复调用无害） */
  if(window.__pfmRefFit) window.__pfmRefFit();
  _selLayerSync();
  _gridSync();
  _symUISync();
}

function showDrawModal(){
  // Ensure draw board is initialized (defensive against early click)
  if(!pfmDrawCanvas || !pfmDrawCtx){
    pfmDrawCanvas = q('pfmDrawCanvas');
    if(pfmDrawCanvas) pfmDrawCtx = pfmDrawCanvas.getContext('2d');
  }
  if(!pfmDrawCanvas) return;
  q('pfmDrawModal').style.display = 'flex';
  _exportConfirmClose();   /* 2026-09-26（甲）：开板先收掉可能残留的导出确认 */
  /* 2026-09-26（甲）：预设行已搬到底栏常驻 ⇒ 打开画板时就渲染（内部 _synced 保证首帧只拉一次远端）。 */
  presetsRender();
  hdDrawFontsFill();   /* 2026-09-13 C: 字体选项扩到全量（幂等） */
  /* 2026-09-04：每次打开画板复位缩放视图。
     🔴 2026-09-29（用户裁决 2）：改成**无条件调用** —— 复位按钮现在**常驻**、靠 `disabled` 表达
        「已无东西可复位」，而 `_zoomBtnSync()` 只在 `pfmDrawZoomApply()` 里被调；
        原先带条件（只在 s≠1 时复位）⇒ **首次开板（本来就是 1.0）压根不调** ⇒ 按钮带着
        「可点」的初始态显示出来（实拍抓到的假象：视图明明已复位，按钮却是亮的）。 */
  if(typeof pfmDrawZoom!=='undefined') pfmDrawZoomReset();
  /* 2026-09-22: 每次打开画板**复位颜色区展开态** —— 手机端颜色区默认收起（省 138px 给画布），
     只有点「Colour」tab 才展开。若上次展开后直接关板，不清的话下次打开它会继续占高度。
     桌面端该 class 无对应 CSS ⇒ 完全无影响（零回归）。 */
  var _cc = q('pfmDrawColors'); if(_cc) _cc.classList.remove('open');
  if(pfmDraw.setDrawCompact) pfmDraw.setDrawCompact(false,true);
  /* 🔴🔴 2026-09-28（用户裁决 乙）：**每次打开画板都回到「没选工具」**（当前工具格空白）。
     动机：默认预选画笔 ⇒ 一开板随手一碰就落笔（用户要求「不要默认选中画笔，为空白」）。
     ⚠️ 四件事必须一起做，缺任何一件都会「看着空白其实还能画 / 选项行还挂着」：
       ① 引擎状态 `tool=''` —— 无工具的绘制分支天然什么都不画（drawMouseDown 的分支链**没有兜底 else**）
       ② 清掉工具格上的 `.sel`
       ③ 让 snippet 把「当前工具」格的图标 + 文字也清空（跨 IIFE ⇒ 走暴露的钩子）
       ④ 收起**文本选项卡**、并让选项卡片按空工具重算（`__pfmShowOpts('')` ⇒ 无行可见时整卡隐藏） */
  if(pfmDraw.text) textCancel();   /* 2026-10-01（甲）：开板不该残留未提交的文字对象 */
  pfmDraw.tool = '';
  /* 🔴 2026-10-04（用户裁决）：开板一并复位「上一个真实工具」——
     开板后**直接**点 Pick（没先选任何工具）时没有"上一个"可回 ⇒ 取色后停在吸管（不空切）。 */
  _pickPrevTool = '';
  try{
    var _ts = document.querySelectorAll('.pfm-dtool[data-tool]'), _ti;
    for(_ti=0;_ti<_ts.length;_ti++) _ts[_ti].classList.remove('sel');
    /* 2026-09-30（甲）：收起**文本选项卡**改走 snippet 钩子（保证与卡片机制一致；缺钩子回退旧写法） */
    if(window.__pfmShowTextOpts) window.__pfmShowTextOpts(false);
    else { var _to = q('pfmDrawTextOptions'); if(_to) _to.style.display = 'none'; }
    if(window.__pfmBlankCurTool) window.__pfmBlankCurTool();
    /* 🔴 参考图「移动」开关也要一起复位：否则重开后它还是"开着"⇒ 用户想画一笔却把参考图拖走了 */
    if(window.__pfmResetRefMove) window.__pfmResetRefMove();
    if(window.__pfmShowOpts) window.__pfmShowOpts('');
  }catch(e){}
  // Resize canvas to fit on mobile
  var box = q('pfmDrawBox');
  if(box){
    /* 2026-09-22：显示尺寸计算抽成 `resizeDrawCanvas()`（颜色区收起/展开时要复用它）。
       这里只负责「内部尺寸 = HW」+ 清空 + 重建撤销栈，**显示尺寸**交给那个函数。
       ⚠️ 顺序要紧：先设 canvas.width（会清空内容），再让它去改 style。 */
    var HW = 1200;
    /* 2026-09-25（3 层）：**三张画布都要设内部尺寸**（设 width 会清空该 canvas 并重置其 ctx 状态）。
       顺序要紧：先全部设尺寸 → 再把 pfmDrawCtx 指到当前层、设线型 → 再清空/建快照/建撤销栈。 */
    if(!pfmDraw.layers) initDrawLayers();
    var _nL = layerCount() || 1, _li;
    if(pfmDraw.active >= _nL) pfmDraw.active = _nL - 1;
    pfmDraw.vis = [true,true,true];                 /* 每次打开画板：显隐与不透明度复位（画板本身是"一次一张"的临时稿） */
    pfmDraw.op = [1,1,1];
    for(_li=0;_li<_nL;_li++){
      pfmDraw.layers[_li].cv.width = HW;
      pfmDraw.layers[_li].cv.height = HW;
      pfmDraw.layers[_li].cv.style.display = '';
    }
    pfmDrawCtx = pfmDraw.layers[pfmDraw.active].ctx;
    resizeDrawCanvas();
    for(_li=0;_li<_nL;_li++){
      pfmDraw.layers[_li].ctx.lineCap = 'round';
      pfmDraw.layers[_li].ctx.lineJoin = 'round';
    }
    pfmDrawCtx.clearRect(0,0,HW,HW);
    pfmDraw.snapshot = pfmDrawCtx.getImageData(0,0,HW,HW);   /* snapshot 保持 ImageData：形状拖动预览回滚用 putImageData（**按层**） */
    /* 撤销条目 = {u:[各层 dataURL], a:当前层}。pushUndo 只重编码当前层、其余层复用上一条的字符串
       ⇒ 内存/耗时与单层时几乎相同（每份 202KB / 编码 18ms / 撤销往返 21ms）。 */
    initUndoStack();
    pfmDraw.undoLock = false;
    layerUISync();
  }
  /* 2026-09-17: canvas 宽高刚被重设 ⇒ 通知画板参考底图按新尺寸重排（snippet 暴露的钩子） */
  if(window.__pfmRefFit) window.__pfmRefFit();
  selClear();     /* 2026-09-20 第 2 批 b：c尺寸已变 ⇒ 旧 mask 分辨率不再对应，必须清掉 */
  _selLayerSync();
  _gridSync();    /* 2026-09-20 第 3 批：网格覆盖层重排 */
  _symUISync();   /* 2026-09-20: 对称轴覆盖层重排（第 5 批起也带拖拽层） */
  symDragBind();  /* 2026-09-21 第 5 批：懒绑定（bindDrawEvents 可能早于 DOM 就绪时已跑过） */
  /* 🔴🔴 2026-09-27（用户裁决「一起」）：**打开画板时预算必须按「当前真实布局」再算一遍**。
     🔴 现象（`_hdnav/_jitter_probe.js` 实测，同一档 1366×900）：
          从 1280（同断点）切过来 ⇒ 画布 590 / 溢出 0  ✅
          从  390（跨断点）切过来 ⇒ 画布 **620** / 溢出 28  ❌（差 30 ≈ 选项区高：手机 6 ↔ 桌面 38）
        反方向（宽→窄，如横屏转竖屏、拖窗口跨 768 边界）会把画布**算小 32px**。
     🔴 根因：上面那次 `resizeDrawCanvas()`（本函数中段）跑在「选项区 / 分类行等**由 JS 决定显隐**的块」
        就位**之前** ⇒ `_drawBudgetH()` 读到的是**上一种断点的布局高度** ⇒ 预算偏小 ⇒ 画布算大、内容溢出。
     ✅ 收口：在这里（所有初始化都已跑完）**清掉预算缓存再算一次**。
        ⚠️ 只发生在「打开画板」这一刻 ⇒ 不影响用户裁决的「用的时候固定大小」
           （之后切工具 / 开关面板仍走缓存，画布纹丝不动）。
     ⚠️ 别把本函数中段那次 `resizeDrawCanvas()` 删掉 —— 它负责设完 canvas 内部尺寸后的显示尺寸与居中；
        这里是「再校准一次」，两次都幂等。 */
  _syncLayoutThenResize();   /* 2026-09-27：同步选项区 → 清预算缓存 → 重算（见其定义处的说明） */
}

function hideDrawModal(){
  /* 2026-10-01（甲）：关画板前提交浮动文字 —— 不提交就等于用户白打一遍。
     显式丢弃走 ✕ 按钮 / Esc，那两条路不经过这里。 */
  if(pfmDraw.text) textCommit();
  q('pfmDrawModal').style.display = 'none';
  _exportConfirmClose();   /* 2026-09-26（甲）：关板一并收确认层 */
  var _m=q('pfmDrawModal'); if(_m) _m.style.pointerEvents='';
}

/* 🔴🔴 2026-09-30（用户裁决 丙）：**整幅快照改为「按需拍」**。
   原先这里对**每个工具**都拍一张 5.76MB 的整幅 ImageData，但全文件只有 6 个读点
   （6 处 putImageData 回填），全在「形状/曲线拖拽预览回滚 · 渐变拖拽 ·
   选区提取/拖动/变换」三类路径里 ⇒ 画笔系从来不用它，白拍一张，还触发 Chrome 的
   「Canvas2D: Multiple readback operations using getImageData…」读回警告
   （GPU↔CPU 每笔同步一次）。
   🔴 方向刻意选**黑名单**（未列出的工具一律照拍）：漏判只会多花一次 5.76MB，
      绝不会让形状/选区类工具失去回滚基线。text 也刻意留在外面（改动无关、少一次判断）。
   🔴 2026-09-30（乙·合并）：把本批**新增的 6 支笔**一并列入 —— marker/pencil/calli/water/air 都是
      笔迹类；mixer 与 smudge 同构（smudge 已在表内）⇒ 否则这 6 支会白拍一张 5.76MB。 */
/* 🔴 2026-10-01（丙）：`neon` / `water` / `spiro` 已改为**整笔累积**（每次 mousemove 从 snapshot 重画）
   ⇒ 它们**必须有 snapshot**做回滚底，故从黑名单移除（blacklist 语义 = 免拍）。 */
/* 🔴 2026-10-01（乙）：走整笔累积的 7 支（brush/ink/crayon/soft/pixel/marker/pencil）
   **必须有 snapshot**（每帧 `_strokeRestore` 要擦上一帧）⇒ 从黑名单移除。
   仍在黑名单的 = 逐段绘制、不需要回滚底的：spray/web/smudge/stamp/eraser/air/mixer/oil/rainbow/comet。
   代价：这 7 支每次落笔多一次 `getImageData`（约 5.76MB、10~20ms，**每笔一次**不是每帧）。 */
/* 🔴 2026-10-01（乙·第三批）：`comet` / `web` 也移出 —— 两者都改成了「每帧从 snapshot 重画」
   （comet 整笔累积、web 实时预览），必须有 snapshot 做回滚底。 */
/* 🔴 2026-10-01（乙·性能）：`air` **回到黑名单** —— 它改回增量绘制后不再需要 snapshot
   （整笔重画才需要回滚底）⇒ 每次落笔又省下一次 5.76MB 的 `getImageData`。 */
var SNAP_FREE_TOOLS = { rainbow:1, air:1, liquify:1, particles:1, filtbrush:1,
                        spray:1, smudge:1, stamp:1, eraser:1, mixer:1 };
/* 🔴 2026-10-01（甲·v7）：`calli` **从此不在黑名单** —— 毛笔改为整笔重画，
   每次 mousemove 要先 `putImageData(snapshot)` 擦掉上一版，**必须有 snapshot**。 */
function _snapNotNeeded(){
  var t = pfmDraw.tool;
  if(t === 'fill') return !pfmDraw.isGradient;   /* 渐变拖拽要回滚预览；非渐变（floodFill）自己读像素、不需要基线 */
  return !!SNAP_FREE_TOOLS[t];
}

/* 🔴 2026-10-04（用户裁决）：**吸管取色后自动切回上一个工具**所需的「上一个真实工具」。
   对标 PS 的「Alt 临时吸管」语义（用完即回原工具）：吸管只响应按下，
   取色后若工具停在 picker，用户在画布上拖一笔**什么都不会发生** ⇒ 看起来像画板坏了。
   🔴 唯一真源：在下方 `Tool selection` 的工具格 click 里维护（非 picker ⇒ 记为它；
      picker ⇒ 保留进入前那个，不覆盖）；`showDrawModal()` 开板复位为 ''。 */
var _pickPrevTool = '';

function drawMouseDown(e){
  e.preventDefault && e.preventDefault();
  // 2026-09-04: Ctrl+拖 / 中键拖 = 平移画板视图（放大后查看局部；不进入绘制）
  if(e.ctrlKey || e.button===1){
    pfmDrawPan.on=true; pfmDrawPan.lx=e.clientX; pfmDrawPan.ly=e.clientY;
    pfmDraw.isDrawing=false;
    return;
  }
  /* 🔴 2026-09-28（用户裁决）：参考图「移动」模式开着时，这一次拖动用来平移**选中的参考图**（不落笔）。
     判定/位移/状态都在 snippet（它拥有参考图那套数据）—— 与 `__pfmRefDrop`/`__pfmRefPick` 同一套跨 IIFE 口径。
     ⚠️ 位置：必须排在上面「Ctrl / 中键 = 平移画板」之后（Ctrl 是显式修饰键，优先级更高）。 */
  if(window.__pfmRefMoving && window.__pfmRefMoving()){
    pfmDraw.isDrawing = false;
    if(window.__pfmRefDragStart) window.__pfmRefDragStart(e.clientX, e.clientY);
    return;
  }
  var pos = getDrawPos(e);
  /* 2026-09-20 第 3 批：网格落笔吸附（吸管除外 —— 取色必须精确） */
  if(pfmDraw.tool!=='picker') pos = _snapPt(pos);
  /* 2026-09-20 第 1 批：吸管 —— 只取色，不进入绘制态（不产生笔画、不入撤销栈） */
  if(pfmDraw.tool==='picker'){
    try{
      var _x=Math.max(0,Math.min(pfmDrawCanvas.width-1,Math.round(pos.x)));
      var _y=Math.max(0,Math.min(pfmDrawCanvas.height-1,Math.round(pos.y)));
      var _px=pfmDrawCtx.getImageData(_x,_y,1,1).data;
      /* 2026-09-20 第 2 批：画板本身透明时，回退到**参考底图**取色（snippet 曝露的 __pfmRefPick） */
      var _ref = (_px[3] < 8 && typeof window.__pfmRefPick === 'function') ? window.__pfmRefPick(pos.x, pos.y) : null;
      if(_ref){ _px = [_ref.r, _ref.g, _ref.b, 255]; }
      if(_px[3]<8){
        _pickTip('Transparent area — no color to pick here');
        _pickSwatch(e, null);   /* 2026-10-04（甲）：透明也要给反馈 —— 浮标色块画**斜纹**（无文字） */
      }
      else{
        var _hx='#'+[_px[0],_px[1],_px[2]].map(function(v){ return ('0'+v.toString(16)).slice(-2); }).join('');
        pfmDraw.color=_hx.toUpperCase(); pfmDraw.isGradient=false;
        var _cp=q('pfmDrawColorPicker'); if(_cp) _cp.value=_hx;
        document.querySelectorAll('.pfm-dcolor').forEach(function(el){ el.classList.remove('sel'); });
        var _hit=null;
        document.querySelectorAll('.solid-color').forEach(function(el){
          if(String(el.dataset.color||'').toLowerCase()===_hx.toLowerCase()) _hit=el;
        });
        if(_hit) _hit.classList.add('sel');
        _pickTip('Picked '+_hx.toUpperCase());
        /* 🔴 2026-10-04（甲+乙·用户裁决）：取色后**屏幕上必须有反馈** ——
           ① 取色点旁弹「色块 + HEX」浮标（本文件 `_pickSwatch`）；
           ② 刷新底栏常驻的「当前色」指示块（snippet 暴露的钩子，同 `__pfmRefPick` 先例）。
           背景：`PFM_PICK_TIP_ON=false`（9-26 裁决关掉画板内全部气泡）⇒ 取色原本**零反馈**
           （颜色区默认收起、参数卡常不在）⇒ 用户报「Pick 现在看不到吸取了什么颜色」。 */
        _pickSwatch(e, _hx);
        if(window.__pfmCurColor){ try{ window.__pfmCurColor(); }catch(err2){} }
      }
      /* 🔴 2026-10-04（用户裁决）：**取色后自动切回上一个工具**（对标 PS 的 Alt 临时吸管）。
         动机：吸管只响应按下（`drawMouseMove` 里 `if(tool==='picker') return`）⇒ 取完色若停在吸管，
               接着在画布上拖一笔**毫无反应**，用户会以为画板坏了。
         ✅ 复用**工具格 click**（切工具 / 高亮 / 通知 snippet 的唯一实现）⇒ 不写第二份，与手动点回完全一致。
         ⚠️ 用 `.click()` 会走完那条链末尾的「选完即全收」（工具卡 + 参数卡收起）—— 与用户手点同义，符合预期。
         ⚠️ 透明区域（上面那个分支，`_pickSwatch(e,null)`）**也回** —— 与"点过一次吸管就结束"一致；
            没有上一个工具（`_pickPrevTool === ''`，即开板后直接点 Pick）⇒ 不动，保持吸管。 */
      if(_pickPrevTool && _pickPrevTool !== 'picker'){
        var _pb = document.querySelector('.pfm-dtool[data-tool="'+_pickPrevTool+'"]');
        if(_pb && !_pb.disabled){ try{ _pb.click(); }catch(err4){} }
      }
    }catch(err){}
    return;
  }
  pfmDraw.isDrawing = true;
  pfmDraw.lastX = pos.x;
  pfmDraw.lastY = pos.y;
  pfmDraw.sx = pos.x; pfmDraw.sy = pos.y;   /* 防抖平滑起点 */
  pfmDraw.startX = pos.x;
  pfmDraw.startY = pos.y;
  /* 🔴 2026-10-04（甲·Path 曲线修复）：**每次落笔清空路径轨迹**（弧度由它算出来，见 `_pathCtrl`）。
     同时清 `pathPts`（起/控/终三点的历史容器，仅记录用）。 */
  pfmDraw.pathTrail = [];
  pfmDraw.pathPts = null;
  // Save snapshot for shape/tool undo（🔴 2026-09-30 丙：只给真正会回滚的工具拍，见 _snapNotNeeded）
  if(!_snapNotNeeded()) pfmDraw.snapshot = pfmDrawCtx.getImageData(0,0,pfmDrawCanvas.width,pfmDrawCanvas.height);
  /* 2026-10-04（乙批）：**有选区 ⇒ 本次落笔的绘制裁剪到选区**。
     位置讲究：必须在 `_isSelTool` 分支**之前**（且该分支已被判定表排除，不会裁选区工具自己）。
     ⚠️ 这里的 `save()` 与 `drawMouseUp` 末尾的 `_selClipEnd()` 严格配对；
        中间所有 early-return（pan / 参考图 / 非绘制态）都在本行之后**不会**发生（见各自守卫）。 */
  if(_paintClipsToSel(pfmDraw.tool)) _selClipBegin();
  if(_isSelTool(pfmDraw.tool)){ selDown(pos); return; }
  if(pfmDraw.tool==='spray'){
    // Continuous spray via interval — realistic graffiti feel
    if(pfmDraw.sprayInterval) clearInterval(pfmDraw.sprayInterval);
    pfmDraw.sprayInterval = setInterval(function(){
      if(!pfmDraw.isDrawing){ clearInterval(pfmDraw.sprayInterval); pfmDraw.sprayInterval=null; return; }
      drawSpray(pfmDraw.lastX, pfmDraw.lastY);
    }, 16);
    drawSpray(pos.x, pos.y);
  } else if(pfmDraw.tool==='eraser'){
    pfmDrawCtx.lineWidth = _eraseW();   /* 2026-09-20: 接 #pfmEraseSize（此前是哑控件，恒用 brushSize*1.5） */
    pfmDrawCtx.beginPath();
    pfmDrawCtx.moveTo(pos.x, pos.y);
  } else if(isBrushTool(pfmDraw.tool)){
    if(pfmDraw.tool==='rainbow') pfmDraw.rainHue = Math.floor(Math.random()*360);
    if(pfmDraw.tool==='pixel') pfmDraw.pxPrev = null;
    pfmDrawCtx.beginPath();
    pfmDrawCtx.moveTo(pos.x, pos.y);
    applyDrawStyle();
    pfmDraw.lastT=_pfmNowTs(); pfmDraw.curW=pfmDraw.brushSize;
    pfmDraw.oilW=null; pfmDraw.oilD=null;   /* 2026-09-30（乙·第三批）：油画笔 —— 每次落笔重掷毛须粗细/位置 */
    pfmDraw.oilPrev=null;                   /* …以及重置「上一段终点」（见 oil 分支，防段间接缝） */
    pfmDraw.inkPts=null; pfmDraw.inkHair=null;   /* 2026-10-01（甲·v7）：毛笔每笔重来 */
    pfmDraw.oilHair=null;                       /* 2026-10-01（乙·第二批）：油画笔毛须特征每笔重掷 */
    /* 丙·B：图形类（形状/渐变/蛛网/花环）的**脏矩形游标**每笔清空 —— 清空后第一帧走
       `_snapRestore(null)` = 整幅还原，语义与「落笔前状态」一致（正确），之后才是并集累积。 */
    pfmDraw.shapeBox=null; pfmDraw.gradBox=null; pfmDraw.spiroBox=null; pfmDraw.webBox=null;
    if(pfmDraw.tool==='neon'||pfmDraw.tool==='rainbow'||pfmDraw.tool==='pixel'){ drawFxStroke(pos.x, pos.y, pos.x, pos.y); }
    else if(pfmDraw.tool==='comet'){
      /* 2026-10-01（乙·第三批）：彗星改**整笔累积** —— 旧实现每段落一个圆点 + 3 层尾巴，
         密集采样时是一串胶囊、彗尾被后段覆盖（不再走 `drawFxStroke`）。这里只初始化折线。 */
      pfmDraw.cometPts = [{ x: pos.x, y: pos.y }, { x: pos.x, y: pos.y }];
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    else if(pfmDraw.tool==='soft'){ pfmDrawCtx.globalAlpha = 0.15*_pfmA(); pfmDrawCtx.lineWidth = pfmDraw.brushSize*3; pfmDrawCtx.lineTo(pos.x+0.5, pos.y+0.5); pfmDrawCtx.stroke(); pfmDrawCtx.globalAlpha=_pfmA(); }
    else if(pfmDraw.tool==='web'){
      /* 2026-10-01（乙·第三批）：蛛网改为**以落笔点为中心**、拖动实时预览（见 `drawWeb` 新签名）。
         落笔时半径 0 ⇒ 不画；每笔固定一个随机种子，避免拖动过程中蛛丝抖动。 */
      pfmDraw.webSeed = Math.random() * 1000;
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    /* 2026-10-01（乙·性能）：air 走**增量撒点**（`_airScatter`）—— 不落印、不整笔重画。
       `airS` = 已画到的全局弧长游标（种子按弧长取 ⇒ 点位置稳定、密度与整笔版完全一致）。 */
    else if(pfmDraw.tool==='air'){
      pfmDraw.airS = 0;
      pfmDraw.airLastX = pos.x; pfmDraw.airLastY = pos.y;
      /* 🔴 2026-10-02（丙②）：**按住不动的积墨定时器** —— 真喷枪按住会持续喷。
         只在「指针确实没动（位移 ≤3px）」时才 puff：**移动中交给 `_airScatter`**
         （它按弧长铺点）⇒ 拖动观感一字不变，只补上「静止」这一半行为。
         清理点：`drawMouseUp` 开头（否则指针抬起后还在喷 ⇒ 一笔画完还在积墨）。 */
      if(pfmDraw.airTimer) clearInterval(pfmDraw.airTimer);
      pfmDraw.airTimer = setInterval(function(){
        if(!pfmDraw.isDrawing || pfmDraw.tool !== 'air') return;
        var nx = pfmDraw.lastX, ny = pfmDraw.lastY;
        var d = Math.sqrt((nx - pfmDraw.airLastX) * (nx - pfmDraw.airLastX) + (ny - pfmDraw.airLastY) * (ny - pfmDraw.airLastY));
        pfmDraw.airLastX = nx; pfmDraw.airLastY = ny;
        if(d > 3) return;
        _airPuff(nx, ny, _bcfg('air'));
      }, 70);
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    else if(pfmDraw.tool==='water'){
      /* 丙②：水彩不落默认圆点（`a=0.16` 的圆点会是一个可见的深斑），交给 `_waterRender`。 */
      pfmDraw.waterPts = [{ x: pos.x, y: pos.y }, { x: pos.x, y: pos.y }];
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    else if(pfmDraw.tool==='neon'){
      /* 丙③：霓虹同样交给 `_neonRender`（默认分支会落一个带光晕的圆点）。 */
      pfmDraw.neonPts = [{ x: pos.x, y: pos.y }, { x: pos.x, y: pos.y }];
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    else if(_bcfg(pfmDraw.tool) && _bcfg(pfmDraw.tool).acc){
      /* 2026-10-01（乙）：整笔累积类 —— 只初始化折线，**不落任何印**。
         🔴 硬笔尖（`nib`）的**落笔顿点**已搬进 `_strokeRender`（起点半宽 ×1.35）。
            原来在这里画顿点是错的：整笔每帧重画会先 `_strokeRestore()` 把它擦掉。 */
      pfmDraw.strPts = [{ x: pos.x, y: pos.y, t: _pfmNowTs() }];
      pfmDraw.strBox = null;
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    else if(_bcfg(pfmDraw.tool) && _bcfg(pfmDraw.tool).ink){
      /* 2026-10-01（甲·v7）：毛笔**不画落笔印** —— v1 这里落到默认分支，
         直接落下 brushSize×1.7 的圆帽实心点 ⇒ 起笔一个大黑饼（实拍抓到）。
         起笔由收敛系数渐开；只点一下不动时折线只有 2 点，也会得到一个小尖点。 */
      pfmDraw.inkPts = [{ x: pos.x, y: pos.y }, { x: pos.x, y: pos.y }];
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    /* ⚠️ 2026-10-01（乙·第二批）：`oil` 已改 `acc:1` 走整笔累积 ⇒ 本落笔印分支**不会再被命中**；
       保留是为了万一回滚 `oil` 的 acc 标记时仍有旧行为（与 `soft` 同一个处理口径）。 */
    else if(_bcfg(pfmDraw.tool) && _bcfg(pfmDraw.tool).bristle){
      /* 2026-09-30（乙·第三批）：油画笔的**落笔印**也走毛须 —— 否则落笔处是一个实心圆盘，
         在满是条纹的笔迹里最扎眼（实拍抓到的观感缺陷）。 */
      var _ocfg = _bcfg(pfmDraw.tool), _od = pfmDrawCtx.lineWidth * 0.35;
      /* 🔴 落笔印只画在**触点左侧**（pos.x-_od → pos.x）—— butt 帽首尾相接 ⇒ 与随后的笔画
         **零重叠**。原来以触点为中心（±_od/2）会与第一段叠一块：a=1 时本该看不见，
         但用户在「笔刷不透明度」滑杆下调过值（_pfmA<1）时那块会明显更黑（实拍抓到的深色方块）。
         🔴 长度取 0.35×笔宽（不是 0.8）—— 落笔印方向只能是水平的（此刻还不知道笔画方向），
            太长会变成一块与斜向笔画不同角度的方形色块（实拍抓到）。 */
      _bristleStroke(pos.x - _od, pos.y, pos.x, pos.y, _ocfg);
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pos.x, pos.y);
    }
    else { pfmDrawCtx.lineTo(pos.x+0.5, pos.y+0.5); pfmDrawCtx.stroke(); }
  } else if(pfmDraw.tool==='stamp'){
    pfmDraw.stampLX = undefined; pfmDraw.stampLY = undefined;   /* 丙⑦：每笔重置间距游标 */
    drawStamp(pos.x, pos.y);
    pushUndo();
  } else if(pfmDraw.tool==='smudge'){
    /* 2026-09-20 第 2 批：涂抹 —— 记住起点，移动时把上一采样点的像素拖过来 */
    pfmDraw.smudgePrev = {x:pos.x, y:pos.y};
  } else if(pfmDraw.tool==='mixer'){
    /* 2026-09-30（乙）：湿边/混色 —— 与 smudge 同构（记忆起点），但必须**显式备样式**：
       它不在 isBrushTool 里 ⇒ 通用笔刷段那句 applyDrawStyle 不会执行（混色层要用 fillStyle）。 */
    applyDrawStyle();
    pfmDraw.mixPrev = {x:pos.x, y:pos.y};
    pfmDraw.mixRun = 0;                 /* 丙·甲：颜料行程归零 —— **抬笔再落笔 = 重新蘸色** */
  } else if(pfmDraw.tool==='liquify'){
    /* 丙-2：液化 —— 记起点；整笔只在抬笔入一次撤销栈（与 smudge/mixer 同口径） */
    pfmDraw.liqPrev = {x:pos.x, y:pos.y};
  } else if(pfmDraw.tool==='particles'){
    /* 丙-3：粒子 —— 落笔先来一簇（与 stamp 的落笔印同理，笔头要有东西） */
    pfmDraw.partPrev = {x:pos.x, y:pos.y};
    drawParticles(pos.x, pos.y, pos.x, pos.y);
  } else if(pfmDraw.tool==='filtbrush'){
    /* 丙-4：滤镜笔 —— 落笔即对触点做一次滤镜（不动就不留空笔） */
    applyDrawStyle();
    pfmDraw.filtPrev = {x:pos.x, y:pos.y};
    drawFilterBrush(pos.x, pos.y, pos.x, pos.y);
  } else if(pfmDraw.tool==='fill'){
    if(pfmDraw.isGradient){
      /* 2026-09-20 第 2 批：渐变模式改为**拖拽定义方向**（按下处=填充点，拖到哪=渐变走向与长度） */
      pfmDraw.gradStart = {x:pos.x, y:pos.y};
    } else {
      floodFill(pos.x, pos.y, pfmDraw.color);
      pushUndo();
    }
  } else if(pfmDraw.tool==='text'){
    /* 2026-10-01（甲·浮动文字对象）：**不再直接烘焙** —— 先浮起来（可拖 / 可改样式），
       点 ✓ 才落进画布。
       🔴 2026-10-02（甲·③）：已有浮动态 ⇒ 这一次点击**只提交、不新建**（= Win11 画图的规则：
          点框外即打勾）。旧行为是「先提交、紧接着又开一个新空框」⇒ 用户点别处想打勾，
          结果又冒出一个框。想建新框：**再点一下**即可（那时已无浮动态）。 */
    if(pfmDraw.text){ textCommit(); return; }
    textBegin(pos.x, pos.y);
    /* 字体未就绪不再阻止落字：预览层是 DOM canvas，等字体到位重画一遍即可（不会留下 fallback 像素） */
    if(!hdFontReady(pfmDraw.fontFamily)){
      hdFontLoad(pfmDraw.fontFamily).then(function(){ try{ if(_textLive()){ _textPreview(); _textSync(); } }catch(e){} });
    }
  }
}

function drawMouseMove(e){
  // 2026-09-04: 平移模式（Ctrl/中键按下）
  if(pfmDrawPan.on){
    e.preventDefault && e.preventDefault();
    pfmDrawZoom.tx += (e.clientX-pfmDrawPan.lx);
    pfmDrawZoom.ty += (e.clientY-pfmDrawPan.ly);
    pfmDrawPan.lx=e.clientX; pfmDrawPan.ly=e.clientY;
    _zoomSchedule();   /* 2026-09-26：rAF 合并（原来每个 mousemove 跑一次完整同步链 ⇒ 发涩） */
    return;
  }
  /* 2026-09-28：参考图「移动」模式 → 位移交给 snippet（**必须放在 `if(!pfmDraw.isDrawing) return` 之前**，
     因为移动模式刻意不进绘制态）。 */
  if(window.__pfmRefMoving && window.__pfmRefMoving()){
    e.preventDefault && e.preventDefault();
    if(window.__pfmRefDragMove) window.__pfmRefDragMove(e.clientX, e.clientY);
    return;
  }
  if(!pfmDraw.isDrawing) return;
  e.preventDefault && e.preventDefault();
  var pos = getDrawPos(e);
  var tool = pfmDraw.tool;
  if(tool==='picker') return;   /* 吸管只响应按下 */
  if(_isSelTool(tool)){ selMove(pos); pfmDraw.lastX=pos.x; pfmDraw.lastY=pos.y; return; }
  /* 2026-09-20 第 3 批：形状类的**终点**也吸附（画规整矩形/直线时最有用）；连续笔画不吸。
     2026-09-21 第 5 批：并上 Shift 等比约束 + 对称轴吸附 —— 与落笔（drawMouseUp）**同一函数**，
     否则松手瞬间终点会跳一下（预览走了约束、落笔没走）。 */
  if(_shapeFamily(tool)) pos = _shapeEnd(pos.x, pos.y, e.shiftKey, e.altKey);
  /* 2026-10-03（丙-5）：辅助线 —— 把落点投影到过起笔点的方向线上（直尺）。
     只对"落笔型"工具生效；选区 / 吸管 / 文字 / 填充不参与。默认 off ⇒ 零影响。 */
  if(tool !== 'picker' && tool !== 'text' && tool !== 'fill' && !_isSelTool(tool)) pos = _assistPt(pos.x, pos.y);
  if(isBrushTool(tool)){
    /* 2026-09-20 第 1 批：防抖平滑 —— 速度感应仍用**原始**位移算，手感不变 */
    var pp=_stabPt(pos.x, pos.y);
    /* 🔴🔴 2026-10-01（乙）：`acc:1`（整笔累积）的分支**必须放在链首**。
       第一版放在链尾 ⇒ `soft` 被前面的 `else if(tool==='soft')` 截胡，仍旧走逐段渲染
       ⇒ 实拍摄到「soft 一串圆盘交叠」（旧实现的典型症状）。同一类坑：分支顺序 = 语义。 */
    if((_bcfg(tool) || {}).acc){
      if(!pfmDraw.strPts) pfmDraw.strPts = [];
      /* 🔴🔴 2026-10-02（乙·返修）：**把 jitter 补到整笔累积路径上** —— 这是一处**真 bug**：
         `_c.jitter` 只在**旧的逐段画笔路径**里实现，而 `_strokeRender`（9 支 acc 笔走的路）**完全没有**。
         pencil（`acc:1, jitter:0.55`）自 2026-10-01 迁到整笔累积之后，**它唯一的纹理特征（纸纹抖动）
         就再没生效过**（认证台颗粒实测恒为 0；笔宽 4 时更是零）⇒ 铅笔看起来只是一条淡线。
         ⚠️ **必须在"推点"时抖动、不能放在 `_strokeRender` 里**：整笔每帧从 snapshot 重画，
            若在渲染时取随机数，同一个点每帧位置都不同 ⇒ 整条笔迹会**持续抖动/闪烁**。
            在 push 时抖一次 ⇒ 每个点的偏移**终身固定**，笔迹稳定。 */
      var _jcf = _bcfg(tool) || {};
      if(_jcf.jitter){
        var _jd = Math.max(_fxMin(_jcf), pfmDraw.brushSize * _jcf.jitter * 0.5);
        pp = { x: pp.x + (Math.random() - 0.5) * _jd, y: pp.y + (Math.random() - 0.5) * _jd };
      }
      pfmDraw.strPts.push({ x: pp.x, y: pp.y, t: _pfmNowTs() });
      _strokeRender();
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pp.x, pp.y);
    }
    else if(tool==='rainbow'||tool==='pixel'){   /* 🔴 2026-10-01（丙③）：neon 已移到自己的整笔分支 */
      drawFxStroke(pfmDraw.lastX, pfmDraw.lastY, pp.x, pp.y);
      _symStroke(pfmDraw.lastX, pfmDraw.lastY, pp.x, pp.y);
    }
    /* 2026-10-01（乙·第三批）：彗星 —— 整笔累积（见 `_cometRender`）。
       与 neon/water 同一口径：累积折线 + 每帧从 snapshot 重画。 */
    else if(tool==='comet'){
      if(!pfmDraw.cometPts) pfmDraw.cometPts = [];
      pfmDraw.cometPts.push({ x: pp.x, y: pp.y });
      _cometRender();
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pp.x, pp.y);
    }
    /* ⚠️ 2026-10-01（乙）：`soft` 已改为 `acc:1` 走整笔累积 ⇒ 本分支**不会再被命中**；
       保留是为了万一回滚 `soft` 的 acc 标记时仍有旧行为（不做无谓删除）。 */
    else if(tool==='soft'){
      pfmDrawCtx.globalAlpha=0.15*_pfmA(); pfmDrawCtx.lineWidth=pfmDraw.brushSize*3;
      pfmDrawCtx.lineTo(pp.x,pp.y); pfmDrawCtx.stroke();
      _symStroke(pfmDraw.lastX,pfmDraw.lastY,pp.x,pp.y);
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pp.x,pp.y); pfmDrawCtx.globalAlpha=_pfmA();
    }
    /* 2026-10-01（乙·性能）：air —— 主轴逐段描 + **增量撒点**。
       🔴 这里**不能**走 `acc`：整笔重画会让每帧重画整条笔迹的全部散点。
       主轴只有 `w:0.45`（极细）⇒ 逐段 stroke 看不出段界。 */
    else if(tool==='air'){
      var _ap = _stabPt(pos.x, pos.y);
      pfmDrawCtx.lineTo(_ap.x, _ap.y); pfmDrawCtx.stroke();
      _symStroke(pfmDraw.lastX, pfmDraw.lastY, _ap.x, _ap.y);
      _airScatter(pfmDraw.lastX, pfmDraw.lastY, _ap.x, _ap.y, _bcfg('air'));
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(_ap.x, _ap.y);
    }
    /* 2026-10-01（乙·第三批）：蛛网 —— 拖动**实时预览**（每帧从 snapshot 重画），松手定格。
       旧实现每次调用都往画布上**叠加** 6 条从画布中心出发的直线 ⇒ 拖一路糊成一条粗带。
       🔴 预览必须整体重画：蛛网是一个**图形**，叠加画法下每帧都会留下上一帧的丝。 */
    else if(tool==='web'){
      var _wp = _stabPt(pos.x, pos.y);
      _snapRestore(pfmDraw.webBox);   /* 丙·B：只还原上一帧蛛网的范围（原来是整幅） */
      var _wdx = _wp.x - pfmDraw.startX, _wdy = _wp.y - pfmDraw.startY;
      var _wr = Math.sqrt(_wdx*_wdx + _wdy*_wdy);
      if(_wr > 3) drawWeb(pfmDraw.startX, pfmDraw.startY, _wr);
    }
    /* 2026-10-01（丙②）：**水彩洇散** —— 整笔累积（见 `_waterRender`）。
       逐段画不出干净的湿边：低透明度下段界会叠出痕。 */
    else if(tool==='water'){
      if(!pfmDraw.waterPts) pfmDraw.waterPts = [];
      pfmDraw.waterPts.push({ x: pp.x, y: pp.y });
      _waterRender();
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pp.x, pp.y);
    }
    /* 2026-10-01（丙③）：**霓虹** —— 整笔累积（见 `_neonRender`）。
       原来每段各画一圈 shadowBlur 光晕 + 白芯 ⇒ 一串各自带光晕的胶囊。 */
    else if(tool==='neon'){
      if(!pfmDraw.neonPts) pfmDraw.neonPts = [];
      pfmDraw.neonPts.push({ x: pp.x, y: pp.y });
      _neonRender();
      pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(pp.x, pp.y);
    }
    else {
      /* 🔴 2026-09-30（乙）：本段的一切差异都从 `BRUSH_CFG` 读（表 = 唯一真源）。
         · jitter 端点抖动 ⇒ 纸纹感（铅笔 / 蜡笔）
         · dry   随机断段 ⇒ 水彩的干刷、边缘不规则
         · noSpeed 等宽（记号笔 / 铅笔）· taper 更狠的锥度下限（毛笔）
         ⚠️ 抖动只作用于**画出来的点**：指针状态仍用未抖动的 `pos`（函数末尾统一更新 lastX/lastY）
            ⇒ 笔迹连续、不会因为抖动把下一段带偏。 */
      var _c = _bcfg(tool) || {};
      var _jx = pp.x, _jy = pp.y;
      if(_c.jitter){
        /* 🔴 2026-10-02（乙）：下限 `fxMin`。原式 `笔宽×jitter×0.5` 在默认笔宽 4 下是 **0.55px（亚像素）**
           ⇒ 铅笔的"纸纹颗粒"实测 = 0（认证台 innerStd 0）—— 铅笔看起来就是一条淡线。 */
        var _jr = Math.max(_fxMin(_c), pfmDraw.brushSize * _c.jitter * 0.5);
        _jx += (Math.random()-0.5)*_jr;
        _jy += (Math.random()-0.5)*_jr;
      }
      if(pfmDraw.useSpeed!==false && !_c.noSpeed && _c.chisel===undefined){
        /* 速度感应：快→细、慢→粗，EMA 平滑后逐段设线宽 */
        var _t=_pfmNowTs(), _dt=Math.max(1,_t-(pfmDraw.lastT||_t));
        var _dx=pos.x-pfmDraw.lastX, _dy=pos.y-pfmDraw.lastY;
        var _v=Math.sqrt(_dx*_dx+_dy*_dy)/_dt;
        var _k=1.15-Math.min(0.8,_v/1.6);
        var _tw=pfmDraw.brushSize*Math.max((_c.taper||0.35),Math.min(1.15,_k));
        var _cw=(typeof pfmDraw.curW==='number')?pfmDraw.curW:pfmDraw.brushSize;
        pfmDraw.curW=_cw+(_tw-_cw)*0.35;
        pfmDrawCtx.lineWidth=Math.max(0.5,pfmDraw.curW);
        pfmDraw.lastT=_t;
      } else if(_c.noSpeed){
        /* 等宽笔（记号笔 / 铅笔）：不走速度感应，逐段显式把线宽钉回表值。 */
        pfmDrawCtx.lineWidth = Math.max(0.5, pfmDraw.brushSize * (_c.w || 1));
        pfmDraw.curW = pfmDrawCtx.lineWidth;
      } else if(_c.chisel !== undefined){
        /* 2026-09-30（乙·第三批）：**斜切笔尖（chisel）** —— 毛笔的真正特征。
           固定倾角的平头笔尖在纸面上的投影 ⇒ 笔迹宽度 = |cos(笔画方向 − 倾角)|：
           横粗竖细、沿倾角方向最宽、垂直方向最窄（Win11 画图的「毛笔」同理）。
           🔴 仍走 `curW` 的 EMA 平滑（0.35）—— 逐段硬切会让宽度抖成锯齿。
           🔴 与「速度锥度」互斥：速度感应由上面第一条 if 的 `_c.chisel===undefined` 短路。 */
        var _sdx = _jx - pfmDraw.lastX, _sdy = _jy - pfmDraw.lastY;
        var _sl = Math.sqrt(_sdx*_sdx + _sdy*_sdy);
        var _proj = 1;
        if(_sl > 0.01){ _proj = Math.abs(Math.cos(Math.atan2(_sdy, _sdx) - _c.chisel * Math.PI / 180)); }
        var _cwid = pfmDraw.brushSize * (_c.w || 1) * Math.max(0.22, _proj);
        var _pw = (typeof pfmDraw.curW === 'number') ? pfmDraw.curW : _cwid;
        pfmDraw.curW = _pw + (_cwid - _pw) * 0.35;
        pfmDrawCtx.lineWidth = Math.max(0.5, pfmDraw.curW);
      }
      if(_c.dry && Math.random() < _c.dry){
        /* 本段不落笔，但路径起点照推进 —— 否则下一段会把断口跨接起来（看着像没断）。 */
        pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(_jx, _jy);
      } else if(_c.ink){
        /* 2026-10-01（甲·v7）：毛笔 —— **累积折线 + 整笔重画**（唯一实现 `_inkRender`）。
           🔴 不用逐段绘制：笔宽随方向逐段微变 ⇒ 逐段方案的毛丝横向偏移逐段错开 ⇒ 砖墙阶梯
              （v3/v4 实拍抓到）。整笔重画后每条丝是一条连续折线，天然没有阶梯。 */
        if(!pfmDraw.inkPts) pfmDraw.inkPts = [];
        pfmDraw.inkPts.push({ x: _jx, y: _jy });
        _inkRender();
        pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(_jx, _jy);
      } else if(_c.bristle){
        /* 2026-09-30（乙·第三批）：油画笔 —— 本段画成**一排平行毛须**（唯一实现 `_bristleStroke`）。
           🔴🔴 起点**必须**是上一段画到的点（= 稳定器平滑点），不能借 `pfmDraw.lastX/lastY`：
              那两个是**原始指针点**（速度计算/镜像要用它们），与平滑点差一个稳定器滞后量
              （默认 Stab=3 时可达十几 px）⇒ 每段都从上一段终点往回一截 ⇒ 段间留下**整段断裂**的缝
              （实测 30 段 = 30 处 100% 下凹，间距正好等于段长）。
              普通笔刷分支没这个问题，是因为它写 `lineTo(_jx,_jy)`、依赖 path 的上一点。 */
        var _oP = pfmDraw.oilPrev || { x: pfmDraw.lastX, y: pfmDraw.lastY };
        _bristleStroke(_oP.x, _oP.y, _jx, _jy, _c);
        pfmDraw.oilPrev = { x: _jx, y: _jy };
        pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(_jx, _jy);
      } else {
        pfmDrawCtx.lineTo(_jx, _jy); pfmDrawCtx.stroke();
        _symStroke(pfmDraw.lastX, pfmDraw.lastY, _jx, _jy);
        pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(_jx, _jy);
      }
      /* 2026-09-30（乙）：散布 —— 在主轴之上再撒一层随机点（喷枪/沙粒）。
         刻意**保留 polyline 主轴** ⇒ 稳定器/对称/速度感应全部照旧生效（不做"假控件"）。 */
      /* ⚠️ 2026-10-01（乙·第二批）：air 已改 `acc:1` 走整笔累积（`_accScatter`）
         ⇒ 本逐段撒点分支**不会再被命中**；保留以便回滚（`_scatterDots` 同此）。 */
      if(_c.spread) _scatterDots(_jx, _jy, _c);
    }
  /* 🔴🔴 2026-10-01（丙④）：万花尺的实时预览分支**必须放在 `if(isBrushTool(tool))` 之外** ——
     `spiro` **不在** `isBrushTool()` 名单里（它是 fx 类），第一版插在块内 ⇒ 整段死代码，
     表现是「拖动时画布上什么都没有、松手才出图」，而 pageerror 依然是 0（站点有全局错误处理，
     静默失败抓不到）—— 靠 `_verify_prop1.js` 的 S1 行为断言才抓出来。
     这里与 drawMouseUp 里 `} else if(tool==='spiro'){` 同级，位置对齐。 */
  } else if(tool==='spiro'){
    var _pp = _stabPt(pos.x, pos.y);
    _snapRestore(pfmDraw.spiroBox);   /* 丙·B：只还原上一帧花环的范围 */
    var _sdx = _pp.x - pfmDraw.startX, _sdy = _pp.y - pfmDraw.startY;
    var _srad = Math.sqrt(_sdx*_sdx + _sdy*_sdy);
    if(_srad > 3) drawSpiro(pfmDraw.startX, pfmDraw.startY, _srad);
  } else if(tool==='spray'){
    // Interval handles continuous spray; just track position
  } else if(tool==='eraser'){
    pfmDrawCtx.globalCompositeOperation = 'destination-out';
    pfmDrawCtx.lineWidth = _eraseW();   /* 2026-09-20: 接 #pfmEraseSize（原为哑控件 brushSize*1.5） */
    var ep=_stabPt(pos.x, pos.y);
    pfmDrawCtx.lineTo(ep.x, ep.y); pfmDrawCtx.stroke();
    _symStroke(pfmDraw.lastX, pfmDraw.lastY, ep.x, ep.y);
    pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(ep.x, ep.y);
    pfmDrawCtx.globalCompositeOperation = 'source-over';
  } else if(tool==='stamp'){
    /* 🔴🔴 2026-10-03（甲）：**本分支原来不存在** —— `drawStamp()` 全文件只在 mousedown 被调一次
       ⇒ Stamp 实际是"点一下盖一个章"，而脚底那段"真图章笔沿路径等距盖"的注释、以及 `drawStamp`
       里的间距游标 `stampLX/stampLY` 全是死代码（实测 1440：拖 110 CSS px 仍只得到 1 枚章）。
       现在按注释原意补上移动端调用（间距判定在 `drawStamp` 内：≥0.9×笔宽才盖下一枚）。
       ⚠️ 必须插在**移动链**（用局部 `tool` + `pos`，与 eraser/smudge 同类），
          不要插进 mousedown 链 —— 那条链已有 stamp 分支（含 `pushUndo`），插进去会把它顶掉、丢撤销。 */
    drawStamp(pos.x, pos.y);
  } else if(tool==='smudge'){
    var pv = pfmDraw.smudgePrev || {x:pos.x, y:pos.y};
    drawSmudge(pv.x, pv.y, pos.x, pos.y);
    pfmDraw.smudgePrev = {x:pos.x, y:pos.y};
  } else if(tool==='mixer'){
    var mpv = pfmDraw.mixPrev || {x:pos.x, y:pos.y};
    drawMixer(mpv.x, mpv.y, pos.x, pos.y);
    pfmDraw.mixPrev = {x:pos.x, y:pos.y};
  } else if(tool==='liquify'){
    /* 丙-2：液化 —— 与 smudge 同构（记住上一采样点），像素改写在 drawLiquify 内自洽 */
    var lpv = pfmDraw.liqPrev || {x:pos.x, y:pos.y};
    drawLiquify(pos.x, pos.y, lpv.x, lpv.y);
    pfmDraw.liqPrev = {x:pos.x, y:pos.y};
  } else if(tool==='particles'){
    /* 丙-3：粒子 —— 弹道在出生时一次算完，抬笔不留定时器 */
    var ppv = pfmDraw.partPrev || {x:pos.x, y:pos.y};
    drawParticles(pos.x, pos.y, ppv.x, ppv.y);
    pfmDraw.partPrev = {x:pos.x, y:pos.y};
  } else if(tool==='filtbrush'){
    /* 丙-4：滤镜笔 —— 同样记上一采样点，取两点中点做局部滤镜 */
    var fpv = pfmDraw.filtPrev || {x:pos.x, y:pos.y};
    drawFilterBrush(pos.x, pos.y, fpv.x, fpv.y);
    pfmDraw.filtPrev = {x:pos.x, y:pos.y};
  } else if(tool==='fill' && pfmDraw.isGradient && pfmDraw.gradStart){
    /* 2026-09-20 第 2 批：渐变拖拽预览（虚线 + 两端控制点），只画在预览层，落在 snapshot 上、不进最终像素 */
    _snapRestore(pfmDraw.gradBox);   /* 丙·B：只还原上一帧预览线段的范围（线宽可能几十 px ⇒ 余量给足） */
    var gs=pfmDraw.gradStart;
    pfmDraw.gradBox = _unionBox(pfmDraw.gradBox, {   /* 同形状：预览线段也随拖动变 ⇒ 并集 */
      x0: Math.min(gs.x, pos.x) - 14, y0: Math.min(gs.y, pos.y) - 14,
      x1: Math.max(gs.x, pos.x) + 14, y1: Math.max(gs.y, pos.y) + 14 });

    pfmDrawCtx.save();
    pfmDrawCtx.setLineDash([7,5]);
    pfmDrawCtx.lineWidth=Math.max(1, pfmDraw.brushSize*0.35);
    pfmDrawCtx.strokeStyle='rgba(124,58,237,0.85)';
    pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(gs.x, gs.y); pfmDrawCtx.lineTo(pos.x, pos.y); pfmDrawCtx.stroke();
    pfmDrawCtx.setLineDash([]);
    pfmDrawCtx.fillStyle='#ffffff'; pfmDrawCtx.strokeStyle='#7C3AED'; pfmDrawCtx.lineWidth=2;
    pfmDrawCtx.beginPath(); pfmDrawCtx.arc(gs.x, gs.y, 5, 0, Math.PI*2); pfmDrawCtx.fill(); pfmDrawCtx.stroke();
    pfmDrawCtx.beginPath(); pfmDrawCtx.arc(pos.x, pos.y, 5, 0, Math.PI*2); pfmDrawCtx.fill(); pfmDrawCtx.stroke();
    pfmDrawCtx.restore();
  } else if(_shapeFamily(tool)){
    // Restore snapshot and redraw preview
    _snapRestore(pfmDraw.shapeBox);   /* 丙·B：只还原上一帧形状的范围（余量按笔宽走） */
    /* 🔴 形状几何**随拖动变化**（拖远时大、收尾时小）⇒ box 必须取**并集**：
       只按本帧几何算的话，"上一帧比本帧更靠外"的那一圈擦不到 ⇒ 拖动中留残影。 */
    var _shp = Math.max(8, pfmDraw.brushSize * 1.5) + 8;
    pfmDraw.shapeBox = _unionBox(pfmDraw.shapeBox, {
      x0: Math.min(pfmDraw.startX, pos.x) - _shp, y0: Math.min(pfmDraw.startY, pos.y) - _shp,
      x1: Math.max(pfmDraw.startX, pos.x) + _shp, y1: Math.max(pfmDraw.startY, pos.y) + _shp });
    applyDrawStyle();
    /* 🔴 第 6 批：预览与落笔共用 `_paintShape` / `_paintPath`（并各自画镜像）
       —— 改前两段各写一份 rect/ellipse/line/arrow 代码，已经踩过「预览实心 / 落笔空心」的不一致。 */
    if(tool==='path'){
      /* 🔴🔴 2026-10-04（甲·用户裁决·Path 曲线修复）：控制点**由拖动轨迹推出来**，
         不再写死「起点→终点的中点」——那个写法会让二次贝塞尔在数学上**退化成一条直线**
         （用户实测「Path 画出来和 Line 一样」）。算法见 `_pathCtrl()` 的长注释。
         轨迹采样：本分支每帧收到的是**约束后**的 pos（吸附/轴吸附一致）⇒ 记录它，
         并对 <2px 的抖动做过滤（省内存 + 去噪）。 */
      if(!pfmDraw.pathTrail) pfmDraw.pathTrail=[];
      var _tl=pfmDraw.pathTrail, _lp=_tl[_tl.length-1];
      if(!_lp || Math.abs(_lp.x-pos.x)+Math.abs(_lp.y-pos.y) >= 2) _tl.push({x:pos.x, y:pos.y});
      var _cp=_pathCtrl(pos.x, pos.y), _cpx=_cp.x, _cpy=_cp.y;
      pfmDraw.pathPts=[{x:_cpx,y:_cpy},{x:pos.x,y:pos.y}];
      /* 🔴🔴 2026-10-04（用户实测「path 显示错误」—— 截图里一条紫色长带 + 右上紫框）：
         **脏矩形必须含控制点**。二次贝塞尔的凸包由 A/C/B 三点决定，而 C 现在由轨迹算出、
         可能远在弦之外（实测 812 后备 px）⇒ 上面按"起终点 bbox"算的 `shapeBox` **盖不住曲线**
         ⇒ 每帧还原不干净 ⇒ 残影累积成紫色带。并进 A/C/B 的并集 + 笔宽余量后才画。 */
      pfmDraw.shapeBox = _unionBox(pfmDraw.shapeBox, {
        x0: Math.min(pfmDraw.startX, pos.x, _cpx) - _shp,
        y0: Math.min(pfmDraw.startY, pos.y, _cpy) - _shp,
        x1: Math.max(pfmDraw.startX, pos.x, _cpx) + _shp,
        y1: Math.max(pfmDraw.startY, pos.y, _cpy) + _shp });
      _paintPath(pfmDraw.startX, pfmDraw.startY, _cpx, _cpy, pos.x, pos.y);
      _paintPathMirrors(pfmDraw.startX, pfmDraw.startY, _cpx, _cpy, pos.x, pos.y);
      /* 🚫 2026-10-04：**控制手柄虚线已删**（原来在这里画「起→控→终」的紫虚线）。
         理由：① 控制点飞出弦外后，这条线本身就成了"紫色长带"的直因（用户就是这么认的）；
              ② 曲线现在本来就贴着手势走，手柄只剩噪音；
              ③ 它还是残影的高危源（跨越大半画布，脏矩形一旦漏一点就留痕）。
         要恢复：把这三行加回（`strokeStyle='rgba(124,58,237,0.5)'` + `setLineDash([3,3])`）。 */
    } else {
      _paintShape(tool, pfmDraw.startX, pfmDraw.startY, pos.x, pos.y);
      _paintShapeMirrors(tool, pfmDraw.startX, pfmDraw.startY, pos.x, pos.y);
    }
  }
  pfmDraw.lastX = pos.x;
  pfmDraw.lastY = pos.y;
  pfmDraw.lastShift = !!e.shiftKey;
  pfmDraw.lastAlt = !!e.altKey;   /* 2026-10-03（甲批）：Alt 从中心画 —— 与 lastShift 同一理由 */   /* 落笔时 mouseup 可能不带 shiftKey ⇒ 记住最后一次预览的约束状态 */
}

function drawMouseUp(e){
  if(pfmDrawPan.on){ pfmDrawPan.on=false; pfmDraw.isDrawing=false; return; }
  /* 2026-09-28：参考图「移动」模式 → 收尾（不落笔、不入撤销栈、不推产品预览） */
  if(window.__pfmRefMoving && window.__pfmRefMoving()){
    if(window.__pfmRefDragEnd) window.__pfmRefDragEnd();
    return;
  }
  /* 🔴 兜底：即使绘制态在某处被提前置 false，也绝不能把 clip 留在 ctx 上（否则后续绘制全被裁）。 */
  if(!pfmDraw.isDrawing){ _selClipEnd(); return; }
  pfmDraw.isDrawing = false;
  if(pfmDraw.sprayInterval){ clearInterval(pfmDraw.sprayInterval); pfmDraw.sprayInterval=null; }
  /* 🔴 2026-10-02（丙②）：喷枪的**积墨定时器**在这里清（与 spray 的定时器同一个收口点）——
     否则指针抬起后定时器还在跑（守卫只认 `isDrawing`，抬笔后为 false ⇒ 空转，但仍属泄漏）。 */
  if(pfmDraw.airTimer){ clearInterval(pfmDraw.airTimer); pfmDraw.airTimer = null; }
  var tool = pfmDraw.tool;
  if(_isSelTool(tool)){ selUp(e); refreshProductPreview(); return; }
  /* 2026-09-20 第 1 批：防抖收笔补偿 —— 平滑点落在手指后面，补画最后一段到真实终点，
     否则笔画会比手指短一截（急收笔时最明显）。 */
  if(_stabVal()>0 && pfmDraw.sx!=null && tool!=='spray' && (isBrushTool(tool)||tool==='eraser')){
    var _cx=pfmDraw.sx, _cy=pfmDraw.sy;
    if(Math.abs(_cx-pfmDraw.lastX)>0.5 || Math.abs(_cy-pfmDraw.lastY)>0.5){
      if(tool==='eraser'){ pfmDrawCtx.globalCompositeOperation='destination-out'; pfmDrawCtx.lineWidth=_eraseW(); }
      var _bcmp = _bcfg(tool);
      if(_bcmp && _bcmp.ink){
        /* 2026-10-01（甲·v7）：毛笔的收笔补偿 = 把折线补到真实终点再整笔重画
           （v1 这里落默认分支 ⇒ 收笔一个大圆盘，实拍抓到）。 */
        if(!pfmDraw.inkPts) pfmDraw.inkPts = [];
        pfmDraw.inkPts.push({ x: pfmDraw.lastX, y: pfmDraw.lastY });
        _inkRender();
      } else if(_bcmp && _bcmp.bristle){
        /* 2026-09-30（乙·第三批）：油画笔的补偿段也必须走毛须 ——
           否则收笔处会补出一条**实心带**，整笔的条纹在末尾断掉。 */
        _bristleStroke(_cx, _cy, pfmDraw.lastX, pfmDraw.lastY, _bcmp);
      } else {
        pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(_cx,_cy);
        pfmDrawCtx.lineTo(pfmDraw.lastX, pfmDraw.lastY); pfmDrawCtx.stroke();
        _symStroke(_cx,_cy,pfmDraw.lastX,pfmDraw.lastY);
      }
      if(tool==='eraser') pfmDrawCtx.globalCompositeOperation='source-over';
    }
    pfmDraw.sx=null; pfmDraw.sy=null;
  }
  /* 2026-10-01（乙）：整笔累积类抬笔 —— 用真实终点重画一次（末点跟手，收笔才落在手停的位置）。 */
  if(pfmDraw.strPts && _bcfg(tool) && _bcfg(tool).acc){
    /* 🔴🔴 2026-10-02（丙·返修）：**抬笔这一帧必须整幅恢复**（把 `strBox` 置 null ⇒
       `_strokeRestore()` 走 `_snapRestore(null)` = 全画布还原）。
       原因（逐帧实测 `_diag_frames.js`）：拖动期间 `dark=0` 完全干净，
       **只有抬笔那一下冒出 1702 个纯黑像素**（bbox 从 560~640 突变成 532~667）——
       收笔帧的几何与拖动帧不同（末点=最后一帧已 push 过的同一坐标 ⇒ 法线塌陷），
       画出来的范围**超出上一帧的脏矩形** ⇒ 超出的部分擦不到、永久留在画布上。
       抬笔只发生一次，整幅还原的代价可忽略（比按面积漏擦安全得多）。 */
    pfmDraw.strBox = null;
    _strokeRender();
    pfmDraw.strPts = null;
    pfmDraw.strBox = null;
  }
  /* 2026-10-01（丙②③）：水彩 / 霓虹抬笔 —— 用真实终点再整笔重画一次。
     🔴 **不能**用 `pfmDraw.isDrawing` 做守卫：drawMouseUp 在更靠前处就把它置成 false 了，
        加了守卫这段永远不会执行（水彩/霓虹的收尾重画会静默失效）。 */
  if(tool==='water' || tool==='neon' || tool==='comet'){
    if(tool==='water'){ if(pfmDraw.waterPts){ pfmDraw.waterPts.push({x:pfmDraw.lastX,y:pfmDraw.lastY}); _waterRender(); } }
    else if(tool==='neon'){ if(pfmDraw.neonPts){ pfmDraw.neonPts.push({x:pfmDraw.lastX,y:pfmDraw.lastY}); _neonRender(); } }
    else { if(pfmDraw.cometPts){ pfmDraw.cometPts.push({x:pfmDraw.lastX,y:pfmDraw.lastY}); _cometRender(); } }
  }
  /* 2026-10-01（甲·v7）：毛笔抬笔 —— 用真实终点再整笔重画一次，收锋才落到手上停的位置。 */
  var _inkC = _bcfg(tool);
  if(_inkC && _inkC.ink && pfmDraw.inkPts && pfmDraw.inkPts.length > 1){
    pfmDraw.inkPts.push({ x: pfmDraw.lastX, y: pfmDraw.lastY });
    _inkRender();
  }
  if(isBrushTool(tool)||tool==='spray'||tool==='stamp'){
    pfmDrawCtx.closePath();
    pushUndo();
  } else if(tool==='liquify'){
    /* 丙-2：整笔液化结束才入一次撤销栈（与 smudge 同口径） */
    pushUndo();
    refreshProductPreview();
    pfmDraw.liqPrev = null;
  } else if(tool==='particles'){
    pushUndo();
    refreshProductPreview();
    pfmDraw.partPrev = null;
  } else if(tool==='filtbrush'){
    pushUndo();
    refreshProductPreview();
    pfmDraw.filtPrev = null;
  } else if(tool==='smudge'){
    /* 2026-09-20 第 2 批：整笔涂抹结束才入一次撤销栈（中途每帧都入会撑爆预算） */
    pfmDrawCtx.closePath();
    pushUndo();
    pfmDraw.smudgePrev = null;
  } else if(tool==='mixer'){
    /* 同 smudge：整笔只入一次撤销栈。 */
    pfmDrawCtx.closePath();
    pushUndo();
    pfmDraw.mixPrev = null;
  } else if(tool==='fill' && pfmDraw.isGradient && pfmDraw.gradStart){
    /* 2026-09-20 第 2 批：按拖拽方向填充 —— 拖得太短（<6px）视为单击 ⇒ 退回旧的垂直渐变 */
    var gs2 = pfmDraw.gradStart;
    var _gdx = pfmDraw.lastX - gs2.x, _gdy = pfmDraw.lastY - gs2.y;
    /* 拖得太短（<6px）视为单击 ⇒ 退回整幅垂直渐变（旧行为） */
    var _far = Math.sqrt(_gdx*_gdx + _gdy*_gdy) >= 6;
    pfmDrawCtx.putImageData(pfmDraw.snapshot,0,0);   /* 先擦掉虚线预览，后面读的是当前像素 */
    floodFill(gs2.x, gs2.y, null, _far ? {x1:gs2.x, y1:gs2.y, x2:pfmDraw.lastX, y2:pfmDraw.lastY} : null);
    pushUndo();
    pfmDraw.gradStart = null;
  /* 2026-09-21 第 5 批：形状落笔的终点必须与**预览**用同一套约束（吸附 + Shift 等比 + 轴吸附），
     否则鼠标在画布外松手 / 浏览器丢弃末段 mousemove 时，落下去的会与看到的不一致。
     坐标优先取 mouseup 事件自己带的（第 4 批踩过：lastX 会落空），与选区拖动同法。 */
  } else if(_shapeFamily(tool)){
    /* 2026-09-21 第 6 批：Path 也纳入约束链（A2）。
       🔴 Path 的 Shift **不生效** —— 曲线没有「等比/45°」的意义；
         只走它的网格吸附 + 对称轴吸附（`_shapeEnd` 内部对 path 会跳过 Shift，
         见 `_isShapeTool` 不含 path）。 */
    var _lep=null;
    if(e){ var _pt=(e.changedTouches&&e.changedTouches[0])?e.changedTouches[0]:e;
      if(_pt&&_pt.clientX!=null){ _lep=_shapeEnd(getDrawPos(_pt).x, getDrawPos(_pt).y, !!e.shiftKey, !!e.altKey); } }
    if(!_lep) _lep=_shapeEnd(pfmDraw.lastX, pfmDraw.lastY, !!pfmDraw.lastShift, !!pfmDraw.lastAlt);
    pfmDraw.lastX=_lep.x; pfmDraw.lastY=_lep.y;
    pfmDrawCtx.putImageData(pfmDraw.snapshot,0,0);
    applyDrawStyle();
    if(tool==='path'){
      /* 🔴 2026-10-04（甲·Path 曲线修复）：**落笔用与预览同一份控制点算法**（`_pathCtrl`，唯一实现）
         —— 否则会出现"看到的是弧、落下去是直线"的不一致（本项目形状段踩过同款坑）。
         端点已约束（吸附 + 轴吸附），轨迹里的点也是约束后的 ⇒ 两者同源。 */
      var _p0=pfmDraw.startX, _p1=pfmDraw.startY;
      var _cpf=_pathCtrl(_lep.x, _lep.y), _cpx=_cpf.x, _cpy=_cpf.y;
      pfmDraw.pathPts=[{x:_cpx,y:_cpy},{x:_lep.x,y:_lep.y}];
      _paintPath(_p0,_p1,_cpx,_cpy,_lep.x,_lep.y);
      _paintPathMirrors(_p0,_p1,_cpx,_cpy,_lep.x,_lep.y);
    } else {
      _paintShape(tool, pfmDraw.startX, pfmDraw.startY, _lep.x, _lep.y);
      _paintShapeMirrors(tool, pfmDraw.startX, pfmDraw.startY, _lep.x, _lep.y);
    }
    pushUndo();
  } else if(tool==='spiro'){
    /* 2026-10-01（丙④）：抬笔定格 —— **先擦掉预览版**再画最终版。
       拖动时每一帧都画过同一参数（lastX 与 pos 相同）⇒ 不擦就叠了两遍、颜色更深。 */
    if(pfmDraw.snapshot) pfmDrawCtx.putImageData(pfmDraw.snapshot, 0, 0);
    var dx2 = pfmDraw.lastX - pfmDraw.startX, dy2 = pfmDraw.lastY - pfmDraw.startY;
    var rad = Math.sqrt(dx2*dx2 + dy2*dy2);
    if(rad > 3) drawSpiro(pfmDraw.startX, pfmDraw.startY, rad);
    pushUndo();
  }
  // Reset style
  pfmDrawCtx.globalAlpha = 1;
  /* 2026-09-21 第 7 批：混合模式**收笔即复位**。
     🔴 必须复位 —— 模式会遗留在 ctx 上，污染后续的 `putImageData`（预览擦除）、
        选区浮动层、以及紧接着切到橡皮时的 destination-out 语义。
     （`putImageData` 本身忽略 composite，但它之后的 `fill/stroke` 会受影响。） */
  pfmDrawCtx.globalCompositeOperation = 'source-over';
  /* 2026-10-04（乙批）：绘制收尾 ⇒ 撤掉选区裁剪（与落笔的 `_selClipBegin` 配对）。
     ⚠️ 必须放在**所有绘制之后**（收笔补偿 / 整笔重画 / 形状落笔都在上面）—— 否则收笔那一段不被裁剪。 */
  _selClipEnd();
  /* 2026-10-04（丙批）：虚线状态兜底复位（与 globalAlpha / composite 同一收口处）。
     正常路径下 `_paintShape`/`_paintPath` 已清；这里是「万一有分支提前返回」的第二道保险。 */
  pfmDrawCtx.setLineDash([]);
  refreshProductPreview();
}

// 2026-09-04: 画板缩放 —— 滚轮/双指捏合缩放、Ctrl拖或双指拖平移、双击复位；单指绘制不变。
// getDrawPos 用 getBoundingClientRect 比例换算 → 视觉放大后坐标仍映射 600 逻辑像素（免疫 transform）。
var pfmDrawZoom={s:1,tx:0,ty:0};
/* ===== 2026-09-26（用户报「拖动不丝滑」）：平移/缩放热路径三条性能规矩 =====
   ① **rAF 合并**（`_zoomSchedule()`）：每帧最多施加一次。原来每个 mousemove/touchmove 都跑完整
      同步链，高回报率鼠标一秒能触发几百次 ⇒ 主线程被样式重算塞满，手感发涩。
   ② **写前比对**（`_ss`/`_sc`/`_sp`）：值没变就不写 —— 重复写同一个值同样会触发样式重算。
      实测（1920×1200、200 步快速拖）改前 **RecalcStyleCount 675 / ScriptDuration 40.9ms**。
      平移时几何量、对称百分比、classList 全都没变 ⇒ 每帧只剩 4 次 transform 写入。
   ③ **几何量一帧只读一次**（`_cvGeo()`）：`offsetLeft/Top/Width/Height` 原来被 4 个同步函数
      各自读一遍；`_applyDrawSize()` 会把它置空强制重测。 */
function _ss(el, prop, val){ if(el && el.style[prop] !== val) el.style[prop] = val; }
function _sc(el, cls, on){ if(el && el.classList.contains(cls) !== !!on) el.classList.toggle(cls, !!on); }
/* 🔴 2026-09-26 修正：CSSStyleDeclaration 上读自定义属性是 `getPropertyValue`（不是 `getProperty`）。
   写错会抛 `TypeError` ⇒ `_symUISync()` 在写完对称拖拽层后中断 ⇒ **Apply 后面的
   `_selLayerSync / _gridSync / selHandlesSync` 全部不执行**（网格不跟着缩放的真相）。
   由 `verify_gridzoom.js` 的「画布 == 网格」断言抓到 —— 典型"新增行抛异常打断调用方"。 */
function _sp(el, prop, val){ if(el && el.style.getPropertyValue(prop) !== val) el.style.setProperty(prop, val); }
function _cvGeo(){
  var g = pfmDraw._geo;
  if(!g || !g.w){ var c=pfmDrawCanvas; g = pfmDraw._geo = { left:c.offsetLeft, top:c.offsetTop, w:c.offsetWidth, h:c.offsetHeight }; }
  return g;
}
var pfmDrawRAF = 0;
function _zoomSchedule(){
  if(pfmDrawRAF) return;
  var rq = window.requestAnimationFrame || function(f){ return setTimeout(f, 16); };
  pfmDrawRAF = rq(function(){ pfmDrawRAF = 0; pfmDrawZoomApply(); });
}
function pfmDrawZoomApply(){
  var c=pfmDrawCanvas; if(!c) return;
  /* 2026-09-26（乙）：s ≤ 1 就是「原始视图」⇒ 强制归位（s=1 / 平移 0）。这里是**唯一收口**：
     不管哪条路径（滚轮 / 捏合 / Ctrl 平移 / 双指平移）把状态改怪，落到 1.0 就必然与外框严丝合缝。 */
  if(pfmDrawZoom.s<=1.001){ pfmDrawZoom.s=1; pfmDrawZoom.tx=0; pfmDrawZoom.ty=0; }
  /* 乙：平移也夹在「图案始终盖满外框」的范围内（标准看图器做法；transform-origin 是 0 0）
     ⇒ 任何缩放下**框内都不会露出没有画布的区域**（那会"看着能画却画不上"）。 */
  var _gv=_cvGeo(), _zw=_gv.w||0, _zh=_gv.h||0;
  if(_zw && pfmDrawZoom.s>1){
    var _zx=_zw*(pfmDrawZoom.s-1), _zy=_zh*(pfmDrawZoom.s-1);
    if(pfmDrawZoom.tx>0) pfmDrawZoom.tx=0;
    if(pfmDrawZoom.tx< -_zx) pfmDrawZoom.tx=-_zx;
    if(pfmDrawZoom.ty>0) pfmDrawZoom.ty=0;
    if(pfmDrawZoom.ty< -_zy) pfmDrawZoom.ty=-_zy;
  }
  var _tf='translate('+pfmDrawZoom.tx+'px,'+pfmDrawZoom.ty+'px) scale('+pfmDrawZoom.s+')';
  _ss(c,'transform',_tf);
  _zoomBtnSync();   /* 复位按钮只在缩放中（s>1）出现 */
  /* 2026-09-25（3 层）：两张图层画布 + 参考垫层必须与主画布**同一 transform**，
     否则缩放/平移时三层会错位（它们尺寸相同、原点相同 ⇒ 复制同一串即可）。
     🔴 2026-09-26（用户裁决 乙）：**棋盘格垫层（板面 / 外框）刻意不进这份名单** ——
        外框恒定不动，缩放**只缩放里面的图案**（画布 + 三图层 + 网格 + 对称/选区覆盖层），
        超出外框的部分由 wrap 的 `clip-path` 裁掉（见 `_applyDrawSize` 末尾）。
        ⇒ 任何缩放下「框内处处是绘画区」，不会出现"框比图案大、边上画不上"的空白。
        ❌ 别再把 `pfmDrawChecker` 加回来：那会让外框跟着缩放、框外露一条空白（09-26 用户报过）。 */
  var _mz = ['pfmLayerBase','pfmLayerLine','pfmDrawRefBack'];
  for(var _zi=0;_zi<_mz.length;_zi++){
    var _ze = document.getElementById(_mz[_zi]);
    if(_ze) _ss(_ze,'transform',_tf);
  }
  _symUISync();   /* 2026-09-20: 对称轴覆盖层跟随画板 transform */
  _selLayerSync();   /* 2026-09-20 第 2 批 b：选区蚂蚁线覆盖层同步 */
  _gridSync();       /* 2026-09-20 第 3 批：网格覆盖层同步 */
  selHandlesSync();  /* 2026-09-21 第 4 批：手柄随画布 transform 同步 */
  _textSync();       /* 2026-10-01（甲）：浮动文字预览层 + 框随画布 transform / 缩放同步 */
}
function pfmDrawZoomReset(){ pfmDrawZoom.s=1; pfmDrawZoom.tx=0; pfmDrawZoom.ty=0; pfmDrawZoomApply(); }
/* 2026-09-26（乙）+（用户改口：双击容易出错 ⇒ 改按钮）：复位按钮 `#pfmDrawZoomReset`。
   🔴 2026-09-29（用户裁决 2，「长驻，不可用就灰」）：**覆盖**上面那条「只在缩放中（s>1）出现」——
      现在**永远显示**；视图已是默认（缩放 1.0 且未平移）⇒ **禁用 + 置灰**（"不可用必须看得见"）。
      配套：CSS `#pfmDrawZoomReset` 已由 display:none 改为常显；禁用观感复用 `.pfm-dtool:disabled`。 */
function _zoomBtnSync(){
  var b=document.getElementById('pfmDrawZoomReset'); if(!b) return;
  var d=(pfmDrawZoom.s<=1.001 && !pfmDrawZoom.tx && !pfmDrawZoom.ty);
  if(b.disabled!==d) b.disabled=d;
  /* 老行为（.on 控制显隐）已废 —— 清掉历史残留，避免老 CSS 把它藏起来 */
  if(b.classList.contains('on')) b.classList.remove('on');
}
function pfmDrawZoomAt(vx,vy,f){
  if(!pfmDrawCanvas) return;
  var z=pfmDrawZoom;
  /* 2026-09-26（乙）：缩放下限 = **1.0（整幅适应外框）**。再往下缩图案就比外框小 ⇒
     框内会露出没有画布的区域（"看着能画却画不上"）。上限仍 3.0（放大看细节，靠 clip 裁切 + 平移）。 */
  var ns=Math.max(1,Math.min(3,z.s*(f||1)));
  if(Math.abs(ns-z.s)<0.001) return;
  z.tx=z.tx - vx*(ns-z.s);
  z.ty=z.ty - vy*(ns-z.s);
  z.s=ns;
  _zoomSchedule();   /* 2026-09-26：改为每帧最多施加一次（滚轮/捏合可高频触发） */
}
var pfmDrawPan={on:false,lx:0,ly:0};
/* 2026-09-26：`fx/fy` = 两指中点（**屏幕坐标**，用于平移 1:1）；
   `mid` = 同一个点换算到画布局部（**只**给缩放锚点用，别用它算平移 —— 会反馈）。 */
var pfmDrawT={pinch:false,d0:1,s0:1,fx:null,fy:null,mid:{x:0,y:0}};
function drawTouchStart(e){
  e.preventDefault();
  var ts=e.touches;
  if(ts.length===1){
    pfmDrawT.pinch=false;
    pfmDraw.isDrawing=false;
    drawMouseDown({clientX:ts[0].clientX,clientY:ts[0].clientY,button:0});
  } else if(ts.length>=2){
    pfmDraw.isDrawing=false;
    if(pfmDraw.sprayInterval){ clearInterval(pfmDraw.sprayInterval); pfmDraw.sprayInterval=null; }
    if(pfmDraw.airTimer){ clearInterval(pfmDraw.airTimer); pfmDraw.airTimer=null; }   /* 丙②：双指手势开始时一并清 */
    pfmDrawT.pinch=true;
    pfmDrawT.d0=Math.max(1,Math.hypot(ts[1].clientX-ts[0].clientX, ts[1].clientY-ts[0].clientY));
    pfmDrawT.s0=pfmDrawZoom.s;
    var r=pfmDrawCanvas.getBoundingClientRect();
    pfmDrawT.fx=(ts[0].clientX+ts[1].clientX)/2;      /* 屏幕坐标：平移 1:1 */
    pfmDrawT.fy=(ts[0].clientY+ts[1].clientY)/2;
    pfmDrawT.mid.x=pfmDrawT.fx-r.left;                /* 画布局部：仅缩放锚点 */
    pfmDrawT.mid.y=pfmDrawT.fy-r.top;
  }
}
function drawTouchMove(e){
  e.preventDefault();
  var ts=e.touches;
  if(ts.length>=2 && pfmDrawT.pinch){
    var d=Math.max(1,Math.hypot(ts[1].clientX-ts[0].clientX, ts[1].clientY-ts[0].clientY));
    var r=pfmDrawCanvas.getBoundingClientRect();
    var fx=(ts[0].clientX+ts[1].clientX)/2, fy=(ts[0].clientY+ts[1].clientY)/2;
    var mx=fx-r.left, my=fy-r.top;
    /* 1) 平移（2026-09-26 乙 · 用户报「缺少移动画布」）：
       🔴 增量必须用**屏幕坐标** fx/fy —— 原来用画布局部坐标 mx/my，而 mx 里含 `-r.left`，
          而 r.left 又随我们自己的平移变化 ⇒ 形成反馈：实测把 90px 手指位移衰减成约一半
          （数学上 dtx 交替为 dF / 0 ⇒ 长期只有 50% 位移）。
       🔴 **必须在这里显式 `pfmDrawZoomApply()`**（见下面分支）：原来施加平移后紧接着调
          `pfmDrawZoomAt()`，而两指等距时 ZoomAt 里 `|ns-s|<0.001 ⇒ return` ⇒ **Apply 从不执行**
          ⇒ 平移状态改了、DOM 没更新 ⇒ 触屏"纯平移"永久无效
          （实测铁证：JS 里 tx 已累到 −224.5，`cv.style.transform` 仍是旧的 −134.5）。 */
    if(pfmDrawT.fx!=null){
      pfmDrawZoom.tx += (fx-pfmDrawT.fx);
      pfmDrawZoom.ty += (fy-pfmDrawT.fy);
    }
    pfmDrawT.fx=fx; pfmDrawT.fy=fy;
    /* 2) 缩放：两指距离**明显**变化（≥6px 死区）才动缩放 ⇒ 纯平移不会被顺带缩放
          （修前实测：想平移 90px，结果 s 从 1.574 掉到 1.124 —— 白白缩了 28%）。 */
    if(Math.abs(d-pfmDrawT.d0)>=6){
      var target=Math.max(1,Math.min(3,pfmDrawT.s0*d/pfmDrawT.d0));   /* 下限 1.0（见 pfmDrawZoomAt） */
      if(Math.abs(target-pfmDrawZoom.s)>0.001){
        pfmDrawZoomAt(mx,my,target/pfmDrawZoom.s);
        return;                    /* ZoomAt 内部已 Apply（含本帧平移增量） */
      }
    }
    _zoomSchedule();               /* 纯平移路径：必须显式施加（这是修好平移的关键一行）+ rAF 合并 */
    return;
  }
  if(ts.length===1 && !pfmDrawT.pinch){
    drawMouseMove({clientX:ts[0].clientX,clientY:ts[0].clientY});
  }
}
function drawTouchEnd(e){
  var ts=e.touches;
  if(!ts || ts.length<2) pfmDrawT.pinch=false;
  drawMouseUp(e);
}
function pfmDrawWheel(e){
  e.preventDefault();
  var r=pfmDrawCanvas.getBoundingClientRect();
  pfmDrawZoomAt(e.clientX-r.left, e.clientY-r.top, e.deltaY<0?1.12:1/1.12);
}

function getDrawPos(e){
  var rect = pfmDrawCanvas.getBoundingClientRect();
  var scaleX = pfmDrawCanvas.width / rect.width;
  var scaleY = pfmDrawCanvas.height / rect.height;
  return {
    x: (e.clientX - rect.left) * scaleX,
    y: (e.clientY - rect.top) * scaleY
  };
}

/* ===== 2026-09-30（用户裁决 乙）：**参数表驱动笔刷** =====
   新增 4 支「纸笔质感」笔刷（对照 Win11 画图补齐）：marker 记号笔 · pencil 普通铅笔 ·
   calli 毛笔 · water 水彩画笔。
   🔴 一律走**同一张表**（表 = 唯一真源）：不写第二套渲染分支，每支笔的差异 = 表里几个数。
      w       笔宽倍数（× brushSize）
      a       每段透明度（再乘"笔刷不透明度"滑杆）
      cap     线帽：round（默认）/ butt（平头 ⇒ 记号笔）/ square
      minW    最小线宽（细笔防消失）
      noSpeed 关掉「快→细」速度感应（记号笔 / 铅笔要**等宽**）
      taper   速度锥度下限（毛笔：慢粗快细，比默认 0.35 更狠）
      jitter  端点随机抖动比例（铅笔 / 蜡笔的纸纹感）
      dry     随机断段比例（水彩的干刷、边缘不规则）
      tex / spread / count / dot / wet —— 见下方 air / mixer 两行注释（2026-09-30 第二批）
      chisel  斜切笔尖的固定倾角（度）⇒ 笔宽 = w×|cos(笔画方向 − 倾角)|（毛笔 · 第三批）
      bristle 毛须**间距**（画布 px，不是根数 —— 间距恒定才不会大笔变瓦楞）·
      bjitter 毛须**逐根粗细**的波动幅度（0.35 ⇒ 0.65~1.35 × 间距，细的地方就是缝）（油画笔 · 第三批）
   ⚠️ 已有笔刷的取值必须与改前**逐项相同**（brush 1/1 · ink 1.2/1 · crayon 1/0.6 · soft 3/0.15）
      ⇒ 零回归；其余（spiro/web/neon/rainbow/comet/pixel/spray/stamp）保持 a=1。 */
/* ★ 2026-10-03（用户裁决 **甲·浓度**）：**把过淡的 5 支笔的 `a` 抬回业界口径**。
   改前 12 支笔实拍平均不透明度（`_diag_allbrushes.js`，同色 #111111 / 同手势 / 满滑杆）：
     ink .985 · pixel .982 · oil .815 · calli .738 · marker .687 · **brush .634（基准）** ·
     water .435 · crayon .351 · air .275 · pencil .231 · mixer .18 · soft .121
   —— 后 5 支用户直接读成「颜色太淡」。对照 PS / Procreate / Krita / CSP / Painter：
   它们的笔刷**默认不透明度都是 100%**，「淡」是靠 flow 叠加 / 纹理 / 混合模式做出来的，
   **不是压 alpha**。而本画板 `cfg.a` 是**硬上限**、笔刷不透明度滑杆是**再乘**它
   ⇒ 原来 soft 把滑杆拉满也只有 15%，用户自己救不回来。
   ⇒ 本轮按比例抬这 5 支（**滑杆机制不变**）：soft .15→**.45** · pencil .45→**.75** ·
     crayon .6→**.85** · water .20→**.38** · air .20→**.30**。
   ⚠️ mixer 的 .18 **不抬** —— 它是**涂抹/混色**笔，`faint` 是「源与目标都空白时的淡色」
     设计值（见其自身注释），不是浓度缺陷。
   ⚠️ 本条**作废**表内外关于 `a` 的旧注释：上面「已有笔刷取值必须与改前逐项相同」那条是
     **2026-09-30 迁移**时的一次性约束（为了迁移零回归），本轮是用户裁决要改；
     water 行那句「a 0.10→0.20」同理，现值以本行为准。
   ⚠️ 未改的仍在表外：`mixer` 的感知混色（`perc`）与「同笔内重叠加深」是独立议题，本轮不动。 */
var BRUSH_CFG = {
  /* 🔴 2026-10-01（乙）：`acc:1` = 走**整笔累积渲染**（`_strokeRender`，见下方长注释）；
     `load` = **墨量随速度**的强度（拖快变淡 + 飞白）：
       画笔 0.35 · 铅笔 0.55（素描手感，最需要）· 蜡笔 0.45 · 柔笔 0.30
       记号笔 / 硬笔 / 像素 **不设 load** —— 马克笔与针管笔是**恒定出墨**，变淡反而不真。 */
  /* 🔴 2026-10-02（丙·返修§6）：`tIn`/`tOut` = 起笔/收笔的**宽度系数**（1 = 不收），
     `tLen` = 收细段长度（**笔宽倍**）。取值对照 Win11 画图那 9 支笔的笔锋强弱。 */
  brush:  { w:1,    a:1,    acc:1, load:0.35, charge:55, tIn:0.35, tOut:0.30, tLen:4.0 },
  /* 2026-10-01（丙①）：**硬笔尖** —— 认证实测它与 Brush 的距离只有 0.060（10 维里 9 维全同、
     仅粗 1.2×）⇒ 肉眼同款。真钢/针管笔的特征是：**等宽**（不随速度变细）、**平头**、落笔有**顿点**。
     noSpeed 关掉速度锥度 · cap:butt 平头 · nib 让落笔印变成一个方顿点。 */
  ink:    { w:1.25, a:1,    minW:2, noSpeed:1, cap:'butt', nib:1, acc:1 },
  /* 2026-10-02（丙⑥）：`streak:1` = 叠一层**沿运笔方向的擦痕**（`_accStreak`）——
     原来只有各向同性的 `tex` 噪声，`_verify_real.js` D1 实测横竖拖各向异性 1.04/1.02。 */
  /* `fxMin` = 本支笔**特征元素的最小尺寸**（CSS px，见 `_fxMin`）：擦痕线宽 / 毛须缝 / 洇散点半径 ……
     没有它时，默认笔宽 4 会把毛须缝、擦痕、洇散点、墨丝全部压成**亚像素**（特性直接消失）。
     默认 0.9；air 的"点"给 0.8（雾点本来就小，0.8 已能读出颗粒）。 */
  crayon: { w:1,    a:0.85, jitter:0.30, tex:0.40, acc:1, load:0.45, streak:1, fxMin:0.9, charge:50, tIn:0.55, tOut:0.50, tLen:3.5 },
  /* 🔴 soft 用 **方头**：它的笔宽是 3×，圆头端帽半径 = 1.5×笔宽（很大），
     在 a=0.15 的低透明度下实拍成一个**深色大圆**（_shot_acc.js 抓到；关掉端帽即消失）。
     柔焦/气笔的端头本来就该是方的，方头也更贴真实。 */
  /* 🔴 2026-10-01（乙）：**笔宽倍率全线收敛到 0.7~1.8**。`w` 是「同一滑杆值下这支笔画多宽」的倍率，
     历史上为了让每支笔「看起来对」逐个加，从没统一过 ⇒ 实测跨度 **0.35~3.0（8.6 倍）**，
     同一个滑杆值下 soft 画出来是 pencil 的 5.5 倍粗，用户直接感知为「不对劲」。
     收敛原则：**保留每支笔的性格（柔焦/水彩/马克/油画该宽），只砍掉极端值**。 */
  /* 🔴 2026-10-02（丙③）：加 **`noSpeed:1`** —— 柔焦笔（PS Soft Round / Krita 柔边）是**等宽**的，
     不随速度变细。原来它走速度锥度、`taper` 下限 0.35 ⇒ 视觉成「哑铃」：
     实测（笔宽 24）两端列高 86 / 72 而 p50 只有 31（`leftSpike 2.77`）。 */
  /* 🔴🔴 2026-10-04（乙）：加 **`softEdge:6`** —— soft 原来走 `_strokeRender` 的通用路径
     （整条轮廓**一次 fill**、同一个 alpha 铺满）⇒ 边缘与中心一样实，实拍就是一个**硬边色块**，
     与 PS Soft Round / Krita 柔边圆笔、以及本笔的名字「柔焦」都不符。
     `softEdge` = **递减宽度 stroke 的层数**（见 `_accSoftStroke`）。 */
  soft:   { w:1.8,  a:0.45, acc:1, load:0.30, cap:'butt', noSpeed:1, softEdge:6 },
  /* 🔴 2026-10-02（丙⑧）：加 `load:0.25` —— `_cert_brushes.js` 实测 `Pen ~ Marker` 的归一化距离
     只有 **0.094**（10 维里 9 维全同：颗粒/断口/变厚/端头/方向都是 0），只有透明度能分。
     真马克笔**快画会变淡**（颜料跟不上）⇒ 加墨量随速度后，`innerStd`/`alpha` 沿长度起伏
     ⇒ 与恒定浓黑的 Pen 在"内部结构"维度上分开。（`noSpeed` 只管**宽度**，与 `load` 不冲突。） */
  /* 🔴🔴 2026-10-04（乙）：**删掉 `tIn/tOut`**（= 1）—— 真马克笔是**等宽平头**（chisel tip 竖直压下去
     写出来的就是等宽矩形），而 0.75/0.70 的行程锥度把两端收成**斜切楔形**（用户点名）。
     顺带：本笔的 `cap:'butt'` 已经是方头 ⇒ 删掉锥度后两端就是干净的**等宽平头**。
     ✅ 与 `_verify_brushes` 的 D9（brush 的 thickVar > marker）同向：marker 更"等宽"更稳。 */
  marker: { w:1.6,  a:0.85, cap:'butt', noSpeed:1, acc:1, load:0.25 },
  /* 🔴 2026-10-04（戊·甲）：铅笔覆盖率 0.45 / 画图 0.22（同一暗度下我更密）。
     改：`a` 0.75→0.55（更淡）＋ 叠 `streak:1`（沿运笔方向的擦痕 = 素描排线感，累积路径的真旋钮）。
     🚫 不用 `tex`：pencil 是 `acc:1`，累积路径**不读 tex**（:3322 只服务非累积路径）⇒ 加了是死开关。 */
  pencil: { w:0.7,  a:0.55, minW:1, noSpeed:1, jitter:0.55, acc:1, streak:1, load:0.55, fxMin:0.9, charge:38, tIn:0.40, tOut:0.35, tLen:4.0 },
  /* 2026-10-01（甲·v7）：**毛笔**对照用户给的真笔迹重做（整笔累积渲染）。
     ink  启用「毛笔渲染」，与 bristle 互斥
     hair 墨丝**间距**（画布 px，2.6 ⇒ 细密才像「毛」）
     wet  墨色浓淡的幅度（每根丝相位/浓淡不同 ⇒ 丝间不同步 = 墨丝感）
     a    0.92：真毛笔透出纸色，不是实心黑 */
  calli:  { w:1.4,  a:0.92, chisel:45, taper:0.22, ink:1, hair:2.6, wet:0.5, fxMin:0.9, charge:42 },
  /* 2026-10-01（丙②）：水彩 —— 半透明 + **湿边洇散** + 断墨。
     a 0.10→0.20：原值连「是水彩」都看不出；洇散由 `_waterRender` 的毛边点负责（feather）。
     dry 0.28→0.20：洇散毛边自己就带不规则，断墨不必那么密。 */
  /* 🔴 2026-10-04（戊·甲）：水彩覆盖率 0.84 / 画图 0.46。病根：`dry`（主体断墨概率）只有 0.20
     ⇒ 主体几乎连续；`a` 0.38 偏高 ⇒ 一遍就实。改：dry 0.20→**0.45**、a 0.38→**0.26**。⚠️ 覆盖率主要由**洇散点**（每 4px 撒 2 点 × 两侧 ±0.5~1.07 笔宽）决定，`dry` 只管主体断口
     ⇒ 再往上加覆盖率几乎不动（0.708 vs 0.692）⇒ 停在 0.45。
     🔴 `a` 为什么是 0.26 而不是 0.30：`dry` 提高会把**淡主体**删掉、只剩较浓的洇散点
        ⇒ 平均 alpha 反而**上升**（实测 0.213→0.565），撞 `_verify_brushes` **D4**
        「水彩明显比画笔透明」（阈值 brush×0.9=0.564，实测 0.565 **差 0.001 挂**）。降到 0.26 后通过。
     ⚠️ 湿边 `feather` 不动（水彩特征）；`a` 降低同时满足 `_verify_brushes` D4「水彩明显比画笔透明」。 */
  /* 🔴 2026-10-04（乙）：`dry` 0.20 → **0.32**（主体断口更明显 ⇒ 破"实心灰块"感）。 */
  water:  { w:1.6,  a:0.38, dry:0.32, feather:0.5, fxMin:0.9, tIn:0.45, tOut:0.40, tLen:4.5 },
  spiro:  { w:1,    a:1 },
  web:    { w:1,    a:1 },
  neon:   { w:1,    a:1 },
  rainbow:{ w:1,    a:1 },
  comet:  { w:1,    a:1 },
  /* 🔴🔴 2026-10-02（丙⑨）：**补上 `pixel:1`** —— `_strokeRender` 里判断的是 `cfg.pixel`，
     而这里从来**没设过**这个字段 ⇒ `_accPixel`（方块像素）一直是**死代码**，
     Pixel 笔走的是普通轮廓 fill ⇒ **它根本不是像素笔**（实拍：圆头平滑带，无方块）。
     ⚠️ 这是"关掉的开关"类缺陷：`grep cfg.pixel` 只有一处读取、零处写入。 */
  pixel:  { w:1,    a:1,    acc:1, noSpeed:1, pixel:1 },
  spray:  { w:1,    a:1 },
  stamp:  { w:1,    a:1 },
  /* ===== 2026-09-30（乙·第二批）：**纹理 / 散布 / 湿边** 三能力的落点 =====
     · tex    纹理强度 0..1 —— 笔迹描边/填充色换成**程序生成的噪声瓦片图案**（不引外部文件）
     · spread 散布半径（× 笔宽；缺省 = 关）· count 每步散点数 · dot 散点半径（× 笔宽）
     · wet    湿边混色比 0..1（仅 mixer 用）
     🔴 给已有笔刷加 `tex` 会**改变观感**（crayon 本来就该有颗粒 —— 上轮对照 Win11 时用户点名的缺口）。 */
  /* 2026-10-01（丙⑤·v2）：喷枪 —— 实拍 v1 画出来是「一串大圆盘」，因为主轴 `w:1.8`
     本身就是一条 ~68 CSS px 的粗带 ⇒ 视觉主体成了粗笔。
     现在：主轴降细降淡 + 高 tex（自身噪声化成「雾芯」），散点点数 ×8、单点半径封顶 4 画布 px
     ⇒ 大笔宽也是**细密雾点**，不是大团块。 */
  /* 🔴 2026-10-01（丙⑤·v3）：主轴再降到 `w:0.35 / a:0.20` —— v2 实拍里主轴仍是
     一条 1.2×笔宽（≈46 CSS px）的带，分步画出来就是「一串半透明大圆盘」。
     真喷枪**没有实心主轴**，只有雾。主轴留极细一条（保证稳定器/对称仍生效，不做假控件），
     视觉主体交给散点。`spread` 保持 1.4（`_verify_brushfx` 的 S2b 要求厚度 ≥2.2× brush）。 */
  /* 🔴 2026-10-01（乙·第二批）：air 也改**整笔累积** ⇒ `acc:1`。
     原来逐段撒点 ⇒ 点数随**段数**变（mousemove 采样率一变，雾的浓淡就变），且主轴折线有段界。
     现在沿**弧长**确定性布点（见 `_accScatter`）⇒ 只与笔迹长度有关。 */
  /* 🔴 2026-10-01（乙·性能）：air **移出 `acc`** —— 它不需要整笔重画（散点画上去就不该变），
     整笔化只会让每帧重画整条笔迹的全部散点（实测 336ms/步、8fps）⇒ 改走增量 `_airScatter`。
     `w` 是**主轴**宽度（不是视觉宽度 —— 雾的铺开由 `spread:1.4` 决定），只微调 0.35→0.45。 */
  /* 🔴 2026-10-01（乙·返修）：`tex` 0.45→**0**。散点笔的每一帧要画几十个小圆，
     而 `tex` 会把 `fillStyle` 换成**纹理 pattern** ⇒ 每个小圆都要采样纹理，
     实测这一步就吃掉 39ms/步（`crayon` 也有 tex，但它每帧只 fill **一次**折线）。
     散点本身就是颗粒，不需要再叠纸纹。 */
  /* 🔴 2026-10-01（乙·返修）：`w` 回到 **0.35** —— 对 air 来说 `w` 是**主轴**（细芯）宽度，
     不是视觉宽度（雾的铺开由 `spread:1.4` 决定）⇒ **它不该参与「笔宽倍率收敛」**。 */
  /* 🔴 2026-10-04（戊·甲·透气度）：实测喷枪覆盖率 0.83 / Win11 画图 **0.09**（差最多的一支）。
     病根：① `count:8` 每步撒 8 点 ⇒ 叠成一条连续雾带（不是"点雾"）；
           ② `spread:1.4` 铺得太窄 ⇒ 同样点数挤在窄带里；
           ③ 主轴 `a:0.30` 自己就是一条 8.5 画布 px 宽的带（散点之外还有主轴）。
     改：count 8→5 · dot 0.14→0.11 · dotMax 4→3（点更细）· spread 1.4→2.4（铺开 1.7×，同点数更稀）
         · a 0.30→**0.24**。⚠️ 试过 0.18/0.10：散点 alpha = `a×0.30×不透明度`，压到 0.10 时**整支笔几乎无墨**
       （实测带宽内最大墨量 <0.25，等于消失）；0.18 尚可但中部仍偏浓。0.24 是「够淡但看得见」的位置。 */
  air:    { w:0.35, a:0.24, spread:2.4, count:5, dot:0.11, dotMax:3, noSpeed:1, fxMin:0.8 },
  /* 🔴 2026-10-02（乙）：`faint` = **源与目标都空白**时铺的淡笔色（alpha 值 0~1）。
     真涂抹笔（PS Smudge / 混色笔）在空白处**不出任何像素** —— 但本画板是**电商定制**
     （多数用户直接在空白产品上作画）⇒ 纯真行为会被当成「Mix 点了没反应」。
     取舍：空白处留 18% 的淡色（看得见、明显比画笔淡），有底色处走真混合。0 = 关闭该行为。 */
  /* `perc:1` = **感知混色**（线性光插值 + 彩度恢复）；0 退回旧的 sRGB 线性插值（会发浑）。
     见 `_memBlit` 的混色段与 `_mixPerceptualInit`。 */
  /* 🔴🔴 2026-10-02（丙·返修§4·甲）：`charge` 机制**已实现但刻意不启用**。
     实测（`_verify_charge.js` M 段，"蓝带 + 红笔横拖"）：逐段红分量 = **100 → 183.7 → 197.5 → 200 → 200**
     —— **递增**，与预期的"颜料耗尽 ⇒ 后段红减少"**相反**。
     原因（架构级、非调参能解）：PS 的笔色（reservoir）与画布色（pickup）是**两口独立的井**；
     而我们的实现里「笔色一旦写进画布就变成画布的一部分」⇒ 拖带会把它**链式**带到后段
     ⇒ `mixA → 0` 只表示"不再**新增**笔色"，**已经染上的颜色不会消失** ⇒ **观感不可辨识**。
     ⇒ 按「观感上不可见的功能 = 不存在的功能」原则**不启用**（`charge` 留空）。
        将来要启用只需给 `mixer` 补 `charge:<笔宽倍>` —— `drawMixer` 里的逻辑已就绪；
        真要做出 PS 那种效果，需要把"笔色"作为**独立状态**追踪（架构改动）。 */
  mixer:  { w:1.3,  a:1,    wet:0.5, faint:0.18, perc:1 },
  /* 2026-09-30（乙·第三批）：**油画笔** —— 对照 Win11 画图刷子清单的最后一块缺口。
     硬毛刷：一笔 = 一排平行毛须（不是一条实心带）⇒ 笔迹里看得见一根根毛。
     `bristle` 是**间距**（画布 px，≈5 CSS px）而不是根数 ⇒ 大笔同样是细毛，不会变成瓦楞纸。
     `bjitter` 让每根毛须的**粗细**波动 ⇒ 细的那几根之间留出缝，缝就是「毛须纹」。
     🔴 `a:1` **不透明**是刻意的：拐弯处相邻两段必然重叠，半透明会叠出深色菱形；
        不透明时重叠处与本体同色、完全不可见（实拍对比后定下的）。
     `tex` 只给画布留一点纸纹颗粒。 */
  /* 🔴 2026-10-01（乙·第二批）：oil 改**整笔累积** ⇒ `acc:1`。
     原来逐段画一排毛须（`_bristleStroke`）—— 接缝虽已修（`oilPrev` 用平滑点），
     但每段仍是**独立一排**，拐弯处相邻两排的毛须横向错位 ⇒ 条纹在弯道处对不齐。
     现在每根毛须是**一条连续折线**（`_accBristle`）⇒ 跟着笔迹弯，且无段界。 */
  /* 🔴 2026-10-01（乙·第三批）：`tex` 0.18→**0.05** —— 1:1 特写（`_oil2_zoom.png`）显示
     笔迹上叠着一层明显的噪声，像砂纸（油画颜料本身不透明、没有纸纹颗粒）。
     条纹的「毛须感」由毛须本身承担，不需要 tex 帮忙。 */
  /* 🔴 2026-10-01（乙）：`w` 2.0→**1.6** —— 但注意 oil 的**视觉宽度** = `w × 0.8`（毛须总铺展），
     所以 1.6 时仍比 `brush` 略宽（≈1.28×），只是不再夸张到 1.6×。 */
  /* 🔴 `fxMin` = **1.8**（不是默认 0.9）：毛须缝两侧都是**不透明**线，抗锯齿会把缝填平 ——
     实测 0.9 CSS（1.7 画布 px）和 1.25 CSS（2.35）两档下 `gaps` 都在 0/1 之间乱跳；
     1.8 CSS ≈ 3.4 画布 px 才稳定留得下"能看见的灰沟"。
     ✅ 大笔宽不受影响：笔宽 30 时 `needStep = 1.8/0.22 = 8.2` ⇒ Kmax=4，与原 K=4 一致。 */
  /* 🔴 2026-10-04（戊·甲）：油画覆盖率 **0.996** / 画图 0.54 —— 缝完全看不出来。两个病根：
     ① 缝里那层「底色带」alpha **写死 0.46** ⇒ 缝永远是 46% 灰（高于判定阈值）⇒ 量出来"满"；
        ⇒ 参数化成 `cfg.baseA`（见 `_accBristle`），此处设 **0.20**。
     ② 毛须根数被 `_kMax = span / max(2.0, fxMin/0.22)` 卡住：`fxMin:1.8` ⇒ 本笔宽下 `K=2`
        ⇒ 整条只有**中间一道缝**，不成纹。`fxMin` 1.8→0.95 ⇒ `K=4`，缝 ≥2 画布 px（≈1 CSS px，可见）。
        `bristle` 9→5（间距）配合 ⇒ 大笔宽下 K 也跟上去（16 封顶）。
     ⚠️ `tex:0.05` 保留但**无效**（累积路径不读 tex，见文件头 ⚠️1）。 */
  /* 🔴 2026-10-04（乙）：`tIn/tOut` 0.45/0.40 → **0.68/0.64** —— 端头聚拢幅度过强，
     配合"底色带也收窄"后才不会形成尖角（见 `_accBristle` 的 `_tpArr` 两处）。 */
  oil:    { w:1.6,  a:1,    bristle:5, bjitter:0.35, tex:0.05, noSpeed:1, acc:1, fxMin:0.95, baseA:0.20, tIn:0.68, tOut:0.64, tLen:4.0 }
};
function _bcfg(t){ return BRUSH_CFG[t] || null; }

/* 2026-09-30（乙·第二批）：纹理瓦片 —— 按「颜色+强度」缓存一张 64×64 噪声瓦片，
   供 `createPattern(tile,'repeat')` 当描边色用 ⇒ 笔迹自带颗粒（纸纹 / 蜡质）。
   🔴 只缓存**瓦片 canvas**；`createPattern` 每次现建 —— pattern 对象与 ctx 绑定，
      画板有 3 个层 canvas（Base/Line/Colour），跨 ctx 复用会出问题。不引任何外部资源。 */
function _texTile(color, amount){
  try{
    var cache = _texTile._c || (_texTile._c = {});
    var key = color + '|' + amount;
    if(cache[key]) return cache[key];
    var N = 64, cv = document.createElement('canvas');
    cv.width = N; cv.height = N;
    var g = cv.getContext('2d');
    var img = g.createImageData(N, N), d = img.data;
    var lo = Math.max(0, 1 - amount);                       /* amount=1 ⇒ 最斑驳 */
    for(var i=0;i<N*N;i++){ d[i*4+3] = (lo + Math.random()*(1-lo)) * 255; }   /* 只填 alpha */
    g.putImageData(img, 0, 0);
    g.globalCompositeOperation = 'source-in';               /* 用噪声 alpha 裁出颜色 */
    g.fillStyle = color;
    g.fillRect(0, 0, N, N);
    g.globalCompositeOperation = 'source-over';
    cache[key] = cv;
    return cv;
  }catch(err){ return null; }
}
/* 散布：在 (cx,cy) 周围撒 `count` 个半径 `dot×笔宽` 的实心点，偏移 ≤ `spread×笔宽`。
   🔴 同步画**镜像点**（走 `_symPts`，与 `_symStroke` 同一套映射）—— 否则对称行会变成"假控件"。 */
function _scatterDots(cx, cy, cfg){
  var bs = pfmDraw.brushSize || 8;
  var rad = Math.max(1, bs * (cfg.spread || 1));
  /* 🔴 2026-10-01（丙⑤）：真实喷枪在**大笔径**下是"撒得更多、点更细"，不是"点更大"。
     原来 `dot = bs×0.26` 与 `n = count` 都跟笔宽无关/线性放大 ⇒ 大笔宽 = 又大又少的**团块**（老遗留）。
     现在：点数随笔宽增长（上限 5×）、单点半径封顶 `dotMax`（默认 2.2 画布 px）。 */
  var dot = Math.max(0.5, Math.min(bs * (cfg.dot || 0.25), cfg.dotMax || 2.2));
  var n = Math.max(1, Math.round((cfg.count || 4) * Math.min(5, Math.max(1, bs / 12))));
  for(var i=0;i<n;i++){
    var ang = Math.random()*Math.PI*2, rr = Math.sqrt(Math.random())*rad;
    var px = cx + Math.cos(ang)*rr, py = cy + Math.sin(ang)*rr;
    pfmDrawCtx.beginPath(); pfmDrawCtx.arc(px, py, dot, 0, Math.PI*2); pfmDrawCtx.fill();
    var mp = _symPts(px, py);
    for(var j=0;j<mp.length;j++){
      pfmDrawCtx.beginPath(); pfmDrawCtx.arc(mp[j].x, mp[j].y, dot, 0, Math.PI*2); pfmDrawCtx.fill();
    }
  }
}

/* 2026-09-30（乙·第三批）：**油画笔的毛须** —— 一段不画实心带，而画 K 根平行细线。
   沿该段**法线**等距铺开（总铺展 ≈ 0.8×笔宽）；毛须**间距恒定**而不是根数恒定：
   `bristle` = 相邻毛须的间距（画布 px，≈5 CSS px）⇒ 大笔也是同样细的毛，不会变成"瓦楞纸"。
   `bjitter` 让每根毛须的**粗细**围绕间距波动（0.65~1.35 × 间距）：
   粗的地方互相盖住（看不出接缝），细的地方自然留出一条缝 —— **那条缝就是"毛须纹"**。
   🔴 为什么用"缝隙"而不是"逐根不同透明度"来造纹（第一版做法，实拍被否）：
      逐根 alpha 会在拐弯处把两段的重叠区叠成**深色菱形**（`_oil_paint.png` 满屏菱形）；
      而"不透明 + 粗细波动留缝"中，重叠区与本体同色 ⇒ 完全看不见，缝仍清晰。
   🔴 段内临时切 `lineCap='butt'`：相邻两段首尾相接，圆帽会在接缝处叠出更深的圆斑
      （实拍抓到"每段中间一道竖纹"）。butt 首尾严丝合缝。
   🔴 镜像复用 `_symStroke`（同一份对称实现）—— 不做第二套，否则对称行会变成"假控件"。
   🔴 线宽读 `ctx.lineWidth`（已由 `noSpeed` 分支钉成 brushSize×w）—— 表仍是唯一真源。 */
function _bristleStroke(x0, y0, x1, y1, cfg){
  var ctx = pfmDrawCtx;
  var w = Math.max(1, ctx.lineWidth || pfmDraw.brushSize || 8);
  var span = w * 0.8;                                     /* 整排毛须的总铺展 */
  var K = Math.max(4, Math.min(16, Math.round(span / Math.max(3, cfg.bristle || 9))));
  var dx = x1 - x0, dy = y1 - y0;
  var len = Math.sqrt(dx*dx + dy*dy);
  if(len < 0.01){ dx = 1; dy = 0; len = 1; }              /* 单点（落笔那一瞬）也要给一排毛 */
  var nx = -dy/len, ny = dx/len;                          /* 单位法线 = 毛须铺开方向 */
  var step = (K > 1) ? span / (K - 1) : span;
  var amp = (cfg.bjitter === undefined) ? 0.35 : cfg.bjitter;
  var jw = pfmDraw.oilW, jd = pfmDraw.oilD;
  if(!jw || jw.length !== K || !jd || jd.length !== K){    /* 每次落笔重掷一组毛须特征 */
    jw = []; jd = [];
    for(var k=0;k<K;k++){
      jw.push(1 - amp * 0.35 + Math.random() * amp * 1.3);
      jd.push((Math.random() - 0.5) * 0.4);                /* 横向偏移：别等距（等距 = 机械感） */
    }
    pfmDraw.oilW = jw; pfmDraw.oilD = jd;
  }
  var keepW = ctx.lineWidth, keepCap = ctx.lineCap;
  ctx.lineCap = 'butt';
  for(var i=0;i<K;i++){
    var off = (i - (K-1)/2) * step + jd[i] * step;
    var ox = nx * off, oy = ny * off;
    ctx.lineWidth = Math.max(0.5, step * jw[i]);
    ctx.beginPath();
    ctx.moveTo(x0+ox, y0+oy);
    ctx.lineTo(x1+ox, y1+oy);
    ctx.stroke();
    _symStroke(x0+ox, y0+oy, x1+ox, y1+oy);
  }
  ctx.lineCap = keepCap;
  ctx.lineWidth = keepW;
}

/* 2026-10-01（甲·v7）：**毛笔整笔渲染** —— 每次 mousemove 从 snapshot 重画整条笔迹。
   为什么必须整笔重画：毛丝的横向偏移 = (i − 中位) × 步距，步距随笔宽变，而笔宽随方向变（chisel EMA）
   ⇒ 逐段画时外侧丝每段整体横移 ⇒ 段间露**砖墙阶梯**（v3/v4 实拍）。整笔重画后每根丝是一条
   **连续折线** ⇒ 没有任何段界痕迹。
   🔴 **不要分块**（v5/v6 沿弧长切 8/16 段各设一次线宽 ⇒ 轮廓 16 级阶梯 + 块间色阶）。
      收锋改成"**毛丝向中线收拢**"（逐点按弧长算收敛系数，天然平滑），每根丝一次画完整条。
   🔴 笔宽取**整笔方向**的 chisel 投影（不逐点取）：逐点方向会被稳定器的微抖放大成毛丝横向锯齿。
   🔴 渐细幂曲线必须**夹到 1**（v6 漏夹 ⇒ f=0.5 时 pow(3,0.75)=2.28 ⇒ 中段被撑宽 2.28×）。
   🔴 镜像：整条镜像折线，复用 `_symAxisX/_symAxisY`。 */
function _inkRender(){
  var pts = pfmDraw.inkPts;
  if(!pts || pts.length < 2) return;
  var P = pts.concat([{ x: pfmDraw.lastX, y: pfmDraw.lastY }]);     /* 末点用实时指针 ⇒ 跟手 */
  var cfg = _bcfg('calli') || {};
  var ctx = pfmDrawCtx;
  _snapRestore(pfmDraw.inkBox);   /* 丙·B：只还原上一帧毛笔笔迹的范围 */
  var n = P.length, NX = [], NY = [], cum = [0];
  for(var j=0;j<n;j++){
    var a1 = P[Math.max(0,j-1)], b1 = P[Math.min(n-1,j+1)];
    var dx = b1.x-a1.x, dy = b1.y-a1.y, L = Math.sqrt(dx*dx+dy*dy) || 1;
    NX.push(-dy/L); NY.push(dx/L);
    if(j>0){
      var ex = P[j].x-P[j-1].x, ey = P[j].y-P[j-1].y;
      cum.push(cum[j-1] + Math.sqrt(ex*ex+ey*ey));
    }
  }
  var total = cum[n-1] || 1;
  var dxT = P[n-1].x - P[0].x, dyT = P[n-1].y - P[0].y;
  var projT = 1;
  if(cfg.chisel !== undefined && (dxT || dyT)) projT = Math.abs(Math.cos(Math.atan2(dyT,dxT) - cfg.chisel*Math.PI/180));
  var Wone = pfmDraw.brushSize * (cfg.w || 1) * Math.max(0.22, projT);
  /* 丙·B：墨丝铺展 ≈ ±Wone×0.5、再加自身线宽 ⇒ 余量 0.6×Wone 足够。 */
  pfmDraw.inkBox = _ptsBox(P, Wone * 0.6 + 4);
  var pitch = Math.max(1.6, cfg.hair || 2.6);
  var K = Math.max(3, Math.min(26, Math.round((Wone * 0.95) / pitch)));
  var step = (K > 1) ? (Wone * 0.95) / (K - 1) : Wone * 0.95;
  var H = pfmDraw.inkHair;
  if(!H){                          /* 每次落笔重掷一次；表长固定 26 ⇒ 永不因 K 变化而重建 */
    H = pfmDraw.inkHair = { n: 26, jw: [], ja: [], jd: [], ph: [] };
    for(var i0=0;i0<26;i0++){
      H.jw.push(0.85 + Math.random() * 0.35);
      H.ja.push(0.62 + Math.random() * 0.38);
      H.jd.push((Math.random() - 0.5) * 0.28);
      H.ph.push(Math.random() * Math.PI * 2);
    }
  }
  var sym = _symMode(), ax = _symAxisX(), ay = _symAxisY();
  var keepA = ctx.globalAlpha;
  ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  var mirs = [''];
  if(sym === 'v') mirs.push('v');
  else if(sym === 'h') mirs.push('h');
  else if(sym === 'quad'){ mirs.push('v'); mirs.push('h'); mirs.push('q'); }
  for(var mi=0;mi<mirs.length;mi++){
    var mk = mirs[mi];
    for(var i=0;i<K;i++){
      var ii = i % H.n;
      /* 🔴 2026-10-02（丙·墨量）：**「一笔墨」** —— 毛笔的墨量在**每根墨丝**上。
         丝越湿（`H.ja` 越大）画得越长（`fEnd` 越大）⇒ 笔尾只剩少数干丝 ⇒ 越写越枯。
         为什么**只截断、不改线宽/alpha**：墨丝是「整条一次 stroke」，改线宽必须分段 stroke，
         而 `_accBristle` v2 已经实测过分段会留下**砖墙/梯子状段界**（`_b3.png`）。
         截断只是少画后半截 ⇒ 零段界、零叠色。 */
      /* 🔴🔴 2026-10-02（丙·返修§3）：墨量改成**按丝序号确定**，不再复用 `H.ja`（随机表）。
         原因：`K` 很小（笔宽 4 时 `K = 3`）⇒ 只抽到随机表的**前 3 个**值 ⇒
         墨量表现每次运行都不同 —— 同一份代码连跑三次的「首/尾覆盖厚度比」= **1.92 / 1.45 / 1.06**
         ⇒ 判据随机 FAIL（线上真机实测）。
         ✅ 现在 `fEnd` 由 `i`（丝序号）**线性铺开**在 0.55~1.0，叠加 `H.jd`（±0.14 的固定抖动）
         ⇒ 参差但**均衡可控**：最干的丝画到 ~60%、最湿的画到 ~95% ⇒ 笔尾稳定地只剩少数干丝。 */
      var fEnd = 1;
      if(cfg.charge){
        /* 🔴🔴 2026-10-04（乙）：墨丝长度改为**按「到中线的距离」对称铺开**。
           改前按丝序号 `i` 线性铺开（`0.55 + 0.45×(i+0.5)/K`）⇒ **一侧的丝永远画得更长**
           ⇒ 笔尾只剩偏一侧的那几根 ⇒ 末端墨迹**系统性偏侧**（实拍 drift 10.3px，画图同笔 3.0）。
           现在：`_dc` = |i − 中心| 的归一化距离（0 = 中线、1 = 最外），**两侧对称**；
           且让**中线丝最长**（真毛笔收锋时笔尖在中线）⇒ 笔尾收成一个对称的尖。
           🔴 跨度同时收窄（0.55~1.0 → 0.70~1.0）：原来最干的丝只画 55%，笔尾只剩 1~2 根。 */
        var _dc = Math.abs(i - (K - 1) / 2) / Math.max(1, (K - 1) / 2);
        fEnd = Math.max(0.70, Math.min(1, 0.70 + 0.30 * (1 - _dc) + H.jd[ii] * 0.8));
      }
      var wetA = (cfg.wet === undefined) ? 0.5 : cfg.wet;
      /* 整笔一个 alpha：丝间浓淡靠 `H.ja`，再叠一点"墨色随长度"的低频起伏（会随重画一致，因为相位固定） */
      ctx.globalAlpha = keepA * H.ja[ii];
      /* 🔴 2026-10-02（乙）：下限 0.4 → `fxMin`（墨丝是毛笔的核心特征，不能被压成亚像素）。 */
      ctx.lineWidth = Math.max(_fxMin(cfg), step * H.jw[ii]);
      ctx.beginPath();
      for(var j=0;j<n;j++){
        var f = cum[j] / total;
        if(f > fEnd) break;                       /* 丙·墨量：这根丝墨尽了 */
        /* 收锋只在**两端各约 7%** 内完成（系数 14）—— 系数 6 时收到 17%,
           整条笔迹看起来像柳叶（v7 实拍）；幂 1.05 让尖更锐。下限 0.06 防亚像素消失。
           🔴 `Math.min(1, ·)` 不能漏：漏了 f=0.5 时 pow(3,0.75)=2.28 ⇒ 中段被撑宽 2.28×（v6 的 bug）。 */
        var tp = Math.max(0.06, Math.min(1, Math.pow(Math.min(f, 1 - f) * 14, 1.05)));
        var wj = 1 - wetA * 0.22 * (0.5 + 0.5 * Math.sin(cum[j] * 0.05 + H.ph[ii]));
        /* 🔴 2026-10-04（乙）：收锋的**横向收拢保底** —— 原来直接乘 `tp`（可低到 0.06），
           把**所有**墨丝在两端挤到中线一条线上（实拍"尾部塌成几条细线"）。
           改为 `(0.45 + 0.55×tp)`：tp=1 时逐像素相同（**零回归**），tp→0 时仍保留 45% 铺展
           ⇒ 尾部是"收窄的毛束"而不是"一条线"。 */
        var off = ((i - (K-1)/2) + H.jd[ii]) * step * (0.45 + 0.55 * tp);
        var X = P[j].x + NX[j]*off, Y = P[j].y + NY[j]*off;
        if(mk === 'v') X = 2*ax - X;
        else if(mk === 'h') Y = 2*ay - Y;
        else if(mk === 'q'){ X = 2*ax - X; Y = 2*ay - Y; }
        if(j === 0) ctx.moveTo(X, Y); else ctx.lineTo(X, Y);
      }
      ctx.stroke();
    }
  }
  /* 🔴🔴 2026-10-04（乙）：**收笔端的实心中心尖** ——
     墨丝只靠"向中线聚拢"表达收锋 ⇒ 实拍是「几条**分离的**细线」（用户点名"尾部塌成几条细线"）。
     真毛笔收锋时毛与墨是**一体的实心尖**（毛聚拢 + 墨连成一片）。
     做法：沿中心线画一段**宽度按收锋系数递减到 0 的实心轮廓**，只在末尾 22% 内
     （`cum/total ≥ 0.78` 是**单一连续区间** ⇒ 不会把起笔端错连进来）。
     🔴 宽度用 `Wone`（已含 `projT` 斜切投影）⇒ 与 D7「斜切方向感应」同源，不破坏它。
     🔴 用轮廓多边形（沿 ±法线两条边闭合）而不是"逐点画圆"：后者在稀疏采样下会变成
        **珠链**（点距 > 直径）；轮廓法天然连续、无段界。 */
  var _k0 = -1;
  for(var jt=0;jt<n;jt++){ if(cum[jt] / total >= 0.78){ _k0 = jt; break; } }
  if(_k0 >= 0 && (n - _k0) >= 3){
    ctx.globalAlpha = keepA * 0.90;
    for(var mt=0;mt<mirs.length;mt++){
      var mkt = mirs[mt];
      ctx.beginPath();
      var _first = true;
      for(var jt2=_k0; jt2<n; jt2++){
        var tt2 = (total - cum[jt2]) / total;                  /* 0.22 → 0（越靠末端越小） */
        var rr2 = Wone * 0.30 * Math.max(0, Math.pow(tt2 / 0.22, 0.7));
        var px2 = P[jt2].x + NX[jt2]*rr2, py2 = P[jt2].y + NY[jt2]*rr2;
        if(mkt === 'v') px2 = 2*ax - px2; else if(mkt === 'h') py2 = 2*ay - py2;
        else if(mkt === 'q'){ px2 = 2*ax - px2; py2 = 2*ay - py2; }
        if(_first){ ctx.moveTo(px2, py2); _first = false; } else ctx.lineTo(px2, py2);
      }
      for(var jt3=n-1; jt3>=_k0; jt3--){
        var tt3 = (total - cum[jt3]) / total;
        var rr3 = Wone * 0.30 * Math.max(0, Math.pow(tt3 / 0.22, 0.7));
        var qx2 = P[jt3].x - NX[jt3]*rr3, qy2 = P[jt3].y - NY[jt3]*rr3;
        if(mkt === 'v') qx2 = 2*ax - qx2; else if(mkt === 'h') qy2 = 2*ay - qy2;
        else if(mkt === 'q'){ qx2 = 2*ax - qx2; qy2 = 2*ay - qy2; }
        ctx.lineTo(qx2, qy2);
      }
      ctx.closePath();
      ctx.fill();
    }
  }
  ctx.globalAlpha = keepA;
}

/* 2026-10-01（丙②）：**水彩整笔渲染** —— 湿边洇散 + 主体断口。
   两遍（都在每次 mousemove 从 snapshot 重画，所以永远不会叠出段界）：
     ① **外晕**：宽 1.6×、更淡 ⇒ 颜料向纸纤维渗开的"湿边"
     ② **主体**：正常宽 + 按**弧长**细分后逐小段随机跳过 ⇒ 干刷断口
   🔴 ② 的断口与主体是**同一条 path 里的多个子路径**（`moveTo` 重开），最后只 `stroke()` 一次 ——
      同一 stroke 内相邻子路径首尾相接**不会双重合成** ⇒ 断口干净、没有段界。 */
function _waterRender(){
  var pts = pfmDraw.waterPts;
  if(!pts || pts.length < 2) return;
  var cfg = _bcfg('water') || {};
  var ctx = pfmDrawCtx;
  _snapRestore(pfmDraw.waterBox);   /* 丙·B：只还原上一帧水彩笔迹的范围 */
  var P = pts.concat([{ x: pfmDraw.lastX, y: pfmDraw.lastY }]);
  /* 丙·B：洇散点的横向偏移 + 半径都在 0.5×笔宽 量级 ⇒ 1.2× 保守够用。 */
  pfmDraw.waterBox = _ptsBox(P, Math.max(1, pfmDraw.brushSize) * 1.2 + 6);
  var bs = Math.max(1, pfmDraw.brushSize);
  var A = _pfmA();
  ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  var keepA = ctx.globalAlpha, keepW = ctx.lineWidth;
  /* ① 洇散毛边（v1 返修）：**不再**画一条加宽的带 —— 那只是「更宽的淡带」，看不出洇。
     真水彩的湿边是**颜料沿着纸纤维不规则渗开** ⇒ 用沿折线每隔 ~4px 撒 2 个
     **随机横向偏移 + 随机半径**的小晕点来造毛边。 */
  var aMain = A * (cfg.a === undefined ? 1 : cfg.a);
  var edge = (cfg.feather === undefined) ? 0.5 : cfg.feather;
  var _wx = [], _wy = [];
  for(var q=0;q<P.length;q++){
    var _a2 = P[Math.max(0,q-1)], _b2 = P[Math.min(P.length-1,q+1)];
    var _dx2 = _b2.x-_a2.x, _dy2 = _b2.y-_a2.y, _l2 = Math.sqrt(_dx2*_dx2+_dy2*_dy2) || 1;
    _wx.push(-_dy2/_l2); _wy.push(_dx2/_l2);
  }
  /* 🔴🔴 2026-10-02（丙⑤）：**湿边方向原来搞反了**。真水彩的 edge darkening（湿边）是
     颜料被水推到笔触**边界沉积** ⇒ **边缘比中心浓**；原来这里乘了 `*0.55` ⇒ 洇散点比主体淡
     ⇒ 边缘反而更虚（`_verify_real.js` C1 实测 edge/core = **0.37**，方向正好相反）。
     现在：边缘点用 `aMain × (1 + edge×1.0)`（edge=0.5 时约 1.5×主体）⇒ 边缘更浓 ✅
     上限 1 兜底（aMain 本身只有 0.20，不会溢出）。 */
  /* 🔴 2026-10-02（丙·返修）：系数 1.0 → **1.5**。1.0 时 `_verify_real` 的 C1 只有
     0.98~1.09、贴阈值波动（洇散点用 `Math.random()` 撒）⇒ 加到 1.5（edge=0.5 ⇒ 1.75×主体）。 */
  ctx.globalAlpha = Math.min(1, aMain * (1 + edge * 1.5));
  /* 🔴🔴 2026-10-04（乙）：湿边点**步长自适应**（原来写死 `LL/4` = 每 4 画布 px 撒一组）。
     病根：湿边点半径 = `max(fxMin, bs×(0.09~0.17))`，**随笔宽线性增长**，而步长恒为 4px
     ⇒ 笔宽一变大（bs=30 ⇒ 半径 2.7~5.1px、直径 >5px）相邻两步的湿边点**必然重叠**
     ⇒ 同一处被合成 2~3 次 ⇒ 平均 alpha 从设计值 0.665 抬到 0.7+
     ⇒ 撞 `_verify_brushes` **D4**「水彩明显比画笔透明」（线上实测 0.669 vs 阈值 0.609）。
     ⇒ 步长改为「**≥ 2.4 × 平均半径**」：相邻湿边点沿路径方向互不重叠。
        · 默认笔宽 4：`max(0.9, 0.52)=0.9` ⇒ `2.4×0.9=2.16 < 4` ⇒ 步长仍 4 ⇒ **逐像素零回归**；
        · 大笔宽：步长随半径放开 ⇒ 不再叠色，湿边仍是"不规则毛边"（点本来就是随机偏移的）。
     顺带：覆盖率随之下降（正是上一批"透气度"在水彩上想做而参数层做不到的那件事）。 */
  var _wrRad = Math.max(_fxMin(cfg), bs * 0.13);
  var _wrGap = Math.max(4, _wrRad * 2.4);
  for(var j2=1;j2<P.length;j2++){
    var x0b = P[j2-1].x, y0b = P[j2-1].y, x1b = P[j2].x, y1b = P[j2].y;
    var ddx = x1b-x0b, ddy = y1b-y0b, LL = Math.sqrt(ddx*ddx+ddy*ddy);
    var stb = Math.max(1, Math.round(LL / _wrGap));
    for(var s2=1;s2<=stb;s2++){
      if(cfg.dry && Math.random() < cfg.dry*0.5) continue;      /* 断墨处湿边也淡 */
      for(var k2=0;k2<2;k2++){
        var t2 = s2/stb;
        var bx = x0b + ddx*t2, by = y0b + ddy*t2;
        var side = (k2 ? 1 : -1) * (0.52 + Math.random()*0.55);
        /* 🔴 2026-10-02（丙·返修）：边缘点**变细**而不是变淡 ——
           湿边系数提到 1.5 后水彩整体变浓，`_verify_brushes` 的 D4（"水彩该比画笔透明"）
           实测 0.654 vs brush 0.689 ⇒ 不再"明显更透明"（**真回归**）。
           半径从 `0.16~0.30 × bs` 收到 `0.09~0.17 × bs`：边缘**照样浓**（沉积感更强、
           更像真水彩的颜料在边界结粒），但**覆盖面积减半** ⇒ 平均 alpha 落回透明区间
           （实测 0.654 → 0.213，对照 brush 0.705 ✅）。 */
        /* 🔴 2026-10-02（乙）：半径下限 `fxMin`。原式 `bs×(0.09~0.17)` 在默认笔宽 4 下是
           **0.36~0.68px（亚像素）** ⇒ 洇散点整个看不见（只剩"主体断口"这一个特征）。 */
        var rr2 = Math.max(_fxMin(cfg), bs * (0.09 + Math.random()*0.08));
        var ox2 = _wx[j2]*bs*side*0.5, oy2 = _wy[j2]*bs*side*0.5;
        ctx.beginPath(); ctx.arc(bx+ox2, by+oy2, rr2, 0, Math.PI*2); ctx.fill();
      }
    }
  }
  /* ② 主体（带按弧长的断口）—— 🔴🔴 2026-10-04（乙）：**收窄 + 变淡 + 断口加密**。
     原来是一条 `lineWidth = bs`、`alpha = a` 的**均匀连续带**（四条边一样实），
     实拍就是一块「灰色实心方块」，与周围的洇散点不像同一笔（用户点名）。
     现在：宽度 `bs` → `0.85×bs`（主体不再顶到笔迹边缘，边缘交给洇散点）、
     alpha ×0.85、`dry` 0.20 → 0.32（断口更明显 ⇒ 破"实心"感、更像颜料在纸上不匀）。
     ⚠️ 平均 alpha 同时下降 ⇒ 直接帮 `_verify_brushes` **D4**「水彩明显比画笔透明」。 */
  ctx.globalAlpha = A * (cfg.a === undefined ? 1 : cfg.a) * 0.85;
  ctx.lineWidth = bs * 0.85;
  var seg = 6, dry = cfg.dry || 0;
  ctx.beginPath();
  var ok = true;
  for(var j=1;j<P.length;j++){
    var x0 = P[j-1].x, y0 = P[j-1].y, x1 = P[j].x, y1 = P[j].y;
    var dx = x1-x0, dy = y1-y0, L = Math.sqrt(dx*dx+dy*dy);
    var st = Math.max(1, Math.ceil(L/seg));
    for(var s=1;s<=st;s++){
      var xx = x0 + dx*s/st, yy = y0 + dy*s/st;
      if(dry && Math.random() < dry){ ok = false; continue; }   /* 断口：下一小段重新 moveTo */
      if(!ok){ ctx.moveTo(xx, yy); ok = true; } else { ctx.lineTo(xx, yy); }
    }
  }
  ctx.stroke();
  ctx.globalAlpha = keepA; ctx.lineWidth = keepW;
}

/* 2026-10-01（丙③）：**霓虹整笔渲染** —— 整条路径一次发光 ⇒ 连续光管。
   原来逐段各画一圈 `shadowBlur` 光晕 + 白芯 ⇒ 每段一个胶囊，接起来像一串珠子。 */
function _neonRender(){
  var pts = pfmDraw.neonPts;
  if(!pts || pts.length < 2) return;
  var ctx = pfmDrawCtx;
  _snapRestore(pfmDraw.neonBox);   /* 丙·B：只还原上一帧霓虹的范围 */
  var P = pts.concat([{ x: pfmDraw.lastX, y: pfmDraw.lastY }]);
  /* 🔴 丙·B：霓虹的余量要给**4.5×笔宽** —— `shadowBlur = 笔宽×2.2`，但 canvas 的 shadowBlur
     不是「精确半径」、实际扩散比它大得多。第一版按 2.4× 给，`_verify_prop1` 的 N1 立刻报
     「40 段的厚度 131 vs 2 段的 101」—— 极淡的光晕外围**没被擦掉**（总像素只多 0.8%，
     但包围盒厚了 30px）。**判据看点：残影不一定是「像素数暴涨」，也可能是「包围盒悄悄变大」。** */
  /* 2026-10-03（甲·参数化）：光晕强度与白芯宽度可调（默认 = 改前 2.2× / 0.45×）。
     ⚠️ 脏矩形余量必须跟着光晕走：原来写死 4.5×（= 2.2× 的 2.05 倍）⇒ 光晕调大后余量不够
        会留残影（2026-10-01 那条"N1 厚度 131 vs 101"的教训：残影可能只表现为**包围盒变大**）。 */
  var _glow = Math.max(0.5, _drawNum('pfmFxNeonGlow', 22) / 10);
  pfmDraw.neonBox = _ptsBox(P, Math.max(1, pfmDraw.brushSize) * Math.max(4.5, _glow * 2.05) + 8);
  var col = drawFxColor(), bs = Math.max(1, pfmDraw.brushSize);
  var keepA = ctx.globalAlpha, keepW = ctx.lineWidth, keepJ = ctx.lineJoin, keepC = ctx.lineCap;
  ctx.save();
  ctx.beginPath();
  for(var i=0;i<P.length;i++){ if(i===0) ctx.moveTo(P[i].x, P[i].y); else ctx.lineTo(P[i].x, P[i].y); }
  ctx.strokeStyle = col; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  ctx.shadowColor = col; ctx.shadowBlur = bs * _glow;
  ctx.lineWidth = bs * 0.9;
  ctx.globalAlpha = _pfmA();
  ctx.stroke();
  ctx.shadowBlur = 0;
  ctx.lineWidth = Math.max(1, bs * (Math.max(0, Math.min(100, _drawNum('pfmFxNeonCore', 45))) / 100));
  ctx.strokeStyle = 'rgba(255,255,255,0.85)';
  ctx.stroke();
  ctx.restore();
  ctx.globalAlpha = keepA; ctx.lineWidth = keepW; ctx.lineJoin = keepJ; ctx.lineCap = keepC;
}

/* ===== 2026-10-01（乙）：统一整笔累积渲染 =====
   ## 为什么不用 stroke()
   canvas 的 `stroke()` **一条 path 只有一个 lineWidth** ⇒ 想沿长度变宽就得分段，而分段必然露台阶
   （毛笔 v3/v4 实证：笔宽随方向逐段变，外侧毛丝逐段横移 ⇒ 砖墙）。改用 **fill 轮廓**：
     上轮廓（每点 + 法线×半宽）+ 下轮廓（反向）+ 两端半圆端帽 → **一条 path 一次 fill**。
     ⇒ 宽度逐点连续（无台阶）· 一次 fill 不叠色（无段界）· 一条连续几何。
   ## 墨量随速度
   真画材拖快 = 出墨少 = **变淡 + 飞白**。`load_j = 1 − cfg.load × min(1, v/1.8)`；
   按弧长分 10 组取组内平均作 alpha（fill 的 alpha 是全路径统一的，只能分组）。
   飞白 = 低墨量组按**稳定伪随机**（种子 = 组起始弧长）整组跳过。
   🔴 随机必须稳定：整笔每帧重画，用 Math.random() 会让飞白位置逐帧乱跳。
   ## 性能：脏矩形还原
   每帧要用 snapshot 擦上一帧 ⇒ 用 `putImageData` 的 dirty rect 参数只还原"上一帧笔迹包围盒"。
   整幅是 6.5MB，脏矩形通常几百 KB（省 ~40×）。 */
function _accRnd(i){ var x = Math.sin(i * 12.9898) * 43758.5453; return x - Math.floor(x); }
/* 🔴🔴 2026-10-02（丙·墨量）：**整数 hash**（murmur3 finalizer）。
   为什么不能沿用 `_accRnd`：那是经典的 `frac(sin(x)*43758)` shader hash，
   在**等差数列**种子上有系统性偏差 —— 实测墨量飞白（种子 `Math.round(CUM/3)*97+23`，
   随点等差递增）的**保留率沿长度从 53% 单调升到 67%**
   ⇒ 笔尾反而比中段完整，与"渐干"**方向相反**（`_verify_charge` 的 A2 抓到）。
   整数 hash 输出在 `[0,1)` 上均匀，且对 `k2`（点序号，逐帧稳定）直接可用、无浮点精度问题。 */
function _dryRnd(i){
  var x = Math.imul(i ^ 0x9e3779b9, 0x85ebca6b);
  x = Math.imul(x ^ (x >>> 13), 0xc2b2ae35);
  return ((x ^ (x >>> 16)) >>> 0) / 4294967296;
}

/* ===== **快照还原的唯一实现**（2026-10-01 丙）=====
   `box = {x0,y0,x1,y1}`（画布坐标）；省略 / null ⇒ 整幅还原。
   现状（改前）：整幅 `putImageData(snapshot, 0, 0)` 在引擎里**写了 15 遍**，只有 `_strokeRender`
   用了脏矩形。整幅还原 = 每帧把整张快照搬回去（638² ⇒ 1.6MB；1200² ⇒ **5.76MB**）——
   当前画布尺寸下约 1ms 还不吃紧，但**大屏 / 高 dpr 下按面积放大**。
   🔴 调用方约定：**先 `_snapRestore(上一帧的 box)` 擦，再画本帧，最后把本帧的 box 存起来**。
      传错（用完没更新）会留下"上一帧的残影"—— 所以每支笔都要在自己渲染完的那一刻更新 box。 */
/* 🔴🔴 2026-10-03（丁）：局部还原**不再走 putImageData**。
   实测（`_probe_putbox.js` / 线上 1200x1200 画布，每步 1 次还原）：
     · 单次 putImageData = **1.33ms 固定**，与 box 面积**几乎无关**
       （0.25k px -> 1.15ms；128k px -> 1.36ms，面积涨 500 倍耗时只涨 18%）
     · 同一张画布在**事件处理之外**调 `putImageData(1000x40)` 实测 **0ms**、整幅 0.5ms
     ⇒ 这 1.3ms 不是数据搬运，而是「在每步绘制流程里调 putImageData」触发的一次
        **CPU->GPU 上传 / 管线同步**。所以「把 box 改小」没有任何收益（实测确认），
        真正有效的是**换掉这条路径**。
   ⇒ 局部还原改为纯 GPU 操作：`clearRect(box)` + `drawImage(离屏快照 canvas, box)`。
     实测每步成本 **1.57ms -> 0.04ms**（clearRect 0.008ms + drawImage 0.032ms）；
     CPU 4x 节流下帧 p90 4.8ms -> 0.35ms、最大帧 68ms -> 25ms（不再掉帧）。
   🔴 `clearRect` 不能省：`drawImage` 是 source-over，快照里的**透明像素不会覆盖**目标，
      必须先擦干净才能把「快照里本来就是空的区域」还原成空。
   🔴 `_snapCanvas()` 惰性把 `snapshot`（ImageData）镜像到一张离屏 canvas，按**引用比对**失效
      ⇒ 不必改 9 处 `pfmDraw.snapshot = ...` 赋值点（少碰一处就少一处回归面）。 */
function _snapCanvas(){
  var s = pfmDraw.snapshot;
  if(!s) return null;
  var sc = pfmDraw.snapCv;
  if(!sc){ sc = pfmDraw.snapCv = document.createElement('canvas'); sc._src = null; }
  if(sc.width !== s.width || sc.height !== s.height){ sc.width = s.width; sc.height = s.height; }
  if(sc._src === s) return sc;
  var t = _snapCanvas._t || (_snapCanvas._t = document.createElement('canvas'));
  if(t.width !== s.width || t.height !== s.height){ t.width = s.width; t.height = s.height; }
  t.getContext('2d').putImageData(s, 0, 0);   /* ImageData -> 临时 canvas（每笔一次；非显示 canvas，无同步代价） */
  var g = sc.getContext('2d');
  g.globalAlpha = 1; g.globalCompositeOperation = 'source-over';
  g.clearRect(0, 0, sc.width, sc.height);
  g.drawImage(t, 0, 0);
  sc._src = s;
  return sc;
}
function _snapRestore(box){
  var ctx = pfmDrawCtx;
  if(!pfmDraw.snapshot) return;
  if(!box){ ctx.putImageData(pfmDraw.snapshot, 0, 0); return; }
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  var x = Math.max(0, Math.floor(box.x0)), y = Math.max(0, Math.floor(box.y0));
  var w = Math.min(W - x, Math.ceil(box.x1 - box.x0) + 1), h = Math.min(H - y, Math.ceil(box.y1 - box.y0) + 1);
  if(w <= 0 || h <= 0 || x >= W || y >= H){ ctx.putImageData(pfmDraw.snapshot, 0, 0); return; }
  var sc = _snapCanvas();
  if(!sc){ ctx.putImageData(pfmDraw.snapshot, 0, 0, x, y, w, h); return; }
  var ka = ctx.globalAlpha, kc = ctx.globalCompositeOperation;
  ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
  ctx.clearRect(x, y, w, h);
  ctx.drawImage(sc, x, y, w, h, x, y, w, h);
  ctx.globalAlpha = ka; ctx.globalCompositeOperation = kc;
}

/* 两个 box 的并集（图形类的脏矩形要用它：几何随拖动变大/变小，只按本帧算会漏擦）。 */
function _unionBox(a, b){
  if(!a) return b;
  if(!b) return a;
  return { x0: Math.min(a.x0, b.x0), y0: Math.min(a.y0, b.y0),
           x1: Math.max(a.x1, b.x1), y1: Math.max(a.y1, b.y1) };
}

/* 圆/方图形的包围盒（web/spiro 这类以某点为心的图形用）。 */
function _circleBox(cx, cy, r){ return { x0: cx - r, y0: cy - r, x1: cx + r, y1: cy + r }; }

/* 点集包围盒 + 余量（脏矩形用）。空点集返回 null。 */
function _ptsBox(P, pad){
  if(!P || !P.length) return null;
  var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
  for(var i=0;i<P.length;i++){
    var px = P[i].x, py = P[i].y;
    if(px < x0) x0 = px; if(px > x1) x1 = px;
    if(py < y0) y0 = py; if(py > y1) y1 = py;
  }
  if(x0 > x1) return null;
  pad = pad || 0;
  return { x0: x0 - pad, y0: y0 - pad, x1: x1 + pad, y1: y1 + pad };
}

function _strokeRestore(){ _snapRestore(pfmDraw.strBox); }

/* 端帽：往**同一条 path** 里追加一个半圆（一次 fill 不会有叠色）。 */
function _capArc(ctx, cx, cy, hw, ang, head){
  /* 🔴🔴 2026-10-02 修：首端端帽原来画的是 `ang-π/2 → ang+π/2`（**下半圆**），
     而笔迹从起点向右延伸时首端必须是**左半圆**。更要命的是：那段弧与轮廓的**环绕方向相反**
     ⇒ canvas 非零环绕规则下，重叠区的环绕数 = 0 ⇒ 被**挖空**成白色三角缺口
     （`_shot_ends.js` 5× 特写 + `_diag_ends.js` 左刺 1.17~2.77 抓到；线上真机同值）。

     正解：θ 从 `ang`（法线正向）起、**递增** π ⇒ 与轮廓同绕向 ⇒ 取并集、不挖洞。
     几何核对（笔迹沿 +x、法线 N=(0,1) ⇒ ang = π/2）：
       · 首端左半圆 = 从下端点(θ=π/2) 经左(π) 到上端点(3π/2)  ⇒ `arc(ang, ang+π)`  ✅
       · 尾端右半圆 = 从上端点(3π/2) 经右(2π) 到下端点(5π/2)  ⇒ `arc(ang+π, ang+2π)` ✅
     调用方的 `moveTo` 也必须落在各自弧的**起点角**上（否则 `arc()` 会先连一条直线）。 */
  if(head) ctx.arc(cx, cy, hw, ang, ang + Math.PI);
  else ctx.arc(cx, cy, hw, ang + Math.PI, ang + Math.PI*2);
}

/* 记录本帧笔迹的包围盒（下一帧用它做脏矩形还原） */
function _accBox(P, HW, pad){
  /* 🔴 2026-10-01（乙·第二批）：新增 `pad` —— **air 的散点半径远超笔宽**
     （`spread×笔宽`，默认 1.4×）⇒ 只按 `HW+3` 算脏矩形，下一帧 `_strokeRestore`
     擦不到外围的散点 ⇒ 画布上留下一圈"上一帧的雾"。 */
  var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9, pad = pad || 0;
  /* 🔴🔴 2026-10-03（乙-1）：**必须把镜像副本也算进脏矩形**。
     改前只按本体 `P` 算 ⇒ 下一帧 `_strokeRestore` 擦不到镜像那一侧 ⇒ 镜像笔迹每帧被
     重复叠加、越描越黑（对称在 9 支累积笔刷上是"越画越脏"而不是干净镜像 —— 老 bug）。
     `_symMarkers()` 在 off 时返回 `['']` ⇒ 本改动对"没开对称"是**零变化**。 */
  var _mks = _symMarkers(), _ax = _symAxisX(), _ay = _symAxisY();
  for(var i=0;i<P.length;i++){
    var h = HW[i] + 3 + pad;
    for(var mi=0;mi<_mks.length;mi++){
      var _q = _symMapPoint(P[i].x, P[i].y, _mks[mi], _ax, _ay);
      if(_q[0] - h < x0) x0 = _q[0] - h;
      if(_q[1] - h < y0) y0 = _q[1] - h;
      if(_q[0] + h > x1) x1 = _q[0] + h;
      if(_q[1] + h > y1) y1 = _q[1] + h;
    }
  }
  pfmDraw.strBox = { x0:x0, y0:y0, x1:x1, y1:y1 };
}

/* pixel 笔：整笔重画 + 保留"方块 snap 到网格"的语义（离散方块本就不是连续笔迹） */
function _accPixel(P, mirs, ax, ay){
  var ctx = pfmDrawCtx, bs = Math.max(1, pfmDraw.brushSize);
  /* 🔴🔴 2026-10-02（丙⑨）：吸附网格 = **笔宽/4**（原来 `step = bs*0.9` 与方块同尺寸
     ⇒ 中心总落在同一格、边缘齐平 ⇒ 连成平滑带，完全看不出像素感）。
     方块边长仍 ≈ 笔宽（`half`），只是**中心吸附到细网格** ⇒ 相邻方块错位 ⇒ 阶梯锯齿。 */
  var step = Math.max(2, Math.round(bs / 4));
  var half = Math.max(1, bs * 0.48);
  ctx.globalAlpha = _pfmA();
  ctx.fillStyle = pfmDraw.color;
  var lx = null, ly = null;
  function put(gx, gy){
    if(gx === lx && gy === ly) return;                 /* 与上一格相同就不重复盖 */
    lx = gx; ly = gy;
    for(var m=0;m<mirs.length;m++){
      /* 2026-10-03（乙-1）：改用单一实现的 `_symMapPoint` —— 原来这里自己 inline 判 v/h/q
         ⇒ 万花筒在像素笔下会静默失效（与 `_strokeRender` 同源的病）。 */
      var _mp = _symMapPoint(gx, gy, mirs[m], ax, ay);
      ctx.fillRect(_mp[0] - half, _mp[1] - half, half*2, half*2);
    }
  }
  for(var i=0;i<P.length;i++){
    /* 🔴 2026-10-02（丙⑨·v2）：相邻采样点之间**按网格步进补格**。
       只按采样点盖章的话，采样稀疏时（实测 15 段 ≈ 67px 间距）笔迹会漏成**一串离散方块**
       （第一版实拍就是「虚线」）—— 真像素笔是一条**连续的方块带**。 */
    if(i > 0){
      var ddx = P[i].x - P[i-1].x, ddy = P[i].y - P[i-1].y;
      var dist = Math.sqrt(ddx*ddx + ddy*ddy);
      var nSeg = Math.max(1, Math.round(dist / step));
      for(var k=1;k<nSeg;k++){
        var ix = P[i-1].x + ddx*k/nSeg, iy = P[i-1].y + ddy*k/nSeg;
        put(Math.round(ix/step)*step, Math.round(iy/step)*step);
      }
    }
    put(Math.round(P[i].x/step)*step, Math.round(P[i].y/step)*step);
  }
  ctx.globalAlpha = 1;
}

/* ===== 2026-10-01（乙·第二批）：oil 的**整笔毛须** =====
   一笔 = K 根与路径平行的**连续折线**，沿法线等距铺开（总铺展 0.8×笔宽）。
   · 每根毛须**一次画完整条** ⇒ 拐弯处毛须跟着笔迹弯（逐段版会让相邻两排错位）
   · 粗细波动（`bjitter`）留缝造毛须纹 —— 与逐段版同一套参数表，视觉一致
   · 特征表 `pfmDraw.oilHair` 固定 16 条（**永不因 K 变而重建**）：K 由笔宽推出，
     若按 K 建表，笔宽微抖就会整表重掷 ⇒ 毛须逐帧换位置（`_inkRender` v3 踩过同一个坑）
   · 镜像复用 `MAP`（与 `_strokeRender` 同一套映射）⇒ 对称行不是假控件 */
function _accBristle(P, NX, NY, HW, CUM, mirs, MAP){
  var ctx = pfmDrawCtx, cfg = _bcfg('oil') || {};
  var bs = Math.max(1, pfmDraw.brushSize) * (cfg.w || 1);
  var span = bs * 0.8;
  var pitch = Math.max(3, cfg.bristle || 9);
  var K = Math.max(4, Math.min(16, Math.round(span / pitch)));
  /* 🔴 2026-10-02（乙）：**K 还要受"缝看得见"约束**。
     缝宽 ≈ `step × (1 − jw均值)` ≈ `0.22 × step`（`H.jw` 均值 0.78）⇒ 要缝 ≥ `fxMin`（0.9px）
     就得 `step ≥ fxMin / 0.22 ≈ 4.1px` ⇒ `K ≤ span / 4.1`。
     笔宽 4 时 span=5.12 ⇒ K 从 4 降到 **2**（"双股"），缝 ~1.1px **看得见**；
     笔宽 30 时 span=38.4 ⇒ Kmax=9，原 K=4 **不受影响**（大笔宽观感不变 —— 这是本改动的硬要求）。 */
  var _fxm = _fxMin(cfg);
  var _needStep = Math.max(2.0, _fxm / 0.22);
  var _kMax = Math.max(2, Math.floor(span / _needStep));
  if(K > _kMax) K = _kMax;
  var step = (K > 1) ? span / (K - 1) : span;
  var amp = (cfg.bjitter === undefined) ? 0.35 : cfg.bjitter;
  var H = pfmDraw.oilHair;
  if(!H){
    H = pfmDraw.oilHair = { n: 16, jw: [], jd: [], ph: [] };
    for(var i0=0;i0<16;i0++){
      /* 🔴 2026-10-01（乙·第三批·v3）：`jw` 的均值必须 **< 1** —— 毛须宽 = `step × jw`，
         均值 ≥1 时相邻毛须互相盖住 ⇒ 缝只是**偶尔**出现（实测同一支笔有时 12 条缝、有时 0 条，
         判据完全不可靠）。改成 0.55~1.02（均值 ≈0.78）⇒ 缝宽 ≈ 0.22×step（约 2.3px）**稳定出现**。
         `bjitter` 仍然参与：它让这个区间的下限更低（毛须更参差）。 */
      H.jw.push((0.62 - amp * 0.20) + Math.random() * (0.40 + amp * 0.20));
      H.jd.push((Math.random() - 0.5) * 0.4);
      H.ph.push(Math.random() * Math.PI * 2);   /* 摆动相位：每根毛须各不相同 */
    }
  }
  var keepA = ctx.globalAlpha, keepW = ctx.lineWidth, keepCap = ctx.lineCap;
  ctx.globalAlpha = _pfmA() * ((cfg.a === undefined) ? 1 : cfg.a);
  /* 🔴 2026-10-01（乙·第三批·v2）：改 **round** —— 毛须现在按弧长**分段改线宽**（见下），
     相邻段共享端点，圆帽能把段界盖住（`butt` 在段界处会露出一道线宽突变的横痕）。
     因为 `oil` 的 `a=1`（不透明），圆帽重叠**不会叠深**（当初选 butt 是为"逐段画"的接缝；
     整笔重画下每帧只有一条折线，不存在跨段叠色）。 */
  /* ① **底色带** = 缝里露出的那层薄颜料。
     🔴 2026-10-01（乙·第三批·v3）：没有它时，缝是**纯白**（完全透明）⇒ 黑带 + 白线、
        对比度 100%，像瓦楞纸/木纹。真油画的毛须缝里是有薄薄一层颜料的（灰调）。 */
  var A2 = ctx.globalAlpha;
  var total = CUM[P.length - 1] || 1;
  /* 🔴🔴 2026-10-02（丙·返修§6）：**行程锥度（笔锋）** —— oil 走 `_accBristle` 的 early return，
     不经过 `_strokeRender` ⇒ 上一节加在 `_strokeRender` 里的锥度碰不到它（`_t_taper` 实测 1.00/1.00）。
     做法：把毛须的**横向偏移**乘系数 ⇒ 两端毛须向中心聚拢，整体形成笔锋（不改线宽 ⇒ 无段界）。
     预计算成数组（一次 O(n)），毛须循环里直接查 ⇒ 不增加 K×n 次重复计算。 */
  var _tInB = (cfg.tIn === undefined) ? 1 : cfg.tIn;
  var _tOutB = (cfg.tOut === undefined) ? 1 : cfg.tOut;
  var _tpArr = null;
  if(_tInB < 1 || _tOutB < 1){
    var _tlb = ((cfg.tLen === undefined) ? 4 : cfg.tLen) * bs;
    _tpArr = [];
    for(var jz=0;jz<P.length;jz++){
      var _pz = 1;
      var _fa2 = CUM[jz] / _tlb, _fb2 = (total - CUM[jz]) / _tlb;
      if(_tInB < 1 && _fa2 < 1) _pz = Math.min(_pz, _tInB + (1 - _tInB) * _fa2);
      if(_tOutB < 1 && _fb2 < 1) _pz = Math.min(_pz, _tOutB + (1 - _tOutB) * _fb2);
      _tpArr.push(_pz);
    }
  }
  for(var mi=0;mi<mirs.length;mi++){
    var mk = mirs[mi];
    /* 🔴 2026-10-04（戊·甲）：缝的亮度**不再写死 0.46** —— 它决定「毛须缝能不能透底」，
       而 0.46 正是实测「油画覆盖率 0.996 = 缝全被这层灰填满」的直因。
       改读 `cfg.baseA`，**缺省值仍 0.46**（未设该字段的笔零回归）。 */
    ctx.globalAlpha = A2 * ((cfg.baseA === undefined) ? 0.46 : cfg.baseA);
    ctx.beginPath();
    /* 🔴🔴 2026-10-04（乙）：**底色带也要跟着锥度收窄** —— 改前毛须被 `_tpArr` 向中心聚拢，
       而底色带恒按 `span×0.5` 满宽铺 ⇒ 端头变成"**毛须收成一点 + 一片满宽灰底**"
       ⇒ 视觉上就是用户报的「端头毛须向外散成尖角」（尖角是从灰底里支出来的）。
       现在底色带与毛须**用同一个 `_tpArr`** ⇒ 端头整体收成梯形（= 真硬毛刷的笔锋）。 */
    for(var ja=0; ja<P.length; ja++){
      var _spA = span * 0.5 * (_tpArr ? _tpArr[ja] : 1);
      var qa = MAP(P[ja].x + NX[ja]*_spA, P[ja].y + NY[ja]*_spA, mk);
      if(ja === 0) ctx.moveTo(qa[0], qa[1]); else ctx.lineTo(qa[0], qa[1]);
    }
    for(var jb=P.length-1; jb>=0; jb--){
      var _spB = span * 0.5 * (_tpArr ? _tpArr[jb] : 1);
      var qb = MAP(P[jb].x - NX[jb]*_spB, P[jb].y - NY[jb]*_spB, mk);
      ctx.lineTo(qb[0], qb[1]);
    }
    ctx.closePath();
    ctx.fill();
    /* ② 毛须：每根**整条一次 stroke**、宽度恒定 ⇒ 无从产生段界。
       🔴 试过"按弧长分段改线宽"造断续缝（v2）—— 无论 round 还是 butt 帽都会留下
          **砖墙/梯子**状的段界（`_b3.png` 实拍）。断续感改由"底色带 + 每根毛须起止错开"承担。 */
    ctx.globalAlpha = A2;
    ctx.lineCap = 'butt';
    for(var i=0;i<K;i++){
      var ii = i % H.n;
      /* 🔴 2026-10-02（乙·返修）：**缝的绝对下限**。缝宽 = `step − 相邻两根的宽度`，而宽度 = `step × jw`
         （`jw` 是逐根随机 0.55~1.02）⇒ 两根都抽到偏厚时**缝会消失**（实测 `gapPx` 在 0~5 设备 px 间乱跳）。
         ⇒ 把线宽**封顶**在 `step − fxMin`：无论 jw 抽到什么，缝都 ≥ fxMin。
         「减数量、不缩元素」的另一半：元素（缝）有下限，宽了就把线**压窄**。
         ⚠️ `fxMin` 取 1.25（不是默认 0.9）—— 两侧都是不透明线时，AA 会填掉 ~1.7 画布 px 的缝
            （实测 0.9 CSS 档 `gaps` 在 0/1 乱跳 = 判据不可靠）。 */
      ctx.lineWidth = Math.max(0.5, Math.min(step * H.jw[ii], step - _fxm));
      var off = (i - (K-1)/2) * step + H.jd[ii] * step;
      /* 🔴 2026-10-01（乙·第三批·v3）：**不做起止错开**。试过起点 0~10% / 终点 0~4.5% 的错开，
         实拍两端各出现一排"阶梯状灰块"（部分毛须先结束 ⇒ 只剩底色带），像没画匀。
         齐平的方头两端更接近真笔刷（缝的断续感已由 `jw` 的参差承担）。 */
      ctx.beginPath();
      for(var jc=0; jc<P.length; jc++){
        var _ofB = _tpArr ? off * _tpArr[jc] : off;      /* §6：两端向中心聚拢 = 笔锋 */
        var q = MAP(P[jc].x + NX[jc]*_ofB, P[jc].y + NY[jc]*_ofB, mk);
        if(jc === 0) ctx.moveTo(q[0], q[1]); else ctx.lineTo(q[0], q[1]);
      }
      ctx.stroke();
    }
  }
  ctx.globalAlpha = keepA; ctx.lineWidth = keepW; ctx.lineCap = keepCap;
}

/* 2026-10-04（乙）：**柔边（软圆笔）** —— 唯二走"多遍递减宽度 stroke"的渲染器。
   `_strokeRender` 的通用路径是「整条轮廓一次 fill」⇒ 同一个 alpha 铺满 ⇒ 边缘与中心同实
   （实拍 = 硬边色块）。这里改成：
     把中心线 path **建一次**，然后用**逐层递减的 `lineWidth`** stroke NE 次
     （最外最宽、alpha 最低；最内最窄、alpha 最高）⇒ 横向形成径向 alpha 分布。
   🔴 用 stroke 而非多次 fill：同一条 path 多次 fill 会**叠色**（中心越来越深、边缘不变），
      而 width 递减的 stroke 天然是"外淡内浓"。
   🔴 每层 alpha 用 `1 − (1−A)^(1/NE)` 反算 ⇒ NE 层在中心叠加后 ≈ A **与原值一致**（亮度不漂）。
   🔴 `lineCap='butt'`（soft 的 cap 本就是 butt，方头端更贴"柔焦/气笔"）；横向柔边不受影响。
   🔴 path 只建一次、`stroke()` 调 NE 次 ⇒ 顶点数不变（只有 stroke 次数 ×NE），性能可控。 */
function _accSoftStroke(P, NX, NY, HW, mirs, MAP, cfg){
  var ctx = pfmDrawCtx, n = P.length;
  if(n < 2) return;
  var NE = Math.max(2, Math.min(10, (cfg.softEdge | 0) || 6));
  /* soft 是 `noSpeed:1` + 无 charge/tIn/tOut/minW ⇒ HW 恒定；取最大值即可（逐点变宽 canvas
     的 stroke 做不到，而这里本来就不需要）。 */
  var hwMax = 0;
  for(var q=0;q<n;q++){ if(HW[q] > hwMax) hwMax = HW[q]; }
  if(hwMax < 0.2) return;
  var keepA = ctx.globalAlpha, keepW = ctx.lineWidth, keepCap = ctx.lineCap, keepS = ctx.strokeStyle;
  var A = ctx.globalAlpha;                                   /* 已是 a × 笔刷不透明度 × 墨量均值 */
  var aE = 1 - Math.pow(Math.max(1e-4, 1 - A), 1 / NE);      /* 每层 alpha（叠加后 ≈ A） */
  ctx.strokeStyle = ctx.fillStyle;
  ctx.lineCap = 'butt'; ctx.lineJoin = 'round';
  var sol = ctx.lineWidth;
  for(var mi=0;mi<mirs.length;mi++){
    var mk = mirs[mi];
    ctx.beginPath();
    for(var j=0;j<n;j++){
      var p2 = MAP(P[j].x, P[j].y, mk);
      if(j === 0) ctx.moveTo(p2[0], p2[1]); else ctx.lineTo(p2[0], p2[1]);
    }
    for(var e=0;e<NE;e++){
      var fr = (NE > 1) ? (e / (NE - 1)) : 1;                /* 0 = 最外层（最宽最淡） */
      var wE = 2 * hwMax * (1 - 0.80 * fr);
      if(wE < 0.3) continue;
      ctx.globalAlpha = aE;
      ctx.lineWidth = wE;
      ctx.stroke();
    }
  }
  ctx.globalAlpha = keepA; ctx.lineWidth = keepW; ctx.lineCap = keepCap; ctx.strokeStyle = keepS;
  void sol;
}

/* ===== 2026-10-01（乙·性能）：air 的**增量散点** =====
   `(x0,y0) → (x1,y1)` 是**本帧新增**的那一小段；只在这段上撒点，已画过的部分不动。
   🔴 为什么不能"整笔累积重画"（v1 的错）：每帧要重画整条笔迹的点（3.5 点/画布 px，且
      随笔迹长度**线性增长**）⇒ 实测 336ms/步、**8fps**。而散点**画上去就不该再变**，
      它没有形状/蛛网那种"拖动预览"语义 ⇒ 整笔重画纯属浪费。
   🔴 但**种子仍然按"绝对弧长"取**（`pfmDraw.airS` 游标 + `k*stride` 网格）：
      这样同一处的点在跨帧时不会换位置（用帧内计数当种子的话，快速拖动时点会"跳"）。
   🔴 与整笔版**同密度**（同一个 `stride`/`per` 公式）⇒ 观感零变化。 */
function _airScatter(x0, y0, x1, y1, cfg){
  var ctx = pfmDrawCtx;
  var bs = Math.max(1, pfmDraw.brushSize);
  var dx = x1 - x0, dy = y1 - y0;
  var dist = Math.sqrt(dx*dx + dy*dy);
  if(dist < 0.01) return;
  var s = pfmDraw.airS || 0;
  var stride = Math.max(1.5, bs * 0.05);
  var per = Math.max(1, Math.round((cfg.count || 8) * Math.min(5, Math.max(1, bs / 12)) / 4));
  var rad = Math.max(1, bs * (cfg.spread || 1.4));
  /* 🔴 2026-10-02（乙）：下限 0.5 → `fxMin`（0.8）。0.5~0.56px 的"点"会被抗锯齿抹成一片灰雾，
     看不出**点**的颗粒感（雾要靠"点"读出来）。air 的拖动与积墨两处同改。 */
  var dot = Math.max(_fxMin(cfg), Math.min(bs * (cfg.dot || 0.14), cfg.dotMax || 4));
  var k0 = Math.floor(s / stride) + 1;
  var kEnd = Math.floor((s + dist) / stride);
  var keepA = ctx.globalAlpha;
  ctx.globalAlpha = _pfmA() * ((cfg.a === undefined) ? 1 : cfg.a);
  for(var k = k0; k <= kEnd; k++){
    var t = (k * stride - s) / dist;
    if(t < 0 || t > 1) continue;
    var px = x0 + dx * t, py = y0 + dy * t;
    var seed0 = Math.round(k * stride * 13.7);
    for(var c = 0; c < per; c++){
      var sd = seed0 + c * 911;
      var ang = _accRnd(sd) * Math.PI * 2;
      var rr = Math.sqrt(_accRnd(sd + 7)) * rad;
      var qx = px + Math.cos(ang) * rr, qy = py + Math.sin(ang) * rr;
      ctx.beginPath(); ctx.arc(qx, qy, dot, 0, Math.PI * 2); ctx.fill();
      var mp = _symPts(qx, qy);
      for(var j = 0; j < mp.length; j++){ ctx.beginPath(); ctx.arc(mp[j].x, mp[j].y, dot, 0, Math.PI * 2); ctx.fill(); }
    }
  }
  ctx.globalAlpha = keepA;
  pfmDraw.airS = s + dist;
}

/* 2026-10-02（丙②）：**停留积墨** —— 真喷枪（PS Airbrush / Krita Spray / Win11 喷枪）按住不动会
   持续喷、密度随时间上升。原来只有 `_airScatter`（按**位移**铺点）⇒ 指针一停就什么都不画
   （`_verify_real.js` A1 实测：按住 0.4s 与 1.9s 都是 **0 像素**）。
   `_airPuff` 就是"不动时的那一次喷"：种子按**次数**推进（不是弧长）⇒ 每次 puff 落在新位置，
   累积成雾。alpha 取 `cfg.a × 0.30`（比拖动时的单点淡）⇒ 与拖动叠加也不突兀。 */
function _airPuff(x, y, cfg){
  var ctx = pfmDrawCtx;
  var bs = Math.max(1, pfmDraw.brushSize);
  var per = Math.max(2, Math.round((cfg.count || 8) * Math.min(5, Math.max(1, bs / 12)) / 3));
  var rad = Math.max(1, bs * (cfg.spread || 1.4));
  /* 🔴 2026-10-02（乙）：下限 0.5 → `fxMin`（0.8）。0.5~0.56px 的"点"会被抗锯齿抹成一片灰雾，
     看不出**点**的颗粒感（雾要靠"点"读出来）。air 的拖动与积墨两处同改。 */
  var dot = Math.max(_fxMin(cfg), Math.min(bs * (cfg.dot || 0.14), cfg.dotMax || 4));
  var keepA = ctx.globalAlpha;
  ctx.globalAlpha = _pfmA() * ((cfg.a === undefined) ? 1 : cfg.a) * 0.30;
  var seed = (pfmDraw.airPuffSeed = ((pfmDraw.airPuffSeed || 1) + 7919) >>> 0);
  for (var c = 0; c < per; c++) {
    var sd = seed + c * 911;
    var ang = _accRnd(sd) * Math.PI * 2;
    var rr = Math.sqrt(_accRnd(sd + 7)) * rad;
    var qx = x + Math.cos(ang) * rr, qy = y + Math.sin(ang) * rr;
    ctx.beginPath(); ctx.arc(qx, qy, dot, 0, Math.PI * 2); ctx.fill();
    var mp = _symPts(qx, qy);
    for (var j = 0; j < mp.length; j++) { ctx.beginPath(); ctx.arc(mp[j].x, mp[j].y, dot, 0, Math.PI * 2); ctx.fill(); }
  }
  ctx.globalAlpha = keepA;
}

/* ===== 2026-10-01（乙·第三批）：**彗星整笔渲染** =====
   旧实现（`drawFxStroke` 的 comet 分支）**每段**画 3 层折返尾巴 + 一个圆点：
   尾巴最长只有 7×笔宽、且被后一段的圆点压在下面 ⇒ 密集采样下只看得到一串**胶囊**，彗尾完全消失。
   现在：整条笔迹**最近 `tailLen` 弧长**的一段画成**渐细渐淡**的折线（分 12 层），末端一个实心彗核。
   🔴 分层之间**共享端点 + `lineCap='round'`** ⇒ 段界被圆帽盖住，看不出接缝（这不是"分段绘制"，
     而是"同一条尾巴的宽度渐变"；真正的分段绘制问题是每段各自重来、位置错开）。
   🔴 分层的索引按**弧长**取（`total - s`），不按点索引 —— 鼠标采样疏密不均时，按索引分层会一边厚一边薄。 */
/* 🔴 2026-10-04（用户报「Comet 画出来和蝌蚪似的」）：把一个颜色串解析成带 alpha 的 rgba。
   引擎里 `drawFxColor()` 可能返回 `#rrggbb` / `#rgb` / `rgb()` / `rgba()` / 渐变对象；
   前四种能转 ⇒ 彗尾可以**用线性渐变做渐隐**；渐变对象则降级为整体半透明。 */
function _rgbaA(col, a){
  if(typeof col !== 'string') return null;
  var m = /^#([0-9a-fA-F]{6})$/.exec(col);
  if(m){ var v = parseInt(m[1], 16); return 'rgba(' + ((v>>16)&255) + ',' + ((v>>8)&255) + ',' + (v&255) + ',' + a + ')'; }
  m = /^#([0-9a-fA-F]{3})$/.exec(col);
  if(m){ var t3 = m[1]; return 'rgba(' + parseInt(t3[0]+t3[0],16) + ',' + parseInt(t3[1]+t3[1],16) + ',' + parseInt(t3[2]+t3[2],16) + ',' + a + ')'; }
  m = /^rgba?\(([^)]+)\)$/.exec(col);
  if(m){ var pp = m[1].split(','); return 'rgba(' + pp[0].trim() + ',' + pp[1].trim() + ',' + pp[2].trim() + ',' + a + ')'; }
  return null;
}
function _cometRender(){
  var pts = pfmDraw.cometPts;
  if(!pts || pts.length < 2) return;
  var P = pts.concat([{ x: pfmDraw.lastX, y: pfmDraw.lastY }]);
  var ctx = pfmDrawCtx;
  _snapRestore(pfmDraw.cometBox);   /* 丙·B：只还原上一帧彗星的范围 */
  var bs = Math.max(1, pfmDraw.brushSize);
  /* 🔴 2026-10-04：核 0.75→0.45×bs（原头过大 ⇒ 像蝌蚪）；尾最宽 0.85×bs ⇒ box 按 1.05× 留量。 */
  pfmDraw.cometBox = _ptsBox(P, bs * 1.05 + 6);
  var n = P.length;
  var cum = [0], j;
  for(j=1;j<n;j++){
    var ex = P[j].x - P[j-1].x, ey = P[j].y - P[j-1].y;
    cum.push(cum[j-1] + Math.sqrt(ex*ex + ey*ey));
  }
  var total = cum[n-1] || 1;
  /* 🔴 尾长 bs*4…bs*9 ⇒ bs*6…bs*14（更飘逸，像流星而不是蝌蚪尾巴） */
  var tailLen = Math.max(bs * 6, Math.min(bs * 14, total));
  var s0 = Math.max(0, total - tailLen);
  var i0 = 0;
  while(i0 < n - 2 && cum[i0 + 1] < s0) i0++;
  var keepA = ctx.globalAlpha;
  ctx.save();
  ctx.lineJoin = 'round';
  var col = drawFxColor();
  /* 🔴🔴 尾巴改为**一条连续锥形带**（沿路径取样、向两侧各偏移半宽、一次性 fill）。
     改前是 12 段"圆头折线"逐段描边 ⇒ 段段重叠成**串珠**（用户看到的那一串圆块）。 */
  var SEG = 30, up = [], dn = [], q;
  for(q = 0; q <= SEG; q++){
    var t = q / SEG;                                  /* 0 = 尾梢 · 1 = 贴核 */
    var sPos = s0 + (total - s0) * t;
    var k = i0;
    while(k < n - 2 && cum[k + 1] < sPos) k++;
    var seg = Math.max(1e-6, cum[k + 1] - cum[k]);
    var uu = Math.max(0, Math.min(1, (sPos - cum[k]) / seg));
    var bx = P[k].x + (P[k+1].x - P[k].x) * uu;
    var by = P[k].y + (P[k+1].y - P[k].y) * uu;
    var tx = (P[k+1].x - P[k].x) / seg, ty = (P[k+1].y - P[k].y) / seg;
    var hw = bs * (0.05 + 0.80 * Math.pow(t, 0.62));
    up.push([bx - ty * hw, by + tx * hw]);
    dn.push([bx + ty * hw, by - tx * hw]);
  }
  ctx.beginPath();
  ctx.moveTo(up[0][0], up[0][1]);
  for(q = 1; q <= SEG; q++) ctx.lineTo(up[q][0], up[q][1]);
  for(q = SEG; q >= 0; q--) ctx.lineTo(dn[q][0], dn[q][1]);
  ctx.closePath();
  var c0 = _rgbaA(col, 0), c1 = _rgbaA(col, 0.5), c2 = _rgbaA(col, 1);
  if(c0 && c1 && c2){
    var grad = ctx.createLinearGradient(P[i0].x, P[i0].y, P[n-1].x, P[n-1].y);
    grad.addColorStop(0, c0); grad.addColorStop(0.42, c1); grad.addColorStop(1, c2);
    ctx.fillStyle = grad; ctx.globalAlpha = keepA;
  } else { ctx.fillStyle = col; ctx.globalAlpha = keepA * 0.85; }
  ctx.fill();
  ctx.globalAlpha = keepA;
  ctx.fillStyle = col;
  ctx.beginPath(); ctx.arc(P[n-1].x, P[n-1].y, Math.max(1, bs * 0.45), 0, Math.PI * 2); ctx.fill();
  ctx.restore();
}


function _strokeRender(){
  var pts = pfmDraw.strPts;
  if(!pts || !pts.length) return;
  var cfg = _bcfg(pfmDraw.tool) || {};
  var ctx = pfmDrawCtx;
  var P = pts.concat([{ x: pfmDraw.lastX, y: pfmDraw.lastY, t: _pfmNowTs() }]);   /* 末点跟手 */
  /* 🔴 2026-10-02：**丢掉与上一点重合的末点**。抬笔时 `lastX/lastY` 与 `strPts` 的最后一点
     是同一个坐标（move 时已 push 过）⇒ 两点重合 ⇒ `NX/NY` 算出 (0,0) ⇒ 该点轮廓**塌陷**、
     末段变成一条退化竖条。重合就 pop（拖动帧不受影响：那时 lastX/lastY 还落后一步）。 */
  if(P.length > 2){
    var _pl = P[P.length-1], _pq = P[P.length-2];
    if(Math.abs(_pl.x - _pq.x) < 0.01 && Math.abs(_pl.y - _pq.y) < 0.01) P.pop();
  }
  if(P.length < 2) P = [P[0], { x: P[0].x + 0.01, y: P[0].y, t: P[0].t }];
  _strokeRestore();
  var n = P.length, NX = [], NY = [], CUM = [0], HW = [], LOAD = [], INK = [];
  var bs = Math.max(1, pfmDraw.brushSize);
  /* 🔴 2026-10-02（丙·返修§6）：**笔迹总弧长**（画布 px）—— 行程锥度的收笔端要用
     （起笔端用 `CUM[j]`，收笔端用 `totalLen − CUM[j]`）。一次 O(n) 遍历，可忽略。 */
  var totalLen = 0;
  for(var jt=1;jt<n;jt++){
    var _tx = P[jt].x - P[jt-1].x, _ty = P[jt].y - P[jt-1].y;
    totalLen += Math.sqrt(_tx*_tx + _ty*_ty);
  }
  /* 🔴🔴 2026-10-02（丙·返修§4·乙）：**沿长度淡出**（Procreate `Fall Off` 的等效 ——
     官方原文「让下笔时的笔划完全可见并**随着路径延伸而淡出**」）。
     做法：把整条笔迹的 `fillStyle` 换成**沿「起笔 → 收笔」方向的线性渐变**（alpha 1 → kEnd），
     **一次 fill 完成** ⇒ 零额外顶点、无接缝（对比：分段 fill 会在段界留抗锯齿接缝；
     分层前缀 fill 顶点 ×3.5）。已实测：`addColorStop` 的 rgba alpha 沿方向平滑生效。
     🚫 **渐变不能塞 pattern**（`addColorStop(0.5, CanvasPattern)` ⇒ SyntaxError）
        ⇒ 只在 `fillStyle` 是**纯色 hex** 时启用；有 `tex` 的 crayon（pattern）自动退回整笔平均。
     ⚠️ 端点必须过 `MAP`，否则**对称镜像**那一侧的渐变方向会反。 */
  var _fsStr = String(ctx.fillStyle);
  var useGrad = !!(cfg.charge && n > 2 && /^#[0-9a-fA-F]{6}$/.test(_fsStr));
  var gRGB = useGrad ? hexToRgb(_fsStr) : null;
  /* 🔴 2026-10-01（乙）修：宽度 EMA 的**初值必须是该笔的目标宽度**（bs × cfg.w），不是 `bs`。
     用 `bs` 的话每支笔的**起笔段都从 1× 渐粗到自己的倍数**：
     marker(2.2×)/crayon/soft 起笔明显偏细，`_verify_brushes` 的 D9 因此报
     「marker 的 thickVar 从 0 涨到 23」——"等宽"这条不成立。 */
  var curW = bs * (cfg.w || 1), lastV = 0;
  /* 2026-10-02（丙·墨量）：墨耗尽后的下限（不写 0 —— 干透的笔也要留痕，否则用户以为画板坏了）。 */
  var chgMin = (cfg.dryMin === undefined) ? 0.32 : cfg.dryMin;
  /* `dryA` = 墨量耗尽处的 alpha 衰减幅度（0..1；0.45 ⇒ 尾部 alpha 降到 55%）。见下方 `LOAD.push`。 */
  var dryA = (cfg.dryA === undefined) ? 0.45 : cfg.dryA;
  for(var j=0;j<n;j++){
    var a1 = P[Math.max(0,j-1)], b1 = P[Math.min(n-1,j+1)];
    var dx = b1.x - a1.x, dy = b1.y - a1.y, L = Math.sqrt(dx*dx + dy*dy) || 1;
    NX.push(-dy/L); NY.push(dx/L);
    var seg = 0;
    if(j > 0){
      var ex = P[j].x - P[j-1].x, ey = P[j].y - P[j-1].y;
      seg = Math.sqrt(ex*ex + ey*ey);
      CUM.push(CUM[j-1] + seg);
    }
    var dt = Math.max(1, P[j].t - P[Math.max(0,j-1)].t);
    /* 🔴 2026-10-02（丙④）：**首点不参与速度估计** —— j=0 时 seg=0 ⇒ `0/dt=0` ⇒ lastV 被拉成 0
       ⇒ `kk = 1.15`（满宽）⇒ 起笔处一个**鼓包**（哑铃的另一头）。首点没有速度信息，保持"中性"。 */
    if(j > 0) lastV = lastV + ((seg / dt) - lastV) * 0.4;             /* 速度 EMA，防抖 */
    var proj = 1;
    if(cfg.chisel !== undefined && (dx || dy)) proj = Math.abs(Math.cos(Math.atan2(dy,dx) - cfg.chisel*Math.PI/180));
    var tw = bs * (cfg.w || 1) * Math.max(0.22, proj);
    if(pfmDraw.useSpeed !== false && !cfg.noSpeed){
      var kk = (j === 0) ? 1 : (1.15 - Math.min(0.8, lastV / 1.6));
      /* 🔴 2026-10-02（丙④）：下限 0.35 → **0.62**。0.35 时真人/Playwright 的慢速采样会把
         `lastV` 顶到 ≥1.28 ⇒ kk 触底 ⇒ 中间被压到 0.35×，而两端各一个鼓包
         ⇒ **匀速拖动也是哑铃形**（实测 brush 两端 49/31 对中间 17）。
         真画笔匀速拖动是**等宽**的，锥度只在明显加减速时出现。 */
      tw *= Math.max(Math.max(cfg.taper || 0, 0.62), Math.min(1.15, kk));
    }
    if(cfg.minW) tw = Math.max(cfg.minW, tw);
    curW = curW + (tw - curW) * 0.35;                                  /* 宽度 EMA，与逐段版同系数 */
    var hw = Math.max(0.25, curW / 2);
    if(cfg.nib && j === 0) hw *= 1.35;                                 /* 硬笔尖：落笔顿点 */
    /* 🔴🔴 2026-10-02（丙·返修§6）：**行程锥度 = 笔锋**（Procreate `Taper` / Win11 画图那 9 支笔的共同特征）
       —— 官方原文：「调节下笔时的笔划**起始和结尾**粗细度及可见度，让笔划呈现自然、渐细的效果」。
       🔴 与**速度锥度**（下面那段 `kk`）是**两回事**：速度锥度只在加减速时出现，匀速拖动是等宽的；
          而「笔锋」是**不管快慢、两端必然收细**。我原来只做了前者，还把下限提到 0.62 ⇒ 结果是
          「等宽 + 起笔鼓包」（实测 brush 起/中 = **1.44**），与真笔完全相反。
       🔴 用**绝对长度**（`tLen` × 笔宽）而非比例：真笔的笔锋长度固定，不随笔画总长变化。
       🚫 `tIn`/`tOut` 未设（=1）的笔**完全不受影响**（逐像素零回归）：ink（针管笔）/soft/pixel/oil 等。 */
    var _tIn = (cfg.tIn === undefined) ? 1 : cfg.tIn;
    var _tOut = (cfg.tOut === undefined) ? 1 : cfg.tOut;
    if(_tIn < 1 || _tOut < 1){
      var _tl = ((cfg.tLen === undefined) ? 1.2 : cfg.tLen) * bs;
      var _tp = 1;
      if(_tIn < 1){ var _fa = CUM[j] / _tl; if(_fa < 1) _tp = Math.min(_tp, _tIn + (1 - _tIn) * _fa); }
      if(_tOut < 1){ var _fb = (totalLen - CUM[j]) / _tl; if(_fb < 1) _tp = Math.min(_tp, _tOut + (1 - _tOut) * _fb); }
      hw *= _tp;
    }
    /* 🔴🔴 2026-10-02（丙·墨量耗尽）：**单笔内的「蘸色 → 渐干」**
       （PS Load / Procreate Charge / Krita Soak Ink / Corel Painter 吸墨 的等效机制）
       `charge` = 这一笔能画多长（**笔宽倍** —— 笔越粗越费墨，符合真笔的观感），
       沿**弧长** `CUM` 线性耗尽 ⇒ `inkJ` 从 1 落到 `dryMin`。
       🔴 **蘸色 = 抬笔再落笔**：`CUM` 每笔从 0 重算 ⇒ 每笔天然满墨
          ⇒ **零状态、零泄漏、零 UI**（不做墨量条，也不会出现「画着画着画不出来」）。
       三项表达（都是「笔干了」的真实表现）：
         ① 变细 `hw × (0.75 + 0.25·inkJ)`（尾部最多细 25%）
         ② 略淡 `LOAD × (0.80 + 0.20·inkJ)`（整笔平均最多淡 20% —— **必须有上限**，
            否则用户读到的不是「笔干了」而是「这支笔颜色不对」）
         ③ 飞白（见下方 `cfg.charge` 分支，尾部按段跳过 ⇒ 越画越碎）
       未设 `charge` 的笔 ⇒ `inkJ` 恒 1 ⇒ **逐像素零回归**。 */
    var inkJ = 1;
    if(cfg.charge) inkJ = Math.max(chgMin, 1 - CUM[j] / (cfg.charge * bs));
    hw *= (0.75 + 0.25 * inkJ);
    HW.push(hw);
    /* 🔴 2026-10-02（丙·返修）：alpha 的墨量衰减从「×(0.80 + 0.20·inkJ)」（最多淡 20%）
       提到 **×(1 − (1−inkJ)·dryA)**（默认 `dryA = 0.45` ⇒ 耗尽处 alpha 降到 **55%**）。
       为什么：飞白关掉后，「变淡」成了**唯一**能表达「墨量耗尽」的手段，
       而 20% 的幅度会被速度项（`load` 占 35%）淹没 —— 实测尾/首只有 **0.945**，根本测不出来。
       ⚠️ 仍**有上限**（干透处还有 55% 的墨，不会淡到看不见）。 */
    /* 🔴🔴 2026-10-02（丙·返修§5）：**墨量项必须彻底从 `LOAD` 拿掉**（用户报「crayon 卡顿，会断」）。
       原因：它把 `lss` 拉低 ⇒ **误触发「速度飞白」**（判据 `cfg.load && lss < 0.42`）
       ⇒ 整 `SEG` 段被跳过 = **笔画断成虚线**。
       实测（`_t_dbg.js`，快拖 30 步、`lastV` 饱和 = 2.06 · 画布 px/ms = 1.8 即饱和）：
         brush (`load:0.35`) `lss = 0.65 × 0.694 = 0.451` ⇒ **> 0.42，安全**
         crayon(`load:0.45`) `lss = 0.55 × 0.694 = `**`0.382`** ⇒ **< 0.42 ⇒ 跳段（= 会断）**
         pencil(`load:0.55`) `lss = 0.45 × 0.694 = `**`0.312`** ⇒ 断得更厉害
       ⚠️ 我原来的 `A2「笔画连续」`判据**只测 brush** ⇒ 恰好避开了会断的两支笔（假 PASS）。
       ⇒ 墨量现在只由两处表达：**变细**（`HW`）+ **渐变 alpha**（纯色笔的 `useGrad`）；
         非纯色笔（crayon 的 `tex`）只有"变细"，但**绝不再触碰 `LOAD`**。
       ⇒ `LOAD` 恢复成只含速度项 ⇒ 速度飞白的触发条件与改前**逐位相同**（零回归）。 */
    LOAD.push(1 - (cfg.load || 0) * Math.min(1, lastV / 1.8));
    INK.push(inkJ);
  }
  var A = _pfmA() * ((cfg.a === undefined) ? 1 : cfg.a);
  var sym = _symMode(), ax = _symAxisX(), ay = _symAxisY();
  /* 🔴🔴 2026-10-03（乙-1）：镜像清单与点映射**收归单一实现**
     （`_symMarkers()` / `_symMapPoint()`）。改前这里另写了一份只认 v/h/quad 的表
     ⇒ 万花筒在 9 支"整笔累积"笔刷下静默无镜像（行显示、档位可选、画出来只有一笔）。 */
  var mirs = _symMarkers();
  var MAP = function(x, y, mk){ return _symMapPoint(x, y, mk, ax, ay); };
  if(cfg.pixel){ _accPixel(P, mirs, ax, ay); _accBox(P, HW); return; }
  /* oil：无轮廓 fill，整条笔迹 = K 根连续毛须折线（见 `_accBristle`）。 */
  if(cfg.bristle){ _accBristle(P, NX, NY, HW, CUM, mirs, MAP); _accBox(P, HW); return; }
  var capRound = (cfg.cap !== 'butt');
  /* ===== 绘制（2026-10-01 乙·返修）：**一条 path + 多个闭合子路径 → 一次 fill** =====
     🔴 第一版是"按弧长分 10 组、每组一条轮廓各自 fill"，实拍立刻暴露两个硬伤：
        · 相邻组**共享端点** ⇒ 轮廓在组界重叠 ⇒ 重叠区被 fill 两次 ⇒ 一串**深色圆盘**（soft/marker 最明显）
        · 组界还会把闭合轮廓切成"独立图形" ⇒ 笔迹看着是一节一节
     ⇒ 正确做法：整条笔迹的轮廓拆成"每 ~6 个点一个小四边形子路径"，**全部放进同一个 path**，
        最后 **一次 fill**。canvas 的 fill 对同一 path 的多个子路径取**并集**（不做 alpha 叠加）⇒
        子路径之间**不会叠色**、笔迹仍是连续的一条。飞白 = 直接跳过某些小段（缺口干净）。
     🔴 墨量 alpha 用**整笔平均**（不能沿长度渐变：fill 的 alpha 是全路径统一的）；
        局部差异由**飞白**表达。 */
  var ldSum = 0;
  for(var ls0=0; ls0<n; ls0++) ldSum += LOAD[ls0];
  var keepA = ctx.globalAlpha, keepFill = ctx.fillStyle;
  /* 收笔处的 alpha 系数：与 `dryA` 同一口径（干透处 = 1−(1−chgMin)·dryA ≈ 0.69）。 */
  var kEnd = 1 - (1 - chgMin) * dryA;
  /* soft：柔边走"多遍递减宽度 stroke"（见 `_accSoftStroke`）。
     🔴 位置**必须**在 `ldSum` 之后、`SEG` 之前 —— `ctx.globalAlpha` 到那时才是 `A×墨量均值`。 */
  if(cfg.softEdge){
    ctx.globalAlpha = A * Math.min(1, ldSum / n);
    _accSoftStroke(P, NX, NY, HW, mirs, MAP, cfg);
    ctx.globalAlpha = keepA; ctx.fillStyle = keepFill;
    _accBox(P, HW);
    return;
  }
  var SEG = 6;
  for(var mi=0;mi<mirs.length;mi++){
    var mk = mirs[mi];
    ctx.globalAlpha = A * Math.min(1, ldSum / n);
    if(useGrad){
      var _e0 = MAP(P[0].x, P[0].y, mk), _e1 = MAP(P[n-1].x, P[n-1].y, mk);
      var _gg = ctx.createLinearGradient(_e0[0], _e0[1], _e1[0], _e1[1]);
      var _c = 'rgba(' + gRGB.r + ',' + gRGB.g + ',' + gRGB.b + ',';
      _gg.addColorStop(0, _c + '1)');
      _gg.addColorStop(1, _c + kEnd.toFixed(3) + ')');
      ctx.fillStyle = _gg;
    }
    ctx.beginPath();
    for(var s0=0; s0<n-1; s0+=SEG){
      var s1 = Math.min(n-1, s0+SEG);
      var lss = 0;
      for(var q=s0;q<=s1;q++) lss += LOAD[q];
      lss /= (s1 - s0 + 1);
      /* 飞白：低墨量小段按**稳定伪随机**跳过（种子取该段起始弧长 ⇒ 逐帧一致，不会闪） */
      if(cfg.load && lss < 0.42 && _accRnd(Math.round(CUM[s0] / 6) * 37 + 11) < (0.42 - lss) * 1.6) continue;
      if(cfg.charge){
        /* 🔴 2026-10-02（丙·墨量）：**干笔飞白** —— 墨量越低，断口越多。
           🔴 粒度必须是**点对**（不是 `SEG=6` 个点的整段）：在高频采样下 `SEG` 只有十几 px，
              但在**稀疏采样**（快拖 / 低刷新率 / 自动化脚本）下**一段就是整条笔迹的 1/4**
              —— 跳一段 = 少画四分之一条线（实测该段有内容的列数 184 → 38）。
           🔴🔴 **但也不能"一个点对一个子路径"**：那样每个子路径 4 个顶点 ⇒ 整条笔迹 **4n** 个顶点
              （原实现是 `n/SEG` 段 × 2×SEG = **2n**）⇒ 实测大笔宽下 crayon/brush/pencil 全部
              **慢约 2×**，且出现 100~280ms 的 GC 离群（`_diag_perf_all --bs=100`）。
              ✅ 正解 = **按「连续未跳过的段」合并子路径**：断口在哪里就切在哪里，
                 每段的顶点数 = 2×段长 ⇒ 全笔迹仍是 **2n** 个顶点（与原实现相同），
                 只有 `closePath` 的次数变多（很便宜）。
           种子 `_dryRnd(k2)` 用**点序号**（整数 hash，逐帧稳定、无浮点精度问题）⇒ 不会闪。 */
        /* 🔴🔴 2026-10-02（丙·返修）：**飞白默认关闭**（`dryFan` 默认 0）。
           为什么：用户看到实拍图的第一反应是「画笔会断断续续」——
           而「墨量耗尽」在专业软件里（PS `Load` / Procreate `Charge`）的主表现是
           **笔迹沿途变淡**，**不是断线**；断线是「干笔 / dry brush」的特征，属于另一支笔。
           ⇒ 现在的 charge = **变细 + 变淡**（笔画连续不断）。
           飞白保留为**可调项**：给某支笔写 `dryFan: 0.3 ~ 1.4` 即可开回来（越大断口越多）。
           ⚠️ `dens = 0` 时下面的循环恒不跳过 ⇒ 整段一个子路径 ⇒ **与原实现等价**（无性能代价）。 */
        var dens = (cfg.dryFan === undefined) ? 0 : cfg.dryFan;
        var a0 = s0;                                  /* 当前连续段的起点 */
        for(var k2 = s0; k2 <= s1; k2++){
          var jump = false;
          if(k2 < s1){
            var ik = INK[k2];
            if(ik < 0.62 && _dryRnd(k2) < (0.62 - ik) * dens) jump = true;
          }
          if(jump || k2 === s1){
            if(k2 > a0){                              /* 至少 2 个点才成轮廓 */
              for(var j2=a0;j2<=k2;j2++){
                var pa = MAP(P[j2].x + NX[j2]*HW[j2], P[j2].y + NY[j2]*HW[j2], mk);
                if(j2 === a0) ctx.moveTo(pa[0], pa[1]); else ctx.lineTo(pa[0], pa[1]);
              }
              for(var j3=k2;j3>=a0;j3--){
                var pb = MAP(P[j3].x - NX[j3]*HW[j3], P[j3].y - NY[j3]*HW[j3], mk);
                ctx.lineTo(pb[0], pb[1]);
              }
              ctx.closePath();
            }
            a0 = k2 + 1;
          }
        }
      } else {
        for(var j2=s0;j2<=s1;j2++){
          var pa = MAP(P[j2].x + NX[j2]*HW[j2], P[j2].y + NY[j2]*HW[j2], mk);
          if(j2 === s0) ctx.moveTo(pa[0], pa[1]); else ctx.lineTo(pa[0], pa[1]);
        }
        for(var j3=s1;j3>=s0;j3--){
          var pb = MAP(P[j3].x - NX[j3]*HW[j3], P[j3].y - NY[j3]*HW[j3], mk);
          ctx.lineTo(pb[0], pb[1]);
        }
        ctx.closePath();
      }
      /* 端帽：只在整个笔迹的首/末小段加；🔴 必须先 moveTo 到圆弧起点，
         否则 `arc()` 会从当前点**连一条直线**过去（第一版实拍端头的小钩就是这么来的）。 */
      if(capRound && s0 === 0){
        var c0 = MAP(P[0].x, P[0].y, mk), a0a = Math.atan2(NY[0], NX[0]);
        /* 🔴 2026-10-02：moveTo 必须落在 `_capArc` 的**起点角**上（首端 = ang）—— 见 `_capArc` 注释。 */
        ctx.moveTo(c0[0] + HW[0]*Math.cos(a0a), c0[1] + HW[0]*Math.sin(a0a));
        _capArc(ctx, c0[0], c0[1], HW[0], a0a, true);
      }
      if(capRound && s1 === n-1){
        var c1 = MAP(P[n-1].x, P[n-1].y, mk), a1a = Math.atan2(NY[n-1], NX[n-1]);
        /* 🔴 2026-10-02：尾端弧的起点角 = ang + π（与 `_capArc` 的 else 分支一致）。 */
        ctx.moveTo(c1[0] + HW[n-1]*Math.cos(a1a + Math.PI), c1[1] + HW[n-1]*Math.sin(a1a + Math.PI));
        _capArc(ctx, c1[0], c1[1], HW[n-1], a1a, false);
      }
    }
    ctx.fill();
  }
  if(cfg.streak) _accStreak(P, NX, NY, HW, CUM, mirs, MAP, cfg);   /* 丙⑥：蜡笔擦痕（填充之后） */
  ctx.globalAlpha = keepA;
  ctx.fillStyle = keepFill;                                       /* 渐变用完后还原（后续笔刷依赖它）*/
  /* 2026-10-01（乙·性能）：air 已改**增量撒点**（`_airScatter`）⇒ 不再走整笔累积，
     这里的 spread 分支与 `_accBox` 的 `pad` 一并撤除（那条路会让每帧重画整条笔迹的散点）。 */
  _accBox(P, HW);
}

/* 2026-10-02（丙⑥）：**蜡笔的方向性擦痕** —— 真蜡笔/粉笔的颗粒**沿运笔方向被拉长**
   （蜡被纸纹推着走），而原来的 `tex` 是**各向同性的噪声瓦片**：
   `_verify_real.js` D1 实测横拖/竖拖的各向异性 = 1.04 / 1.02 ⇒ 完全测不出方向性。
   做法：轮廓填充之后，沿笔迹画 K 条**平行细线**（局部切线方向、法向随机偏移 0~±0.85 笔宽、
   长度与 alpha 随机）⇒ 颗粒被"拉"成条纹 ⇒ 横竖拖的统计自然分开。
   🔴 不动 `tex`：那层纸纹颗粒留着（两者叠加才像蜡）。
   🔴 `strokeStyle = fillStyle` 沿用当前笔刷色（含 tex pattern / 渐变），不写第二份取色逻辑。 */
function _accStreak(P, NX, NY, HW, CUM, mirs, MAP, cfg){
  var ctx = pfmDrawCtx, n = P.length;
  if(n < 2) return;
  var total = CUM[n-1] || 1;
  var bs = Math.max(1, pfmDraw.brushSize);
  /* 🔴 2026-10-02（丙·性能）：条数从 `total/18`（上限 90）降到 **`total/30`（上限 34）**——
     90 条时笔宽 100 实测 28.8ms（×2.7，进了「慢的」列表）；42 条仍 22ms（×2.1）贴线。
     34 条实测 14.9ms（×1.4）。擦痕是「质感」不是「信息」，肉眼无差别但少了一半 stroke。 */
  /* ★ 2026-10-03（用户裁决 **甲·性能**）：条数再降一档 ⇒ **`total/70`（上限 14）**。
     动机：线上真机实测 crayon 每步 **19.9ms（笔宽 24）/ 21.3ms（笔宽 100）= brush 的 ×1.9**，
     是唯一**稳定 2×** 的画笔（marker/calli 首测 240ms 是 GC 伪影，隔离复测掉回 10.5ms）；
     长笔画 60/180/360 点实测 19.6/18.9/24.9（×1.3）⇒ 与点数基本无关，是**每步固定开销**。
     A/B 归因（本地预演，同一 run 内比 brush 基准）：原版 ×1.8（20.0ms）→ **只删 `streak`**
     ⇒ ×1.2（12.9ms，−35%）⇒ **根因就是本函数**（每条擦痕都要遍历全笔迹 n 点，O(K·n)）。
     ⇒ 选择**减 K**而不是删 streak：方向性擦痕是「蜡笔之所以像蜡笔」的特征，不能丢。
     ⚠️ 短笔迹（total < 280）仍落到下面的 `min 4` ⇒ **小笔画零变化**，只削长笔迹。
     ⚠️ 若后续仍嫌卡：下一步是 乙（关 streak 只留 tex，回 ~10.6ms）或 丙（增量追加，架构级）。 */
  /* 🔴 2026-10-05（用户裁决 ②·保量）：K 回抬到 `total/30`（上限 34）——
     即 10-02 验收过 D1=1.23/1.24 的那一档。10-03 为压 O(K·n) 把它砍到 14
     ⇒ `_verify_real` D1 掉到 1.10/1.07。本次配合下面的二分定位一并回抬
     （单条擦痕从 O(n) → O(log n)），条数翻 2.5x 而总耗时仍低于降量前。 */
  var K = Math.max(4, Math.min(34, Math.round(total / 30)));
  /* 🔴 2026-10-02（乙）：擦痕的**横向铺展** = `1.70 × HW`（见下面的 `offF`）。条数太多时
     相邻擦痕的间距 < 1px ⇒ 全叠在一起、退化成一条实心带（笔宽 4 实测 20 条挤在 3.4px 里）。
     约束：**每条至少占 1.05px 的横向空间** ⇒ `K ≤ 1.70 × HW均值 / 1.05`。
     笔宽 4 ⇒ K 从 20 降到 **3**；笔宽 30 ⇒ HW=15 ⇒ 上限 24，原 K=20 **不受影响**。 */
  var _hwS = 0; for(var _q = 0; _q < n; _q++) _hwS += HW[_q];
  var _hwA = _hwS / Math.max(1, n);
  var _spanX = 1.70 * _hwA;                       /* 擦痕的横向铺展（CSS px，与 offF 的范围一致） */
  /* 🔴 2026-10-02（乙·返修）：约束必须是「**相邻擦痕之间留得下一条可见的缝**」= `间距 ≥ 擦痕宽 + fxMin`，
     而不是上一版的「每条占 1.05px」—— 笔宽 4 实测：4 条 0.9px 的线间距只有 0.68 CSS px
     （1.28 设备 px）⇒ 仍然全叠，`gapPx` 只有 0.3 设备 px（没改善）。
     ⚠️ 只在**小笔宽**（笔画宽 ≤10 CSS px）生效：大笔宽那一档的观感已经验收过
        （随机偏移会天然扎堆 ⇒ 实测有 7.5 设备 px 的缝），**不能为了小笔宽去动它**。 */
  /* 🔴🔴 2026-10-05：**修死代码** —— `_lwCss` / `_strokeWCss` 原来在**使用之后**才 `var` 声明，
     var 提升成 `undefined` ⇒ `if(undefined <= 10)` 恒 false ⇒ **本段从未执行过**
     （下方注释写着「定义已提到前面」，实际没有 —— 典型「看不见的功能 = 不存在」）。
     现把两个声明**真正提到前面**，本约束恢复生效（仅小笔宽 ≤10 生效；D1 用笔宽 30 不受影响）。 */
  var _lwCss = Math.max(_fxMin(cfg), Math.min(3.2, bs * 0.055));
  var _strokeWCss = bs * ((cfg.w === undefined) ? 1 : cfg.w);
  if(_strokeWCss <= 10){
    var _room = _lwCss + _fxMin(cfg);
    var _kCap = Math.max(2, Math.floor(_spanX / _room));
    if(K > _kCap) K = _kCap;
  }
  var keepA = ctx.globalAlpha, keepW = ctx.lineWidth, keepC = ctx.lineCap, keepS = ctx.strokeStyle;
  ctx.lineCap = 'butt';
  ctx.strokeStyle = ctx.fillStyle;
  var A = _pfmA() * ((cfg.a === undefined) ? 1 : cfg.a);
  /* 擦痕线宽（CSS px）= 上面已算好的 `_lwCss`（已提到 `_kCap` 之前）。 */
  var lw = _lwCss;   /* 🔴 2026-10-02（乙）：下限 0.7 → `fxMin`(0.9)（0.7px 在默认笔宽 4 下是亚像素）；
                        上限 3.2 不变。定义已提到前面（K 的上限要用它）。 */
  for(var mi=0; mi<mirs.length; mi++){
    var mk = mirs[mi];
    for(var i=0;i<K;i++){
      var s0 = _accRnd(i * 311 + 11) * 0.82 * total;
      var lenF = (0.06 + _accRnd(i * 577 + 3) * 0.26) * total;
      /* 🔴 2026-10-02（乙）：条数很少时（≤6）**均布** —— 随机偏移在 K 小的时候会挤到一块
         （笔宽 4 只有 3 条，随机可能两条完全重合 ⇒ 白改）。均布后仍保留 ±0.06 的轻微抖动。 */
      /* 🔴 2026-10-02（乙·返修）：均布公式原来写成 `((i+0.5)/K − 0.5)` —— K=2 时得到 ±0.425（**只铺了一半**），
         两条擦痕挤在中间、间隔 0.3 设备 px（实测 FX2 仍 FAIL）。正解是 `i/(K−1) − 0.5`
         ⇒ K=2 时取 ±0.5 ⇒ 乘 1.70 得 ±0.85×HW（**铺满整个笔宽**）。 */
      var offF = (K <= 6)
        ? ((i / (K - 1)) - 0.5) * 1.70 + (_accRnd(i * 131 + 7) - 0.5) * 0.12
        : (_accRnd(i * 131 + 7) - 0.5) * 1.70;                 /* -0.85 .. +0.85 × HW */
      ctx.globalAlpha = A * (0.20 + _accRnd(i * 97 + 5) * 0.55);
      ctx.lineWidth = lw * (0.7 + _accRnd(i * 71 + 13) * 0.8);
      ctx.beginPath();
      var started = false;
      /* 🔴 2026-10-05（用户裁决 ②）：**二分定位起点** —— `CUM` 单调递增，
         原来每条擦痕都 `for(j=0;j<n;j++)` 全扫整条笔迹 ⇒ 总开销 O(K·n)
         （= 10-03 被迫把 K 砍到 14 的根因）。二分后 O(K·log n)，**逐像素等价**：
         同为「首个 CUM>=s0 起，首个 CUM>s0+lenF 止」。 */
      var _j0 = n;
      for(var _lo = 0, _hi = n - 1; _lo <= _hi;){
        var _md = (_lo + _hi) >> 1;
        if(CUM[_md] >= s0){ _j0 = _md; _hi = _md - 1; } else { _lo = _md + 1; }
      }
      var _jHi = s0 + lenF;
      for(var j=_j0;j<n;j++){
        if(CUM[j] > _jHi) break;
        var _o = HW[j] * offF;
        var q = MAP(P[j].x + NX[j]*_o, P[j].y + NY[j]*_o, mk);
        if(!started){ ctx.moveTo(q[0], q[1]); started = true; } else ctx.lineTo(q[0], q[1]);
      }
      if(started) ctx.stroke();
    }
  }
  ctx.globalAlpha = keepA; ctx.lineWidth = keepW; ctx.lineCap = keepC; ctx.strokeStyle = keepS;
}

function applyDrawStyle(){
  /* 🔴 2026-09-30（乙）：宽度 / 线帽 / 透明度全部改从 `BRUSH_CFG` **派生**（唯一真源）。
     原来这里是三条内联 if/else（ink ×1.2 · crayon 0.6 · soft 0.15）—— 与表里取值逐项相同，
     行为不变；新增笔刷不必再往这里加分支。 */
  var _cfg = _bcfg(pfmDraw.tool) || {};
  pfmDrawCtx.lineCap = _cfg.cap || 'round';
  pfmDrawCtx.lineJoin = 'round';
  var w = pfmDraw.brushSize * (_cfg.w || 1);
  if(_cfg.minW) w = Math.max(_cfg.minW, w);
  pfmDrawCtx.lineWidth = w;
  if(pfmDraw.isGradient){
    var g = pfmGradients[pfmDraw.gradientIndex];
    var grad = pfmDrawCtx.createLinearGradient(pfmDraw.lastX-50, pfmDraw.lastY-50, pfmDraw.lastX+50, pfmDraw.lastY+50);
    grad.addColorStop(0, g[0]); grad.addColorStop(1, g[1]);
    pfmDrawCtx.strokeStyle = grad;
    pfmDrawCtx.fillStyle = grad;
  } else {
    pfmDrawCtx.strokeStyle = pfmDraw.color;
    pfmDrawCtx.fillStyle = pfmDraw.color;
  }
  /* 2026-09-30（乙）：纹理 —— 描边/填充色换成**噪声瓦片图案**（蜡质/纸纹颗粒）。
     图案锚在画布坐标（不随笔走，与真实纸张一致）；渐变模式跳过（图案承载不了渐变）。 */
  if(_cfg.tex && !pfmDraw.isGradient){
    var _tile = _texTile(pfmDraw.color, _cfg.tex);
    var _tp = _tile ? pfmDrawCtx.createPattern(_tile, 'repeat') : null;
    if(_tp){ pfmDrawCtx.strokeStyle = _tp; pfmDrawCtx.fillStyle = _tp; }
  }
  /* 2026-09-12: 笔刷不透明度接入（只作用于笔刷类；形状/文字/填充不受影响，避免误伤）
     🔴 2026-09-30（乙）：改从 `BRUSH_CFG[tool].a` 派生（crayon 0.6 / soft 0.15 取值不变）。 */
  if(isBrushTool(pfmDraw.tool)||pfmDraw.tool==='spiro'||pfmDraw.tool==='spray'||pfmDraw.tool==='stamp'){
    pfmDrawCtx.globalAlpha = ((_cfg.a!==undefined) ? _cfg.a : 1) * _pfmA();
  } else {
    pfmDrawCtx.globalAlpha = 1;
  }
  /* ===== 2026-09-21 第 7 批：混合模式（Blend） =====
     🔴 只作用于**笔刷 / 形状 / 填充**（即「产出像素」的工具）；
        橡皮**刻意排除** —— 它自己用 destination-out，叠加会互相污染（见 663/728 行）。
     🔴 唯一的读取点就在这里（应用样式的单一入口）⇒ 只要所有绘制段都经 `applyDrawStyle()`，
        模式就自动生效，不需要在各绘制分支里重复设置。
     🔴 默认 = 'source-over'（Normal）= 改前行为 ⇒ 零回归。
     🔴🔴 **这里必须调 `_blendMode()`（无参）** —— `applyDrawStyle` 本身**没有参数**，
        `tool` 在它内部是**未声明的自由变量** ⇒ 写 `_blendMode(tool)` 会抛
        `ReferenceError: tool is not defined` ⇒ 本函数从这一行**中断**，
        调用方的后续代码（形状的 `_paintShape`）永不执行 ⇒ 形状工具静默画不上。
        （`node --check` 语法合法、CDP 因 asset 跨域也看不到堆栈 ⇒ 极难排查。）
        `_blendMode` 内部第一行就是 `tool || pfmDraw.tool` 的兜底 ⇒ 无参调用即正确。 */
  pfmDrawCtx.globalCompositeOperation = _blendMode();
}
/* 混合模式：DOM 直读（与 Stabilizer/Hollow/描边同哲学 —— 绝不写 window 变量却无人读）。
   返回**可直接赋给 ctx 的值**；不在白名单内一律回落 'source-over'（防御性，且天然零回归）。 */
function _blendMode(tool){
  var t = tool || (pfmDraw && pfmDraw.tool);
  /* 橡皮 / 擦除类自有 composite 语义，不参与混合 */
  if(t==='eraser') return 'source-over';
  var el = document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-blend].sel');
  if(!el) return 'source-over';
  var v = el.getAttribute('data-blend');
  /* 🔴🔴 2026-10-04（用户：「混合模式也增加」，UI 裁四栏）：
     6 → 16 种，补齐 PS/Procreate 的标准混合模式。
     ⚠️ 这些全部是 **Canvas 原生** `globalCompositeOperation` 的值 ⇒ 无需自实现算法，
        `OK` 表只是"白名单"（防止 UI 传入非法值）。
     ⚠️ 同时修掉一个既有不一致：darken / lighten 原本在表里但 UI 没给 chip ⇒ 点不到。 */
  var OK = { normal:'source-over', multiply:'multiply', screen:'screen',
             overlay:'overlay', darken:'darken', lighten:'lighten',
             'color-burn':'color-burn', 'color-dodge':'color-dodge',
             'hard-light':'hard-light', 'soft-light':'soft-light',
             difference:'difference', exclusion:'exclusion',
             hue:'hue', saturation:'saturation', color:'color', luminosity:'luminosity' };
  return OK[v] || 'source-over';
}
/* 混合模式是否应该对当前工具显示（笔刷 / 形状 / 填充；橡皮与选择工具不显示） */
function _isBlendTool(t){
  if(!t) return false;
  if(t==='eraser'||t==='selrect'||t==='selasso'||t==='selwand') return false;
  if(t==='fill'||t==='text'||t==='path') return true;
  if(t==='rect'||t==='circle'||t==='line'||t==='arrow') return true;
  if(t==='spiro'||t==='stamp') return true;
  return isBrushTool(t);
}

/* 2026-09-12: 画笔工具函数 —— 时间戳(速度感应) / 笔刷不透明度 */
function _pfmNowTs(){ return (typeof performance!=='undefined' && performance.now) ? performance.now() : Date.now(); }
function _pfmA(){ return (typeof pfmDraw.brushOpacity==='number') ? pfmDraw.brushOpacity : 1; }

/* ===== 2026-09-20 第 1 批：绘制辅助（Stabilizer / Symmetry）· 吸管 · 橡皮粗细 =====
   🔴 三个控件一律**直接读 DOM** —— 旧实现只写 window.__pfmXxx 却无人读
      ⇒「#pfmEraseSize 拖了没反应」「Mirror 三档无差别」= 哑控件，本批一并修复。 */
function _drawNum(id, def){
  var el=document.getElementById(id); if(!el) return def;
  var v=parseInt(el.value,10); return isNaN(v)?def:v;
}
function _stabVal(){ return Math.max(0, Math.min(10, _drawNum('pfmDrawStab', 3))); }
/* 🔴 2026-10-04（用户裁决）：橡皮上限 50 → **100**。clamp 必须与 UI 同步改：
   `#pfmEraseSize` 的 `max="100"`（snippet markup）＋ 它的 input 监听里的 `Math.min(100,…)`
   ＋ 本行 —— 三处漏任一处，滑杆能拖到 100 但落笔仍被悄悄截到 50。 */
function _eraseW(){ return Math.max(1, Math.min(100, _drawNum('pfmEraseSize', 8))) * (pfmDraw.ds||1); }
/* 2026-09-20 第 2 批：Smudge 强度 / 文字字号（用户语义值）/ 行距倍数 —— 同样**直读 DOM** */
function _smudgeStr(){ return Math.max(0, Math.min(100, _drawNum('pfmDrawSmudge', 50))) / 100; }
/* 2026-10-03（乙-3）：涂抹半径倍率（相对笔宽）。默认 60% = **改前写死的 0.6** ⇒ 零回归。 */
/* 🔴 2026-10-04（用户报「Smudge 没有效果」）：改前是**相对笔宽的倍率**（笔宽 × 60%），
   而默认笔宽实测只有 4 ⇒ 涂抹半径 2.4px（比手指还小）⇒ 感知为零。
   现在返回**CSS px 的绝对尺寸**（默认 40 ≈ 手指），与笔宽解耦；
   调用方再 × ds 转成后备量纲。 */
function _smudgeRadius(){ return Math.max(6, Math.min(240, _drawNum('pfmFxSmudgeRad', 40))); }
/* 2026-10-03（乙-3）：蘸色率 —— 涂抹时把**当前主色**按这个比例沉积进去。
   0（默认）= 纯涂抹 = 改前行为 ⇒ 零回归；>0 才有"边涂边带色"的 Krita Color Rate 手感。 */
function _smudgeColorRate(){ return Math.max(0, Math.min(100, _drawNum('pfmFxSmudgeCol', 0))) / 100; }
function _textSizeRaw(){ return Math.max(8, Math.min(200, _drawNum('pfmDrawTextSize', 48))); }
function _textLineH(){ return Math.max(0.8, Math.min(3, _drawNum('pfmDrawTextLine', 120) / 100)); }
function _symMode(){
  var el=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-sym].sel');
  return el ? el.getAttribute('data-sym') : 'off';
}
/* ===== 2026-09-21 第 5 批：形状填充 / 对称轴位置 / Shift 等比约束 =====
   🔴 三个开关与之前的 Stabilizer · Erase · Smudge 同一哲学：**一律直读 DOM**
      （旧实现把参数写进 window.__pfmXxx 却无人读 ⇒ 哑控件，已踩过 4 次）。 */
/* 🔴 语义 = **Hollow（空心）**，不是「Fill」。
   改前基线（bak/hd-draw.js.live-before-20260921-203721.bak:712）的 rect/circle 预览段是
   **无条件** `pfmDrawCtx.fill()`，且 applyDrawStyle() 把 fillStyle 设为 pfmDraw.color（默认不透明黑）
   ⇒ **改前 Rect/Oval 本来就是实心**。若把开关做成「开 = 实心」，等于把「关」这个默认态
   变成空心 —— 相对既有画作是行为回归。故开关语义定为：
     未勾选 → 维持改前的无条件 fill()（实心，零回归）
     勾选   → 跳过 fill()（空心）
   函数名留 _shapeFillOn 会造成误导，故更名 _shapeHollowOn（出口同步给 shapeHollow）。 */
function _shapeHollowOn(){
  var el=document.getElementById('pfmShapeHollow');
  return !!(el && el.classList.contains('sel'));
}
/* 对称轴位置：**逻辑画布 0..1 比例的当前像素值**（W/H 变了也按比例跟随）。
   与 canvas.width/.height 无关，读的是 pfmDrawCanvas（模块级变量、可能尚未 init）。 */
function _symAxisX(){
  var W=(pfmDrawCanvas && pfmDrawCanvas.width)||1200, x=pfmDraw.symX;
  return (typeof x==='number' && x>=0 && x<=1) ? x*W : W/2;
}
function _symAxisY(){
  var H=(pfmDrawCanvas && pfmDrawCanvas.height)||1200, y=pfmDraw.symY;
  return (typeof y==='number' && y>=0 && y<=1) ? y*H : H/2;
}
/* 🔴 位置存**比例**而不是画布像素：画布重设宽高（开板/换机/响应式）后轴不会跑掉。
   经 window 读（snippet 里拖拽写的是 window.__pfmSymPos，跨 IIFE 共享）。 */
function _symPosSync(){
  try{
    var p=window.__pfmSymPos;
    if(p && typeof p.x==='number' && typeof p.y==='number'){ pfmDraw.symX=p.x; pfmDraw.symY=p.y; }
  }catch(e){}
}
function _symPosSave(){
  try{ window.__pfmSymPos={x:pfmDraw.symX, y:pfmDraw.symY}; }catch(e){}
  _symStateSave();          /* 2026-09-21 第 5 批：落盘（下次开板仍是上次的位置） */
  _symUISync();
}
/* Shift 等比约束：只作用于形状类（矩形/椭圆/直线/箭头）。返回**被约束后的终点**。
   直线/箭头取 45° 整数倍；矩形/椭圆取 |dx|=|dy|（正方形/正圆）——
   方向沿**主导轴**（位移大的那一边），符合绘画软件手感。 */
function _shiftPt(sx, sy, x, y){
  var dx=x-sx, dy=y-sy;
  var t=pfmDraw.tool;
  if(t==='line'||t==='arrow'){
    var a=Math.atan2(dy,dx);
    var q=Math.round(a/(Math.PI/4))*(Math.PI/4);
    var L=Math.sqrt(dx*dx+dy*dy);
    return {x:sx+L*Math.cos(q), y:sy+L*Math.sin(q)};
  }
  var m=Math.max(Math.abs(dx), Math.abs(dy));
  return {x:sx+(dx<0?-m:m), y:sy+(dy<0?-m:m)};
}
/* 当前形状的「有效终点」= 吸附 → Shift 等比 → 对称轴吸附。
   预览（drawMouseMove）与落笔（drawMouseUp）**必须走同一个函数**，否则松手会跳一下。
   🔴 Shift 对**全部形状类**生效（line/arrow = 45° 整数倍；rect/circle = 正方形/正圆）
   —— 首版只接了 line/arrow，rect 的 Shift 静默无效（V1.1/V4.1 实测）。 */
function _shapeEnd(x, y, shift, alt){
  var p=_snapPt({x:x, y:y});
  if(shift && _isShapeTool(pfmDraw.tool)) p=_shiftPt(pfmDraw.startX, pfmDraw.startY, p.x, p.y);
  /* 2026-10-03（甲批·丙）：Alt = **以落笔点为中心**向外画（PS 官方语义）。
     实现 = 把"被拖动的那一点"关于起点镜像 ⇒ 起点成为中心、图形天然对称。
     🔴 只对 rect/circle 生效：线/箭头没有"中心扩展"的语义（PS 同此）。 */
  /* 2026-10-04（丙批）：Alt 从中心也覆盖新形状（圆角矩形/多边形/星形 —— 都有「中心扩展」语义）。 */
  if(alt && (pfmDraw.tool==='rect'||pfmDraw.tool==='circle'||pfmDraw.tool==='rrect'||pfmDraw.tool==='poly'||pfmDraw.tool==='star')){
    p={x:2*pfmDraw.startX-p.x, y:2*pfmDraw.startY-p.y};
  }
  return _symSnapPt(p);
}
/* 🔴 第 6 批：`_isShapeTool` **刻意不含 path** —— 曲线没有「等比/45°」的语义，
   对曲线施加 Shift 只会让用户困惑。path 依然享受网格吸附与轴吸附（走 `_snapPt`/`_symSnapPt`）。 */
function _isShapeTool(t){
  return t==='rect'||t==='circle'||t==='line'||t==='arrow'||t==='rrect'||t==='poly'||t==='star';
}
/* 2026-10-04（丙批）：**形状家族（含 path）** —— 驱动「预览/落笔/收尾」三条分支链。
   改前这个列表被**手抄了三遍**（`tool==='rect'||…||tool==='path'`）⇒ 加新形状必漏一两处。
   现在统一走这里：单一真源。 */
function _shapeFamily(t){
  return _isShapeTool(t) || t === 'path';
}
/* 对称轴吸附：按住轴拖形状时贴上去（轴位置本身就是「对齐线」）。
   阈值 6 个画布像素；轴在中心（默认）时等价于原有行为。 */
function _symSnapPt(p){
  var m=_symMode(); if(m==='off') return p;
  var ax=_symAxisX(), ay=_symAxisY(), th=6, r={x:p.x, y:p.y};
  if(m==='v'||m==='quad'){ if(Math.abs(r.x-ax)<th) r.x=ax; }
  if(m==='h'||m==='quad'){ if(Math.abs(r.y-ay)<th) r.y=ay; }
  return r;
}

/* ===== 2026-09-21 第 5 批：对称轴拖拽 =====
   手柄层 #pfmSymDrag 与画布**同尺寸同 transform**：四条臂只在画布**外**露出圆钮
   （画布内 pointer-events:none ⇒ 绝不挡绘制）。拖拽经 pointer 事件（鼠标/触摸/笔统一）。
   约束：轴不许拖到画布外（留 4% 边距），否则镜像图形会整块飞出可视区。
   吸附：落到 1/2、1/3、2/3 附近（3 画布像素内）时对齐——与「三分线」直觉一致。 */
var SYM_KEY='hd_draw_sym_v1';
function _symClamp(v){ return Math.max(0.04, Math.min(0.96, v)); }
function _symSnap(v){
  var cands=[0.5, 1/3, 2/3], th=3/1200;
  for(var i=0;i<cands.length;i++){ if(Math.abs(v-cands[i])<th) return cands[i]; }
  return v;
}
function _symDragApply(kind, cx, cy){
  var cv=pfmDrawCanvas; if(!cv) return;
  var r=cv.getBoundingClientRect();
  if(kind!=='h'){
    var nx=r.width ? (cx-r.left)/r.width : 0.5;
    pfmDraw.symX=_symSnap(_symClamp(nx));
  }
  if(kind!=='v'){
    var ny=r.height ? (cy-r.top)/r.height : 0.5;
    pfmDraw.symY=_symSnap(_symClamp(ny));
  }
  _symPosSave();
}
function symDragBind(){
  var dg=document.getElementById('pfmSymDrag'); if(!dg || dg._bound) return;
  dg._bound=true;
  var kind=null;
  function down(e){
    var b=e.target && e.target.closest ? e.target.closest('[data-arm]') : null;
    if(!b) return;
    kind=b.getAttribute('data-arm');
    try{ dg.setPointerCapture(e.pointerId); }catch(err){}
    dg.classList.add('dragging');
    _symDragApply(kind, e.clientX, e.clientY);
    e.preventDefault(); e.stopPropagation();
  }
  dg.addEventListener('pointerdown', down);
  dg.addEventListener('pointermove', function(e){
    if(!kind) return;
    _symDragApply(kind, e.clientX, e.clientY);
    e.preventDefault();
  });
  function up(e){ if(!kind) return; kind=null; dg.classList.remove('dragging'); }
  dg.addEventListener('pointerup', up);
  dg.addEventListener('pointercancel', up);
  /* 双击 = 回到中心（等价「复位」；与画布双击复位缩放不冲突——那是 canvas 上的事件）。
     🔴 必须放在**捕获阶段**：pointerdown 里做了 setPointerCapture，后续 click/dblclick
     会被重定向到捕获元素；同时 stopPropagation 也拦不住同元素上的其他监听。
     捕获阶段注册能确保即使有别的监听先 stopPropagation，这里仍能被触发。 */
  dg.addEventListener('dblclick', function(e){
    pfmDraw.symX=0.5; pfmDraw.symY=0.5; _symPosSave();
    /* 复位后必须重排：抓手本身位置也变了（否则第二次双击会落空） */
    _symUISync();
    e.preventDefault();
  }, true);
}
function _symStateLoad(){
  try{
    var s=JSON.parse(localStorage.getItem(SYM_KEY)||'null');
    if(s && typeof s.x==='number' && typeof s.y==='number'){
      pfmDraw.symX=_symClamp(s.x); pfmDraw.symY=_symClamp(s.y);
      window.__pfmSymPos={x:pfmDraw.symX, y:pfmDraw.symY};
    }
  }catch(e){}
}
function _symStateSave(){
  try{ localStorage.setItem(SYM_KEY, JSON.stringify({x:pfmDraw.symX, y:pfmDraw.symY})); }catch(e){}
}
/* 防抖：指数平滑。0=关闭（逐点跟手），10=最强。收笔时由 drawMouseUp 补画到真实终点。 */
function _stabPt(x, y){
  var S=_stabVal();
  if(S<=0 || pfmDraw.sx==null){ pfmDraw.sx=x; pfmDraw.sy=y; return {x:x,y:y}; }
  var k=1-0.075*S; if(k<0.22) k=0.22; if(k>1) k=1;
  pfmDraw.sx+=(x-pfmDraw.sx)*k;
  pfmDraw.sy+=(y-pfmDraw.sy)*k;
  return {x:pfmDraw.sx, y:pfmDraw.sy};
}
/* 对称镜像点：v=左右（垂直中轴）/ h=上下（水平中轴）/ quad=四向 / off=无
   2026-09-21 第 5 批：轴位置由 _symAxisX()/_symAxisY() 给（可拖），默认仍是中心。 */
/* ============================================================================
   2026-10-03（乙-1 万花筒）：对称的**唯一实现**。
   🔴🔴 改前这件事有 **3 份**各写各的：
     · `_symPts`（逐段绘制路径用，只认 v/h/quad）
     · `_strokeRender` 里的 `mirs` + `MAP`（9 支"整笔累积"笔刷用，只认 v/h/quad）
     · `_accPixel` 的 `put()`（像素笔用，自己 inline 判 v/h/q）
   ⇒ 任何新增档位（本次的万花筒）都要改三处，漏一处 = **行显示、档位可选、画出来没效果**
     （正是本项目最忌讳的"假控件"；实测就是这样：万花筒在 9 支累积笔刷下完全无镜像）。
   ⇒ 现在统一成：`_symMarkers()` 给**标记清单**、`_symMapPoint()` 给**点映射**，
      三处都调这两个（`_symPts` 退化成一层薄包装）。
   标记语义：`''`（本体）· `'v'`（左右）· `'h'`（上下）· `'q'`（四向）·
             `'k<i>a'` / `'k<i>b'`（万花筒第 i 段的旋转 / 镜像副本）。
   ============================================================================ */
function _kalSegN(){
  return Math.max(3, Math.min(12, Math.round(_drawNum('pfmFxKalSeg', 6))));
}
function _symMarkers(){
  var sym = _symMode(), r = [''];
  if(sym === 'v') r.push('v');
  else if(sym === 'h') r.push('h');
  else if(sym === 'quad'){ r.push('v'); r.push('h'); r.push('q'); }
  else if(sym === 'kaleido'){
    /* 二面体：每段 2 个副本（旋转 i·2π/n + 先镜像再旋转），共 2(n−1) 个 */
    var n = _kalSegN();
    for(var i=1;i<n;i++){ r.push('k' + i + 'a'); r.push('k' + i + 'b'); }
  }
  return r;
}
function _symMapPoint(x, y, mk, ax, ay){
  if(mk === 'v') return [2*ax - x, y];
  if(mk === 'h') return [x, 2*ay - y];
  if(mk === 'q') return [2*ax - x, 2*ay - y];
  if(mk && mk.charAt(0) === 'k'){
    var m = /^k(\d+)([ab])$/.exec(mk);
    if(m){
      var n = _kalSegN(), a = Math.PI*2*(+m[1])/n, c = Math.cos(a), sn = Math.sin(a);
      var dx = x - ax, dy = y - ay;
      if(m[2] === 'a') return [ax + dx*c - dy*sn, ay + dx*sn + dy*c];   /* 旋转 */
      return [ax + dx*c + dy*sn, ay + dx*sn - dy*c];                    /* 先镜像再旋转 */
    }
  }
  return [x, y];
}
function _symPts(x, y){
  var ax = _symAxisX(), ay = _symAxisY(), mks = _symMarkers(), r = [];
  for(var i=1;i<mks.length;i++){
    var p = _symMapPoint(x, y, mks[i], ax, ay);
    r.push({ x: p[0], y: p[1] });
  }
  return r;
}
function _symStroke(x0,y0,x1,y1){
  if(_symMode()==='off') return;
  var a=_symPts(x0,y0), b=_symPts(x1,y1);
  for(var i=0;i<a.length;i++){
    pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(a[i].x,a[i].y); pfmDrawCtx.lineTo(b[i].x,b[i].y); pfmDrawCtx.stroke();
  }
  pfmDrawCtx.beginPath(); pfmDrawCtx.moveTo(x1,y1);   /* 复位主轴：否则下一段会从镜像点连回来 */
}
/* ===== 2026-10-03（丙-5 辅助线 / Assistant）：把落笔点**投影**到指定方向 =====
   语义对齐 CSP 的「直尺 / 对称标尺」与 Krita 的 Assistants：开了辅助线之后，
   不论手怎么画，落点都落在**过起笔点的那条线**上 ⇒ 手绘直线。
   · 直读 `#pfmDrawOpts .pfm-dopt-chip[data-assist].sel`（单一真源，不写第二份状态）
   · `off`（默认）⇒ `_assistPt` 原样返回 ⇒ **逐像素零回归**
   · 锚点 = `pfmDraw.startX/startY`（本笔起点）；h/v/45° 都过起点，
     axv/axh 则直接锁到**对称轴**（配合万花筒画"径向辐条"很顺手）。 */
function _assistMode(){
  var el=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-assist].sel');
  return el ? el.getAttribute('data-assist') : 'off';
}
function _assistPt(x, y){
  var m = _assistMode();
  if(m === 'off') return {x:x, y:y};
  var x0 = pfmDraw.startX, y0 = pfmDraw.startY;
  if(m === 'axv') return {x:_symAxisX(), y:y};
  if(m === 'axh') return {x:x, y:_symAxisY()};
  if(x0 == null || y0 == null) return {x:x, y:y};
  if(m === 'h') return {x:x, y:y0};
  if(m === 'v') return {x:x0, y:y};
  if(m === 'd45'){
    /* 投影到过起点的 45° 对角线：方向 (1,1)/√2 与 (1,-1)/√2，取更接近的那条。
       投影式：t=(dx+dy)/2 ⇒ 点 = (x0+t, y0+t)；对 (1,-1)：t=(dx-dy)/2 ⇒ (x0+t, y0-t)。 */
    var dx = x - x0, dy = y - y0;
    if(Math.abs(dx + dy) >= Math.abs(dx - dy)){
      var t1 = (dx + dy) / 2; return {x:x0 + t1, y:y0 + t1};
    }
    var t2 = (dx - dy) / 2; return {x:x0 + t2, y:y0 - t2};
  }
  return {x:x, y:y};
}
/* ===== 2026-09-21 第 6 批：形状绘制唯一实现 =====
   🔴 预览段（drawMouseMove）与落笔段（drawMouseUp）**本来各写了一份** rect/ellipse/line/arrow 的
      重绘代码 ⇒ 任何改动都要改两处，已经踩过「预览实心 / 落笔空心」的不一致。
      本批抽成单一函数 `_paintShape`，并让**镜像**也复用它 ⇒ 三处共用一份实现。

   参数 decision：
   - `ox, oy` = 本次绘制的**原点**（本体传 startX/startY；镜像传镜像后的原点）
   - `ex, ey` = 终点（本体传约束后的终点；镜像传**终点镜像**）
   - 🔴 镜像调用时**绝不能再走 `_shapeEnd`** —— 原始端点已是约束后的结果，
     二次吸附/二次 Shift 会把镜像扭曲到错误位置。
   - 🔴 `ctx` 状态由调用方先备好（`applyDrawStyle()` 已执行）；本函数只负责路径与绘制。 */
/* 🔴 2026-10-04（丙批）：形状路径的**唯一几何定义**。只把路径加进 ctx（不 fill / 不 stroke）。
   抽出来的原因：`描边对齐` 要用 `clip()` 把同一条路径再描一次 ⇒ 必须能复用几何（否则就得抄第二份）。 */
/* ===== 2026-10-04（用户实测「箭头部分错误的，不是尖的」）：箭头几何的**唯一真源** =====
   病灶两条：
     ① 箭头长度原来只按笔宽线性放大（`brushSize*2+6`）—— 而笔宽默认已由 4 提到 **12**
        ⇒ 箭头长度与线宽同量级 ⇒ 又短又胖，看着是钝头/方块；
     ② 杆一直画到**终点** ⇒ 三角被杆"顶住" ⇒ 更不显尖。
   现在：长度 = max(笔宽 × 3.2, 笔宽 + 14)，并**上限为干长的一半**（短箭头也还是个箭头）；
        半角 30° → **24°**；杆画到「顶点 − 0.9 × 箭头长」（略微插进三角内部，避免接缝）。
   ⚠️ `_paintShape`（画三角）与 `_shapePath`（画杆）**必须调本函数**，否则头/杆会错位。 */
function _arrowGeom(ox, oy, ex, ey){
  var bs = Math.max(1, pfmDraw.brushSize);
  var dx = ex - ox, dy = ey - oy, len = Math.sqrt(dx * dx + dy * dy);
  var sz = Math.max(bs * 3.2, bs + 14);
  if(len > 0.001) sz = Math.min(sz, len * 0.5);
  return { a: Math.atan2(dy, dx), sz: sz, len: len, ang: 0.419 };   /* ang = 24° 半角 */
}
function _shapePath(ctx, tool, ox, oy, ex, ey){
  ctx.beginPath();
  if(tool === 'rect'){
    ctx.rect(ox, oy, ex - ox, ey - oy);
  } else if(tool === 'rrect'){
    _roundRectPath(ctx, ox, oy, ex - ox, ey - oy, _shapeCornerPx());
  } else if(tool === 'poly' || tool === 'star'){
    _ngonPath(ctx, ox, oy, ex - ox, ey - oy, _shapeSidesN(), (tool === 'star') ? _shapeInnerR() : 0);
  } else if(tool === 'circle'){
    ctx.ellipse(ox, oy, Math.abs(ex - ox), Math.abs(ey - oy), 0, 0, Math.PI * 2);
  } else if(tool === 'arrow'){
    /* 🔴 2026-10-04：**杆缩到箭头根部** —— 原来一直画到终点，三角被杆顶住 ⇒ 看着是钝头。
       长度/半角与三角**共用** `_arrowGeom()`（唯一真源）；×0.9 = 略微插进三角内部，不留缝。 */
    var _ag = _arrowGeom(ox, oy, ex, ey);
    ctx.moveTo(ox, oy);
    ctx.lineTo(ex - Math.cos(_ag.a) * _ag.sz * 0.9, ey - Math.sin(_ag.a) * _ag.sz * 0.9);
  } else {
    ctx.moveTo(ox, oy);
    ctx.lineTo(ex, ey);
  }
}
/* 圆角矩形：手写 arcTo（不依赖 `ctx.roundRect` —— 它太新，且在旧版 ArkWeb 上缺失会静默画成直角）。
   ⚠️ 半径自动夹到短边一半（超过就退化成"胶囊"）；≤0.01 时退回直角。 */
function _roundRectPath(ctx, x, y, w, h, r){
  var x0 = Math.min(x, x + w), y0 = Math.min(y, y + h), x1 = Math.max(x, x + w), y1 = Math.max(y, y + h);
  var lw = Math.min(x1 - x0, y1 - y0) / 2;
  if(!(r > 0.01)){ ctx.rect(x0, y0, x1 - x0, y1 - y0); return; }
  r = Math.min(r, lw);
  ctx.moveTo(x0 + r, y0);
  ctx.lineTo(x1 - r, y0); ctx.arcTo(x1, y0, x1, y0 + r, r);
  ctx.lineTo(x1, y1 - r); ctx.arcTo(x1, y1, x1 - r, y1, r);
  ctx.lineTo(x0 + r, y1); ctx.arcTo(x0, y1, x0, y1 - r, r);
  ctx.lineTo(x0, y0 + r); ctx.arcTo(x0, y0, x0 + r, y0, r);
  ctx.closePath();
}
/* 正 n 边形 / n 角星：**内接于拖拽框**（与椭圆同口径：框的宽高 = 直径）。
   `inner` = 0 ⇒ 正多边形；0<inner<1 ⇒ 星形（内径比）。
   顶点从**正上方**起（-90°）—— 用户画三角形/五角星时的直觉方向。 */
function _ngonPath(ctx, ox, oy, dx, dy, n, inner){
  n = Math.max(3, Math.min(60, Math.round(n) || 6));
  var cx = ox + dx / 2, cy = oy + dy / 2;
  var rx = Math.abs(dx) / 2, ry = Math.abs(dy) / 2;
  if(rx < 0.5 || ry < 0.5) return;
  var star = (inner > 0);
  var total = star ? n * 2 : n;
  var a0 = -Math.PI / 2;
  for(var i = 0; i < total; i++){
    var a = a0 + i * (Math.PI * 2 / total);
    var rr = (star && (i % 2 === 1)) ? inner : 1;
    var px = cx + Math.cos(a) * rx * rr, py = cy + Math.sin(a) * ry * rr;
    if(i === 0) ctx.moveTo(px, py); else ctx.lineTo(px, py);
  }
  ctx.closePath();
}
function _paintShape(tool, ox, oy, ex, ey){
  var ctx = pfmDrawCtx;
  /* 2026-10-04（丙批）：几何走**唯一入口** `_shapePath`（旧工具的输出与改前逐字节一致）。 */
  _shapePath(ctx, tool, ox, oy, ex, ey);
  /* 形状描边宽度 / 描边色（第 6 批）：未启用时**完全沿用** applyDrawStyle 的既有值（零回归） */
  /* Hollow 门控：未勾 = 实心（改前行为）；直线/箭头/曲线永不填充（填了会变怪形） */
  var _fillable = (tool==='rect'||tool==='circle'||tool==='rrect'||tool==='poly'||tool==='star');
  /* 🔴 填充先做（不受"描边对齐"影响）——clip 之后再 fill 会把填充也裁掉。 */
  if(_fillable){
    if(!_shapeHollowOn()){ _applyShapeFill(ox, oy, ex, ey); ctx.fill(); }
  } else {
    ctx.fill();
  }
  /* 2026-10-04（丙批）：**描边对齐**（PS 语义：inside / center / outside）。
     canvas 没有原生支持 ⇒ 用 `clip` 截掉一半 + `lineWidth × 2` 补偿 ⇒ **可见宽度仍是用户的 lw**。
     🚫 只对**有面积的形状**生效：line/arrow/path 是无面积路径，inside clip 会得到空集（描边整条消失）。 */
  var _al = _fillable ? _shapeAlign() : 'center';
  _applyShapeStroke();
  if(_al === 'center'){
    ctx.stroke();
  } else {
    ctx.save();
    if(_al === 'inside'){
      ctx.clip();                                  /* 路径内部 */
    } else {
      /* outside = 「外框内、路径外」：补一个覆盖全画布的大矩形，用 **evenodd** 取反。
         ⚠️ 大矩形自身的边在画布之外 ⇒ 不会被描出来。 */
      var _W = pfmDrawCanvas.width, _H = pfmDrawCanvas.height;
      ctx.rect(-_W, -_H, _W * 3, _H * 3);
      ctx.clip('evenodd');
    }
    ctx.lineWidth = ctx.lineWidth * 2;
    ctx.stroke();
    ctx.restore();
  }
  ctx.setLineDash([]);        /* 🔴 复位（下面 arrow 的填充/后续绘制不能被虚线状态污染） */
  if(tool==='arrow'){
    /* 🔴 2026-10-04（用户实测「箭头部分错误的，不是尖的」）：几何改由 `_arrowGeom()` 统一给出 ——
       细长（≈3.2×线宽、上限干长一半）+ 半角 24°（原 30°）+ 杆已在 `_shapePath` 里缩进。 */
    var _ag2=_arrowGeom(ox,oy,ex,ey), a=_ag2.a, sz=_ag2.sz;
    pfmDrawCtx.beginPath();
    pfmDrawCtx.moveTo(ex, ey);
    pfmDrawCtx.lineTo(ex-sz*Math.cos(a-_ag2.ang), ey-sz*Math.sin(a-_ag2.ang));
    pfmDrawCtx.lineTo(ex-sz*Math.cos(a+_ag2.ang), ey-sz*Math.sin(a+_ag2.ang));
    pfmDrawCtx.closePath();
    _applyShapeFill(ox, oy, ex, ey);
    pfmDrawCtx.fill();
  }
}
/* 形状描边宽度：滑杆未启用/未挂载 ⇒ 返回 null（调用方沿用既有 lineWidth，零回归） */
function _shapeStrokeW(){
  var el=document.getElementById('pfmShapeStrokeW');
  if(!el || !el.classList.contains('on')) return null;
  var v=parseFloat(el.value);
  return (isFinite(v) && v>0) ? v : null;
}
function _shapeStrokeColor(){
  var el=document.getElementById('pfmShapeStrokeColor');
  return (el && el.value) ? el.value : null;
}
function _shapeFillColor(){
  var el=document.getElementById('pfmShapeFillColor');
  return (el && el.value) ? el.value : null;
}
function _shapeColorOn(el){ return !!(el && el.classList.contains('on')); }
/* ===== 2026-10-04（丙批）：新形状的参数读取 =====
   铁律「控件不存在 / 未挂载 ⇒ 用默认值」—— 保证引擎在任何 UI 版本下都不会读到 undefined。
   ⚠️ 这些控件**只对"用得上的工具"显示**（见 snippet 的 `shapegeom` 行显隐），
      但引擎不依赖显隐（隐藏时 `value` 仍在 DOM 里，读到的是用户上次设的值 ⇒ 符合"工具参数保持"直觉）。 */
function _shapeRangeVal(id){
  var el = document.getElementById(id);
  if(!el) return null;
  var v = parseFloat(el.value);
  return isFinite(v) ? v : null;
}
function _shapeCornerPx(){ var v=_shapeRangeVal('pfmShapeCorner'); return (v==null) ? 24 : v; }      /* 圆角半径（画布 px） */
function _shapeSidesN(){   var v=_shapeRangeVal('pfmShapeSides');  return (v==null) ? 6  : v; }      /* 顶点数 3~24 */
function _shapeInnerR(){   var v=_shapeRangeVal('pfmShapeInner');  return (v==null) ? 0.5 : Math.max(0.05, Math.min(0.95, v/100)); }   /* 星形内径比（UI 是 0~100） */
/* 形状填充模式：solid（默认 = 改前）/ gradient / pattern */
function _shapeFillMode(){
  var el = document.getElementById('pfmShapeFillMode');
  var m = el && el.getAttribute('data-fill');
  return (m === 'gradient' || m === 'pattern') ? m : 'solid';
}
function _shapeAlign(){    var el=document.getElementById('pfmShapeAlign'); var m=el&&el.getAttribute('data-align'); return (m==='inside'||m==='outside') ? m : 'center'; }
function _shapeDashMode(){ var el=document.getElementById('pfmShapeDash');  var m=el&&el.getAttribute('data-dash');  return (m==='dash'||m==='dot') ? m : 'solid'; }
/* 虚线数组：按**当前线宽**成比例（否则细线看着是实线、粗线的间隙又太密）。 */
function _shapeDashArr(w){
  var m=_shapeDashMode(); w=Math.max(1, w||1);
  if(m==='dash') return [w*3, w*2];
  if(m==='dot')  return [w*0.6, w*2];
  return [];
}
function _applyShapeStroke(){
  var w=_shapeStrokeW(); if(w!=null) pfmDrawCtx.lineWidth=w;
  var c=document.getElementById('pfmShapeStrokeColor');
  if(_shapeColorOn(c) && c.value) pfmDrawCtx.strokeStyle=c.value;
  /* 2026-10-04（丙批）：虚线。🔴 每次**先按需设**（调用方绘制完还会再清一次）——
     `setLineDash` 是 ctx 状态，漏清会污染后面的笔刷 / 蚂蚁线 / 选区框。 */
  pfmDrawCtx.setLineDash(_shapeDashArr(pfmDrawCtx.lineWidth));
}
/* 2026-10-04（丁批）：形状填充三模式。`solid`（默认）= 改前那句纯色 ⇒ **零回归**。
   · gradient：用**颜色面板当前那组渐变**（`pfmGradients[gradientIndex]`）+ 形状的**拖拽方向**
     —— 与 `floodFill` 的拖拽渐变同一口径，用户手感一致。
   · pattern：复用 Stamp 的图案瓦片（`_buildStampTex`，40×40，`data-pat`: tri/star/circle/square/ref）
     —— **不新造图案系统**（那会变成第二份实现）。
   端点由调用方传入（`_paintShape` 的两处），因为渐变方向要跟着形状的起终点走。 */
function _applyShapeFill(ox, oy, ex, ey){
  var c=document.getElementById('pfmShapeFillColor');
  var _fm = _shapeFillMode();
  if(_fm === 'gradient'){
    var _g = pfmGradients[pfmDraw.gradientIndex] || ['#000000', '#000000'];
    if(Math.abs(ex - ox) + Math.abs(ey - oy) > 0.5){
      var _lg = pfmDrawCtx.createLinearGradient(ox, oy, ex, ey);
      _lg.addColorStop(0, _g[0]); _lg.addColorStop(1, _g[1]);
      pfmDrawCtx.fillStyle = _lg;
      return;
    }
  } else if(_fm === 'pattern'){
    var _tile = null;
    try{ _tile = _buildStampTex(pfmDraw.color, _stampPattern()); }catch(err){ _tile = null; }
    if(_tile){
      var _pt = pfmDrawCtx.createPattern(_tile, 'repeat');
      if(_pt){ pfmDrawCtx.fillStyle = _pt; return; }
    }
    /* 拿不到图案（参考图未就绪等）⇒ 静默退回纯色，不留空填充 */
  }
  if(_shapeColorOn(c) && c.value) pfmDrawCtx.fillStyle=c.value;
}
/* 🔴 A1 修复（第 6 批）：形状的镜像。
   改前 `_symStroke` 只镜像**笔刷段**；rect/oval/line/arrow/path 落笔走的是另一条路径，
   从不产生镜像 ⇒「开了 Mirror 画矩形只出一个」= 与用户直觉直接冲突的功能缺陷。
   这里用**原始端点**求镜像（不再过 `_shapeEnd`，否则二次约束会偏位）：
   本体 (sx,sy)-(ex,ey) → 镜像 (sx',sy')-(ex',ey')，逐对重绘。 */
function _paintShapeMirrors(tool, sx, sy, ex, ey){
  if(_symMode()==='off') return;
  var ms=_symPts(sx, sy), me=_symPts(ex, ey);
  if(!ms || !ms.length) return;
  for(var i=0;i<ms.length;i++){
    var m=ms[i], n=me[i]; if(!n) continue;
    _paintShape(tool, m.x, m.y, n.x, n.y);
  }
}
/* ===== Path 的控制点：**由拖动轨迹算出来**（唯一实现，预览与落笔共用）=====
   🔴🔴 2026-10-04（甲·用户裁决）：改前控制点写死成「起点→终点的中点」
     （`_cpx=(startX+ex)/2`）⇒ 二次贝塞尔 B(0.5)=(A+2C+B)/4 在中点上时**数学上退化成直线**
     ⇒ 用户实测「Path 画出来和 Line 一模一样」。
   现在：取轨迹上**离弦 AB 最远**的采样点 P，把它当作曲线 t=0.5 的位置，反解控制点：
       C = 2P − (A+B)/2       〔弦中点 = (A+B)/2〕
   并对「P 相对弦中点」的偏移**限幅**在弦长的 0.75 倍内 —— 防极端拖拽把曲线撕成尖角/自交。
   ⇒ **零回归**：手一抖画直线时最远点几乎落在弦上（垂距 ≤0.5px 直接走中点分支）⇒ 与改前逐像素一致；
      **画弧即成弧**：C 被拉出去，得到一条贴着手势的平滑二次曲线。
   ⚠️ 轨迹由 move 分支按 ≥2px 间距采样（`pfmDraw.pathTrail`），mousedown 时清空。
   ⚠️ 不要用"轨迹弧长中点"替代（两者都是近似，但最远点对**手势幅度**更敏感、且拖动中更稳定）。 */
function _pathCtrl(ex, ey){
  var sx = pfmDraw.startX, sy = pfmDraw.startY;
  var mx = (sx + ex) / 2, my = (sy + ey) / 2;              /* 弦中点（= 改前的固定控制点） */
  var tr = pfmDraw.pathTrail || [];
  var abx = ex - sx, aby = ey - sy, abl = Math.sqrt(abx * abx + aby * aby);
  if(abl < 1 || !tr.length) return { x: mx, y: my };        /* 退化（起终重合 / 没轨迹）⇒ 中点 */
  var i, px, py, d, best = null, bestD = -1;
  for(i = 0; i < tr.length; i++){
    px = tr[i].x - sx; py = tr[i].y - sy;
    d = Math.abs(px * aby - py * abx) / abl;                /* 点到弦的垂距 */
    if(d > bestD){ bestD = d; best = tr[i]; }
  }
  if(!best || bestD <= 0.5) return { x: mx, y: my };        /* 手势基本是直线 ⇒ 不做形变（零回归） */
  var maxD = abl * 0.75, k = 1;
  if(bestD > maxD) k = maxD / bestD;                        /* 限幅：把 P 朝弦中点收缩 */
  var pxc = mx + (best.x - mx) * k, pyc = my + (best.y - my) * k;
  return { x: 2 * pxc - mx, y: 2 * pyc - my };              /* C = 2P − 弦中点 */
}
/* Path（二次曲线）的唯一绘制实现：起/控/终三点。曲线不填充（填了会成怪异扇形）。 */
function _paintPath(sx, sy, cpx, cpy, ex, ey){
  pfmDrawCtx.beginPath();
  pfmDrawCtx.moveTo(sx, sy);
  pfmDrawCtx.quadraticCurveTo(cpx, cpy, ex, ey);
  _applyShapeStroke();
  pfmDrawCtx.stroke();
  pfmDrawCtx.setLineDash([]);   /* 2026-10-04（丙批）：虚线是 ctx 状态 ⇒ 用完即清 */
}
function _paintPathMirrors(sx, sy, cpx, cpy, ex, ey){
  if(_symMode()==='off') return;
  var a=_symPts(sx, sy), b=_symPts(cpx, cpy), c=_symPts(ex, ey);
  if(!a || !a.length) return;
  for(var i=0;i<a.length;i++){
    var x=a[i], y=b[i], z=c[i]; if(!x||!y||!z) continue;
    _paintPath(x.x, x.y, y.x, y.y, z.x, z.y);
  }
}
/* 对称轴虚线：DOM 覆盖层（**不进 canvas 像素** ⇒ 不污染 toDataURL / 撤销栈 / 落产品）
   2026-09-21 第 5 批：轴位置可拖 ⇒ 虚线位置由 CSS 变量 --symx/--symy（%）驱动；
   拖拽手柄层 #pfmSymDrag 与画布同 transform，四条臂由变量定位。 */
function _symUISync(){
  var c=pfmDrawCanvas, el=document.getElementById('pfmDrawSymAxis');
  if(!c) return;
  /* 2026-10-04：对称轴是 DOM 层、整层继承画布 transform ⇒ 线宽与虚线节距会被一起放大。
     写一个 `--hd-zi`（= 1/画布缩放）供 CSS 反向补偿 ⇒ 任何缩放下都是 1px 线、5/5 虚线。 */
  var _szi = 1 / (pfmDrawZoom.s || 1);
  var m=_symMode();
  _symPosSync();                                  /* window.__pfmSymPos → pfmDraw.symX/Y */
  var px=(_symAxisX()/(c.width||1200)*100), py=(_symAxisY()/(c.height||1200)*100);
  var dg=document.getElementById('pfmSymDrag');
  if(dg){
    /* 2026-09-26：全部走"写前比对" —— 平移时这几项都没变，可整批跳过（原来每帧无脑重写）。 */
    var _gs=_cvGeo();
    _ss(dg,'left',_gs.left+'px'); _ss(dg,'top',_gs.top+'px');
    _ss(dg,'width',_gs.w+'px'); _ss(dg,'height',_gs.h+'px');
    _ss(dg,'transformOrigin','0 0');
    _ss(dg,'transform',c.style.transform||'');
    _sp(dg,'--symx', px+'%');
    _sp(dg,'--symy', py+'%');
    _sc(dg,'pfm-symdrag-v', m==='v'||m==='quad');
    _sc(dg,'pfm-symdrag-h', m==='h'||m==='quad');
    _ss(dg,'display', (m==='off') ? 'none' : 'block');
  }
  if(!el) return;
  if(m==='off'){ _ss(el,'display','none'); return; }
  _ss(el,'display','block');
  var _ga=_cvGeo();
  _ss(el,'left',_ga.left+'px'); _ss(el,'top',_ga.top+'px');
  _ss(el,'width',_ga.w+'px'); _ss(el,'height',_ga.h+'px');
  _ss(el,'transformOrigin','0 0');
  _ss(el,'transform',c.style.transform||'');
  _sp(el,'--hd-zi', _szi);
  _sp(el,'--symx', px+'%');
  _sp(el,'--symy', py+'%');
  _sc(el,'pfm-sym-v', m==='v'||m==='quad');
  _sc(el,'pfm-sym-h', m==='h'||m==='quad');
}
window.__pfmSymSync=_symUISync;   /* snippet 的对称 chip 切换后回调 */
window.__pfmSymUI=_symUISync;     /* 幂等别名：拖拽层也走同一同步（避免多一个函数） */
window.__pfmSymPosSave=_symPosSave;
/* 画板内取色气泡（section 的 showToast 在主 IIFE 内，asset 取不到 ⇒ 自建轻量提示）
   🔴 2026-09-26（用户裁决「甲」）：画板内所有**黑底气泡提示一律不弹出**
      （清空 / 清当前层 / 取色 / 剪切 / 粘贴 / 导出 全部静默，成功与失败提示都不弹）。
      为什么「保留函数 + 加开关」而不删 9 处调用点：语义与调用序保持原样，**将来想恢复只改下面这一行**；
      删调用要动 9 个地方、容易漏，且以后想加回反馈成本高。
      ⚠️ 这与本文件上方「隐藏层不再弹 toast」是同一条用户诉求（不要把状态变化再用气泡打扰用户）。
      注：参考图读取失败弹的是**红底** showToast（另一套，定义在 section 主闭包）⇒ **不在**本次范围。 */
var PFM_PICK_TIP_ON = false;   /* ← 想恢复这些气泡：改成 true 即可 */
function _pickTip(msg){
  if(!PFM_PICK_TIP_ON) return;
  var el=document.getElementById('pfmDrawPickTip'); if(!el) return;
  el.textContent=msg; el.classList.add('on');
  if(_pickTip._t) clearTimeout(_pickTip._t);
  _pickTip._t=setTimeout(function(){ el.classList.remove('on'); }, 1400);
}
/* ===== 2026-10-04（甲·用户裁决）：**吸管取色浮标** =====
   为什么要有它：`PFM_PICK_TIP_ON=false`（2026-09-26 用户裁决「画板内气泡一律不弹」）把取色
   唯一的文字反馈也关掉了，而另外两条通道（`#pfmDrawColorPicker` 在参数卡里、`.pfm-dcolor`
   在默认收起的颜色区里）**平时都不可见** ⇒ 取色**在屏幕上零反馈**，用户报
   「Pick 现在看不到吸取了什么颜色」。
   做法（对标 Procreate 的取色放大镜 / PS 的前景色方块）：在**取色点旁**弹一个**实色块**，
   1.2s 后淡出。
   🔴 2026-10-04（用户裁决）：**只要色块，不显示色值文字**（原版是「色块 + #RRGGBB」）——
      已在 markup（`<span>`）与本函数里同步删除，勿再加回来。
   🔴 必须是 **DOM 覆盖层**（同尺寸预览圈 / 对称轴 / 参考图辅助线）：画进 canvas 会进 `toDataURL`
      ⇒ 污染导出与撤销栈。
   🔴 位置用**鼠标事件的 clientX/Y** 换算成 wrap 内坐标，而不是画布后备坐标 ——
      用户看到的反馈应贴在指针上，且省掉"后备像素 ↔ 屏幕"的换算（少一个出错面）。
   ⚠️ 透明区域（alpha<8）也要给反馈：色块改画**斜纹**（`.empty`）—— 删掉文字后这是唯一区分。 */
function _pickSwatch(e, hex){
  var el = document.getElementById('pfmDrawPickSwatch');
  if(!el) return;
  var wrap = document.querySelector('.pfm-draw-canvas-wrap') || el.parentNode;
  if(!wrap) return;
  var r = wrap.getBoundingClientRect();
  var sw = el.querySelector('i');
  if(sw) sw.style.background = hex ? hex : 'transparent';
  if(sw) sw.classList.toggle('empty', !hex);
  var cx = (e && e.clientX != null) ? e.clientX : null;
  var cy = (e && e.clientY != null) ? e.clientY : null;
  if(cx == null || cy == null){ el.classList.remove('on'); return; }
  el.style.left = (cx - r.left) + 'px';
  el.style.top  = (cy - r.top) + 'px';
  el.classList.add('on');
  if(_pickSwatch._t) clearTimeout(_pickSwatch._t);
  _pickSwatch._t = setTimeout(function(){ el.classList.remove('on'); }, 1200);
}

// ============= FX 画笔（2026-09-03）neon / rainbow / comet / pixel =============
function drawFxColor(){
  // 单色取 pfmDraw.color；渐变模式取渐变起点色
  if(pfmDraw.isGradient && pfmGradients[pfmDraw.gradientIndex]){
    return pfmGradients[pfmDraw.gradientIndex][0];
  }
  return pfmDraw.color || '#000';
}
function drawFxStroke(x0, y0, x1, y1){
  var t = pfmDraw.tool, ctx = pfmDrawCtx, _ba = _pfmA();
  ctx.globalAlpha = _ba;
  if(t==='neon'){
    var col = drawFxColor(), bs = Math.max(1, pfmDraw.brushSize);
    ctx.save();
    ctx.strokeStyle = col; ctx.lineCap='round'; ctx.lineJoin='round';
    ctx.shadowColor = col; ctx.shadowBlur = bs*2.2;
    ctx.lineWidth = bs*0.9;
    ctx.beginPath(); ctx.moveTo(x0,y0); ctx.lineTo(x1,y1); ctx.stroke();
    ctx.shadowBlur = 0; ctx.lineWidth = Math.max(1, bs*0.45);
    ctx.strokeStyle = 'rgba(255,255,255,0.85)';
    ctx.beginPath(); ctx.moveTo(x0,y0); ctx.lineTo(x1,y1); ctx.stroke();
    ctx.restore();
  } else if(t==='rainbow'){
    var dist = Math.sqrt((x1-x0)*(x1-x0)+(y1-y0)*(y1-y0));
    /* 2026-10-03（甲·参数化）：色相步速可调（默认 110 ⇒ 1.1/px = 改前）。 */
    pfmDraw.rainHue = (pfmDraw.rainHue + dist * (Math.max(0.2, _drawNum('pfmFxRainbowSpeed', 110) / 100))) % 360;
    ctx.save();
    ctx.strokeStyle = 'hsl('+Math.floor(pfmDraw.rainHue)+',95%,55%)';
    ctx.lineWidth = Math.max(1, pfmDraw.brushSize);
    ctx.lineCap='round'; ctx.lineJoin='round';
    ctx.beginPath(); ctx.moveTo(x0,y0); ctx.lineTo(x1,y1); ctx.stroke();
    ctx.restore();
  /* ⚠️ 2026-10-01（乙·第三批）：`comet` 已改整笔累积（`_cometRender`）⇒ 本分支**不会再被命中**；
     保留以便回滚。切勿删掉 `drawFxStroke` 里的它 —— 回滚时要用。 */
  } else if(t==='comet'){
    var col2 = drawFxColor(), bs2 = Math.max(1, pfmDraw.brushSize);
    var dx=x1-x0, dy=y1-y0, len=Math.sqrt(dx*dx+dy*dy)||1, ux=-dx/len, uy=-dy/len;
    ctx.save();
    ctx.lineCap='round';
    // tail layers（从笔尖反向延伸，越远越淡细）
    var layers=[[bs2*2.6,0.32,bs2*0.85],[bs2*4.6,0.18,bs2*0.6],[bs2*7,0.08,bs2*0.4]];
    for(var i=0;i<layers.length;i++){
      var off=layers[i][0], al=layers[i][1], lw=layers[i][2];
      ctx.globalAlpha=al*_ba; ctx.strokeStyle=col2; ctx.lineWidth=lw;
      ctx.beginPath();
      ctx.moveTo(x1+ux*bs2*0.6, y1+uy*bs2*0.6);
      ctx.lineTo(x1+ux*off, y1+uy*off);
      ctx.stroke();
    }
    ctx.globalAlpha=_ba;
    ctx.fillStyle=col2; ctx.beginPath();
    ctx.arc(x1,y1,Math.max(1,bs2*0.75),0,Math.PI*2); ctx.fill();
    ctx.restore();
  } else if(t==='pixel'){
    var col3 = drawFxColor(), step = Math.max(3, pfmDraw.brushSize*0.9);
    var half = Math.max(1, pfmDraw.brushSize*0.48);
    ctx.save();
    ctx.fillStyle = col3;
    function snapP(v){ return Math.round(v/step)*step; }
    // 首点
    if(!pfmDraw.pxPrev){ pfmDraw.pxPrev = {x:snapP(x0), y:snapP(y0)}; }
    // 沿线段逐步填方块（snap 到步长网格，像素感）
    var d=Math.sqrt((x1-x0)*(x1-x0)+(y1-y0)*(y1-y0));
    var n=Math.max(1, Math.floor(d/step)+1);
    for(var i2=0;i2<=n;i2++){
      var t2=i2/n;
      var gx=snapP(x0+(x1-x0)*t2), gy=snapP(y0+(y1-y0)*t2);
      if(gx===pfmDraw.pxPrev.x && gy===pfmDraw.pxPrev.y) continue;
      ctx.fillRect(gx-half, gy-half, half*2, half*2);
      pfmDraw.pxPrev = {x:gx,y:gy};
    }
    ctx.restore();
  }
}

function hexToRgb(hex){
  // Support both #hex and rgb(r,g,b) / rgba(r,g,b,a) formats
  var m = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i.exec(hex || '');
  if(m){ return { r:+m[1], g:+m[2], b:+m[3] }; }
  var h = (hex || '').replace('#','');
  if(h.length===3){ h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2]; }
  return { r:parseInt(h.slice(0,2),16)||0, g:parseInt(h.slice(2,4),16)||0, b:parseInt(h.slice(4,6),16)||0 };
}
function lerpColor(c1, c2, t){
  // Linear RGB interpolation between two hex colors; t in [0,1]
  if(t<0) t=0; if(t>1) t=1;
  var a = hexToRgb(c1), b = hexToRgb(c2);
  var r = Math.round(a.r + (b.r-a.r)*t);
  var g = Math.round(a.g + (b.g-a.g)*t);
  var bl = Math.round(a.b + (b.b-a.b)*t);
  return 'rgb('+r+','+g+','+bl+')';
}
function createSprayStamp(colorA, colorB){
  var sz = 80;
  var c = document.createElement('canvas');
  c.width = sz; c.height = sz;
  var ctx = c.getContext('2d');
  var cx=sz/2, cy=sz/2, r0=sz/2;
  var isGrad = colorB && colorA !== colorB;
  function colFor(dist){ return isGrad ? lerpColor(colorA, colorB, dist/r0) : colorA; }
  // Layer 0: organic mist base (elliptical, off-center)
  var g0 = ctx.createRadialGradient(cx-4, cy+2, r0*0.05, cx+3, cy-3, r0*0.95);
  if(isGrad){ g0.addColorStop(0, colorA); g0.addColorStop(0.6, colorB); }
  else { g0.addColorStop(0, colorA); g0.addColorStop(0.25, colorA); g0.addColorStop(0.6, colorA); }
  g0.addColorStop(1, 'transparent');
  ctx.globalAlpha = 0.08;
  ctx.fillStyle = g0; ctx.fillRect(0,0,sz,sz);
  // Layer 1: dense micro-dots (nozzle spray)
  ctx.globalAlpha = 0.3 + Math.random()*0.2;
  for(var i=0;i<120;i++){
    var ang = Math.random()*Math.PI*2;
    var dist = Math.pow(Math.random(), 0.55)*r0*0.7;
    var dx = cx+Math.cos(ang)*dist, dy = cy+Math.sin(ang)*dist;
    var rr = 0.6+Math.random()*2.2;
    ctx.fillStyle = colFor(dist);
    ctx.beginPath(); ctx.arc(dx,dy,rr,0,Math.PI*2); ctx.fill();
  }
  // Layer 2: drips — elongated drops simulating paint flow
  ctx.globalAlpha = 0.18 + Math.random()*0.12;
  for(var j=0;j<20;j++){
    var a2 = Math.random()*Math.PI*2;
    var d2 = Math.random()*r0*0.75;
    var dx2 = cx+Math.cos(a2)*d2, dy2 = cy+Math.sin(a2)*d2;
    var len = 2+Math.random()*8;
    var ww = 1+Math.random()*3;
    ctx.fillStyle = colFor(d2);
    ctx.save();
    ctx.translate(dx2, dy2);
    ctx.rotate(a2 + (Math.random()-0.5)*0.8);
    ctx.beginPath();
    ctx.ellipse(0, len/2, ww, len/2, 0, 0, Math.PI*2);
    ctx.fill();
    ctx.restore();
  }
  // Layer 3: large irregular splatters
  ctx.globalAlpha = 0.12 + Math.random()*0.1;
  for(var k=0;k<12;k++){
    var a3 = Math.random()*Math.PI*2;
    var d3 = Math.pow(Math.random(), 0.5)*r0*0.8;
    var dx3 = cx+Math.cos(a3)*d3, dy3 = cy+Math.sin(a3)*d3;
    var r3 = 3+Math.random()*7;
    ctx.beginPath();
    // Irregular blobs — add slight distortion
    var pts = 6+Math.floor(Math.random()*4);
    ctx.moveTo(dx3+r3, dy3);
    for(var p=1;p<pts;p++){
      var pang = (p/pts)*Math.PI*2;
      var pr = r3*(0.7+Math.random()*0.6);
      ctx.lineTo(dx3+Math.cos(pang)*pr, dy3+Math.sin(pang)*pr);
    }
    ctx.closePath();
    ctx.fillStyle = colFor(d3); ctx.fill();
  }
  // Layer 4: secondary mist halo (softer edges)
  var g2 = ctx.createRadialGradient(cx,cy,r0*0.3,cx,cy,r0);
  g2.addColorStop(0,'transparent');
  if(isGrad){ g2.addColorStop(0.5,colorA); g2.addColorStop(0.8,colorB); }
  else { g2.addColorStop(0.5,colorA); g2.addColorStop(0.8,colorA); }
  g2.addColorStop(1,'transparent');
  ctx.globalAlpha = 0.06;
  ctx.fillStyle = g2; ctx.fillRect(0,0,sz,sz);
  // Layer 5: ultra-fine satellite dots (far scatter)
  ctx.globalAlpha = 0.1 + Math.random()*0.15;
  for(var m=0;m<30;m++){
    var a4 = Math.random()*Math.PI*2;
    var d4 = r0*(0.7+Math.random()*0.3);
    var dx4 = cx+Math.cos(a4)*d4, dy4 = cy+Math.sin(a4)*d4;
    ctx.fillStyle = colFor(d4);
    ctx.fillRect(dx4, dy4, 1.5, 1.5);
  }
  ctx.globalAlpha = 1;
  return c;
}

function buildGradientSprayStamps(colorA, colorB){
  // 预渲染 8 档渐变图章（中心A→边缘B），每档单色；按距离选档即得中心→边缘渐变，避免逐点建渐变导致卡顿。
  var arr = [];
  for(var i=0;i<8;i++){
    var t = i/7;
    var col = lerpColor(colorA, colorB, t);
    arr.push(createSprayStamp(col));
  }
  return arr;
}

function drawSpray(x, y){
  var sz = pfmDraw.brushSize * 2.2;
  /* 2026-10-03（甲·参数化）：颗粒数 / 散布半径改为**可调**（直读 DOM；默认 = 改前常量 ⇒ 零回归）。
     改前：stamps = 16 + rand*17（均值 24.5）· 散布固定 ±(sz*1.6)/2。 */
  var _amt = Math.max(4, _drawNum('pfmFxSprayAmt', 24));
  var stamps = Math.max(3, Math.round(_amt * (0.7 + Math.random()*0.6)));
  var _spr = Math.max(20, _drawNum('pfmFxSpraySpread', 100)) / 100;
  var sprayRadius = Math.max(sz*0.8, 10);
  var gradPair = null;
  if(pfmDraw.isGradient){
    gradPair = pfmGradients[pfmDraw.gradientIndex] || pfmGradients[0];
    var gkey = gradPair[0]+'|'+gradPair[1];
    if(!pfmDraw.sprayGradStamps || pfmDraw.sprayGradKey !== gkey){
      pfmDraw.sprayGradKey = gkey;
      pfmDraw.sprayGradStamps = buildGradientSprayStamps(gradPair[0], gradPair[1]);
    }
  } else {
    // Solid mode keeps the pre-rendered organic stamp (cached per color)
    var key = pfmDraw.color;
    if(!pfmDraw.sprayStamp || pfmDraw.sprayStampColor !== key){
      pfmDraw.sprayStampColor = key;
      pfmDraw.sprayStamp = createSprayStamp(pfmDraw.color);
    }
  }
  for(var i=0;i<stamps;i++){
    var ox = x + (Math.random()-0.5)*sz*1.6*_spr;
    var oy = y + (Math.random()-0.5)*sz*1.6*_spr;
    var s = (0.2 + Math.random()*0.7) * (sz/40);
    // Distance ratio from spray center -> drives gradient tier (0=center A, 1=outer B)
    var distRatio = Math.min(1, Math.sqrt((ox-x)*(ox-x)+(oy-y)*(oy-y)) / sprayRadius);
    pfmDrawCtx.save();
    var dripCol = null;
    pfmDrawCtx.globalAlpha = (0.12 + Math.random()*0.2) * _pfmA();
    if(pfmDraw.isGradient){
      // Pick the pre-rendered tier stamp closest to this dot's distance ratio
      var tier = Math.min(7, Math.floor(distRatio*8));
      pfmDrawCtx.translate(ox, oy);
      pfmDrawCtx.rotate(Math.random()*Math.PI*2);
      pfmDrawCtx.scale(s, s);
      pfmDrawCtx.drawImage(pfmDraw.sprayGradStamps[tier], -40, -40);
      if(Math.random()<0.12) dripCol = lerpColor(gradPair[0], gradPair[1], distRatio);
    } else {
      pfmDrawCtx.translate(ox, oy);
      pfmDrawCtx.rotate(Math.random()*Math.PI*2);
      pfmDrawCtx.scale(s, s);
      pfmDrawCtx.drawImage(pfmDraw.sprayStamp, -40, -40);
      if(Math.random()<0.12) dripCol = pfmDraw.color;
    }
    pfmDrawCtx.restore();
    /* 🔴🔴 2026-10-03（甲）：滴落**必须在 restore() 之后**画 ——
       原来这两句写在 `translate(ox,oy); rotate(); scale(s,s)` **里面**，而 `drawDrips` 自己
       又做了一次 `translate(x, y)` ⇒ **坐标被二次平移 + 缩放**：滴落点跑到 ≈(ox + ox·s) 那种
       离落点几百 px 的位置 ⇒ 观感是"整张画布随机散落小点"（实测 1440：Spray 一笔的 bbox 被
       撑到 1164×1200 = 整张画布，而同一批 Stamp/Spiro/Web 的截图都干净）。
       修法：循环内只记颜色，`restore()` 之后再落笔（此处 ox/oy 仍是绝对坐标）。 */
    if(dripCol) drawDrips(ox, oy+6, dripCol);
  }
}

function drawDrips(x, y, baseColor){
  // Gravity paint drips flowing downward from the spray point
  var n = 1 + Math.floor(Math.random()*3);
  var midColor = lerpColor(baseColor, '#000000', 0.2);
  for(var i=0;i<n;i++){
    var len = 6 + Math.random()*18;
    var w = 1.2 + Math.random()*2.5;
    var tilt = (Math.random()-0.5)*0.4;
    pfmDrawCtx.save();
    pfmDrawCtx.translate(x, y + (Math.random()-0.5)*4);
    pfmDrawCtx.rotate(tilt);
    pfmDrawCtx.globalAlpha = (0.25 + Math.random()*0.35) * _pfmA();
    // Solid fill with a slightly darker mid tone (no per-drip gradient creation)
    pfmDrawCtx.fillStyle = midColor;
    pfmDrawCtx.beginPath();
    pfmDrawCtx.ellipse(0, len/2, w, len/2, 0, 0, Math.PI*2);
    pfmDrawCtx.fill();
    pfmDrawCtx.restore();
  }
}

function isBrushTool(t){ return t==='brush'||t==='crayon'||t==='ink'||t==='soft'||t==='web'||t==='mirror'||t==='neon'||t==='rainbow'||t==='comet'||t==='pixel'||t==='marker'||t==='pencil'||t==='calli'||t==='water'||t==='air'||t==='oil'; }   /* 2026-09-30（乙）：+ marker/pencil/calli/water（4 支新笔刷同样走通用笔刷段） */

/* ===== 2026-09-20 第 2 批：涂抹 Smudge =====
   经典算法：取「上一采样点」的圆形区域像素，按 Strength 叠画到当前位置 ⇒ 颜色被拖出去。
   Strength=0 完全不动；越大越糊。粗细复用 ◉ Brush（含 ds 换算）。
   ⚠️ 走独立的 tool 分支，**不进 isBrushTool()** —— 它不是 lineTo 系。 */
function drawSmudge(x0, y0, x1, y1){
  var s = _smudgeStr();
  if(s <= 0) return;
  var ctx = pfmDrawCtx;
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  var R = Math.max(3, _smudgeRadius() * (pfmDraw.ds || 1));   /* CSS px → 后备像素 */
  var dd = Math.ceil(R), size = dd * 2;
  if(size < 2) return;
  /* 🔴🔴 2026-10-01（丙）：**整段只读一次 `getImageData`**。
     改前是**每段一次**（读 `2R×2R` 的取样窗），而 `getImageData` 是最慢的 canvas 操作
     （强制 GPU→CPU 同步）⇒ 实测 20.7ms/步（笔宽 100）×2.0 基准。**与 mixer 是同一个病**，
     mixer 已改成「整段读一次 → 内存处理 → 一次写」⇒ 12ms，本支照搬。
     一次读的范围 = 「源方块 ∪ 目标方块」的 bbox（源/目标通常重叠，必须一次覆盖）。 */
  var bx0 = Math.max(0, Math.floor(Math.min(x0, x1) - dd));
  var by0 = Math.max(0, Math.floor(Math.min(y0, y1) - dd));
  var bx1 = Math.min(W, Math.ceil(Math.max(x0, x1) + dd));
  var by1 = Math.min(H, Math.ceil(Math.max(y0, y1) + dd));
  var bw = bx1 - bx0, bh = by1 - by0;
  if(bw <= 0 || bh <= 0) return;
  var img;
  try { img = ctx.getImageData(bx0, by0, bw, bh); } catch(e){ return; }
  /* 🔴 2026-10-02（甲·②）：与 mixer 同族同待遇 —— 采样源 = 可见图层合成（见 `_mixSample`）。 */
  var srcImg = _mixSample(bx0, by0, bw, bh, img);
  var data = srcImg.data;
  var mk = pfmDraw.smMask;
  if(!mk || mk.length < bw * bh) mk = pfmDraw.smMask = new Uint8Array(bw * bh);
  mk.fill(0, 0, bw * bh);
  var tmp = pfmDraw.smBuf;
  if(!tmp || tmp.length < size * size * 4) tmp = pfmDraw.smBuf = new Uint8ClampedArray(size * size * 4);
  /* 🔴🔴 2026-10-04（乙批）：与 mixer 同因同解 —— `_mixSample` 回退时 `data === img.data`（就地改），
     有选区时必须先复制一份，才能在收尾按「扫过的 ∩ 选区内」回写（见下方循环）。 */
  var _selM = pfmDraw.selMask;
  if(srcImg === img && _selM){
    var _cp = _selCopyBuf("smCopy", bw * bh * 4);
    _cp.set(img.data); data = _cp;
  }
  _memSmudge(data, bw, bh, bx0, by0, x0, y0, x1, y1, dd, size, s, tmp, mk);
  if(srcImg !== img){
    var _cur = img.data;
    /* 2026-10-04（乙批）：除「扫过」外还要**落在选区内**（putImageData 忽略 clip ⇒ 这里兜）。 */
    for(var q0 = 0, qn = bw * bh; q0 < qn; q0++){
      if(!mk[q0]) continue;
      if(_selM){
        var _qy = (q0 / bw) | 0, _qx = q0 - _qy * bw;
        if(!_selM[(by0 + _qy) * W + (bx0 + _qx)]) continue;
      }
      var o0 = q0 * 4;
      _cur[o0] = data[o0]; _cur[o0 + 1] = data[o0 + 1]; _cur[o0 + 2] = data[o0 + 2]; _cur[o0 + 3] = data[o0 + 3];
    }
  }
  /* 🔴 2026-10-03（乙-3 蘸色率）：把命中区域的像素朝**当前主色**混合（Krita Color Rate）。
     默认 rate=0 ⇒ 整段跳过 ⇒ 逐像素与改前一致。混合式与 source-over 同形：
       outRGB = srcRGB·rate + dstRGB·(1−rate)；alpha 取较大者（涂抹本来就只作用于已有像素）。 */
  var _cr = _smudgeColorRate();
  if(_cr > 0){
    var _rgb = _hex2rgb(pfmDraw.color) || {r:0,g:0,b:0};
    var _cd = data;   /* 2026-10-04（乙批）：改副本 —— 否则 Color Rate 直接写 `img.data`，绕过选区回写过滤 */
    for(var q1 = 0, qn1 = bw * bh; q1 < qn1; q1++){
      if(!mk[q1]) continue;
      var o1 = q1 * 4;
      if(_cd[o1 + 3] === 0) continue;
      _cd[o1]     = _cd[o1]     + (_rgb.r - _cd[o1])     * _cr;
      _cd[o1 + 1] = _cd[o1 + 1] + (_rgb.g - _cd[o1 + 1]) * _cr;
      _cd[o1 + 2] = _cd[o1 + 2] + (_rgb.b - _cd[o1 + 2]) * _cr;
    }
  }
  ctx.putImageData(img, bx0, by0);
}

/* 把源方块 `(x0,y0)±R` 以 alpha `a` **source-over** 叠到目标圆 `(x1,y1)` 内（纯内存）。
   🔴 语义必须与原来的 `ctx.globalAlpha=a; ctx.drawImage(...)` **逐像素等价** ——
      那是标准 source-over（**不是替换**）：`outA = sa + da(1−sa)`、
      `outRGB = (srcRGB·sa + dstRGB·da·(1−sa)) / outA`（`sa = srcA·a`）。
      简单写成 `dst = src` 会让涂抹"擦掉"底下的颜色（观感完全不同）。
   🔴 源与目标重叠 ⇒ 必须先把源方块整块复制到 `tmp` 再写目标。 */
function _memSmudge(data, bw, bh, bx0, by0, x0, y0, x1, y1, dd, size, a, tmp, mask){
  var s0x = Math.round(x0 - dd) - bx0, s0y = Math.round(y0 - dd) - by0;
  var d0x = Math.round(x1 - dd) - bx0, d0y = Math.round(y1 - dd) - by0;
  var i, j, ti, si;
  for(j = 0; j < size; j++){
    var sy2 = s0y + j;
    for(i = 0; i < size; i++){
      var sx2 = s0x + i;
      ti = (j * size + i) * 4;
      if(sx2 < 0 || sy2 < 0 || sx2 >= bw || sy2 >= bh){ tmp[ti] = 0; tmp[ti+1] = 0; tmp[ti+2] = 0; tmp[ti+3] = 0; continue; }
      si = (sy2 * bw + sx2) * 4;
      tmp[ti] = data[si]; tmp[ti+1] = data[si+1]; tmp[ti+2] = data[si+2]; tmp[ti+3] = data[si+3];
    }
  }
  for(j = 0; j < size; j++){
    var dy2 = d0y + j;
    if(dy2 < 0 || dy2 >= bh) continue;
    var ry = j - dd + 0.5;
    for(i = 0; i < size; i++){
      var rx = i - dd + 0.5;
      if(rx*rx + ry*ry > dd*dd) continue;          /* 圆形 clip（与原 ctx.clip() 一致） */
      var dx2 = d0x + i;
      if(dx2 < 0 || dx2 >= bw) continue;
      ti = (j * size + i) * 4;
      var di = (dy2 * bw + dx2) * 4;
      if(mask) mask[dy2 * bw + dx2] = 1;      /* 🔴 同 `_memBlit`：标记笔触扫过的像素 */
      var sa = (tmp[ti+3] / 255) * a, da = data[di+3] / 255;
      var oa = sa + da * (1 - sa);
      if(oa > 0.0001){
        data[di]   = (tmp[ti]   * sa + data[di]   * da * (1 - sa)) / oa;
        data[di+1] = (tmp[ti+1] * sa + data[di+1] * da * (1 - sa)) / oa;
        data[di+2] = (tmp[ti+2] * sa + data[di+2] * da * (1 - sa)) / oa;
      }
      data[di+3] = oa * 255;
    }
  }
}

/* 2026-09-30（乙）：**湿边 / 混色** —— 在 smudge 的「取样→拖带」之上，再往当前色混一层。
   取色窗与 drawSmudge 同法（2R×2R）；拖到目标点后按 `wet` 把笔色压上去
   ⇒ 拖过的像素被"蘸"上新色（真颜料混色 / 水彩湿边的手感）。
   🔴 混色层用 `ctx.fillStyle`（由 applyDrawStyle 设好，支持渐变）—— **别写死 pfmDraw.color**。
   🔴🔴 2026-10-02（乙）：**拖带改成 source-over + 空白处淡笔色** ——
   原实现（硬替换 + `alpha=1`）让 Mix 退化成一支普通画笔（`_diag_mix.js` 基线：
   空画布 n=0、蓝带上的结果与 Brush 逐像素相同）。细则见 `_memBlit` 的注释。 */
function drawMixer(x0, y0, x1, y1){
  var cfg = _bcfg('mixer') || {};
  var wet = (cfg.wet === undefined) ? 0.5 : cfg.wet;
  var R = Math.max(2, (pfmDraw.brushSize || 8) * 0.6);
  var dd = Math.ceil(R), w2 = dd * 2;
  if(w2 < 2) return;
  var dx = x1 - x0, dy = y1 - y0;
  var dist = Math.sqrt(dx * dx + dy * dy);
  if(dist < 0.05) return;
  var ctx = pfmDrawCtx;
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  /* 沿路径**子步盖章** = 拖痕连续（一次 mousemove 只盖一个圆会在快速拖动时留下"串珠"）。
     子步长 0.65R ⇒ 章直径 2R、相邻章重叠 ~70%。 */
  var step = Math.max(2, R * 0.65);
  var n = Math.max(1, Math.min(24, Math.ceil(dist / step)));
  /* 🔴🔴 2026-10-01（乙·返修）：**整段只读一次 `getImageData`**。
     原实现是**每个子步**读一次（`_mixerStamp` 内部），而 `getImageData` 是最慢的 canvas 操作
     （强制 GPU→CPU 同步）⇒ 实测 38ms/步（正常拖动时其实每帧只有 3~4 个子步，
     瓶颈**不是**子步数、而是"每次都要同步一次")。
     现在：读一次覆盖整段的 bbox → 在内存 `ImageData` 上跑完全部子步（**保留链式**：
     后一步读到的是前一步改过的像素）→ **一次 `putImageData`**。 */
  var bx0 = Math.max(0, Math.floor(Math.min(x0, x1) - dd - 1));
  var by0 = Math.max(0, Math.floor(Math.min(y0, y1) - dd - 1));
  var bx1 = Math.min(W, Math.ceil(Math.max(x0, x1) + dd + 1));
  var by1 = Math.min(H, Math.ceil(Math.max(y0, y1) + dd + 1));
  var bw = bx1 - bx0, bh = by1 - by0;
  if(bw <= 0 || bh <= 0) return;
  var img;
  try { img = ctx.getImageData(bx0, by0, bw, bh); } catch(err){ return; }
  /* 🔴 2026-10-02（甲·②）：**采样源 = 可见图层合成**（`pfmDraw.mixAllLayers`，默认开）。
     不可用（未分层 / 手动关掉 / 取图失败）时 `_mixSample` 会回退返回 `img` ⇒ 行为与旧版完全一致。 */
  var srcImg = _mixSample(bx0, by0, bw, bh, img);
  var data = srcImg.data;
  /* 笔触扫过的像素掩码（写回当前层时只用它，见收尾的合并） */
  var mk = pfmDraw.mixMask;
  if(!mk || mk.length < bw * bh) mk = pfmDraw.mixMask = new Uint8Array(bw * bh);
  mk.fill(0, 0, bw * bh);
  /* 🔴 2026-10-01（乙·返修）：**必须挂 `pfmDraw`、不能写 `_mixerBuf = ...`** ——
     本文件顶部有 `'use strict'`，给未声明的标识符赋值会抛 **ReferenceError**，
     `drawMixer` 会在这一行直接中断 ⇒ canvas 上一个像素都不改（实测混色=0、拖带=0，
     看起来就是「mixer 完全没反应」）。 */
  var tmp = pfmDraw.mixBuf;
  if(!tmp || tmp.length < w2 * w2 * 4) tmp = pfmDraw.mixBuf = new Uint8ClampedArray(w2 * w2 * 4);
  /* 🔴🔴 2026-10-01（乙·返修）：**混色必须与拖带交替**，不能「先全部拖带、最后统一混色」。
     后者实测：混色叠 n 次（每步 alpha≈0.125，n=24 ⇒ 1-(1-0.125)^24 ≈ 96%）
     ⇒ 拖进来的颜色被盖成**纯笔色**（实拍：蓝底上红拖出来是一串纯红，毫无混合）。
     原实现的语义是每子步「读源 → 贴目标 → 混色」，下一步的源又是这一步混色后的像素
     ⇒ 所以混色也要放进**同一个循环**、在内存里做。 */
  var _rgb = hexToRgb(pfmDraw.isGradient
    ? ((pfmGradients[pfmDraw.gradientIndex] || ['#000000', '#000000'])[0])
    : pfmDraw.color);

  /* 🔴 2026-10-02（乙）：空白处的淡笔色（见 `BRUSH_CFG.mixer` 的 `faint` 注释）。
     再乘 `_pfmA()`：用户把「笔刷不透明度」拉低时，连这份淡色也一起淡下去（控件语义一致）。 */
  var faint = ((cfg.faint === undefined) ? 0.18 : cfg.faint) * _pfmA();
  _mixPerceptualInit(_rgb, (cfg.perc === undefined) ? 1 : cfg.perc);   /* 感知混色：预转笔色到线性光 */
  /* 🔴🔴 2026-10-02（丙·返修§4·甲）：**「颜料耗尽 ⇒ 转为从画布拾取」**
     （PS `Mix: 100%` = 「所有油彩将从画布中拾取」）。真实表现不是「变淡消失」，
     而是**储槽的颜料用完后，笔画从「刷颜料」变成「涂抹画布」**。
     映射到本实现：`mixA` = 「笔色压上去的比例」⇒ 让它沿**行程**从 `wet` 线性降到 **0**
     ⇒ 起笔正常混色，越画越接近**纯拖带（纯涂抹）**。
     `charge` 单位 = 笔宽倍，`mixRun` 累计画布 px ⇒ **抬笔再落笔 = 重新蘸色**（`drawMouseDown` 归零）。
     ⚠️ 未设 `charge` 的笔 `_range = 0` ⇒ `mixA` 恒定 ⇒ **逐像素零回归**。 */
  var _chgM = (cfg.charge === undefined) ? 0 : cfg.charge;
  var _range = _chgM * Math.max(1, pfmDraw.brushSize || 8);
  var _run0 = pfmDraw.mixRun || 0;
  for(var i = 1; i <= n; i++){
    var t0 = (i - 1) / n, t1 = i / n;
    var _mx = wet;
    if(_range > 0) _mx = wet * Math.max(0, 1 - Math.min(1, (_run0 + dist * t1) / _range));
    var mixA = _mx * 0.25 * _pfmA();   /* 子步后每像素会被重复盖章 ~5~9 次 ⇒ 单步必须更轻 */
    _memBlit(data, bw, bh, bx0, by0,
             x0 + dx * t0, y0 + dy * t0, x0 + dx * t1, y0 + dy * t1, dd, w2, tmp, _rgb, mixA, faint, mk);
  }
  pfmDraw.mixRun = _run0 + dist;
  /* 🔴🔴 2026-10-04（乙批）：**有选区时必须在副本上工作**。
     原因：`_mixSample` 回退（未分层 / 关掉多图层 / 取图失败）时 `srcImg === img`，
     此时 `data` 就是 `img.data`，`_memBlit` 的每一次就地修改**立刻写进了画布缓冲** ⇒
     收尾那句"只写扫过的像素"等于没写、选区过滤也无从下手（并在本批新引入的语义下
     把选区外改脏）。⇒ 有选区时先复制一份，收尾再按「扫过的 ∩ 选区内」回写。 */
  var _selM = pfmDraw.selMask;
  if(srcImg === img && _selM){
    var _cp = _selCopyBuf("mixCopy", bw * bh * 4);
    _cp.set(img.data); data = _cp;
  }
  /* 🔴 写回：**只写笔触扫过的像素**。采样源是合成图（含下层），若整块写回会把 bbox 内
     未被笔触覆盖的地方也"复制"进当前层。 */
  if(srcImg !== img || data !== img.data){
    var _cur = img.data;
    /* 2026-10-04（乙批）：除「扫过」外还要**落在选区内**（putImageData 忽略 clip ⇒ 这里兜）。 */
    for(var q0 = 0, qn = bw * bh; q0 < qn; q0++){
      if(!mk[q0]) continue;
      if(_selM){
        var _qy = (q0 / bw) | 0, _qx = q0 - _qy * bw;
        if(!_selM[(by0 + _qy) * W + (bx0 + _qx)]) continue;
      }
      var o0 = q0 * 4;
      _cur[o0] = data[o0]; _cur[o0 + 1] = data[o0 + 1]; _cur[o0 + 2] = data[o0 + 2]; _cur[o0 + 3] = data[o0 + 3];
    }
  }
  ctx.putImageData(img, bx0, by0);
}

/* ===== 2026-10-02（乙）：纹理特征元素的**绝对尺寸下限** =====

   为什么需要：所有纹理都是**随笔宽等比缩放**的，而画板**默认笔宽 4** ⇒ 4px 时
   oil 毛须缝 0.38px · crayon 擦痕 0.7px · water 洇散点半径 0.36~0.68px · pencil 抖动 0.55px
   **全部亚像素**（抗锯齿一糊就没了）⇒ 12 支里 8 支看起来"只是几条线"。
   ⇒ 物理判据：**特征元素的绝对尺寸 ≥ 1 CSS px 才看得见**（`PROBES.md` 第 4 条）。
   本函数给出某个特征元素的**最小尺寸**（CSS px）：默认 0.9，每支笔可用 `BRUSH_CFG.fxMin` 覆盖。
   ⚠️ 空间放不下时**减数量、不缩元素**（例如 oil 4px 时从 4 根毛须降到 2 根，而不是把缝压成 0.38px）。
   ⚠️ 论文式对照：Procreate `Grain → Scale: Cropped`（纹理不跟笔宽缩放）、Adobe「纹理尺寸不够就成盖印章」。 */
function _fxMin(cfg){
  return (cfg && typeof cfg.fxMin === 'number') ? cfg.fxMin : 0.9;
}

/* ===== 2026-10-02（甲）：感知混色 + 图层采样 ===== */

/* sRGB 字节 → **线性光** 0~1（256 项）；以及线性光 0~1 → sRGB 字节（4096 项，索引 `round(v*4095)`）。
   🔴 为什么要在线性光里混：sRGB 是 gamma 编码，直接在编码值上平均会**偏暗偏浑**。
   两张表都是启动时算一次 ⇒ 逐像素只剩查表（混色在 `_memBlit` 的内层循环里，每帧要跑几万次）。 */
var _MIX_S2L = (function(){
  var a = new Float32Array(256);
  for(var i = 0; i < 256; i++){ var c = i / 255; a[i] = (c <= 0.04045) ? (c / 12.92) : Math.pow((c + 0.055) / 1.055, 2.4); }
  return a;
})();
var _MIX_L2S = (function(){
  var a = new Uint8Array(4096);
  for(var i = 0; i < 4096; i++){
    var c = i / 4095;
    var v = (c <= 0.0031308) ? (c * 12.92) : (1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    a[i] = Math.max(0, Math.min(255, Math.round(v * 255)));
  }
  return a;
})();

/* 每次 `drawMixer` 调一次：把笔色预先转成线性光 + 彩度（逐像素不再重复算）。 */
function _mixPerceptualInit(rgb, perc){
  var br = _MIX_S2L[rgb.r], bg = _MIX_S2L[rgb.g], bb = _MIX_S2L[rgb.b];
  var g3 = (br + bg + bb) / 3;
  pfmDraw._mixP = { perc: perc !== 0,
    br: br, bg: bg, bb: bb,
    Cb: Math.max(br, bg, bb) - Math.min(br, bg, bb),      /* 笔色彩度（max−min 口径，与逐像素同口径） */
    vr: br - g3, vg: bg - g3, vb: bb - g3 };              /* 笔色的彩度向量（互补色塌陷时用来定方向） */
}

/* 采样源 = **可见图层的合成**（当前层在最上）。
   🔴 只合成 bbox 那一片 —— `flatDraw()` 是整幅合成（每帧调用太贵，`drawMixer` 每 mousemove 都跑）。
   🔴 `Sample All Layers` 在 PS / Krita 里都是**可选项**（默认只当前层）；我们默认开
      （三层固定结构 Base/Line/Colour + 消费者工作流），`pfmDraw.mixAllLayers = false` 可退回。
   🔴 采样 ≠ 写回：调用方必须按"笔触真正扫过的像素"合并（见 `drawMixer` 的 mask），
      否则 bbox 里没被笔触覆盖的地方会把**下层图层的内容复制进当前层**（图层语义被悄悄改坏）。 */
function _mixSample(bx0, by0, bw, bh, fallback){
  if(!isLayered() || pfmDraw.mixAllLayers === false) return fallback;
  var cv = pfmDrawCanvas; if(!cv) return fallback;
  var c = _mixSample._c || (_mixSample._c = document.createElement('canvas'));
  if(c.width !== cv.width || c.height !== cv.height){ c.width = cv.width; c.height = cv.height; }
  var g = c.getContext('2d');
  g.clearRect(bx0, by0, bw, bh);
  var n = layerCount();
  for(var i = 0; i < n; i++){
    if(pfmDraw.vis && pfmDraw.vis[i] === false) continue;
    g.globalAlpha = (pfmDraw.op && typeof pfmDraw.op[i] === 'number') ? pfmDraw.op[i] : 1;
    g.drawImage(pfmDraw.layers[i].cv, bx0, by0, bw, bh, bx0, by0, bw, bh);
  }
  g.globalAlpha = 1;
  try { return g.getImageData(bx0, by0, bw, bh); } catch(e){ return fallback; }
}

/* 把 `(sx,sy)` 处的 `2dd × 2dd` 方块搬到 `(px,py)`，**在 ImageData 的内存数组上**做。
   🔴 源与目标通常重叠 ⇒ 必须先把源**整块复制到临时缓冲**再写目标，不能就地搬
      （就地搬会在重叠区把"还没读的源"覆盖掉 ⇒ 拖痕出现斜向脏纹）。
   圆形 clip（半径 dd）与原 `_mixerStamp` 的 `ctx.clip()` 一致。

   🔴🔴 2026-10-02（乙）：**拖带 = 标准 source-over**（与 `_memSmudge` 同一套公式）。
   旧实现有两个致命缺陷，合起来让 Mix 退化成普通画笔：
     ① **硬替换**（`data[si] = tmp[ti]` 连 alpha 一起搬）⇒ 拖到空白处是把像素**擦成透明**，
        不是"把颜料拖过来"；
     ② 收尾 `if(data[si+3] < 1) data[si+3] = 1;` —— `data` 是 **Uint8ClampedArray**，
        这句写进去的是 **alpha = 1/255 ≈ 全透明**，不是"强制不透明"
        ⇒ 「在空白处上色」那一步肉眼完全看不见（`_diag_mix.js` ①：空画布 n=0）。
   现在：
     · 源有内容 ⇒ source-over 拖带（保留底层颜色，**不再擦除**）；
     · 源与目标**都**空白 ⇒ 若 `faint > 0` 铺一层淡笔色（乙档的取舍，见 `BRUSH_CFG.mixer`）；
     · 混色（把笔色按 mixA 压上去）**不动 alpha** ⇒ 不会把透明区染实。 */
function _memBlit(data, bw, bh, bx0, by0, sx, sy, px, py, dd, w2, tmp, rgb, mixA, faint, mask){
  var s0x = Math.round(sx - dd) - bx0, s0y = Math.round(sy - dd) - by0;
  var d0x = Math.round(px - dd) - bx0, d0y = Math.round(py - dd) - by0;
  var j, i2, sx2, sy2, ti, si;
  for(j = 0; j < w2; j++){
    sy2 = s0y + j;
    for(i2 = 0; i2 < w2; i2++){
      sx2 = s0x + i2;
      ti = (j * w2 + i2) * 4;
      if(sx2 < 0 || sy2 < 0 || sx2 >= bw || sy2 >= bh){ tmp[ti] = 0; tmp[ti+1] = 0; tmp[ti+2] = 0; tmp[ti+3] = 0; continue; }
      si = (sy2 * bw + sx2) * 4;
      tmp[ti] = data[si]; tmp[ti+1] = data[si+1]; tmp[ti+2] = data[si+2]; tmp[ti+3] = data[si+3];
    }
  }
  for(j = 0; j < w2; j++){
    var dy2 = d0y + j;
    if(dy2 < 0 || dy2 >= bh) continue;
    var ry = j - dd + 0.5;
    for(i2 = 0; i2 < w2; i2++){
      var rx = i2 - dd + 0.5;
      if(rx*rx + ry*ry > dd*dd) continue;          /* 圆形 clip */
      var dx2 = d0x + i2;
      if(dx2 < 0 || dx2 >= bw) continue;
      ti = (j * w2 + i2) * 4;
      si = (dy2 * bw + dx2) * 4;
      if(mask) mask[dy2 * bw + dx2] = 1;      /* 🔴 标记"笔触扫过"⇒ 写回时只写这些像素（见 _mixSample） */
      /* 源 / 目标各自的 alpha（0~1）。**两个都是 0 才是"真空白"** —— 只判目标不够：
         源有内容时那是"把颜料拖过来"，必须走 source-over。 */
      var _sa = tmp[ti + 3] / 255, _da = data[si + 3] / 255;
      if(_sa <= 0.004 && _da <= 0.004){
        /* 🔴 2026-10-02（乙）：**源与目标都空白** ⇒ 没有东西可拖、也没有东西可混。
           铺一层淡笔色（`faint`），让用户在空白产品上也能看见 Mix（取舍见 `BRUSH_CFG.mixer`）。
           🔴 用 `max` 语义（只在比现有更淡时才写）—— 同一像素每个子步、每一帧都会被重复盖章
              5~9 次，若写成 source-over 叠加，几帧之内就会变成实色（"淡色"白设了）。 */
        if(rgb && faint > 0){
          var _fa = Math.round(255 * faint);
          if(data[si + 3] < _fa){
            data[si] = rgb.r; data[si + 1] = rgb.g; data[si + 2] = rgb.b;
            data[si + 3] = _fa;
          }
        }
        continue;
      }
      /* 🔴🔴 2026-10-02（乙·返修）：**淡色拖带也必须封顶**。
         只堵住"两端都空白"那一步不够：淡色一旦写下，下一步就落进下面的 source-over 分支，
         而同一像素每个子步、每一帧都会被重复盖章 5~9 次 ⇒ 18% 很快叠到 ~90%
         （实测 `_diag_mix.js` ①：aVis **227.7**，淡色白设了）。
         判据：**两端都只有淡色**（src、dst 都 ≤ faint+2%）⇒ 不做 source-over 累积，
         直接写"笔色 + faint"，alpha 恒定封顶。
         ⚠️ 不能只判源：源是淡色、目标是真笔画时（`_da` 接近 1）必须走下面的 source-over
            —— 否则会把底下的画面设成 18% 透明（= 擦除）。 */
      if(faint > 0 && _sa <= faint + 0.02 && _da <= faint + 0.02){
        if(rgb){
          data[si] = rgb.r; data[si + 1] = rgb.g; data[si + 2] = rgb.b;
          data[si + 3] = Math.round(255 * faint);
        }
        continue;
      }
      /* ① 拖带：标准 source-over（= 原 `ctx.globalAlpha=a; drawImage(...)` 的逐像素语义）。
         🔴 简单写 `data[si] = tmp[ti]`（旧实现）会把底下的颜色**擦掉** —— 观感是"橡皮"，不是"涂抹"。 */
      var _oa = _sa + _da * (1 - _sa);
      if(_oa > 0.0001){
        data[si]     = (tmp[ti]     * _sa + data[si]     * _da * (1 - _sa)) / _oa;
        data[si + 1] = (tmp[ti + 1] * _sa + data[si + 1] * _da * (1 - _sa)) / _oa;
        data[si + 2] = (tmp[ti + 2] * _sa + data[si + 2] * _da * (1 - _sa)) / _oa;
      }
      data[si + 3] = _oa * 255;
      /* ② 混色（与原 `_mixerStamp` 的 `ctx.fill()` 同一语义：**同一个圆内**、同一个 alpha）
         —— 放在循环里 ⇒ 下一步的拖带会把这一步的混色结果**再拖走**（链式混合，这才有过渡）。
         🔴 **不动 alpha**：旧实现那句 `alpha = 1`（实际 = 1/255）就是"空白处看不见"的元凶。 */
      if(rgb && mixA > 0){
        var _P = pfmDraw._mixP;
        if(_P && _P.perc){
          /* 🔴🔴 2026-10-02（甲·①）：**感知混色**。
             旧写法是 sRGB 字节上的线性插值 —— 那正是 CSP 点名会 **发浑（dulling）** 的 `Standard`
             混色模式：互补色相混时彩度**互相抵消**（黄 + 蓝 → (128,128,128) 死灰）。分两步修：
               ① 在**线性光**里插值（sRGB 是 gamma 编码，直接平均会偏暗偏浑）；
               ② **彩度恢复**：把结果的彩度抬回「两个输入的彩度按同一权重插值」的水平
                  `C* = lerp(Cd, Cb, m)`。只回到"本该有的"彩度、**不超过任一输入** ⇒ 安全。
             数学上：只有当两个色相的彩度向量**部分抵消**时（也就是发浑的那一刻）`C < C*` 才成立，
             同色/接近色 / 黑白笔的情况下 `_k = 1`，与旧行为**完全一致**（零副作用）。
             ⚠️ 这**不是** Kubelka-Munk 减色混色（黄+蓝→绿那种真颜料混合要颜料光谱模型，
                例如 Mixbox —— 有许可与性能成本）。本轮先消掉**肉眼可见的"发浑"**。
             ⚠️ 互补色对半混时方向塌陷（C≈0）⇒ 取**笔色的彩度方向**、长度仍为 C*。 */
          var _m2 = mixA;
          var _dr = _MIX_S2L[data[si]], _dg = _MIX_S2L[data[si + 1]], _db = _MIX_S2L[data[si + 2]];
          var _r = _dr + (_P.br - _dr) * _m2, _g = _dg + (_P.bg - _dg) * _m2, _b = _db + (_P.bb - _db) * _m2;
          var _Ct = (Math.max(_dr, _dg, _db) - Math.min(_dr, _dg, _db)) +
                    (_P.Cb - (Math.max(_dr, _dg, _db) - Math.min(_dr, _dg, _db))) * _m2;
          if(_Ct > 0.002){
            var _C = Math.max(_r, _g, _b) - Math.min(_r, _g, _b);
            var _gr = (_r + _g + _b) / 3;
            if(_C > 0.002){
              var _k = Math.min(3, _Ct / _C);
              _r = _gr + (_r - _gr) * _k; _g = _gr + (_g - _gr) * _k; _b = _gr + (_b - _gr) * _k;
            } else {
              var _k2 = _Ct / (_P.Cb || 1e-6);
              _r = _gr + _P.vr * _k2; _g = _gr + _P.vg * _k2; _b = _gr + _P.vb * _k2;
            }
          }
          data[si]     = _MIX_L2S[_r <= 0 ? 0 : (_r >= 1 ? 4095 : (_r * 4095) | 0)];
          data[si + 1] = _MIX_L2S[_g <= 0 ? 0 : (_g >= 1 ? 4095 : (_g * 4095) | 0)];
          data[si + 2] = _MIX_L2S[_b <= 0 ? 0 : (_b >= 1 ? 4095 : (_b * 4095) | 0)];
        } else {
          data[si]     = data[si]     * (1 - mixA) + rgb.r * mixA;
          data[si + 1] = data[si + 1] * (1 - mixA) + rgb.g * mixA;
          data[si + 2] = data[si + 2] * (1 - mixA) + rgb.b * mixA;
        }
      }
    }
  }
}
/* ===== 2026-09-20 第 2 批 b：选择工具（矩形 / 套索 / 魔棒）=====
   选区用 **Uint8Array mask**（与 canvas 同分辨率）表示，三种工具都能落到同一结构上；
   蚂蚁线画在独立覆盖层 canvas `#pfmDrawSelLayer`，**不碰主 canvas 一个像素**。
   拖拽选区内部 = 移动像素（浮动层模型）：提取 → 擦原区 → 预览 → 定稿平移 mask。 */
function _isSelTool(t){ return t==='selrect'||t==='selasso'||t==='selwand'; }
function _selLayer(){ return document.getElementById('pfmDrawSelLayer'); }
function _wandTol(){ return Math.max(0, Math.min(100, _drawNum('pfmDrawWandTol', 30))) * 2.55; }

/* 覆盖层与主 canvas 同尺寸 / 同位置 / 同 transform（缩放平移后仍对齐） */
function _selLayerSync(){
  var lay=_selLayer(), cv=pfmDrawCanvas;
  if(!lay||!cv) return;
  var W=cv.width, H=cv.height;
  if(lay.width!==W||lay.height!==H){ lay.width=W; lay.height=H; }
  var _gl=_cvGeo();
  _ss(lay,'left',_gl.left+'px'); _ss(lay,'top',_gl.top+'px');
  _ss(lay,'width',_gl.w+'px'); _ss(lay,'height',_gl.h+'px');
  _ss(lay,'transformOrigin','0 0');
  _ss(lay,'transform',cv.style.transform||'');
}
function _selBBoxOf(mask){
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, x0=1e9,y0=1e9,x1=-1,y1=-1;
  for(var y=0;y<H;y++){
    var row=y*W;
    for(var x=0;x<W;x++){
      if(mask[row+x]){ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; }
    }
  }
  return x1<0 ? null : {x0:x0,y0:y0,x1:x1,y1:y1};
}
function selHas(){ return !!(pfmDraw.selMask && pfmDraw.selBBox); }
/* ===== 2026-10-04（乙批）：**绘制裁剪到选区** =====

   PS / Procreate 的选区核心语义（Procreate 官方原文）：
   「Paint, smudge, erase, fill, and transform selected areas **without affecting anything outside it**」。

   🔴 实现选择（不是随手的）：**`ctx.clip()`**，而**不是**逐像素过滤 ——
      · 画笔系（16 支）/ 橡皮 / 形状 / 纹理 / 喷枪 / 蛛网 / 花环 **全部走 ctx 绘制**
        ⇒ 一次 clip 全覆盖，逐像素零代价；
      · 而 `getImageData`/`putImageData` 系（**mixer / smudge / floodFill**）按规范**忽略裁剪**
        ⇒ 那三处必须按 `selMask` 单独过滤（各见其注释）。

   🔴 与本项目「脏矩形 / 残影」机制自洽（想清楚了才这么写）：
      笔迹只落在选区内 ⇒ 脏矩形（按几何 bbox 算）只会**偏大**，不会偏小；
      `_snapRestore` 里被 clip 挡住的那些像素**本来就没被画过** ⇒ 不需要还原。无残影。 */
function _selClipPath(){
  var m = pfmDraw.selMask;
  if(!m) return null;
  var c = pfmDraw.selClipCache;
  if(c && c.m === m) return c.p;              /* 掩码引用不变 ⇒ 复用（选区一变就是新数组，见 selSet） */
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  var p = new Path2D(), nrect = 0;
  var cur = null, y0 = 0;                     /* cur = 当前连续「同行区间」的行程组 */
  for(var y = 0; y <= H; y++){
    var runs = null;
    if(y < H){
      runs = [];
      var x = 0;
      while(x < W){
        if(m[y * W + x]){ var a = x; while(x < W && m[y * W + x]) x++; runs.push(a, x); }
        else x++;
      }
      if(!runs.length) runs = null;
    }
    /* 🔴 相邻行**同区间**合并成一个矩形 —— 矩形选框 ⇒ 1 个 rect；椭圆 ⇒ H 个 rect（都远小于逐行逐段）。
       `cur === runs` 对两个 null 成立 ⇒ 连续空行不会打断（也不会输出空矩形）。 */
    var same = (cur === runs);
    if(!same && cur && runs && cur.length === runs.length){
      same = true;
      for(var k = 0; k < cur.length; k++){ if(cur[k] !== runs[k]){ same = false; break; } }
    }
    if(!same){
      if(cur){ for(var k2 = 0; k2 < cur.length; k2 += 2){ p.rect(cur[k2], y0, cur[k2 + 1] - cur[k2], y - y0); nrect++; } }
      cur = runs; y0 = y;
    }
  }
  pfmDraw.selClipCache = { m: m, p: p, nrect: nrect };
  return p;
}
/* 哪些工具要按选区裁剪 —— 只对**会改像素**的工具。
   🚫 选区工具自身（selrect/selasso/selwand）：它操作的对象就是选区，裁掉就没法改了。
   🚫 picker：只读。🚫 text：是**浮动对象**，烘焙发生在 `textCommit`，不在落笔链里。 */
function _paintClipsToSel(t){
  if(!t) return false;
  if(t === 'picker' || t === 'text') return false;
  if(_isSelTool(t)) return false;
  return isBrushTool(t) || t === 'spray' || t === 'stamp' || t === 'spiro' || t === 'path' ||
         t === 'eraser' || t === 'fill' || t === 'mixer' || t === 'smudge' || _isShapeTool(t);
}
function _selClipBegin(){
  _selClipEnd();                              /* 🔴 防泄漏：上一次没配对（异常中断）就先补掉 */
  if(!selHas()) return;
  var p = _selClipPath();
  if(!p) return;
  pfmDrawCtx.save();
  pfmDrawCtx.clip(p);
  pfmDraw.selClipOn = true;
}
function _selClipEnd(){
  if(!pfmDraw.selClipOn) return;
  pfmDraw.selClipOn = false;                  /* 先置位：即使 restore 抛错也不会重复 restore */
  try{ pfmDrawCtx.restore(); }catch(e){}
}
/* 某个子步副本缓冲（putImageData 系裁剪用）。按需扩容，避免每帧分配。 */
function _selCopyBuf(which, need){
  var b = pfmDraw[which];
  if(!b || b.length < need){ b = pfmDraw[which] = new Uint8ClampedArray(need); }
  return b;
}

/* 🔴 2026-09-20 第 2 批 e：**只清选区本体**（mask / bbox / 浮动层 / 覆盖层），
   **不动交互状态**。selSet 内部必须用它：套索前两个点时
   selFromLasso() 返回 null（不足 3 点）⇒ 若这里连带清了 selDrag/selLass，
   套索会在第 2 个采样点就自我中断（实测：drag 变 null、lassN 归 0、覆盖层永远空）。 */
function selWipe(){
  pfmDraw.selMask=null; pfmDraw.selBBox=null; pfmDraw.selFloat=null;
  pfmDraw.selClipCache=null;
  _selClipEnd();   /* 2026-10-04（乙批）：选区没了 ⇒ 裁剪也必须撤掉（防泄漏） */
  if(_featCache) _featCache.key='';            /* 2026-09-21 第 4 批：羽化距离场缓存随选区失效 */
  selHandlesHide();             /* 2026-09-21 第 4 批：手柄一同隐藏 */
  var lay=_selLayer();
  if(lay){ var g=lay.getContext('2d'); g.clearRect(0,0,lay.width,lay.height); lay.classList.remove('on'); }
  _selAvailSync();      /* 2026-10-03（甲批）：没选区 ⇒ 变形类芯片置灰 */
}
function selClear(){
  selWipe();
  pfmDraw.selDrag=null; pfmDraw.selLass=null;
}
function selInside(x,y){
  if(!selHas()) return false;
  var W=pfmDrawCanvas.width, xi=Math.floor(x), yi=Math.floor(y);
  if(xi<0||yi<0||xi>=W||yi>=pfmDrawCanvas.height) return false;
  return !!pfmDraw.selMask[yi*W+xi];
}
function selFromRect(x0,y0,x1,y1){
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, mask=new Uint8Array(W*H);
  var ax=Math.max(0,Math.min(Math.floor(x0),Math.floor(x1))), bx=Math.min(W-1,Math.max(Math.floor(x0),Math.floor(x1)));
  var ay=Math.max(0,Math.min(Math.floor(y0),Math.floor(y1))), by=Math.min(H-1,Math.max(Math.floor(y0),Math.floor(y1)));
  for(var y=ay;y<=by;y++){ var row=y*W; for(var x=ax;x<=bx;x++) mask[row+x]=1; }
  return mask;
}
/* 2026-10-03（甲批）：椭圆选框 —— 离屏 fill 椭圆后取 alpha。
   🔴 只对**包围盒**取像素（不全幅 getImageData）⇒ 拖动逐帧也不卡。
   边缘 0/1 二值化（>128）与套索一致；羽化仍由 `_featherMap` 在"应用到像素"时负责。 */
function selFromOval(x0,y0,x1,y1){
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height;
  var oc=selFromOval._c||(selFromOval._c=document.createElement("canvas"));
  if(oc.width!==W||oc.height!==H){ oc.width=W; oc.height=H; }
  var ax=Math.min(x0,x1), bx=Math.max(x0,x1), ay=Math.min(y0,y1), by=Math.max(y0,y1);
  var px0=Math.max(0,Math.floor(ax)), py0=Math.max(0,Math.floor(ay));
  var px1=Math.min(W-1,Math.ceil(bx)), py1=Math.min(H-1,Math.ceil(by));
  var bw=px1-px0+1, bh=py1-py0+1;
  if(bw<1||bh<1) return null;
  var g=oc.getContext("2d");
  g.clearRect(0,0,W,H); g.fillStyle="#fff";
  g.beginPath();
  g.ellipse((ax+bx)/2,(ay+by)/2, Math.max(0.5,(bx-ax)/2), Math.max(0.5,(by-ay)/2), 0, 0, Math.PI*2);
  g.fill();
  var im=g.getImageData(px0,py0,bw,bh).data, mask=new Uint8Array(W*H);
  for(var y=0;y<bh;y++){
    var rowo=(py0+y)*W, rowi=y*bw;
    for(var x=0;x<bw;x++) if(im[(rowi+x)*4+3]>128) mask[rowo+px0+x]=1;
  }
  return mask;
}
function selFromLasso(pts){
  if(!pts||pts.length<3) return null;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height;
  var oc=selFromLasso._c||(selFromLasso._c=document.createElement('canvas'));
  if(oc.width!==W||oc.height!==H){ oc.width=W; oc.height=H; }
  var g=oc.getContext('2d');
  g.clearRect(0,0,W,H);
  g.fillStyle='#fff';
  g.beginPath(); g.moveTo(pts[0].x,pts[0].y);
  for(var i=1;i<pts.length;i++) g.lineTo(pts[i].x,pts[i].y);
  g.closePath(); g.fill();
  var im=g.getImageData(0,0,W,H).data, mask=new Uint8Array(W*H), _hit=0;
  for(var k=0;k<W*H;k++){ if(im[k*4+3]>128){ mask[k]=1; _hit++; } }
  selFromLasso._lastN=_hit;   /* 调试留档：套索路径 fill 出的像素数 */
  return mask;
}
/* 魔棒：与 floodFill 同构的 4 邻域扩散，但只产 mask（不改像素） */
function selFromWand(sx,sy){
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height;
  var data=pfmDrawCtx.getImageData(0,0,W,H).data;
  var ix=Math.max(0,Math.min(W-1,Math.floor(sx))), iy=Math.max(0,Math.min(H-1,Math.floor(sy)));
  var st=(iy*W+ix)*4;
  var tr=data[st],tg=data[st+1],tb=data[st+2],ta=data[st+3];
  var T=_wandTol(), mask=new Uint8Array(W*H), seen=new Uint8Array(W*H);
  var stack=[[ix,iy]];
  while(stack.length){
    var pt=stack.pop(), px=pt[0], py=pt[1];
    if(px<0||px>=W||py<0||py>=H) continue;
    var idx=py*W+px;
    if(seen[idx]) continue;
    seen[idx]=1;
    var j=idx*4;
    if(Math.abs(data[j]-tr)>T||Math.abs(data[j+1]-tg)>T||Math.abs(data[j+2]-tb)>T||Math.abs(data[j+3]-ta)>T) continue;
    mask[idx]=1;
    stack.push([px+1,py],[px-1,py],[px,py+1],[px,py-1]);
  }
  return mask;
}
/* 蚂蚁线：只扫 bbox；3×3 邻域判定边界（约 2~3px 粗），蓝白相间 */
function selRedraw(){
  var lay=_selLayer();
  if(!lay) return;
  _selLayerSync();
  var g=lay.getContext('2d');
  var W=lay.width, H=lay.height;
  g.clearRect(0,0,W,H);
  if(!selHas()){ lay.classList.remove('on'); return; }
  var b=pfmDraw.selBBox, mask=pfmDraw.selMask;
  var x0=Math.max(0,b.x0-2), x1=Math.min(W-1,b.x1+2), y0=Math.max(0,b.y0-2), y1=Math.min(H-1,b.y1+2);
  var bw=x1-x0+1, bh=y1-y0+1;
  var img=g.createImageData(bw,bh), dd=img.data;
  for(var y=y0;y<=y1;y++){
    for(var x=x0;x<=x1;x++){
      var i=y*W+x;
      if(!mask[i]) continue;
      var edge=false;
      for(var dy=-1;dy<=1&&!edge;dy++){
        for(var dx=-1;dx<=1;dx++){
          var nx=x+dx, ny=y+dy;
          if(nx<0||ny<0||nx>=W||ny>=H){ edge=true; break; }
          if(!mask[ny*W+nx]){ edge=true; break; }
        }
      }
      if(!edge) continue;
      var o=((y-y0)*bw+(x-x0))*4;
      if(((x+y+pfmDraw.selPhase)>>2)&1){ dd[o]=255;dd[o+1]=255;dd[o+2]=255;dd[o+3]=235; }
      else { dd[o]=17;dd[o+1]=24;dd[o+2]=39;dd[o+3]=235; }
    }
  }
  g.putImageData(img,x0,y0);
  lay.classList.add('on');
  _selAvailSync();      /* 2026-10-03（甲批）：有选区 ⇒ 变形类芯片可用 */
  selHandlesSync();   /* 2026-09-21 第 4 批：选区变了 ⇒ 手柄跟着重定位 */
}
function selSet(mask){
  if(!mask){ selWipe(); return; }
  pfmDraw.selMask=mask;
  pfmDraw.selClipCache=null;   /* 2026-10-04（乙批）：掩码换了 ⇒ clip 路径缓存作废 */
  pfmDraw.selBBox=_selBBoxOf(mask);
  if(!pfmDraw.selBBox){ selWipe(); return; }
  if(_featCache) _featCache.key='';   /* 2026-09-21 第 4 批：选区变了 ⇒ 羽化距离场必须重算 */
  selRedraw();
}
/* 提取浮动层：把选区内像素抠出来（mask 之外 alpha 归 0），并把原位置擦成透明 */
function selExtractFloat(){
  var b=pfmDraw.selBBox; if(!b) return false;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, mask=pfmDraw.selMask;
  var bw=b.x1-b.x0+1, bh=b.y1-b.y0+1;
  var patch=pfmDrawCtx.getImageData(b.x0,b.y0,bw,bh);
  var pd=patch.data;
  var fmap=_featherMap();   /* 2026-09-21 第 4 批：羽化 = 边缘 alpha 渐变（r=0 时为 null ⇒ 行为不变） */
  for(var y=0;y<bh;y++){
    for(var x=0;x<bw;x++){
      var mi0=(b.y0+y)*W+(b.x0+x), pi0=(y*bw+x)*4;
      if(!mask[mi0]){ pd[pi0+3]=0; continue; }
      if(fmap) pd[pi0+3]=Math.round(pd[pi0+3]*fmap[mi0]/255);
    }
  }
  var oc=selExtractFloat._c||(selExtractFloat._c=document.createElement('canvas'));
  oc.width=bw; oc.height=bh;
  oc.getContext('2d').putImageData(patch,0,0);
  /* 擦原位置：putImageData 忽略 globalCompositeOperation ⇒ 必须逐像素写 */
  var full=pfmDrawCtx.getImageData(0,0,W,H), fd=full.data;
  for(var y2=0;y2<bh;y2++){
    for(var x2=0;x2<bw;x2++){
      var mi2=(b.y0+y2)*W+(b.x0+x2);
      if(!mask[mi2]) continue;
      var fi=mi2*4;
      /* 2026-09-21 第 4 批：原位置按 1-alpha 擦除（羽化后边缘留半透明，与浮动层叠加正好还原） */
      var ka=fmap ? (1-fmap[mi2]/255) : 0;
      fd[fi]=Math.round(fd[fi]*ka); fd[fi+1]=Math.round(fd[fi+1]*ka); fd[fi+2]=Math.round(fd[fi+2]*ka);
      fd[fi+3]=Math.round(fd[fi+3]*ka);
    }
  }
  pfmDrawCtx.putImageData(full,0,0);
  pfmDraw.selFloat={cv:oc, ox:b.x0, oy:b.y0};
  return true;
}
function selPaintFloat(dx,dy){
  if(!pfmDraw.snapshot) return;
  var f=pfmDraw.selFloat;
  /* 2026-10-24(甲): dirty rect —— 只还原上一帧浮动层矩形，不整幅 putImageData(5.76MB)。
     首帧无 _floatRect ⇒ 整幅还原（清掉拖前预览）；之后只还原小框。 */
  var _pr=pfmDraw._floatRect;
  if(_pr && _pr.w>0 && _pr.h>0){
    var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height;
    var _x0=Math.max(0,_pr.x), _y0=Math.max(0,_pr.y);
    var _x1=Math.min(W,_pr.x+_pr.w), _y1=Math.min(H,_pr.y+_pr.h);
    if(_x1>_x0 && _y1>_y0){ pfmDrawCtx.putImageData(pfmDraw.snapshot,0,0,_x0,_y0,_x1-_x0,_y1-_y0); }
    else { pfmDrawCtx.putImageData(pfmDraw.snapshot,0,0); }
  } else {
    pfmDrawCtx.putImageData(pfmDraw.snapshot,0,0);
  }
  if(f){
    var _nx=Math.round(f.ox+dx), _ny=Math.round(f.oy+dy);
    pfmDrawCtx.drawImage(f.cv, _nx, _ny);
    pfmDraw._floatRect={ x:_nx, y:_ny, w:f.cv.width, h:f.cv.height };
  } else {
    pfmDraw._floatRect=null;
  }
}
function selCommitFloat(dx,dy){
  if(!selHas()) return 0;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, mask=pfmDraw.selMask;
  var ndx=Math.round(dx), ndy=Math.round(dy);
  if(!ndx && !ndy){ pfmDraw.selFloat=null; return 0; }
  var nm=new Uint8Array(W*H);
  for(var y=0;y<H;y++){
    for(var x=0;x<W;x++){
      if(!mask[y*W+x]) continue;
      var nx=x+ndx, ny=y+ndy;
      if(nx<0||ny<0||nx>=W||ny>=H) continue;
      /* 先清旧位、再置新位：同一批 mask 里 old→new 不会互相污染（nm 是独立数组） */
      nm[ny*W+nx]=1;
    }
  }
  pfmDraw.selFloat=null;
  selSet(nm);
  return 1;
}
/* 三个操作：填充 / 复制 / 删除 */
function selFill(){
  if(!selHas()) return;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, mask=pfmDraw.selMask;
  var full=pfmDrawCtx.getImageData(0,0,W,H), fd=full.data;
  var col=pfmDraw.color||'#000';
  var r=parseInt(col.slice(1,3),16), gg=parseInt(col.slice(3,5),16), bb=parseInt(col.slice(5,7),16);
  var fmap=_featherMap();   /* 2026-09-21 第 4 批 */
  for(var y=0;y<H;y++){
    for(var x=0;x<W;x++){
      var ix=y*W+x;
      if(!mask[ix]) continue;
      var i=ix*4;
      var t=fmap ? fmap[ix]/255 : 1;
      fd[i]=Math.round(fd[i]*(1-t)+r*t);
      fd[i+1]=Math.round(fd[i+1]*(1-t)+gg*t);
      fd[i+2]=Math.round(fd[i+2]*(1-t)+bb*t);
      fd[i+3]=Math.round(fd[i+3]*(1-t)+255*t);
    }
  }
  pfmDrawCtx.putImageData(full,0,0);
  pushUndo();
}
function selDelete(){
  if(!selHas()) return;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, mask=pfmDraw.selMask;
  var full=pfmDrawCtx.getImageData(0,0,W,H), fd=full.data;
  var fmap=_featherMap();   /* 2026-09-21 第 4 批 */
  for(var y=0;y<H;y++){
    for(var x=0;x<W;x++){
      var ix=y*W+x;
      if(!mask[ix]) continue;
      var i=ix*4;
      var ka=fmap ? (1-fmap[ix]/255) : 0;
      fd[i]=Math.round(fd[i]*ka); fd[i+1]=Math.round(fd[i+1]*ka);
      fd[i+2]=Math.round(fd[i+2]*ka); fd[i+3]=Math.round(fd[i+3]*ka);
    }
  }
  pfmDrawCtx.putImageData(full,0,0);
  pushUndo();
}
function selDuplicate(){
  if(!selHas()) return;
  var b=pfmDraw.selBBox, W=pfmDrawCanvas.width, mask=pfmDraw.selMask;
  var bw=b.x1-b.x0+1, bh=b.y1-b.y0+1;
  var patch=pfmDrawCtx.getImageData(b.x0,b.y0,bw,bh), pd=patch.data;
  var fmap=_featherMap();   /* 2026-09-21 第 4 批 */
  for(var y=0;y<bh;y++){
    for(var x=0;x<bw;x++){
      var mi1=(b.y0+y)*W+(b.x0+x), pi1=(y*bw+x)*4;
      if(!mask[mi1]){ pd[pi1+3]=0; continue; }
      if(fmap) pd[pi1+3]=Math.round(pd[pi1+3]*fmap[mi1]/255);
    }
  }
  var oc=selDuplicate._c||(selDuplicate._c=document.createElement('canvas'));
  oc.width=bw; oc.height=bh;
  oc.getContext('2d').putImageData(patch,0,0);
  pfmDrawCtx.drawImage(oc, b.x0, b.y0);   /* 原地复制一份 ⇒ 视觉上变实（叠加） */
  pushUndo();
}
/* 指针三件套 */
/* ===== 2026-10-03（甲批）：选区增强 ===== */
/* 加/减：拖动期间每帧都要与"按下时的选区"做并/差。selOp="" 时直接返回新 mask（原行为，零回归）。 */
function selCombine(mk){
  var op=pfmDraw.selOp, base=pfmDraw.selBase;
  if(!mk) return null;
  if(!op || !base) return mk;
  var n=pfmDrawCanvas.width*pfmDrawCanvas.height, out=new Uint8Array(n), i;
  if(op==="add"){ for(i=0;i<n;i++) out[i] = (base[i]||mk[i])?1:0; }
  else { for(i=0;i<n;i++) out[i] = (base[i]&&!mk[i])?1:0; }
  return out;
}
/* 只移边界：把 base 掩码整体平移 (dx,dy)，不动任何像素。 */
function _selShiftMask(base, dx, dy){
  if(!base) return;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, out=new Uint8Array(W*H);
  if(!dx && !dy){ selSet(base); return; }
  for(var y=0;y<H;y++){
    var ny=y+dy; if(ny<0||ny>=H) continue;
    var srow=y*W, drow=ny*W;
    for(var x=0;x<W;x++){ if(!base[srow+x]) continue; var nx=x+dx; if(nx<0||nx>=W) continue; out[drow+nx]=1; }
  }
  selSet(out);
}
/* 积分图（一次 O(W·H)）⇒ 方框形态学：Expand/Contract/Border/Smooth 都与半径无关地一次算完。
   CSP 的"扩大/缩小"默认即方角（向四角），与此处的方框核一致。 */
function _selIntegral(mask){
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height;
  var it=new Uint32Array((W+1)*(H+1)), x, y;
  for(y=1;y<=H;y++){
    var rs=0, row=(y-1)*W;
    for(x=1;x<=W;x++){ rs += mask[row+x-1] ? 1 : 0; it[y*(W+1)+x] = it[(y-1)*(W+1)+x] + rs; }
  }
  return it;
}
function _selBoxSum(it, x, y, r, W, H){
  var x0=x-r<0?0:x-r, x1=x+r>W-1?W-1:x+r, y0=y-r<0?0:y-r, y1=y+r>H-1?H-1:y+r;
  return it[(y1+1)*(W+1)+(x1+1)] - it[y0*(W+1)+(x1+1)] - it[(y1+1)*(W+1)+x0] + it[y0*(W+1)+x0];
}
function selMorph(kind, n){
  if(!selHas()) return;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, src=pfmDraw.selMask;
  var r=Math.max(1,Math.min(40,Math.round(n)||1));
  var br=(kind==="border") ? Math.max(1,Math.round(r/2)) : r;   /* Border = 以边界为中心、总宽约 r 的环 */
  var it=_selIntegral(src), out=new Uint8Array(W*H);
  var full=(2*br+1)*(2*br+1), half=Math.round(full/2);
  for(var y=0;y<H;y++){
    for(var x=0;x<W;x++){
      var v=_selBoxSum(it,x,y,br,W,H), k=y*W+x;
      if(kind==="grow") out[k] = v>0 ? 1 : 0;                  /* 膨胀：框内碰到就算 */
      else if(kind==="shrink") out[k] = (v===full) ? 1 : 0;    /* 腐蚀：整框都在里面才算 */
      else if(kind==="smooth") out[k] = (v>=half) ? 1 : 0;     /* 中值/多数表决 ⇒ 抹平毛刺 */
      else out[k] = (v>0 && v<full) ? 1 : 0;                   /* border：框跨边界 ⇒ 环带 */
    }
  }
  selSet(out);
}
/* 色域选择（PS "Similar" / CSP「選択範囲を色域で選択」的等效）：
   以**当前选区的平均色**为基准，在**本图层**上把所有容差内的像素选进来（非连通）。 */
function selSimilar(){
  if(!selHas()) return;
  var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height, src=pfmDraw.selMask;
  var d=pfmDrawCtx.getImageData(0,0,W,H).data, i, n=0, sr=0, sg=0, sb=0, sa=0;
  for(i=0;i<W*H;i++){ if(!src[i]) continue; var o=i*4; sr+=d[o]; sg+=d[o+1]; sb+=d[o+2]; sa+=d[o+3]; n++; }
  if(!n) return;
  var tr=sr/n, tg=sg/n, tb=sb/n, ta=sa/n, T=_wandTol();
  var out=new Uint8Array(W*H);
  for(i=0;i<W*H;i++){
    var j=i*4;
    if(Math.abs(d[j]-tr)<=T && Math.abs(d[j+1]-tg)<=T && Math.abs(d[j+2]-tb)<=T && Math.abs(d[j+3]-ta)<=T) out[i]=1;
  }
  selSet(out);
}
/* 「不可用必须看得见」：无选区时把变形类芯片置灰（不弹提示 —— 画板里没有提示通道）。 */
function _selAvailSync(){
  var has = selHas();
  var ids=["pfmSelGrow","pfmSelShrink","pfmSelBorder","pfmSelSmooth","pfmSelSimilar","pfmSelInvert"];
  for(var i=0;i<ids.length;i++){ var e=document.getElementById(ids[i]); if(e) e.disabled=!has; }
}
function selDown(pos){
  if(selInside(pos.x,pos.y)){
    /* 2026-10-03（甲批）：Move=Box ⇒ 拖动只平移**蚂蚁线**（PS 选框工具的语义）。默认仍是移像素。 */
    if(!pfmDraw.selMovePix){ pfmDraw.selDrag={mode:"movebox", sx:pos.x, sy:pos.y, base:pfmDraw.selMask}; return; }
    /* 点在选区内 ⇒ 移动模式（浮动层） */
    if(selExtractFloat()){
      /* 🔴 2026-09-20 第 2 批 c：提取后必须**重拍 snapshot**。
         原 snapshot 是 mousedown 时（还没擦除）的状态 ⇒
         selPaintFloat 用它 putImageData 会把选区内容复原，
         与浮动层重叠、像素翻倍（实测 n 5766 → 10930）。 */
      pfmDraw.snapshot = pfmDrawCtx.getImageData(0,0,pfmDrawCanvas.width,pfmDrawCanvas.height);
      pfmDraw._floatRect = null;
      pfmDraw.selDrag={mode:'move', sx:pos.x, sy:pos.y};
      return;
    }
  }
  /* 2026-10-03（甲批）：进入"新建选区"分支前，记住按下瞬间的选区 —— 加/减都以它为基准。
     （放在这里而不是函数开头：点内部走"移动"分支时不需要 base。） */
  pfmDraw.selBase = pfmDraw.selMask || null;
  var t=pfmDraw.tool;
  if(t==='selwand'){
    selSet(selCombine(selFromWand(pos.x,pos.y)));
    pfmDraw.selDrag={mode:'none'};
  } else if(t==='selasso'){
    pfmDraw.selLass=[{x:pos.x,y:pos.y}];
    pfmDraw.selDrag={mode:'lasso'};
  } else {
    pfmDraw.selDrag={mode:'rect', sx:pos.x, sy:pos.y};
  }
}
function selMove(pos){
  var dr=pfmDraw.selDrag; if(!dr) return;
  dr.lx=pos.x; dr.ly=pos.y;   /* 2026-09-21 第 4 批：兜底终点（见 selUp 注释） */
  if(dr.mode==='move'){
    var _mdx=pos.x-dr.sx, _mdy=pos.y-dr.sy;
    selPaintFloat(_mdx, _mdy);
    /* 2026-10-24(甲): 虚线框跟随——给 sel 层加 CSS translate（GPU 合成，零重绘，不占 CPU） */
    try {
      var _lay=document.getElementById('pfmDrawSelLayer');
      if(_lay && pfmDraw.selBBox){
        var _gl=_cvGeo();
        var _ksx=_gl.w/pfmDrawCanvas.width, _ksy=_gl.h/pfmDrawCanvas.height;
        _lay.style.transform='translate('+(_mdx*_ksx).toFixed(2)+'px,'+(_mdy*_ksy).toFixed(2)+'px)'+(pfmDrawCanvas.style.transform?' '+pfmDrawCanvas.style.transform:'');
      }
    } catch(e){}
  }
  else if(dr.mode==='movebox'){ _selShiftMask(dr.base, Math.round(pos.x-dr.sx), Math.round(pos.y-dr.sy)); }
  else if(dr.mode==='rect'){
    /* 2026-10-03（甲批）：椭圆选框（芯片 Oval）+ 加/减（selCombine）。 */
    var _mk = pfmDraw.selOval ? selFromOval(dr.sx, dr.sy, pos.x, pos.y) : selFromRect(dr.sx, dr.sy, pos.x, pos.y);
    selSet(selCombine(_mk));
  }
  else if(dr.mode==='lasso'){
    var last=pfmDraw.selLass[pfmDraw.selLass.length-1];
    if(!last || Math.abs(pos.x-last.x)>2 || Math.abs(pos.y-last.y)>2) pfmDraw.selLass.push({x:pos.x,y:pos.y});
    selSet(selCombine(selFromLasso(pfmDraw.selLass)));
  }
}
function selUp(e){
  var dr=pfmDraw.selDrag;
  if(dr && dr.mode==='move'){
    /* 🔴 2026-09-21 第 4 批：终点坐标优先级 —— mouseup/touchend 事件坐标 > 最后一次 move > lastX。
       浏览器会**丢弃/合并 mousemove**（每帧 selPaintFloat 要 putImageData 一整幅
       1200x1200，主线程忙时后续 move 根本到不了页面）⇒ 只用 lastX 会"提前落定"：
       实测拖 160 显示像素只落定 76 画布像素（第 2 批就存在的既有缺陷，断言阈值 80 侥幸通过）。
       mouseup 一定会送达，是最可靠的终点来源。 */
    var ux = dr.lx, uy = dr.ly;
    if(e){
      var pt = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0] : e;
      if(pt && pt.clientX != null){ var up = getDrawPos(pt); ux = up.x; uy = up.y; }
    }
    if(ux == null){ ux = pfmDraw.lastX; uy = pfmDraw.lastY; }
    /* 🔴 第二层根因：selCommitFloat 只重算 mask、**不重绘画布**。
       mousemove 被丢弃时画布上的浮动层还停在倒数第 N 个采样点，
       而 mask 按终点走 ⇒ "像素没跟上、选区框却走了"（实测 cx 408->486 只走 78，
       而 mask 已经到 366 处，V2.3 反而 PASS）。必须先用终点补绘一次预览。 */
    /* 2026-10-24(甲): 先复位框层 translate（提交后 selSet→selRedraw 会按新位置重画，不复位会双重位移） */
    try { var _l2=document.getElementById('pfmDrawSelLayer'); if(_l2){ _l2.style.transform=pfmDrawCanvas.style.transform||''; } } catch(e){}
    selPaintFloat(ux-dr.sx, uy-dr.sy);
    var moved = selCommitFloat(ux-dr.sx, uy-dr.sy);
    if(moved) pushUndo();
  }
  pfmDraw.selDrag=null;
  pfmDraw.selLass=null;
  /* 2026-09-21 第 4 批：框选/套索结束后**必须补一次手柄同步**。
     selHandlesSync 的判据含「selDrag 非空 ⇒ 正在画选区 ⇒ 隐藏」，
     绘制过程中它一直走隐藏分支；若此处不补，画完手柄不会重新出现
     （实测 V1.1：on=false、frame 恒 0x0，后续手柄断言全部连带失败）。 */
  selHandlesSync();
}

/* ===== 2026-09-21 第 4 批：选区羽化（距离场）=====
   mask 本体**保持 0/1**（selInside / 蚂蚁线边界判定 / _selBBoxOf 全部照旧），
   羽化只在「把 mask 应用到像素」时按距离取 alpha ⇒ r=0 时 _featherMap() 返回 null，
   所有调用点走原路径，零回归。
   边缘像素 dist=0 ⇒ alpha=0（全透明），到 r 像素深处 alpha=255 ⇒ 由外向内渐显。 */
var _featCache = { key:'', map:null };
function _featherR(){ return Math.max(0, Math.min(20, _drawNum('pfmDrawFeather', 0))); }
function _featherMap(){
  var r = _featherR();
  if(r <= 0) return null;
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height, mask = pfmDraw.selMask;
  if(!mask) return null;
  var b = pfmDraw.selBBox;
  var key = r + '|' + W + 'x' + H + '|' + (b ? (b.x0 + ',' + b.y0 + ',' + b.x1 + ',' + b.y1) : '-');
  if(_featCache.key === key && _featCache.map) return _featCache.map;
  var dist = new Int16Array(W * H), q = [], head = 0, i, x, y, row, edge, k;
  for(i = 0; i < W * H; i++) dist[i] = -1;
  for(y = 0; y < H; y++){
    row = y * W;
    for(x = 0; x < W; x++){
      i = row + x;
      if(!mask[i]) continue;
      edge = false;
      if(x === 0 || y === 0 || x === W - 1 || y === H - 1) edge = true;
      else if(!mask[i-1] || !mask[i+1] || !mask[i-W] || !mask[i+W]) edge = true;
      if(edge){ dist[i] = 0; q.push(i); }
    }
  }
  while(head < q.length){
    i = q[head++];
    var dd = dist[i];
    if(dd >= r) continue;
    var cy = (i / W) | 0, cxx = i - cy * W;
    if(cxx > 0)   { k = i - 1; if(mask[k] && dist[k] < 0){ dist[k] = dd + 1; q.push(k); } }
    if(cxx < W-1) { k = i + 1; if(mask[k] && dist[k] < 0){ dist[k] = dd + 1; q.push(k); } }
    if(cy > 0)    { k = i - W; if(mask[k] && dist[k] < 0){ dist[k] = dd + 1; q.push(k); } }
    if(cy < H-1)  { k = i + W; if(mask[k] && dist[k] < 0){ dist[k] = dd + 1; q.push(k); } }
  }
  var map = new Uint8Array(W * H);
  for(i = 0; i < W * H; i++){
    if(!mask[i]) continue;
    var a = dist[i] < 0 ? r : dist[i];
    map[i] = Math.round(255 * Math.min(1, a / r));
  }
  _featCache.key = key; _featCache.map = map;
  return map;
}

/* ===== 2026-09-21 第 4 批：全选 / 反选 ===== */
function selAll(){
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  var mk = new Uint8Array(W * H); mk.fill(1);
  selSet(mk);
}
function selInvert(){
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  if(!selHas()){ selAll(); return; }
  var src = pfmDraw.selMask, mk = new Uint8Array(W * H);
  for(var i = 0; i < W * H; i++) mk[i] = src[i] ? 0 : 1;
  selSet(mk);
}

/* ===== 2026-09-21 第 4 批：内部剪贴板（Cut / Copy / Paste）=====
   不用系统剪贴板：ArkWeb 上 clipboard API 异步且常被拒，POD 场景只需板内周转。 */
function selCopyClip(){
  var b = pfmDraw.selBBox; if(!b) return false;
  var W = pfmDrawCanvas.width, mask = pfmDraw.selMask;
  var bw = b.x1 - b.x0 + 1, bh = b.y1 - b.y0 + 1;
  var patch = pfmDrawCtx.getImageData(b.x0, b.y0, bw, bh), pd = patch.data;
  var fmap = _featherMap();
  for(var y = 0; y < bh; y++){
    for(var x = 0; x < bw; x++){
      var mi = (b.y0 + y) * W + (b.x0 + x), pi = (y * bw + x) * 4;
      if(!mask[mi]){ pd[pi+3] = 0; continue; }
      if(fmap) pd[pi+3] = Math.round(pd[pi+3] * fmap[mi] / 255);
    }
  }
  var oc = selCopyClip._c || (selCopyClip._c = document.createElement('canvas'));
  oc.width = bw; oc.height = bh;
  oc.getContext('2d').putImageData(patch, 0, 0);
  pfmDraw.selClip = { cv: oc, w: bw, h: bh };
  return true;
}
function selCutClip(){
  if(!selCopyClip()){ _pickTip('Draw a selection first'); return; }
  selDelete();
  _pickTip('Cut ' + pfmDraw.selClip.w + 'x' + pfmDraw.selClip.h);
  refreshProductPreview();
}
function selPasteClip(){
  var cl = pfmDraw.selClip;
  if(!cl){ _pickTip('Clipboard is empty'); return; }
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  var ox = Math.round((W - cl.w) / 2), oy = Math.round((H - cl.h) / 2);
  if(selHas()){
    var b = pfmDraw.selBBox;
    ox = Math.max(0, Math.min(W - cl.w, b.x0));
    oy = Math.max(0, Math.min(H - cl.h, b.y0));
  }
  pfmDrawCtx.drawImage(cl.cv, ox, oy);
  var cd = cl.cv.getContext('2d').getImageData(0, 0, cl.w, cl.h).data;
  var mk = new Uint8Array(W * H);
  for(var y = 0; y < cl.h; y++){
    for(var x = 0; x < cl.w; x++){
      if(cd[(y * cl.w + x) * 4 + 3] > 0){
        var nx = ox + x, ny = oy + y;
        if(nx >= 0 && ny >= 0 && nx < W && ny < H) mk[ny * W + nx] = 1;
      }
    }
  }
  selSet(mk);
  pfmDraw.snapshot = pfmDrawCtx.getImageData(0, 0, W, H);
  pushUndo();
  refreshProductPreview();
  _pickTip('Pasted — drag to move');
}

/* ===== 2026-09-21 第 4 批：选区变换手柄 =====
   手柄是 DOM（z-index 4），定位基准是「画布坐标 -> CSS 像素」换算，
   外层 wrap 跟随画布的 transform ⇒ 画布缩放平移后仍然贴住选区。
   落定策略沿用现有模型：**松手即落定**（selCommitFloatXf 写回 mask）。 */
function _isXfTool(){ var t = pfmDraw.tool; return t === 'selrect' || t === 'selasso' || t === 'selwand'; }
function _selWrap(){ return document.getElementById('pfmDrawSelHandles'); }
function _selFrame(){ return document.getElementById('pfmSelFrame'); }
function selHandlesHide(){ var w = _selWrap(); if(w) w.classList.remove('on'); }
function selXfBind(){
  var wrap = _selWrap(); if(!wrap || wrap._hdXfBound) return;
  wrap._hdXfBound = true;
  var hs = wrap.querySelectorAll('[data-xf]');
  for(var i = 0; i < hs.length; i++) hs[i].addEventListener('pointerdown', selXfDown);
  selToolWatch();
}
/* 工具切换不会经过选区代码 ⇒ 必须挂一个委托监听：
   否则从"矩形选框"切到"画笔"后手柄仍显示，而手柄 pointer-events:auto
   会吃掉画布落笔（画不进去）。setTimeout 0 让 snippet 的工具处理器先跑完。 */
function selToolWatch(){
  var box = document.getElementById('pfmDrawTools');
  if(!box || box._hdXfWatch) return;
  box._hdXfWatch = true;
  box.addEventListener('click', function(ev){
    var el = ev.target;
    while(el && el !== box && !(el.getAttribute && el.getAttribute('data-tool'))) el = el.parentElement;
    if(el && el !== box) setTimeout(selHandlesSync, 0);
  }, true);
}
function selHandlesSync(){
  var wrap = _selWrap(), fr = _selFrame(), cv = pfmDrawCanvas;
  if(!wrap || !fr || !cv) return;
  selXfBind();
  var drawing = !!(pfmDraw.selDrag && pfmDraw.selDrag.mode !== 'none');
  /* 每次 Apply 都会走到这里 ⇒ 无选区时也要"写前比对"，别每帧都去 remove 一次 class */
  if(!selHas() || !_isXfTool() || drawing){ _sc(wrap,'on',false); return; }
  var W = cv.width || 600, H = cv.height || 600;
  var _gh = _cvGeo();
  var ow = _gh.w || W, oh = _gh.h || H;
  /* 🔴 主 canvas 在 .pfm-draw-canvas-wrap 内不是从 (0,0) 开始（居中/有留白），
     必须跟 _selLayerSync 一样补 offsetLeft/offsetTop —— 漏了会整体水平偏移
     （实测 dx=-47px，且缩放后误判为"超出画布"）。 */
  _ss(wrap,'left', (_gh.left || 0) + 'px');
  _ss(wrap,'top', (_gh.top || 0) + 'px');
  _ss(wrap,'width', ow + 'px'); _ss(wrap,'height', oh + 'px');
  _ss(wrap,'transform', cv.style.transform || '');
  var b = pfmDraw.selBBox, kx = ow / W, ky = oh / H;
  var x0 = b.x0 * kx, y0 = b.y0 * ky;
  var w = (b.x1 - b.x0 + 1) * kx, h = (b.y1 - b.y0 + 1) * ky;
  _ss(fr,'left', x0 + 'px'); _ss(fr,'top', y0 + 'px');
  _ss(fr,'width', w + 'px'); _ss(fr,'height', h + 'px');
  var sx = pfmDraw.xfSx || 1, sy = pfmDraw.xfSy || 1, rot = pfmDraw.xfRot || 0;
  _ss(fr,'transform', 'rotate(' + rot + 'deg) scale(' + sx + ',' + sy + ')');
  _sc(fr,'tiny', w < 64 || h < 64);
  /* 手柄反缩放：frame 被 scale 后手柄会一起变形 ⇒ 反向补偿，视觉尺寸恒定。
     🔴🔴 2026-10-04（用户报「画布放大了，控制点也放大了，应该保持不变」）：
       补偿因子**必须同时含画布视图缩放 `pfmDrawZoom.s`** —— 本层上面继承了
       `cv.style.transform`（自带 `scale(z)`），只补 `xfSx/xfSy` 时一旦放大画布，
       手柄就按 z 倍长大。实测（`_t_selzoom.js`，滚轮 ×1.97）：角手柄 14→28px、
       旋转点 18→36px、旋转杆（框顶到圆点）31→61px —— 正好 z 倍。
       📌 浮动文字层早就这么做（`var inv = 1 / (pfmDrawZoom.s || 1)`）⇒ 这里补上同一件事。
       ⚠️ 旋转杆（`::before` 伪元素）与 frame 自身的 1px 边框**没法被 JS 逐个设 transform**
          ⇒ 走 CSS 变量 `--hd-inv-x/--hd-inv-y`（见 hd-canvas.css 的 `.pfm-sel-hd-frame`）。 */
  var _hz = pfmDrawZoom.s || 1;
  var _hix = 1 / (sx * _hz), _hiy = 1 / (sy * _hz);
  _sp(fr, '--hd-inv-x', _hix); _sp(fr, '--hd-inv-y', _hiy);
  var inv = 'scale(' + _hix + ',' + _hiy + ')';
  var hs = fr.querySelectorAll('[data-xf]');
  for(var i = 0; i < hs.length; i++) _ss(hs[i],'transform', inv);
  wrap.classList.add('on');
}
function selXfDown(e){
  if(!selHas() || !_isXfTool()) return;
  e.preventDefault(); e.stopPropagation();
  var kind = this.getAttribute('data-xf');
  var pos = getDrawPos(e);
  var b = pfmDraw.selBBox;
  var cx = (b.x0 + b.x1 + 1) / 2, cy = (b.y0 + b.y1 + 1) / 2;
  if(!pfmDraw.selFloat){
    if(!selExtractFloat()) return;
    /* 与 selDown 同一条铁律：提取后必须重拍 snapshot，
       否则 selPaintFloatXf 用旧图把选区内容复原 ⇒ 与原内容重叠、像素翻倍 */
    pfmDraw.snapshot = pfmDrawCtx.getImageData(0, 0, pfmDrawCanvas.width, pfmDrawCanvas.height);
  }
  var dx = pos.x - cx, dy = pos.y - cy;
  pfmDraw.selXf = { kind:kind, cx:cx, cy:cy, d0:Math.max(1, Math.hypot(dx, dy)), a0:Math.atan2(dy, dx) };
  pfmDraw._floatRect = null;
  pfmDraw.xfRot = 0; pfmDraw.xfSx = 1; pfmDraw.xfSy = 1;
  selHandlesHide();
  document.addEventListener('pointermove', selXfMove);
  document.addEventListener('pointerup', selXfUp);
  document.addEventListener('pointercancel', selXfUp);
}
function selXfMove(e){
  var x = pfmDraw.selXf; if(!x) return;
  if(e.cancelable) e.preventDefault();
  var pos = getDrawPos(e);
  var dx = pos.x - x.cx, dy = pos.y - x.cy;
  if(x.kind === 'rot'){
    var deg = (Math.atan2(dy, dx) - x.a0) * 180 / Math.PI;
    var near = Math.round(deg / 15) * 15;
    if(Math.abs(deg - near) < 2.5) deg = near;   /* 近 15deg 倍数吸附（触屏没有 Shift，用数值吸附代替） */
    pfmDraw.xfRot = deg;
  } else {
    var sc = Math.max(1, Math.hypot(dx, dy)) / x.d0;
    sc = Math.max(0.05, Math.min(8, sc));
    if(x.kind === 'nw' || x.kind === 'ne' || x.kind === 'sw' || x.kind === 'se'){
      pfmDraw.xfSx = sc; pfmDraw.xfSy = sc;
    } else if(x.kind === 'n' || x.kind === 's'){ pfmDraw.xfSy = sc; }
    else { pfmDraw.xfSx = sc; }
  }
  selPaintFloatXf();
  selHandlesSync();
}
function selXfUp(){
  if(!pfmDraw.selXf) return;
  document.removeEventListener('pointermove', selXfMove);
  document.removeEventListener('pointerup', selXfUp);
  document.removeEventListener('pointercancel', selXfUp);
  var rot = pfmDraw.xfRot || 0, sx = pfmDraw.xfSx || 1, sy = pfmDraw.xfSy || 1;
  pfmDraw.selXf = null;
  var changed = Math.abs(rot) > 0.01 || Math.abs(sx - 1) > 0.01 || Math.abs(sy - 1) > 0.01;
  if(changed){
    selCommitFloatXf(rot, sx, sy);
    pushUndo();
    refreshProductPreview();
  }
  /* 变换已烘焙进 mask 与像素 ⇒ 参数立刻归零，否则下一轮会重复应用 */
  pfmDraw.xfRot = 0; pfmDraw.xfSx = 1; pfmDraw.xfSy = 1;
  selPaintFloatXf();   /* 归零后再刷一次预览（此时 selFloat 已 null，只剩 snapshot） */
  selHandlesSync();
}
function selPaintFloatXf(rot, sx, sy){
  if(!pfmDraw.snapshot) return;
  rot = (rot == null ? (pfmDraw.xfRot || 0) : rot);
  sx  = (sx  == null ? (pfmDraw.xfSx  || 1) : sx);
  sy  = (sy  == null ? (pfmDraw.xfSy  || 1) : sy);
  /* 2026-10-24(甲): 同 selPaintFloat —— 只还原上一帧（旋转/缩放后）包围盒 */
  var _pr=pfmDraw._floatRect;
  if(_pr && _pr.w>0 && _pr.h>0){
    var W=pfmDrawCanvas.width, H=pfmDrawCanvas.height;
    var _x0=Math.max(0,_pr.x), _y0=Math.max(0,_pr.y);
    var _x1=Math.min(W,_pr.x+_pr.w), _y1=Math.min(H,_pr.y+_pr.h);
    if(_x1>_x0 && _y1>_y0){ pfmDrawCtx.putImageData(pfmDraw.snapshot,0,0,_x0,_y0,_x1-_x0,_y1-_y0); }
    else { pfmDrawCtx.putImageData(pfmDraw.snapshot, 0, 0); }
  } else {
    pfmDrawCtx.putImageData(pfmDraw.snapshot, 0, 0);
  }
  var f = pfmDraw.selFloat;
  if(!f){ pfmDraw._floatRect=null; return; }
  var bw = f.cv.width, bh = f.cv.height;
  var _cx = f.ox + bw / 2, _cy = f.oy + bh / 2;
  pfmDrawCtx.save();
  pfmDrawCtx.translate(_cx, _cy);
  if(rot) pfmDrawCtx.rotate(rot * Math.PI / 180);
  if(sx !== 1 || sy !== 1) pfmDrawCtx.scale(sx, sy);
  pfmDrawCtx.drawImage(f.cv, -bw / 2, -bh / 2);
  pfmDrawCtx.restore();
  /* 记录本帧变换后包围盒（供下一帧 dirty rect；+2 安全余量防旋转边缘残影） */
  var _a = rot * Math.PI / 180, _ca = Math.abs(Math.cos(_a)), _sa = Math.abs(Math.sin(_a));
  var _hw = (bw * Math.abs(sx) * _ca + bh * Math.abs(sy) * _sa) / 2;
  var _hh = (bw * Math.abs(sx) * _sa + bh * Math.abs(sy) * _ca) / 2;
  pfmDraw._floatRect = { x: Math.floor(_cx - _hw) - 2, y: Math.floor(_cy - _hh) - 2, w: Math.ceil(_hw * 2) + 4, h: Math.ceil(_hh * 2) + 4 };
}
/* 把变换烘焙进 mask：目标像素 -> 逆变换回源坐标 -> 查源 mask（离散采样，中心点 0.5 偏移） */
function selCommitFloatXf(rot, sx, sy){
  if(!selHas()) return 0;
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height, mask = pfmDraw.selMask;
  var b = pfmDraw.selBBox;
  var bw = b.x1 - b.x0 + 1, bh = b.y1 - b.y0 + 1;
  var cx = (b.x0 + b.x1 + 1) / 2, cy = (b.y0 + b.y1 + 1) / 2;
  var a = rot * Math.PI / 180, ca = Math.cos(a), sa = Math.sin(a);
  var ex = (bw * sx) / 2, ey = (bh * sy) / 2;
  var rx = Math.abs(ex * ca) + Math.abs(ey * sa);
  var ry = Math.abs(ex * sa) + Math.abs(ey * ca);
  var tx0 = Math.max(0, Math.floor(cx - rx)), tx1 = Math.min(W - 1, Math.ceil(cx + rx));
  var ty0 = Math.max(0, Math.floor(cy - ry)), ty1 = Math.min(H - 1, Math.ceil(cy + ry));
  var nm = new Uint8Array(W * H);
  for(var y = ty0; y <= ty1; y++){
    for(var x = tx0; x <= tx1; x++){
      var ux = x + 0.5 - cx, uy = y + 0.5 - cy;
      var vx = (ux * ca + uy * sa) / sx;
      var vy = (-ux * sa + uy * ca) / sy;
      var sxp = Math.floor(cx + vx), syp = Math.floor(cy + vy);
      if(sxp < 0 || syp < 0 || sxp >= W || syp >= H) continue;
      if(mask[syp * W + sxp]) nm[y * W + x] = 1;
    }
  }
  pfmDraw.selFloat = null;
  selSet(nm);
  pfmDraw.snapshot = pfmDrawCtx.getImageData(0, 0, W, H);
  return 1;
}

/* ===== 2026-09-21 第 4 批：导出 PNG =====
   只取主 canvas ⇒ 选区蚂蚁线 / 手柄 / 网格 / 对称轴这些 DOM 覆盖层天然不进图。
   参考底图是用户本地 FileReader 的 dataURL，不会 taint canvas ⇒ toDataURL 安全。 */
/* 2026-09-26（用户裁决 甲）：导出前确认 —— 详见 hd-canvas.css 里的同名注释块
   （为什么自建 / 挂哪 / 为什么不绑 Esc）。
   🔴 兜底：找不到确认层（旧 markup / 半部署中）⇒ **直接导出**（保持旧行为，绝不「点了没反应」）。 */
function _exportConfirmOpen(){
  var el=document.getElementById("pfmDrawConfirm");
  if(!el){ selExportPng(); return false; }                          /* 兜底：无确认层 ⇒ 旧行为 */
  var qq=document.getElementById("pfmDrawConfirmQ");
  if(qq && pfmDrawCanvas) qq.textContent = "Export PNG (" + pfmDrawCanvas.width + " \u00d7 " + pfmDrawCanvas.height + ")?";
  el.hidden=false;
  return true;
}
function _exportConfirmClose(){
  var el=document.getElementById("pfmDrawConfirm"); if(el) el.hidden=true;
}
function _bindExportConfirm(){
  var el=document.getElementById("pfmDrawConfirm"); if(!el || el._bound) return;
  el._bound=1;
  var yes=document.getElementById("pfmDrawConfirmYes"), no=document.getElementById("pfmDrawConfirmNo");
  if(no) no.addEventListener("click", function(){ _exportConfirmClose(); });
  if(yes) yes.addEventListener("click", function(){ _exportConfirmClose(); selExportPng(); });
  /* 点遮罩（卡片以外）也取消 —— 与色轮弹窗同一套交互语言 */
  el.addEventListener("click", function(ev){ if(ev.target===el) _exportConfirmClose(); });
}

function selExportPng(){
  try{
    var cv = pfmDrawCanvas; if(!cv) return false;
    var url = outUrl();   /* 2026-09-25（3 层）：导出的是**合成图**（不含被隐藏的层） */
    var dt = new Date(), p2 = function(n){ return (n < 10 ? '0' : '') + n; };
    var name = 'highdeep-draw-' + dt.getFullYear() + p2(dt.getMonth() + 1) + p2(dt.getDate())
             + '-' + p2(dt.getHours()) + p2(dt.getMinutes()) + p2(dt.getSeconds()) + '.png';
    var a = document.createElement('a');
    a.href = url; a.download = name; a.style.display = 'none';
    document.body.appendChild(a); a.click();
    setTimeout(function(){ if(a.parentNode) a.parentNode.removeChild(a); }, 0);
    _pickTip('Exported ' + cv.width + 'x' + cv.height + ' PNG');
    return true;
  }catch(err){
    if(window.console && console.warn) console.warn('[hd-draw] export failed', err);
    _pickTip('Export failed');
    return false;
  }
}

/* 2026-09-20 第 2 批：**公开调试出口**（象 __pfmOpenBoard 那样有意曝露）。
   选区状态在 IIFE 内，外部探针读不到 ⇒ 靠它定位问题。 */
/* ===== 2026-09-20 第 3 批：网格辅助（显示 + 落笔吸附）=====
   网格画在 DOM 覆盖层 `#pfmDrawGridLayer`（CSS 渐变，零循环），
   **不进 canvas 像素** ⇒ 不污染 toDataURL / 撤销栈 / 落产品。 */
var GRID_KEY='hd_draw_grid_v1';
function _gridGap(){ return Math.max(8, Math.min(200, _drawNum('pfmDrawGridGap', 40))); }
function _chipOn(id){ var e=document.getElementById(id); return !!(e && e.classList.contains('sel')); }
function _gridOn(){ var el=document.getElementById('pfmDrawGridLayer'); return !!(el && el.classList.contains('on')); }
function _gridStateSave(){
  try{ localStorage.setItem(GRID_KEY, JSON.stringify({ on:_gridOn(), gap:_gridGap(), snap:_chipOn('pfmGridSnap'), thirds:_chipOn('pfmGridThirds') })); }catch(e){}
}
function _gridRestore(){
  var st={};
  try{ st=JSON.parse(localStorage.getItem(GRID_KEY)||'{}')||{}; }catch(e){ st={}; }
  var el=document.getElementById('pfmDrawGridLayer');
  var gb=document.getElementById('pfmDrawGrid');
  if(typeof st.gap==='number'){ var gp=document.getElementById('pfmDrawGridGap'); if(gp){ gp.value=String(st.gap); var gv=document.getElementById('pfmDrawGridGapVal'); if(gv) gv.textContent=String(st.gap); } }
  var sc=document.getElementById('pfmGridSnap'); if(sc) sc.classList.toggle('sel', st.snap!==false);
  var tc=document.getElementById('pfmGridThirds'); if(tc) tc.classList.toggle('sel', !!st.thirds);
  var on=!!st.on;
  if(el) el.classList.toggle('on', on);
  if(gb) gb.classList.toggle('sel', on);
  _gridSync();
}
function _gridSync(){
  var el=document.getElementById('pfmDrawGridLayer'), cv=pfmDrawCanvas;
  if(!el||!cv) return;
  /* 2026-10-04：网格线宽同样被画布缩放放大 ⇒ 写 `--hd-zi`（= 1/z）供 CSS 反向补偿。
     ⚠️ 只补**线宽**：格**间距**必须继续随缩放（那样才对得上内容）—— 所以 backgroundSize 不乘 inv。 */
  _sp(el,'--hd-zi', 1 / (pfmDrawZoom.s || 1));
  var _gg=_cvGeo();
  var disp=_gg.w||600, lg=cv.width||1200;
  _ss(el,'left',_gg.left+'px'); _ss(el,'top',_gg.top+'px');
  _ss(el,'width',disp+'px'); _ss(el,'height',(_gg.h||disp)+'px');
  _ss(el,'transformOrigin','0 0');
  _ss(el,'transform',cv.style.transform||'');
  /* 2026-09-26（用户报「网格和绘画区不匹配」）：**不能取整**。
     取整后网格是"显示整数像素"的等距格（如 18px），而吸附/落笔走的是**逻辑格**
     （1200 画布上的 gap，映射到显示 = 18.333px）⇒ 两套格距不一致：
     到第 29 格累计偏差 ~10px；且画布右/下会留一条窄条（gap=100 时 28px）。
     改为保留小数 ⇒ 格线与吸附点完全重合、格子等分、四边不留窄条。
     （1px 细线落在小数坐标上会有轻微抗锯齿，但线本身只有 16% 不透明度，可忽略。） */
  var px=Math.max(3, _gridGap()*disp/lg);
  _ss(el,'backgroundSize', px+'px '+px+'px');
  /* 🔴🔴 2026-09-30（用户裁决 甲）：**网格以画布中心为原点**（中心必是格线交点）。
     原来原点固定在左上角（CSS 默认 `0% 0%`）⇒ 只有间距能整除逻辑画布时中心才恰在交点上
     （40 / 100 能整除 1200）；调成非整除值（37 / 45）就**不关于中心对称**、最后一格被切
     （实测 `_diag_gridcenter.js`：中心偏离最近格线 4.25px / 1.06px）。
     线画在每块 tile 的**起点**（渐变 = `color 1px, transparent 1px`）⇒ 令 tile 原点 P 满足
     `disp/2 ≡ P (mod px)`（即 `P = (disp/2) % px`）⇒ 中心必落一条线，整条格阵关于中心对称，
     且左右/上下留白恒等（不再取决于间距是否能整除）。
     ⚠️ 吸附 `_snapPt()` **必须用同一基准**（格点 = 中心 + k×sp），否则格线与吸附点错位
        —— 那正是 09-26 修掉的「网格和绘画区不匹配」。 */
  var gp = ((disp/2) % px).toFixed(3);
  _ss(el,'backgroundPosition', gp+'px '+gp+'px');
  _sc(el,'thirds', _chipOn('pfmGridThirds'));
}
/* 落笔吸附：**只认 Snap 芯片**（2026-10-06 丙：「吸附」与「网格线是否显示」解耦 —— 网格卡是
   功能键，收起/互斥收尾**不该**静默关掉吸附，否则会出现「Snap 亮着却不吸」）。对象停留在**起点**
   （形状类连终点一并吸）—— 连续笔画中途不吸，避免手绘变成阶梯。 */
function _snapPt(p){
  if(!_chipOn('pfmGridSnap')) return p;
  var sp=_gridGap();
  if(sp<2) return p;
  /* 🔴🔴 2026-09-30（用户裁决 甲）：格点 = **画布中心 + k×sp**（与 `_gridSync` 的绘制原点同一基准）。
     原来 `round(p.x/sp)*sp` 是"从左上角起算的整数格" —— 与"中心为原点"的新网格会错位。 */
  var c=pfmDrawCanvas, cx=(c.width||1200)/2, cy=(c.height||1200)/2;
  return { x: cx + Math.round((p.x-cx)/sp)*sp, y: cy + Math.round((p.y-cy)/sp)*sp };
}
window.__pfmGridSync=_gridSync;
/* 🔴 2026-09-20 第 3 批 b：**参数变更必须落盘** —— 原来只有开关点击会调 _gridStateSave，
   改间距 / 切 Snap / 切 3×3 只重绘不保存 ⇒ 刷新后参数回到默认（实测）。
   给 UI 用的入口 = 同步 + 保存；纯同步的 __pfmGridSync 继续供缩放/开板等内部场景用。 */
window.__pfmGridChanged = function(){ _gridSync(); _gridStateSave(); };

/* ===== 2026-09-20 第 3 批：画笔预设库（localStorage）=====
   预设 = 工具 + 粗细 + 不透明度 + 颜色/渐变 + 防抖 + 对称 + 涂抹强度。
   应用时**复用现有 UI 事件**（点工具格 / 滑杆 / 色块）—— 不另写一套参数落实逻辑。 */
var PRESET_KEY='hd_draw_presets_v1', PRESET_MAX=12;
/* 2026-09-26（用户裁决：预设保留，**邮箱 + 浏览器双存**）：
   · 身份 = Creator onboarding 收集的邮箱（localStorage `hdCreatorProfile_v1` 的 .email）；
     **没填过邮箱 ⇒ 只存浏览器**（与改前行为一致，零回归）。
   · 写 = 先写 localStorage（立即生效、离线可用）→ 再异步 POST 到 bridge（失败静默，绝不打扰用户）。
   · 读 = 点开预设区时拉一次远端 → 与本地**合并**（按参数指纹去重、保留 ts 较新、截断 12 个）。
   · bridge 地址与 section 的 `bridge_url` 默认值一致；将来若改设置，可由 section 注入
     `window.__pfmBridge` 覆盖（这里已留读取口）。
   ⚠️ 2026-10-06 甲：口径已收紧 —— 预设读/写都要 email + nickname 双匹配（nickname 取 hdCreatorProfile_v1.nick）。 */
var PFM_BRIDGE=(window.__pfmBridge||'https://bridge.highdeep.net');
function _drawUserEmail(){
  try{
    var o=JSON.parse(localStorage.getItem('hdCreatorProfile_v1')||'null');
    var e=o&&o.email?String(o.email).trim().toLowerCase():'';
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)?e:'';
  }catch(e){ return ''; }
}
/* 2026-10-06 甲：昵称 = 副键。预设的读写都要「邮箱 + 昵称」双匹配（昵称是公开署名，
   但与邮箱**配对**后才是「只有本人知道的一对值」）。取不到昵称时传空串 ⇒ 后端按存量放行，
   绝不因此打断本地预设（同步失败一律静默，本地仍然可用）。 */
function _drawUserNick(){
  try{
    var o=JSON.parse(localStorage.getItem('hdCreatorProfile_v1')||'null');
    return o&&o.nick?String(o.nick).replace(/<[^>]*>/g,'').trim().slice(0,40):'';
  }catch(e){ return ''; }
}
function _presetKeyOf(p){
  return [p.tool,p.size,p.op,p.color,p.grad?1:0,p.gi,p.stab,p.sym,p.smudge].join('|');
}
function presetsMerge(localArr, remoteArr){
  var map={}, k, j, p;
  function put(arr){ for(j=0;j<(arr||[]).length;j++){ p=arr[j]; if(!p||typeof p!=='object') continue;
    k=_presetKeyOf(p); if(!map[k]||(p.ts||0)>(map[k].ts||0)) map[k]=p; } }
  put(remoteArr); put(localArr);
  var out=[]; for(k in map) out.push(map[k]);
  out.sort(function(a,b){ return (b.ts||0)-(a.ts||0); });
  return out.slice(0, PRESET_MAX);
}
function presetsSyncUp(){
  var email=_drawUserEmail(); if(!email) return;          /* 没邮箱 ⇒ 只存浏览器 */
  try{
    fetch(PFM_BRIDGE+'/designs/presets',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'include',
      body:JSON.stringify({email:email,nickname:_drawUserNick(),data:JSON.stringify(_presets())})}).catch(function(){});
  }catch(e){}
}
function presetsSyncDown(){
  var email=_drawUserEmail(); if(!email) return;          /* 没邮箱 ⇒ 不拉远端 */
  try{
    fetch(PFM_BRIDGE+'/designs/presets?email='+encodeURIComponent(email)+'&nickname='+encodeURIComponent(_drawUserNick()), {credentials:'include'})
      .then(function(r){ return r.json(); })
      .then(function(d){
        if(!d||!d.success||!d.found||!d.data) return;
        var remote; try{ remote=JSON.parse(d.data); }catch(e){ return; }
        if(!(remote instanceof Array)||!remote.length) return;
        var merged=presetsMerge(_presets(), remote);
        if(JSON.stringify(merged)===JSON.stringify(_presets())) return;   /* 无变化不写 */
        _presetsSave(merged); presetsRender();
      }).catch(function(){});
  }catch(e){}
}
function _presets(){
  try{ var s=localStorage.getItem(PRESET_KEY); if(s){ var a=JSON.parse(s); if(Array.isArray(a)) return a; } }catch(e){}
  return [];
}
function _presetsSave(arr){ try{ localStorage.setItem(PRESET_KEY, JSON.stringify(arr)); }catch(e){} }
function _presetSetRange(id, v){
  var e=document.getElementById(id); if(!e) return;
  e.value=String(v); e.dispatchEvent(new Event('input',{bubbles:true}));
}
/* 2026-09-26（用户裁决）：预设色块**正中央显示编号**（1 起，按列表顺序）。
   为什么需要 _presetInk()：色块底色是用户任选的颜色（可能纯白 #fff、纯黑 #000、或渐变），
   固定白字会在浅色块上「隐形」、固定黑字在深色块上「隐形」。
   判据用 WCAG 相对亮度（sRGB 线性化 + 0.2126R+0.7152G+0.0722B）：L > 0.179 用黑字、否则白字。
   🔴 0.179 不是随手取的：它是「黑字对比率 == 白字对比率」的数学交点
      （(1.05)/(L+.05) == (L+.05)/.05 ⇒ L ≈ 0.1791）⇒ 该阈值下最差对比率 = 4.58，
      刚好满足 WCAG AA 对**小字**的 4.5:1 要求（编号是 10px 小字，不能放宽到 3:1 的大字标准）。
      配合**纯黑/纯白**（不用 #111827 这类柔和色，它在交点处只有 3.7）才能保住 4.58。 */
function _presetInk(colors){
  /* 预演实测（`_verify_presetnum.js`）暴露的问题：渐变底（如 #7c3aed→#ec4899）两端明暗相反
     —— 紫端要白字（黑字只有 3.67）、粉端要黑字（白字只有 3.53）⇒ **单一文字色无法两端都达 4.5**。
     故判据从「比平均亮度」改为 **max-min**：在纯黑/纯白中，选「在所有背景色上最差对比率」更大者。
       · 单色块：与 0.179 阈值判据**等价**（0.179 正是黑白对比率相等点）⇒ 仍保证 ≥4.58。
       · 渐变块：至少取到更优的一侧（#11 从 3.67 提到 3.67/白字 3.53 ⇒ 选黑 3.67）。
       · 渐变块剩余的那点不足由 `textShadow` 反向描边补偿（见调用处）。 */
  var Ls = [], i, m;
  for(i = 0; i < (colors || []).length; i++){
    m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(String(colors[i] || '').trim());
    if(!m) continue;
    var c = [parseInt(m[1],16)/255, parseInt(m[2],16)/255, parseInt(m[3],16)/255], j;
    for(j = 0; j < 3; j++){ c[j] = (c[j] <= 0.03928) ? (c[j]/12.92) : Math.pow((c[j]+0.055)/1.055, 2.4); }
    Ls.push(0.2126*c[0] + 0.7152*c[1] + 0.0722*c[2]);
  }
  if(!Ls.length) return '#ffffff';
  var cand = ['#000000', '#ffffff'], best = '#ffffff', bestWorst = -1, k;
  for(k = 0; k < 2; k++){
    var inkL = (k === 0) ? 0 : 1, worst = 99;
    for(i = 0; i < Ls.length; i++){
      var r = (Math.max(inkL, Ls[i]) + 0.05) / (Math.min(inkL, Ls[i]) + 0.05);
      if(r < worst) worst = r;
    }
    if(worst > bestWorst){ bestWorst = worst; best = cand[k]; }
  }
  return best;
}
function presetsRender(){
  var row=document.getElementById('pfmPresetRow'); if(!row) return;
  if(!presetsRender._synced){ presetsRender._synced=1; presetsSyncDown(); }   /* 首次打开预设区拉一次远端 */
  row.innerHTML='';
  var arr=_presets();
  /* 2026-09-26（甲，用户：「不需要描述」）：空态**不再显示任何文字** —— 行尾那个「+」自己就是入口。 */
  arr.forEach(function(p,i){
    var b=document.createElement('button');
    b.type='button'; b.className='pfm-preset';
    b.title=(p.tool||'brush')+' · '+Math.round(p.size||4)+' · '+Math.round((p.op!=null?p.op:1)*100)+'%\nClick = apply · Long-press = delete';
    var gr=pfmGradients[(typeof p.gi==='number')?p.gi:0]||pfmGradients[0];
    b.style.background = p.grad ? ('linear-gradient(135deg,'+gr[0]+','+gr[1]+')') : (p.color||'#000');
    b.textContent = String(i + 1);
    var _ink = _presetInk(p.grad ? [gr[0], gr[1]] : [p.color]);
    b.style.color = _ink;
    b.style.fontSize = (i + 1) >= 10 ? '9px' : '10px';
    b.style.fontVariantNumeric = 'tabular-nums';
    b.style.lineHeight = '1';
    /* 描边**只给渐变块**：单色块已被 max-min 判据数学保证 ≥4.58（加描边反而让 10px 字发糊）；
       渐变块两端明暗相反、单一文字色必然有一端 <4.5 ⇒ 用反向描边保住可读性。 */
    if(p.grad){
      b.style.textShadow = (_ink === '#ffffff')
        ? '0 0 2px rgba(0,0,0,.85)'
        : '0 0 2px rgba(255,255,255,.95)';
    }
    var t=null, lp=false;
    b.addEventListener('pointerdown', function(){
      lp=false;
      t=setTimeout(function(){
        lp=true; var a=_presets(); a.splice(i,1); _presetsSave(a); presetsRender(); presetsSyncUp();
      }, 600);
    });
    var cancel=function(){ if(t){ clearTimeout(t); t=null; } };
    b.addEventListener('pointerup', cancel);
    b.addEventListener('pointerleave', cancel);
    b.addEventListener('pointercancel', cancel);
    b.addEventListener('click', function(){ if(lp) return; applyPreset(i); });
    row.appendChild(b);
  });
  /* 2026-09-26（甲）：行尾的「+」—— **点击即保存**当前笔刷（原「+ Save」按钮的职责）。
     独立类名 `.pfm-preset-add`（不用 `.pfm-preset`）⇒ 不会被「色块」相关的选择器/探针误统计。
     静默保存：项目既有裁决是「状态变化不要用黑底气泡打扰用户」。 */
  var add = document.createElement('button');
  add.type = 'button'; add.className = 'pfm-preset-add';
  add.title = 'Save current brush as a preset';
  add.textContent = '+';
  add.addEventListener('click', function(){ savePresetNow(); });
  row.appendChild(add);
}
function applyPreset(i){
  var p=_presets()[i]; if(!p) return;
  /* 🔴 2026-10-02（甲·续4）：同上放宽 —— 预设里存的工具可能是 eraser / fill / picker，
     它们住在第 2 行平铺键 / 第 3 行，不在 `#pfmDrawTools` 里。 */
  var tb=document.querySelector('.pfm-dtool[data-tool="'+(p.tool||'brush')+'"]');
  if(tb) tb.click();                                   /* 复用工具切换（含 sel 类 / 标签 / showOpts） */
  if(p.size!=null) _presetSetRange('pfmDrawBrushSize', p.size);
  if(p.op!=null) _presetSetRange('pfmDrawBrushOpacity', Math.round(p.op*100));
  if(p.grad){
    var gd=document.querySelector('#pfmDrawColors .pfm-dgradient[data-grad="'+(p.gi||0)+'"]');
    if(gd) gd.click();
  } else if(p.color){
    pfmDraw.color=p.color; pfmDraw.isGradient=false;
    var cp=document.getElementById('pfmDrawColorPicker'); if(cp) cp.value=p.color;
    document.querySelectorAll('.pfm-dcolor').forEach(function(e){ e.classList.remove('sel'); });
    document.querySelectorAll('.solid-color').forEach(function(e){
      if(String(e.dataset.color||'').toLowerCase()===String(p.color).toLowerCase()) e.classList.add('sel');
    });
  }
  if(p.stab!=null) _presetSetRange('pfmDrawStab', p.stab);
  if(p.smudge!=null) _presetSetRange('pfmDrawSmudge', p.smudge);
  if(p.sym){ var sc=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-sym="'+p.sym+'"]'); if(sc) sc.click(); }
}
function savePresetNow(){
  var arr=_presets();
  while(arr.length>=PRESET_MAX) arr.shift();
  arr.push({
    tool: pfmDraw.tool,
    size: (typeof pfmDraw.sizeRaw==='number')?pfmDraw.sizeRaw:_drawNum('pfmDrawBrushSize',12),   /* 🔴 2026-10-04（乙）：默认 4 → 12 */
    op: (typeof pfmDraw.brushOpacity==='number')?pfmDraw.brushOpacity:1,
    color: pfmDraw.color,
    grad: !!pfmDraw.isGradient,
    gi: pfmDraw.gradientIndex||0,
    stab: _stabVal(),
    sym: _symMode(),
    smudge: _drawNum('pfmDrawSmudge',50),
    ts: Date.now()          /* 2026-09-26: 合并远端时按它取较新 */
  });
  _presetsSave(arr);
  presetsRender();
  presetsSyncUp();               /* 2026-09-26: 有邮箱则同步到 bridge（无邮箱自动跳过） */
}
window.__hdDrawGrid=function(){ return { on:_gridOn(), gap:_gridGap(), snap:_chipOn('pfmGridSnap'), thirds:_chipOn('pfmGridThirds') }; };

function _drawDebug(){
  return {
    tool: pfmDraw.tool,
    isDrawing: pfmDraw.isDrawing,
    drag: pfmDraw.selDrag ? pfmDraw.selDrag.mode : null,
    lassN: pfmDraw.selLass ? pfmDraw.selLass.length : 0,
    lassFilled: selFromLasso._lastN || 0,
    hasMask: !!pfmDraw.selMask,
    selClipOn: !!pfmDraw.selClipOn, selClipRects: (pfmDraw.selClipCache ? pfmDraw.selClipCache.nrect : 0),   /* 乙批 */
    bbox: pfmDraw.selBBox,
    wandTol: _drawNum('pfmDrawWandTol', 30),
    layerOn: !!(function(){ var l=_selLayer(); return l && l.classList.contains('on'); })(),
    grid: { on:_gridOn(), gap:_gridGap(), snap:_chipOn('pfmGridSnap'), thirds:_chipOn('pfmGridThirds') },
    presets: _presets().length,
    /* 2026-09-21 第 4 批 */
    feather: _featherR(),
    featKey: _featCache.key ? 'set' : 'empty',
    clip: pfmDraw.selClip ? (pfmDraw.selClip.w + 'x' + pfmDraw.selClip.h) : null,
    xf: pfmDraw.selXf ? pfmDraw.selXf.kind : null,
    xfRot: pfmDraw.xfRot || 0, xfSx: pfmDraw.xfSx || 1, xfSy: pfmDraw.xfSy || 1,
    handles: (function(){ var w=_selWrap(); return !!(w && w.classList.contains('on')); })(),
    float: !!pfmDraw.selFloat,
    /* 2026-09-21 第 5 批 —— hollow = 勾选后形状变空心（**未勾 = 实心 = 改前行为**）
       保留 fill 别名仅为探针/调试兼容，语义同 hollow。 */
    hollow: _shapeHollowOn(),
    fill: _shapeHollowOn(),
    /* 2026-10-04（丙批）：新形状参数 + 描边对齐/虚线（探针断言用） */
    shapeAlign: _shapeAlign(), shapeDash: _shapeDashMode(), shapeFillMode: _shapeFillMode(),
    shapeSides: _shapeSidesN(), shapeInner: _shapeInnerR(), shapeCorner: _shapeCornerPx(),
    symPos: { x: pfmDraw.symX, y: pfmDraw.symY },
    /* 形状约束链的原点（_shapeEnd 内部用的是 startX/startY，不是调用方传的 x/y）
       —— 探针必须能读到它，否则会拿错原点算出错误角度（V1.3 曾因此误判） */
    startX: pfmDraw.startX, startY: pfmDraw.startY,
    symAxis: { x: _symAxisX(), y: _symAxisY() },
    lastShift: !!pfmDraw.lastShift,
    /* 2026-10-03（甲批）：选区增强的可观测状态（探针用） */
    selCount: (function(){ var m=pfmDraw.selMask, c=0; if(m){ for(var i=0;i<m.length;i++) if(m[i]) c++; } return c; })(),
    selBox: (function(){ var b=pfmDraw.selBBox; return b?{x0:b.x0,y0:b.y0,x1:b.x1,y1:b.y1}:null; })(),
    selOp: pfmDraw.selOp||'', selOval: !!pfmDraw.selOval, selMovePix: !!pfmDraw.selMovePix,
    /* 形状落笔起点（Alt 从中心的镜像基准） */
    startX: pfmDraw.startX, startY: pfmDraw.startY,
    /** 形状终点完整约束链（吸附 → Shift 等比 → 对称轴吸附）—— 探针直接调它验证，
     *  不必模拟鼠标轨迹（鼠标轨迹无法在无头环境稳定复现）。 */
    shapeEnd: function(x,y,shift,alt){ return _shapeEnd(x,y,!!shift,!!alt); },
    /* 2026-09-21 第 6 批：形状分色 / 描边宽度 / 镜像求值 */
    shapeStrokeW: (function(){ var w=_shapeStrokeW(); return w==null ? null : w; })(),
    shapeStrokeColor: (function(){ var e=document.getElementById('pfmShapeStrokeColor');
      return (_shapeColorOn(e)&&e.value)?e.value:null; })(),
    shapeFillColor: (function(){ var e=document.getElementById('pfmShapeFillColor');
      return (_shapeColorOn(e)&&e.value)?e.value:null; })(),
    isShapeTool: (function(t){ return _isShapeTool(t); })(pfmDraw.tool),
    /* 2026-09-21 第 7 批：混合模式 */
    blend: _blendMode(),
    blendKey: (function(){ var e=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-blend].sel');
      return e ? e.getAttribute('data-blend') : null; })(),
    blendToolOk: _isBlendTool(pfmDraw.tool),
    ctxComposite: pfmDrawCtx ? String(pfmDrawCtx.globalCompositeOperation) : null,
    symCount: _symPts(0,0).length,
    symPts: function(x,y){ return _symPts(x,y); }
  };
}

/* 2026-10-01（乙·第三批）：**蛛网重做** —— 以落笔点 `(cx,cy)` 为中心、半径 `radius`。
   旧实现（保留在 git 历史里）每次调用都从**画布中心**向指针画 6 条加减笔宽抖动的直线，
   而且是**叠加**画法：拖一路就叠出一团放射线（密集采样下糊成一条粗带），既不是蛛网、
   也和落笔点无关。新实现 = 8 条放射丝 + 若干圈**带垂坠**的弧（蛛丝是软的，弧面向圆心塌）。
   🔴 随机全部走 `pfmDraw.webSeed` 的**确定性哈希**（每笔固定一个种子）—— 用 `Math.random()`
      会让预览每帧重掷随机 ⇒ 蛛丝疯狂抖动（整笔重画的头号坑，与 `_accScatter` 的种子问题同源）。 */
function drawWeb(cx, cy, radius){
  var ctx = pfmDrawCtx;
  var bs = Math.max(1, pfmDraw.brushSize);
  var cap = Math.min(pfmDrawCanvas.width, pfmDrawCanvas.height) * 0.42;
  var R = Math.max(14, Math.min(radius || 0, cap));
  var seed = pfmDraw.webSeed || (pfmDraw.webSeed = Math.random() * 1000);
  var jit = function(i){ var x = Math.sin((seed + i) * 12.9898) * 43758.5453; return x - Math.floor(x); };
  var spokes = 8;
  ctx.lineWidth = Math.max(0.8, Math.min(bs * 0.45, R * 0.05));
  ctx.lineCap = 'round';
  /* 2026-10-01（丙·B）：脏矩形用**最大可能半径 `cap`** 定值（R 随拖拽距离变，定值才无累积问题）。 */
  pfmDraw.webBox = _circleBox(cx, cy, cap + ctx.lineWidth + 4);
  /* ① 放射丝（略不等角 + 略不等长 ⇒ 不是机械的辐条） */
  for(var i=0;i<spokes;i++){
    var a = (i / spokes) * Math.PI * 2 + (jit(i) - 0.5) * 0.20;
    var rr = R * (0.90 + jit(i + 50) * 0.18);
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(cx + Math.cos(a) * rr, cy + Math.sin(a) * rr);
    ctx.stroke();
  }
  /* ② 同心弧（每两条放射丝之间一段，控制点向圆心收 `sag` ⇒ 垂坠感） */
  /* 🔴🔴 2026-10-04（用户报「蜘蛛网图像有缺陷」，附参照图 13 层）：
     原式 `round(R / (bs*3))` 且上限硬编码 7 ⇒ **笔一粗环就少**（实测 bs=24 / R=284后备 ⇒ 2 环）
     ⇒ 画出来是"空心伞骨"而不是蛛网。现改成与笔宽**缓变**、上限提到 14。 */
  var rings = Math.max(3, Math.min(14, Math.round(R / (bs * 0.6 + 12))));
  for(var k=1;k<=rings;k++){
    var rk = R * k / rings;
    var sag = rk * 0.16;
    ctx.beginPath();
    for(var s2=0;s2<spokes;s2++){
      var a0 = (s2 / spokes) * Math.PI * 2 + (jit(s2) - 0.5) * 0.20;
      var a1 = ((s2 + 1) / spokes) * Math.PI * 2 + (jit(s2 + 1) - 0.5) * 0.20;
      var x0 = cx + Math.cos(a0) * rk, y0 = cy + Math.sin(a0) * rk;
      var x1 = cx + Math.cos(a1) * rk, y1 = cy + Math.sin(a1) * rk;
      var mx = (x0 + x1) / 2, my = (y0 + y1) / 2;
      var dx = cx - mx, dy = cy - my, dl = Math.sqrt(dx*dx + dy*dy) || 1;
      if(s2 === 0) ctx.moveTo(x0, y0);
      else ctx.lineTo(x0, y0);
      ctx.quadraticCurveTo(mx + dx/dl*sag, my + dy/dl*sag, x1, y1);
    }
    ctx.stroke();
  }
}

// Spirograph (万花尺): hypotrochoid drawn from drag start point (center)
// with radius = drag distance. R:r = 3:1, d = 0.85r → closes after 3 revolutions.
function drawSpiro(cx, cy, radius){
  /* 2026-10-01（丙④）：**半径必须夹住**。原来 R = 拖拽距离（可达几百 px）⇒ 图案大到
     超出认知范围、看起来只是一团粗线。上限取画布短边的 42%，下限 12。
     线宽也要跟着收：万花尺是**细线图形**，用整支笔宽（几十 px）会糊成一团。 */
  var _cap = Math.min(pfmDrawCanvas.width, pfmDrawCanvas.height) * 0.42;
  var R = Math.max(12, Math.min(radius, _cap));
  /* 2026-10-01（丙④·v2）：R:r 由 3:1 改 **2.5:1**、参数跑到 10π。
     3:1 的 hypotrochoid 数学上就是**三尖形**（实拍是一个圆角三角形），不是「万花尺」的观感。
     R/r = 1/0.4 = 5/2 ⇒ t 到 10π 闭合 ⇒ **5 瓣花环**。 */
  /* 2026-10-03（甲·参数化）：**瓣数可调**。数学：R/r = p/q（既约）⇒ 尖角数 = p、
     闭合条件 t = 2π·q；改前 R:r = 5:2（p=5,q=2）⇒ **5 尖 + tMax=4π** —— 也就是截图里看到的
     "五角星/花环"（同一形状的两种叫法，注释旧文案"5 瓣花环"容易让人以为不是星形，已改）。
     取法：奇数瓣用 q=2（星形、自交），偶数瓣用 q=1（花环、不自交）。默认 5 ⇒ 与改前**逐像素一致**。 */
  var _n = Math.max(3, Math.min(12, Math.round(_drawNum('pfmFxSpiroPetals', 5))));
  var _q = (_n % 2 === 1) ? 2 : 1;
  var r = R * (_q / _n);
  var d = r * 0.85;
  /* 🔴 2026-10-02（丙⑩）：`tMax` 10π → **4π**。R:r = 5/2 ⇒ `(R-r)/r = 3/2`，
     花环的闭合条件是 `t = 2π·r/gcd`，对 5:2 的比例就是 **4π**（10π = 2.5 个周期 ⇒
     多画半圈、图案叠到自己身上 ⇒ 直线拖动下看着像"三角形/乱线"）。 */
  var _tMax = Math.PI * 2 * _q;   /* 闭合条件：t = 2π·q（默认 5:2 ⇒ 4π，与改前一致） */
  var steps = 900;
  applyDrawStyle();
  pfmDrawCtx.lineWidth = Math.max(1, Math.min(pfmDraw.brushSize, R * 0.14));   /* 丙④：细线才像万花尺 */
  /* 丙·B：R 随拖拽距离变 ⇒ 脏矩形用**最大可能半径 `_cap`** 做定值（恒定，不存在累积问题）。 */
  pfmDraw.spiroBox = _circleBox(cx, cy, _cap + pfmDrawCtx.lineWidth + 4);
  pfmDrawCtx.beginPath();
  for(var i=0;i<=steps;i++){
    var t = (i/steps) * _tMax;
    var x = cx + (R-r)*Math.cos(t) + d*Math.cos(((R-r)/r)*t);
    var y = cy + (R-r)*Math.sin(t) - d*Math.sin(((R-r)/r)*t);
    if(i===0) pfmDrawCtx.moveTo(x,y); else pfmDrawCtx.lineTo(x,y);
  }
  pfmDrawCtx.stroke();
}

function drawStamp(x, y){
  /* 🔴🔴 2026-10-03（甲）：**改用独立纹理变量** —— 原来这里复用 `pfmDraw.sprayStamp` /
     `sprayStampColor`（与 `drawSpray` **同一对变量**）⇒ 颜色没变就判定"缓存有效"、跳过重建
     ⇒ **谁先画，另一个就用谁的纹理**：先喷漆再盖章 ⇒ 盖出来的是"喷漆小颗粒"而不是三角章。
     实测（`_t_fx8.js`，1440）：只选 Stamp 画一笔，只得到一颗 ≈30×30、平均 α=31 的浅灰小星。
     判据：改后同条件应得到 ~120×120、由多个三角组成的印章串。 */
  /* 🔴🔴 2026-10-03（乙-2）：纹理缓存键从「颜色」升级成「颜色 + 图案」——
     否则换图案时颜色没变会被判定"缓存有效"而跳过重建（= 早先"共用变量"那类静默 bug 的同族）。
     图案直读 `#pfmDrawOpts .pfm-dopt-chip[data-pat].sel`；默认 `tri` = 改前那个三角形 ⇒ 零回归。 */
  var _pat = _stampPattern();
  var _tkey = pfmDraw.color + '|' + _pat + '|' + (_pat === 'ref' ? _stampRefKey() : '');
  if(!pfmDraw.stampTex || pfmDraw.stampTexKey !== _tkey){
    pfmDraw.stampTexKey = _tkey;
    pfmDraw.stampTexColor = pfmDraw.color;
    pfmDraw.stampTex = _buildStampTex(pfmDraw.color, _pat);
  }
  /* 🔴🔴 2026-10-02（丙⑦）：印章尺寸原来 = `(2+rand*3) * (笔宽/10)`，再 ×40 画出去
     ⇒ 边长 = 笔宽的 **8~20 倍**（笔宽 24 时 192~480px）⇒ 糊成一团，看着像雾不像印章；
     而且**每个 mousemove 点都盖一个**（没有间距概念）⇒ 密集拖动互相吞掉、看不出"一个个章"。
     现在：边长 = **1.5~2.5× 笔宽**（贴近真软件的图章笔），并加**最小间距 0.9× 笔宽**
     （真图章笔是沿路径**等距**盖的）。 */
  var bs = Math.max(1, pfmDraw.brushSize);
  if(pfmDraw.stampLX !== undefined){
    var _sx = x - pfmDraw.stampLX, _sy = y - pfmDraw.stampLY;
    if(Math.sqrt(_sx*_sx + _sy*_sy) < bs * 0.9) return;
  }
  pfmDraw.stampLX = x; pfmDraw.stampLY = y;
  var s = ((1.5 + Math.random()) * bs) / 40;                 /* 纹理是 40×40 ⇒ 换算成倍率 */
  pfmDrawCtx.globalAlpha=(0.4+Math.random()*0.4)*_pfmA();
  pfmDrawCtx.drawImage(pfmDraw.stampTex, x-20*s, y-20*s, 40*s, 40*s);
  pfmDrawCtx.globalAlpha=1;
}

/* ===== 2026-10-03（乙-2 Stamp 图案）：把「一个内置三角」扩成可选图案 =====
   对标 PS Pattern Stamp（可换任意图案）/ Painter Image Hose（喷图片）。
   · 内置 4 种程序化图案（triangle / star / circle / square）+ `ref`（用**参考图**当图案）
   · 统一做法：先按主色铺满 40×40，再用 `destination-in` 裁成图案形状
     ⇒ 与改前的三角章同一套像素路径（不是第二套实现）
   · `ref`：等比缩放居中画进纹理（不裁形），源 = 参考图卡片里那张 `<img>`。
     ⚠️ 跨 IIFE 只用 DOM 查询（参考图模块没暴露取图 API），查不到就退回三角。
   · 纹理 = 40×40，与 `drawStamp` 里 `(1.5+rand)*bs/40` 的换算口径一致，别改尺寸。 */
function _stampPattern(){
  var el=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-pat].sel');
  return el ? el.getAttribute('data-pat') : 'tri';
}
function _stampRefKey(){
  var im = _stampRefImg();
  return im ? (im.currentSrc || im.src || 'ref') : 'none';
}
function _stampRefImg(){
  var im = document.querySelector('#pfmDrawRefCard img');
  if(!im) return null;
  if(!im.complete || !(im.naturalWidth > 0)) return null;
  return im;
}
function _buildStampTex(color, pat){
  var sz=40, c2=document.createElement('canvas'); c2.width=sz; c2.height=sz;
  var cx2=c2.getContext('2d');
  if(pat === 'ref'){
    var im = _stampRefImg();
    if(im){
      var iw = im.naturalWidth || sz, ih = im.naturalHeight || sz;
      var k = Math.min(sz/iw, sz/ih), w = iw*k, h = ih*k;
      cx2.drawImage(im, (sz-w)/2, (sz-h)/2, w, h);
      return c2;
    }
    pat = 'tri';                       /* 没参考图 ⇒ 静默退回三角（不弹空纹理） */
  }
  cx2.fillStyle = color; cx2.fillRect(0,0,sz,sz);
  cx2.globalCompositeOperation = 'destination-in';
  cx2.beginPath();
  if(pat === 'circle'){
    cx2.arc(sz/2, sz/2, sz/2 - 3, 0, Math.PI*2);
  } else if(pat === 'square'){
    cx2.rect(4, 4, sz-8, sz-8);
  } else if(pat === 'star'){
    var pts = 5, R1 = sz/2 - 3, R2 = R1*0.42;
    for(var i=0;i<pts*2;i++){
      var rr = (i%2===0) ? R1 : R2, a = (i*Math.PI/pts) - Math.PI/2;
      var px = sz/2 + Math.cos(a)*rr, py = sz/2 + Math.sin(a)*rr;
      if(i===0) cx2.moveTo(px,py); else cx2.lineTo(px,py);
    }
    cx2.closePath();
  } else {
    cx2.moveTo(sz/2,4); cx2.lineTo(sz-4,sz-4); cx2.lineTo(4,sz-4); cx2.closePath();
  }
  cx2.fill();
  return c2;
}

/* ==================================================================
   2026-10-03（丙批）四个新"像素型"工具 / 效果。共同铁律：
   · 默认值 = 改前不存在 ⇒ 一律**用户主动选工具才生效**，不改变任何既有路径
   · 全部走 `_drawNum`/`_drawChip` 直读 DOM（**不写第二份状态**）
   · 像素操作只作用于**当前图层**（`pfmDraw.layers[pfmDraw.active]`），与画笔同层语义
   ================================================================== */

/* ---- 丙-2 液化（Push / Twirl / Pinch / Expand）----
   对标 Procreate Liquify。做法 = 在指针周围取一个小方块，**反向映射**重采样后写回：
   目标点 P 反查源点 S，再把 S 的像素搬到 P。
   · push：S = P − 拖动增量×强度×衰减 ⇒ 内容跟着指针走（"推"）
   · twirl：绕指针旋转，角度 ∝ 拖动距离×强度×衰减
   · pinch/expand：朝心/离心缩放
   半径 80px（可调 20~200）、强度 50%（可调 1~100）。单次只动 (2R)² 像素 ⇒ 拖动流畅。 */
function _liqMode(){
  var el=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-liq].sel');
  return el ? el.getAttribute('data-liq') : 'push';
}
function drawLiquify(x, y, px, py){
  var ctx = pfmDrawCtx;
  /* 🔴 半径 × `pfmDraw.ds`：画布后备存储是 CSS 的 ds 倍（`ds = 1200/size`），
     而滑杆语义是 **CSS px**（同 `#pfmEraseSize`）⇒ 不乘 ds 的话工具"够不着"笔迹
     （首次预演实测：40 后备 px 的圈覆盖不到 60 后备 px 外的线 ⇒ 看着像没反应）。 */
  var R  = Math.max(10, Math.min(200, _drawNum('pfmFxLiqSize', 80))) / 2 * (pfmDraw.ds || 1);
  var st = Math.max(1, Math.min(100, _drawNum('pfmFxLiqStr', 50))) / 100;
  var mode = _liqMode();
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  var bx0 = Math.max(0, Math.floor(x - R)), by0 = Math.max(0, Math.floor(y - R));
  var bx1 = Math.min(W, Math.ceil(x + R)),  by1 = Math.min(H, Math.ceil(y + R));
  var bw = bx1 - bx0, bh = by1 - by0;
  if(bw < 2 || bh < 2) return;
  var img;
  try { img = ctx.getImageData(bx0, by0, bw, bh); } catch(e){ return; }
  var src = new Uint8ClampedArray(img.data);      /* 必须备份：反向映射会读到"已被写过"的像素 */
  var d = img.data;
  var dx = x - px, dy = y - py;                   /* 指针增量（上层量纲） */
  var vlen = Math.sqrt(dx*dx + dy*dy);
  /* 🔴🔴 2026-10-04（用户报「Liquify 没有效果」）：原位移 = 指针增量 × 0.5，且边缘衰减到 0
     ⇒ 拖 180px 只形变 14px（实测）。位移系数放大到 2.4 / 旋转 2.6 / 缩放 1.15，
     并给位移**限幅**（≤0.75R，防撕裂）。 */
  var rot = (mode === 'twirl') ? (vlen / R) * 2.6 * st : (vlen / R) * 0.7 * st;
  var pushK = 2.4, maxPush = R * 0.75;
  var R2 = R * R;
  for(var yy = 0; yy < bh; yy++){
    for(var xx = 0; xx < bw; xx++){
      var rx = (bx0 + xx + 0.5) - x, ry = (by0 + yy + 0.5) - y;
      var r2 = rx*rx + ry*ry;
      if(r2 > R2) continue;
      var r = Math.sqrt(r2), f = 1 - r / R;
      f = f * f * (3 - 2 * f);                    /* smoothstep：边缘平滑过渡，不留硬圈 */
      var sx, sy;
      if(mode === 'push'){
        var ax2 = dx * st * pushK, ay2 = dy * st * pushK;
        if(ax2 >  maxPush) ax2 =  maxPush; else if(ax2 < -maxPush) ax2 = -maxPush;
        if(ay2 >  maxPush) ay2 =  maxPush; else if(ay2 < -maxPush) ay2 = -maxPush;
        sx = rx - ax2*f; sy = ry - ay2*f;
      }
      else if(mode === 'twirl'){ var a2 = -rot*f, c = Math.cos(a2), sn = Math.sin(a2); sx = rx*c - ry*sn; sy = rx*sn + ry*c; }
      else if(mode === 'pinch'){ var sc = 1 + f*st*1.15; sx = rx*sc; sy = ry*sc; }
      else { var se = 1 - f*st*1.15; sx = rx*se; sy = ry*se; }
      var gx = Math.round(x + sx - bx0), gy = Math.round(y + sy - by0);
      if(gx < 0 || gy < 0 || gx >= bw || gy >= bh) continue;
      var so = (gy*bw + gx)*4, dof = (yy*bw + xx)*4;
      d[dof] = src[so]; d[dof+1] = src[so+1]; d[dof+2] = src[so+2]; d[dof+3] = src[so+3];
    }
  }
  ctx.putImageData(img, bx0, by0);
}

/* ---- 丙-3 粒子发射器（重力 / 风向 / 寿命）----
   对标 Painter 粒子 + PS Scattering 组合。**不做 RAF 动画** —— 每个粒子在"出生"时
   就把它的整条弹道一次算完画成折线（引力下是抛物线）⇒ 落笔即成图，不占帧、不留定时器。
   · gravity 正向 = 向下；wind 正向 = 向右（都可能为负）
   · life 越长尾迹越长（6~80 步）
   口径：把指针增量当作初速度（px/帧）×60 = px/s，再用 dt=1/60 步进 ⇒ 与手感一致。 */
function _partArg(id, def, lo, hi){
  var v = _drawNum(id, def);
  return Math.max(lo, Math.min(hi, v)) / 100;
}
function drawParticles(x, y, px, py){
  var g  = _partArg('pfmFxPartGrav', 40, -200, 200);   /* ×900 px/s² */
  var wd = _partArg('pfmFxPartWind', 0, -200, 200);
  var life = Math.max(6, Math.min(80, _drawNum('pfmFxPartLife', 26)));
  var vx0 = (x - px) * 60, vy0 = (y - py) * 60;
  var bs = Math.max(1, pfmDraw.brushSize);
  var n = 3 + Math.floor(Math.random()*3);
  var dt = 1/60;
  pfmDrawCtx.save();
  pfmDrawCtx.lineCap = 'round';
  pfmDrawCtx.strokeStyle = pfmDraw.color;
  pfmDrawCtx.lineWidth = Math.max(1, bs*0.16);
  for(var i=0;i<n;i++){
    var ax = x + (Math.random()-0.5)*bs*0.5, ay = y + (Math.random()-0.5)*bs*0.5;
    var vx = vx0 + (Math.random()-0.5)*bs*10, vy = vy0 + (Math.random()-0.5)*bs*10;
    pfmDrawCtx.globalAlpha = (0.30 + Math.random()*0.30) * _pfmA();
    pfmDrawCtx.beginPath();
    pfmDrawCtx.moveTo(ax, ay);
    for(var st=0; st<life; st++){
      vx += wd*900*dt; vy += g*900*dt;
      vx *= 0.995; vy *= 0.995;
      ax += vx*dt; ay += vy*dt;
      pfmDrawCtx.lineTo(ax, ay);
    }
    pfmDrawCtx.stroke();
  }
  pfmDrawCtx.globalAlpha = 1;
  pfmDrawCtx.restore();
}

/* ---- 丙-4 画笔自带滤镜（Filter Brush）----
   对标 Krita Filter Brush：一笔下去**同时对该区域做滤镜**（不是落色，是改已有像素）。
   做法 = 把"当前图层自己"用 `ctx.filter` 带滤镜重画一遍（只画指针周围一小块）。
   · blur   ：模糊（把颜色晕开）
   · glow   ：模糊 + 提亮，并用 `lighter` 叠加 ⇒ 像在给已有笔迹"加光"
   · soften ：模糊 + 降饱和 ⇒ 柔化/退色
   局部重画（只取 2.2×笔宽 的方块）⇒ 不是每帧重画整张画布。 */
function _filtMode(){
  var el=document.querySelector('#pfmDrawOpts .pfm-dopt-chip[data-filt].sel');
  return el ? el.getAttribute('data-filt') : 'blur';
}
function drawFilterBrush(x, y, px, py){
  var ctx = pfmDrawCtx;
  var amt = Math.max(1, Math.min(100, _drawNum('pfmFxFiltAmt', 40)));
  var W = pfmDrawCanvas.width, H = pfmDrawCanvas.height;
  var bs = Math.max(1, pfmDraw.brushSize);
  var midx = (x + px) / 2, midy = (y + py) / 2, rad = bs * 2.2;
  var bx0 = Math.max(0, Math.floor(midx - rad)), by0 = Math.max(0, Math.floor(midy - rad));
  var bx1 = Math.min(W, Math.ceil(midx + rad)),  by1 = Math.min(H, Math.ceil(midy + rad));
  var bw = bx1 - bx0, bh = by1 - by0;
  if(bw < 2 || bh < 2) return;
  if(typeof ctx.filter !== 'string') return;      /* 引擎不支持 filter ⇒ 什么也不做（不留假控件式半成品） */
  var cv = pfmDraw.layers ? pfmDraw.layers[pfmDraw.active].cv : pfmDrawCanvas;
  var m = _filtMode();
  var blur = (amt / 100) * Math.max(1, bs * 0.35);
  var f = 'blur(' + blur.toFixed(2) + 'px)';
  var comp = 'source-over', alpha = 0.9;
  if(m === 'glow'){ f = 'blur(' + (blur*1.5).toFixed(2) + 'px) brightness(1.35) saturate(1.15)'; comp = 'lighter'; alpha = 0.55; }
  else if(m === 'soften'){ f = 'blur(' + (blur*1.2).toFixed(2) + 'px) saturate(0.5) contrast(0.92)'; }
  /* 🔴🔴 2026-10-03：**必须经一张临时画布**，不能 `drawImage(本层, ...)` 画到自己身上。
     规范上虽允许（实现内先快照），但实测 Edge/Chromium 上这一路**完全看不到变化**
     （第一次预演：前/后像素签名逐位相同）。经临时画布是明确可预期的
     —— 效果层 `applyEffect` 本来就是这么做的（同一条路，不写第二套）。 */
  var tmp = pfmDraw.filtTmp || (pfmDraw.filtTmp = document.createElement('canvas'));
  if(tmp.width !== bw || tmp.height !== bh){ tmp.width = bw; tmp.height = bh; }
  var tg = tmp.getContext('2d');
  tg.clearRect(0, 0, bw, bh);
  tg.drawImage(cv, bx0, by0, bw, bh, 0, 0, bw, bh);
  ctx.save();
  ctx.filter = f;
  ctx.globalCompositeOperation = comp;
  ctx.globalAlpha = alpha;
  ctx.drawImage(tmp, bx0, by0);
  ctx.restore();
}

/* ---- 丙-1 特效层（对**已有笔迹**整体加特效）----
   对标 PS 滤镜。四种：glow（霓虹辉光）/ oil（油画）/ wind（风吹）/ outline（描边加粗）。
   · 全部作用于**当前图层**，且 `pushUndo()` 一次 ⇒ 一步撤销
   · 临时画布 + `ctx.filter` / `getImageData` 像素运算，结果写回同层（不新增图层 ⇒ 不碰
     `pfmDraw.layers` 的三层结构，避免与图层 UI/合成逻辑打架）
   · 调用入口 = 工具卡里的 Effect 卡（引擎暴露 `window.__pfmApplyEffect`） */
function _hex2rgb(h){
  if(!h) return null;
  h = String(h).replace('#','');
  if(h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
  if(h.length !== 6) return null;
  var v = parseInt(h, 16);
  if(isNaN(v)) return null;
  return { r:(v>>16)&255, g:(v>>8)&255, b:v&255 };
}
function applyEffect(kind){
  if(!pfmDrawCtx || !pfmDrawCanvas || !pfmDraw.layers) return false;
  var cv = pfmDraw.layers[pfmDraw.active].cv;
  var W = cv.width, H = cv.height, g = pfmDrawCtx, i, a;
  if(W < 2 || H < 2) return false;
  pushUndo();
  var t = document.createElement('canvas'); t.width = W; t.height = H;
  var tg = t.getContext('2d');
  if(kind === 'glow'){
    var b = Math.max(2, Math.round(W * 0.010));
    tg.filter = 'blur(' + b + 'px)';
    tg.drawImage(cv, 0, 0);
    g.save();
    g.globalCompositeOperation = 'lighter';
    g.globalAlpha = 0.9; g.drawImage(t, 0, 0);
    g.globalAlpha = 1;   g.drawImage(cv, 0, 0);
    g.restore();
  } else if(kind === 'oil'){
    tg.filter = 'blur(2px) saturate(1.7) contrast(1.08)';
    tg.drawImage(cv, 0, 0);
    var doil = tg.getImageData(0, 0, W, H), ao = doil.data, LV = 5, SC = 255 / (LV - 1);
    for(i = 0; i < ao.length; i += 4){
      if(ao[i+3] === 0) continue;
      ao[i]   = Math.round(ao[i]   / SC) * SC;
      ao[i+1] = Math.round(ao[i+1] / SC) * SC;
      ao[i+2] = Math.round(ao[i+2] / SC) * SC;
    }
    g.clearRect(0, 0, W, H);
    g.putImageData(doil, 0, 0);
  } else if(kind === 'wind'){
    var dw = g.getImageData(0, 0, W, H), aw = dw.data;
    var dist = Math.max(6, Math.round(W * 0.022));
    for(var y = 0; y < H; y++){
      for(var x = 0; x < W; x++){
        var o = (y*W + x)*4;
        if(aw[o+3] === 0) continue;
        for(var k = 1; k <= dist; k++){
          var xo = x + k; if(xo >= W) break;
          var oo = (y*W + xo)*4, wt = (1 - k/dist) * 0.5;
          if(wt <= 0) continue;
          aw[oo]   = aw[oo]   + (aw[o]   - aw[oo])   * wt;
          aw[oo+1] = aw[oo+1] + (aw[o+1] - aw[oo+1]) * wt;
          aw[oo+2] = aw[oo+2] + (aw[o+2] - aw[oo+2]) * wt;
          if(aw[oo+3] < aw[o+3]*wt) aw[oo+3] = aw[o+3]*wt;
        }
      }
    }
    g.clearRect(0, 0, W, H);
    g.putImageData(dw, 0, 0);
  } else if(kind === 'outline'){
    var mk = document.createElement('canvas'); mk.width = W; mk.height = H;
    var mg = mk.getContext('2d');
    mg.drawImage(cv, 0, 0);
    mg.globalCompositeOperation = 'source-in';
    mg.fillStyle = pfmDraw.color || '#000000';
    mg.fillRect(0, 0, W, H);
    var kk = Math.max(2, Math.round(W * 0.006));
    g.save();
    g.globalCompositeOperation = 'destination-over';   /* 只落在笔迹**之外** ⇒ 形成外描边 */
    for(var ang = 0; ang < 8; ang++){
      var aa = ang * Math.PI / 4;
      g.drawImage(mk, Math.cos(aa)*kk, Math.sin(aa)*kk);
    }
    g.restore();
  } else {
    return false;
  }
  try { pfmDraw.snapshot = pfmDrawCtx.getImageData(0, 0, W, H); } catch(e){}
  try { if(typeof refreshProductPreview === 'function') refreshProductPreview(); } catch(e){}
  return true;
}
try { window.__pfmApplyEffect = applyEffect; } catch(e){}



function createGradient(x1,y1,x2,y2,ctx){
  var g = pfmGradients[pfmDraw.gradientIndex];
  /* 2026-10-01（甲）：第 5 参数可选 —— 浮动文字预览层必须用**自己的** ctx 建渐变
     （CanvasGradient 绑定创建它的 ctx，跨 ctx 赋值不生效）。省略时行为与旧版一致。 */
  var grad = (ctx || pfmDrawCtx).createLinearGradient(x1,y1,x2,y2);
  grad.addColorStop(0,g[0]); grad.addColorStop(1,g[1]);
  return grad;
}

function floodFill(sx, sy, fillColor, gradDir){
  var w = pfmDrawCanvas.width, h = pfmDrawCanvas.height;
  var imgData = pfmDrawCtx.getImageData(0,0,w,h);
  var data = imgData.data;
  var idx = (Math.floor(sy)*w + Math.floor(sx))*4;
  var targetR = data[idx], targetG = data[idx+1], targetB = data[idx+2], targetA = data[idx+3];
  // Parse fill color
  var fillR, fillG, fillB, fillA=255;
  if(typeof fillColor==='string'){
    if(fillColor.charAt(0)==='#'){
      fillR=parseInt(fillColor.slice(1,3),16);
      fillG=parseInt(fillColor.slice(3,5),16);
      fillB=parseInt(fillColor.slice(5,7),16);
    } else {
      fillR=0;fillG=0;fillB=0;
    }
  } else {
    // Assume gradient - fall back to first gradient color as approximation
    var gc = pfmGradients[pfmDraw.gradientIndex][1];
    fillR=parseInt(gc.slice(1,3),16);
    fillG=parseInt(gc.slice(3,5),16);
    fillB=parseInt(gc.slice(5,7),16);
  }
  var stack=[[Math.floor(sx),Math.floor(sy)]];
  var visited=new Uint8Array(w*h);
  var tolerance=30;
  while(stack.length){
    var p=stack.pop(), px=p[0], py=p[1];
    if(px<0||px>=w||py<0||py>=h) continue;
    if(visited[py*w+px]) continue;
    visited[py*w+px]=1;
    /* 2026-10-04（乙批）：**填充也裁剪到选区** —— 本函数走 `putImageData`，`clip()` 管不到它。
       落点在选区外 / 连通域伸到选区外时，只填选区内那部分（与 PS 一致）。 */
    if(pfmDraw.selMask && !pfmDraw.selMask[py*w+px]) continue;
    var i=(py*w+px)*4;
    if(Math.abs(data[i]-targetR)>tolerance||Math.abs(data[i+1]-targetG)>tolerance||Math.abs(data[i+2]-targetB)>tolerance||Math.abs(data[i+3]-targetA)>tolerance) continue;
    data[i]=fillR;data[i+1]=fillG;data[i+2]=fillB;data[i+3]=fillA;
    stack.push([px+1,py],[px-1,py],[px,py+1],[px,py-1]);
  }
  pfmDrawCtx.putImageData(imgData,0,0);
  // If gradient, draw a gradient overlay with multiply for a nicer look
  if(pfmDraw.isGradient){
    pfmDrawCtx.save();
    pfmDrawCtx.globalCompositeOperation = 'source-atop';
    var g = pfmGradients[pfmDraw.gradientIndex];
    /* 2026-09-20 第 2 批：这里才是渐变的**真正落点**（上方 fillColor 的渐变分支只是近似，会被本段覆盖）。
       给定 gradDir 则按拖拽方向造渐变，否则退回原来的整幅垂直渐变。 */
    var grad = gradDir
      ? pfmDrawCtx.createLinearGradient(gradDir.x1, gradDir.y1, gradDir.x2, gradDir.y2)
      : pfmDrawCtx.createLinearGradient(0,0,0,h);
    grad.addColorStop(0,g[1]); grad.addColorStop(1,g[0]);
    pfmDrawCtx.fillStyle = grad;
    pfmDrawCtx.globalAlpha = 0.4;
    pfmDrawCtx.fillRect(0,0,w,h);
    pfmDrawCtx.restore();
  }
}

/* ===== 撤销栈（2026-09-17 改为 PNG 快照）=====
   实测依据（probe_undo.js / probe_undo2.js，507x895 触屏档）：
     ImageData 每份 1200²x4B = 5.76 MB ⇒ 30 步要 173 MB（旧代码因此只给 6 步）
     PNG      每份 202 KB（压缩 28x）· 编码 18.3ms · 解码 2.6ms · 回填 0ms ⇒ 一次撤销 20.9ms
   ⇒ 深度 6 → 50，内存从 33MB 降到约 10MB。
   双限：步数 maxUndo + 字节预算 undoBudget（PNG 体积随内容走，铺满笔触时会变大）。
   ⚠️ pfmDraw.snapshot 保持 ImageData —— drawMouseMove 里形状/线条拖动靠它 putImageData 回滚预览。
       🔴 2026-09-30 丙：这些回滚只发生在**形状/曲线/渐变/选区**路径 ⇒ drawMouseDown 只给它们拍快照，
          画笔系（brush/ink/crayon/soft/pixel/neon/rainbow/comet/spray/web/smudge/spiro/stamp/eraser/
                  marker/pencil/calli/water/air/mixer）免拍。 */
function pushUndo(){
  if(pfmDraw.undoLock) return;
  /* 2026-09-25（3 层）：条目 = {u:[各层快照], a:当前层}。
     snapEntry 只重编码**当前层**（绘制永远只改当前层），其余层直接复用上一条的引用
     ⇒ 每次落笔仍只有 1 份新内存，与单层时的开销相同。
     🔴 2026-10-03（甲）：编码已改异步（toBlob）⇒ 字节数此刻还未知，先按 0 计，
        由 blob 回调补账并再裁一次（`_undoTrim`）。 */
  var e = snapEntry();
  pfmDraw.undoStack.push(e);
  pfmDraw.undoBytes = (pfmDraw.undoBytes || 0) + _snapBytes(e);
  _undoTrim();
  pfmDraw.redoStack = [];
}

/* 把一张 PNG 快照贴回画布（异步：解码 2.6ms），完成后重建 snapshot 并同步预览 */
function drawApplySnap(snap, done){
  /* 2026-09-25（3 层）：条目 = {u:[各层 dataURL], a:当前层}；也兼容裸 dataURL 字符串（旧形态/单层退化）。
     applyEntry 只重载**内容真的变了的层**（通常只有 1 层）⇒ 撤销延迟与单层时相当。 */
  var entry = (typeof snap === 'string') ? {u:[snap], a:0} : snap;
  applyEntry(entry, function(){
    if(pfmDraw.layers){
      try{ pfmDraw.snapshot = pfmDrawCtx.getImageData(0,0,pfmDrawCanvas.width,pfmDrawCanvas.height); }catch(e){}
    }
    done && done();
    try{ if(pfmDraw.compact && typeof refreshProductPreview==='function') refreshProductPreview(); }catch(e){}
  });
}

function drawUndo(){
  if(pfmDraw.undoStack.length<=1 || pfmDraw.undoLock) return;
  pfmDraw.undoLock = true;
  var cur = pfmDraw.undoStack.pop();
  pfmDraw.redoStack.push(cur);
  pfmDraw.undoBytes -= _snapBytes(cur);
  if(pfmDraw.undoBytes < 0) pfmDraw.undoBytes = 0;
  drawApplySnap(pfmDraw.undoStack[pfmDraw.undoStack.length-1], function(){ pfmDraw.undoLock = false; });
}

function drawRedo(){
  if(!pfmDraw.redoStack.length || pfmDraw.undoLock) return;
  pfmDraw.undoLock = true;
  var url = pfmDraw.redoStack.pop();
  pfmDraw.undoStack.push(url);
  pfmDraw.undoBytes = (pfmDraw.undoBytes || 0) + _snapBytes(url);
  drawApplySnap(url, function(){ pfmDraw.undoLock = false; });
}

/* ===== 字体库桥接（2026-09-12）=====
   字体库本体外置在 assets/hd-fontlib.js —— 本 section 已逼近 Shopify 256KB 模板上限
   （实测线上 247183 B / 上限 262144 B，只剩约 15KB），故 JS/CSS 一律走 asset。
   该 asset 是独立作用域，主 IIFE 看不到其内部 —— 必须经 window 显式取值
   （同 window.__pfmSaveState 的教训：跨作用域禁止用 typeof 探测猜）。 */
function hdFontLoad(f){ return (window.__hdFontLoad||function(){return Promise.resolve();})(f); }
function hdFontReady(f){ return window.__hdFontReady?window.__hdFontReady(f):true; }
function hdFontsReady(){ return window.__hdFontsReady?window.__hdFontsReady():Promise.resolve(); }
function hdFontVal(f){ return window.__hdFontVal?window.__hdFontVal(f):f; }
function hdFontSyncUI(){ if(window.__hdFontSyncUI){ try{ window.__hdFontSyncUI(); }catch(e){} } }
/* 这个留在主 IIFE —— 它依赖 pfmDrawCtx / pfmDraw / createGradient / pushUndo（都是本作用域局部变量） */
/* ===== 2026-10-01（甲 · 浮动文字对象）=====
   动机：文字原先是「点一下 = 立刻 fillText 烤进画布」—— 落点一错只能整步撤销；
   全站也没有任何「文字对象」可再选中。本批改为 Procreate 模型：**落字先浮着**
   （虚线框可拖，改字体/字号/行高/颜色实时重画预览），点 ✓ 才烘焙；✕ / Esc = 丢弃。

   🔴 预览层是 **DOM canvas**（#pfmTextLayer），与 #pfmDrawSelLayer 同一套定位法
      ⇒ 不进主画布像素 ⇒ 不污染 toDataURL / 撤销栈 / 落产品。
   🔴 预览与烘焙**共用 `_paintTextOn`** —— 预览所见必须与 ✓ 之后所得逐像素一致。
   🔴 锚点 = **左上角**（旧版是基线）。有意行为变更：旧版点 (420,660) 文字出现在其上方 67px。
   ⚠️ 烘焙共 5 个收口：✓ 按钮 · 切工具 · 关画板 · outUrl()（落产品/导出）· Esc（丢弃）。 */
function _textEls(){
  return { hd: document.getElementById('pfmTextHd'),
           lay: document.getElementById('pfmTextLayer'),
           frame: document.getElementById('pfmTextFrame'),
           bar: document.getElementById('pfmTextBar'),
           ok: document.getElementById('pfmTextOk'),
           no: document.getElementById('pfmTextNo') };
}
function _textLive(){ return !!(pfmDraw.text && pfmDraw.text.on); }
function _textCtx(){
  var l = _textEls().lay;
  if(!l) return null;
  if(!l._ctx) l._ctx = l.getContext('2d');
  return l._ctx;
}
function _textVal(){ var i = q('pfmDrawTextInput'); return (i && i.value) ? i.value : 'Text'; }
function _textFS(){ return _textSizeRaw() * (pfmDraw.ds || 1); }
/* 首行基线相对锚点（左上角）的下移量。取字体的实际 ascender；拿不到才退回经验值。 */
function _textAscent(ctx,fontSize){
  try{ var a = ctx.measureText('Hg').actualBoundingBoxAscent; if(a && a > 0) return a; }catch(e){}
  return fontSize * 0.8;
}
/* 对齐档位（与 _symMode 同一套「直读 DOM」写法）。
   2026-10-01（甲·第二批）：样式/对齐/底色一律**直读 DOM**，不额外在 pfmDraw 上存一份
   —— 否则两处状态会不一致（本项目已踩过 4 次「哑控件」）。 */
function _textAlignMode(){
  var el = document.querySelector('#pfmDrawTextOptions [data-ta].sel');
  return el ? el.getAttribute('data-ta') : 'left';
}
/* 唯一文字绘制实现（预览 / 烘焙共用）。返回相对 pos 的包围盒 {w,h}。
   🔴 只管画：不碰状态、不 pushUndo —— 那是调用方的事。
   2026-10-01（甲·第二批）：加入 粗体 / 斜体 / 下划线 / 删除线 / 对齐 / 底色。
   🔴 这些**必须全部在这里实现** —— 预览层与烘焙走同一个函数，加在别处就会出现「预览所见 ≠ ✓ 后所得」。 */
function _paintTextOn(ctx,pos,txt,fontSize){
  if(!ctx) return {w:0,h:0};
  var bold = _chipOn('pfmTextBold'), ital = _chipOn('pfmTextItalic');
  var und  = _chipOn('pfmTextUnderline'), strk = _chipOn('pfmTextStrike');
  var bg   = _chipOn('pfmTextBg'), al = _textAlignMode();
  ctx.font = (bold ? 'bold ' : '') + (ital ? 'italic ' : '') + fontSize + 'px ' + pfmDraw.fontFamily;
  var lines = String(txt).split('\n'), lh = fontSize * _textLineH();
  var asc = _textAscent(ctx,fontSize), i, mw, w = 0, ws = [], ms = [];
  for(i=0;i<lines.length;i++){
    mw = ctx.measureText(lines[i]).width; ws.push(mw); if(mw > w) w = mw;
    ms.push(ctx.measureText(lines[i]));
  }
  var ulw = Math.max(1, Math.round(fontSize*0.06));
  var pad = Math.max(2, fontSize*0.16);
  /* 2026-10-02（甲·②）：逐行求**字形墨迹**并集，不再用 `asc + (n-1)*lh + desc` 那套行盒。
     🔴 旧式里的 desc 是**字体**的下伸部（按 'Hg' 量），可正文字符未必用到它
        ⇒ 底色矩形下方永远白留一截（用户实拍核对：上 6px / 下 24px，4 倍差 = 字像贴顶）。
     本段坐标 = 相对「绘制零点」（左边距 L / 首行基线 baseY），下面再据 pos 反推。 */
  var kx0 = 1e9, ky0 = 1e9, kx1 = -1e9, ky1 = -1e9;
  for(i=0;i<lines.length;i++){
    var _m = ms[i], _ad = ws[i], _ox = 0;
    if(al === 'center') _ox = (w - _ad) / 2;
    else if(al === 'right') _ox = (w - _ad);
    var iL = _m.actualBoundingBoxLeft   || 0, iR = _m.actualBoundingBoxRight   || 0;
    var iA = _m.actualBoundingBoxAscent || 0, iD = _m.actualBoundingBoxDescent || 0;
    /* 空行 / 纯空格：真墨迹为空 ⇒ 退回行盒，否则包围盒会塌缩成 0（虚框缩到抓不住） */
    if(iA <= 0 && iD <= 0 && iL <= 0 && iR <= 0){ iL = 0; iR = _ad; iA = asc; iD = 0; }
    var _b0 = _ox - iL, _b1 = _ox + iR, _c0 = i*lh - iA, _c1 = i*lh + iD;
    if(und) _c1 = Math.max(_c1, i*lh + fontSize*0.13 + ulw);   /* 下划线画在基线下方 ⇒ 要包进盒 */
    if(kx0 > _b0) kx0 = _b0; if(kx1 < _b1) kx1 = _b1;
    if(ky0 > _c0) ky0 = _c0; if(ky1 < _c1) ky1 = _c1;
  }
  if(kx1 < kx0){ kx0 = 0; kx1 = w || fontSize*0.5; }
  if(ky1 < ky0){ ky0 = 0; ky1 = asc; }
  /* 反推绘制原点：`pos` = **框**（墨迹 + 四周等距 pad）的左上角 ⇒ 墨迹左上角 = pos + pad */
  var L = pos.x + pad - kx0, baseY = pos.y + pad - ky0;
  var boxW = (kx1 - kx0) + pad*2, boxH = (ky1 - ky0) + pad*2;
  /* 1) 底色 —— 必须画在文字**之前**（否则盖住字）。取色用独立的文字底色值。 */
  if(bg){
    /* 2026-10-02（甲·②）：底色矩形 = **虚线框本身**（同一个矩形）⇒ 四周等距、两者完全重合。
       旧写法 (pos.x-padv, pos.y-padv*0.5, w+2padv, boxH+1.5padv) 纵向系数 0.5 / 1.5 不对称
       ⇒ 上边距只有下边的三分之一（用户实拍 6px vs 24px）。 */
    ctx.fillStyle = _textBgVal();
    ctx.fillRect(pos.x, pos.y, boxW, boxH);
  }
  /* 2) 正文颜色（藏在底色之后设，避免被底色覆盖） */
  if(pfmDraw.isGradient){
    /* ⚠️ CanvasGradient 绑定在创建它的 ctx 上 ⇒ 预览层必须用**自己的** ctx 创建 */
    ctx.fillStyle = createGradient(pos.x-fontSize*2, pos.y-fontSize, pos.x+fontSize*2, pos.y+fontSize, ctx);
  } else { ctx.fillStyle = pfmDraw.color; }
  /* 2026-10-02（甲·①）：文字描边分支已删（`pfmDraw.textStroke` 字段与 `◉` 按钮一并移除）。 */
  /* 3) 逐行：按对齐算起点，再补下划线 / 删除线。
     ⚠️ 起点必须用**上面反推出来的** L / baseY（笔迹真正落笔处）——
        2026-10-02（甲·②）改墨迹盒后 `pos` 已不再是排版原点，写 pos.x / pos.y+asc 会整体偏一个 pad。 */
  for(i=0;i<lines.length;i++){
    var ox = 0;
    if(al === 'center') ox = (w - ws[i]) / 2;
    else if(al === 'right') ox = (w - ws[i]);
    var lx = L + ox, ly = baseY + i*lh;
    ctx.fillText(lines[i], lx, ly);
    if(und)  ctx.fillRect(lx, ly + fontSize*0.13, ws[i], ulw);           /* 下划线：基线下方 */
    if(strk) ctx.fillRect(lx, ly - asc*0.33, ws[i], ulw);                /* 删除线：基线偏上 */
  }
  return { w: boxW, h: boxH };
}
/* 文字底色取色：直读取色控件；缺控件时退回白（**不静默画成随机色**） */
function _textBgVal(){
  var el = document.getElementById('pfmTextBgColor');
  var v = el ? String(el.value || '') : '';
  return /^#[0-9a-fA-F]{6}$/.test(v) ? v : '#FFFFFF';
}
function hdDrawTextAt(pos,txt,fontSize){
  _paintTextOn(pfmDrawCtx, pos, txt, fontSize);
  pushUndo();
}
/* 脏矩形的安全余量：descender + 下划线/删除线 + 底色 pad，全在这条线内 */
function _textPad(){ return _textFS() * 0.6 + 8; }
/* 只重画预览层，顺带量出包围盒（画布内部坐标）。
   🔴 2026-10-02：改**脏矩形** —— 原来每帧 `clearRect(0,0,cw,ch)` 清整层。
      手机上画布内部是 1200×1200 ⇒ 每帧擦 5.7MB 再重画，是「拖拽不跟手」的第二个原因
      （第一个是缺 touch-action，两件事独立）。
   🔴 必须清「上一帧 ∪ 这一帧」的并集：拖动时包围盒在移动，只清本帧会留下上一帧的残影。 */
function _textPreview(){
  if(!_textLive()) return;
  var c = _textCtx(); if(!c) return;
  var t = pfmDraw.text, pad = _textPad();
  var nx = t.x - pad, ny = t.y - pad;
  var nw = (t.w || 1) + pad * 2, nh = (t.h || 1) + pad * 2;
  var pv = t.pbox;
  if(pv){
    var x0 = Math.min(pv.x, nx), y0 = Math.min(pv.y, ny);
    var x1 = Math.max(pv.x + pv.w, nx + nw), y1 = Math.max(pv.y + pv.h, ny + nh);
    c.clearRect(x0, y0, x1 - x0, y1 - y0);
  } else {
    c.clearRect(0, 0, c.canvas.width, c.canvas.height);   /* 首帧（或尺寸刚变）⇒ 整层 */
  }
  var box = _paintTextOn(c, {x:t.x, y:t.y}, _textVal(), _textFS());
  t.w = box.w; t.h = box.h;
  t.pbox = { x: nx, y: ny, w: box.w + pad * 2, h: box.h + pad * 2 };
}
/* 预览层 / 虚线框 / ✓✕ 条 跟随画布几何与 transform（与 selHandlesSync 同一套做法） */
function _textSync(){
  var e = _textEls(), cv = pfmDrawCanvas, i;
  if(!_textLive()){ _sc(e.hd,'on',false); return; }
  if(!cv || !e.hd) return;
  var W = cv.width || 600, H = cv.height || 600;
  if(e.lay && (e.lay.width !== W || e.lay.height !== H)){
    e.lay.width = W; e.lay.height = H;
    if(pfmDraw.text) pfmDraw.text.pbox = null;    /* 2026-10-02：画布尺寸变了 ⇒ 旧脏矩形作废 */
    _textPreview();
  }
  var _gl = _cvGeo();
  _ss(e.hd,'left', (_gl.left||0)+'px'); _ss(e.hd,'top', (_gl.top||0)+'px');
  _ss(e.hd,'width', (_gl.w||W)+'px');   _ss(e.hd,'height', (_gl.h||H)+'px');
  _ss(e.hd,'transformOrigin','0 0');    _ss(e.hd,'transform', cv.style.transform||'');
  var kx = (_gl.w||W)/W, ky = (_gl.h||H)/H;
  var inv = 1 / (pfmDrawZoom.s || 1);
  var fx = pfmDraw.text.x*kx, fy = pfmDraw.text.y*ky;
  var fw = Math.max(8, pfmDraw.text.w*kx), fh = Math.max(8, pfmDraw.text.h*ky);
  if(e.frame){
    _ss(e.frame,'left', fx+'px'); _ss(e.frame,'top', fy+'px');
    _ss(e.frame,'width', fw+'px'); _ss(e.frame,'height', fh+'px');
    /* 2026-10-01（甲·第二批）：四角缩放手柄**反缩放**（与选区手柄同一套）——
       外层 wrap 带着画布的 scale(s)，不补偿的话放大画布时手柄会变大到抓不住。 */
    /* 2026-10-02：NodeList **缓存** —— 原来每帧一次 querySelectorAll，而拖拽时每帧都走到这里 */
    if(!e.frame._tsH) e.frame._tsH = e.frame.querySelectorAll('[data-tscale]');
    var _hs = e.frame._tsH;
    /* 2026-10-04：文字框的 1px 虚线与选区框同款 ⇒ 同样要**屏幕恒定**（变量由 CSS 侧消费）。
       只手柄用 JS 逐个设 transform 是够的，但边框宽/虚线粗细只能走 CSS 变量。
       ⚠️ 本段是**另一个会话**在 20:0x~20:46 之间加的（+301B）—— 我 20:46 首次推 Path 修复时
          基于的是自己那份（不含它）⇒ 被覆盖；随后按 PUSH.md 定式**重基**补回，勿再删。 */
    _sp(e.frame, '--hd-inv-x', inv); _sp(e.frame, '--hd-inv-y', inv);
    for(i=0;i<_hs.length;i++) _ss(_hs[i],'transform','scale('+inv+')');
  }
  if(e.bar){
    /* 反缩放（origin 0 0 ⇒ 缩放置换不变左上角）：画布放大时按钮不会跟着变大。
       🔴🔴 必须**夹在 wrap 内** —— 手机端（画布仅 358px 宽）把框拖到右侧后，
          按钮条会整条跑到视口外（实测 x=438 > 390）⇒ 用户点不到 ✓，等于没法提交。
       🔴🔴 2026-10-02（甲·③ 收尾）：还要**绝不压住四角手柄**。线上手机实测：框贴画布右缘时，
          条被"夹进 wrap"恰好盖住 SE 手柄 ⇒ 手指按角手柄其实按到 ✓
          （真 CDP 抓到的触点目标链 = `button#pfmTextOk`）⇒ 拖不动四角 / 一按就误提交。
       做法：① 定位与碰撞判定统一到**屏幕坐标**（`#pfmTextFrame` 的 rect 就是现成锚点，
          顺带修掉旧写法 `offsetWidth * inv` 在 zoom≠1 时的宽度换算错误）；
          ② 在框四周列 6 个候选位，取第一个「既在 wrap ∩ 视口内、又不与任一角手柄热区相交」的；
          ③ 都不行才退回原夹取（那时以"一定看得见"为先）。 */
    var fr = e.frame && e.frame.getBoundingClientRect ? e.frame.getBoundingClientRect() : null;
    var hr = e.hd && e.hd.getBoundingClientRect ? e.hd.getBoundingClientRect() : null;
    var bs = e.bar.offsetWidth || 56, bh = e.bar.offsetHeight || 26;   /* 屏幕 px：反缩放后尺寸恒定 */
    var sxp = (fr && fw) ? (fr.width / fw) : 1;                        /* 布局 → 屏幕 的比例 */
    var HR = 16;                     /* 手柄热区半宽（屏幕 px）：12px 手柄 + ::after 外扩 8px */
    var _lim = { l: 4, t: 4, r: (window.innerWidth || 1024) - 4, b: (window.innerHeight || 1024) - 4 };
    if(hr){
      _lim.l = Math.max(_lim.l, hr.left + 2);  _lim.t = Math.max(_lim.t, hr.top + 2);
      _lim.r = Math.min(_lim.r, hr.right - 2); _lim.b = Math.min(_lim.b, hr.bottom - 2);
    }
    var _bx = null, _by = null, _k2;
    if(fr){
      var _cn = [[fr.left, fr.top], [fr.right, fr.top], [fr.left, fr.bottom], [fr.right, fr.bottom]];
      var _hitHd = function(X, Y){
        for(var _q=0;_q<4;_q++){
          if(X < _cn[_q][0]+HR && X+bs > _cn[_q][0]-HR && Y < _cn[_q][1]+HR && Y+bh > _cn[_q][1]-HR) return true;
        }
        return false;
      };
      var _cand = [[fr.right + HR + 2, fr.top], [fr.left - bs - HR - 2, fr.top],
                   [fr.left, fr.top - bh - HR - 2], [fr.left, fr.bottom + HR + 2],
                   [fr.right - bs, fr.bottom + HR + 2], [fr.right - bs, fr.top - bh - HR - 2]];
      for(_k2=0;_k2<6;_k2++){
        var _X = _cand[_k2][0], _Y = _cand[_k2][1];
        if(_X < _lim.l || _Y < _lim.t || _X + bs > _lim.r || _Y + bh > _lim.b) continue;
        if(_hitHd(_X, _Y)) continue;
        _bx = _X; _by = _Y; break;
      }
    }
    if(_bx === null){
      /* 兜底（原夹取语义，只是把边界换成「wrap ∩ 视口」）：极端情况（框几乎占满可见区）仍可能压住手柄 */
      _bx = (fr ? fr.right + 2 : fx + fw + 2);
      _by = (fr ? fr.top - 30 : fy - 30);
      if(_bx + bs > _lim.r) _bx = (fr ? fr.left - bs - 2 : fx - bs - 2);
      if(_bx < _lim.l) _bx = _lim.l;
      if(_bx + bs > _lim.r) _bx = Math.max(_lim.l, _lim.r - bs);
      if(_by < _lim.t) _by = (fr ? fr.bottom + 4 : fy + fh + 4);
      if(_by < _lim.t) _by = _lim.t;
      if(_by + bh > _lim.b) _by = Math.max(_lim.t, _lim.b - bh);
    }
    /* 屏幕 → wrap 布局 px（frame 的 rect 即换算锚点） */
    _ss(e.bar,'left', Math.round(fx + (_bx - fr.left) / sxp) + 'px');
    _ss(e.bar,'top',  Math.round(fy + (_by - fr.top)  / sxp) + 'px');
    _ss(e.bar,'transform', 'scale('+inv+')');
  }
}
/* 进入浮动态：x,y = 画布内部坐标的**左上角** */
function textBegin(x,y){
  pfmDraw.text = { on:true, x:x, y:y, w:0, h:0, drag:null };
  _sc(_textEls().hd,'on',true);
  _textPreview();
  _textSync();
}
/* 丢弃：不落笔 */
function textCancel(){
  if(!pfmDraw.text) return;
  pfmDraw.text = null;
  var c = _textCtx();
  if(c) c.clearRect(0, 0, c.canvas.width, c.canvas.height);
  _sc(_textEls().hd,'on',false);
}
/* 提交：唯一烘焙入口（走 hdDrawTextAt ⇒ 内含 pushUndo） */
function textCommit(){
  if(!pfmDraw.text) return false;
  var t = pfmDraw.text, txt = _textVal(), fs = _textFS();
  textCancel();                                   /* 先收浮动态再落笔：反了会留下预览残影 */
  hdDrawTextAt({x:t.x, y:t.y}, txt, fs);
  return true;
}
function _textBind(){
  var e = _textEls(), i;
  if(e.ok && !e.ok._hdTb){
    e.ok._hdTb = 1;
    e.ok.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); textCommit(); });
  }
  if(e.no && !e.no._hdTb){
    e.no._hdTb = 1;
    e.no.addEventListener('click', function(ev){ ev.preventDefault(); ev.stopPropagation(); textCancel(); });
  }
  if(e.frame && !e.frame._hdTb){
    e.frame._hdTb = 1;
    e.frame.addEventListener('pointerdown', function(ev){
      if(!_textLive()) return;
      ev.preventDefault(); ev.stopPropagation();
      var cv = pfmDrawCanvas, r = cv.getBoundingClientRect();
      pfmDraw.text.drag = { px:ev.clientX, py:ev.clientY, x0:pfmDraw.text.x, y0:pfmDraw.text.y,
        kx:(r.width ? cv.width/r.width : 1), ky:(r.height ? cv.height/r.height : 1) };
      try{ e.frame.setPointerCapture(ev.pointerId); }catch(_e){}
    });
    e.frame.addEventListener('pointermove', function(ev){
      var t = pfmDraw.text; if(!t || !t.drag) return;
      ev.preventDefault();
      t.x = t.drag.x0 + (ev.clientX - t.drag.px) * t.drag.kx;
      t.y = t.drag.y0 + (ev.clientY - t.drag.py) * t.drag.ky;
      /* 🔴🔴 两件都要做，缺一不可：`_textPreview()` 重画预览（**文字真的动**）+ `_textSync()` 挪框。
         只调 _textSync() 的后果：虚线框跟着鼠标跑、**文字原地不动** ⇒ 用户报「不能移动啊」。
         （2026-10-01 实测：框 Δx=120px 而文字 bbox 前后完全相同 Δx=0 —— 根因就在这一行。） */
      _textPreview();
      _textSync();
    });
    var _stop = function(){ if(pfmDraw.text) pfmDraw.text.drag = null; };
    e.frame.addEventListener('pointerup', _stop);
    e.frame.addEventListener('pointercancel', _stop);
  }
  /* 卡片控件**委托**（一个容器监听覆盖整卡）：改字号 / 行高 / 字体 / 描边 / 颜色 ⇒ 重画预览。
     🔴 走容器委托而不是逐个控件绑定 —— 卡片结构以后变（加控件）也不用再改这里。 */
  ['pfmDrawTextOptions','pfmDrawColors'].forEach(function(id){
    var c = document.getElementById(id);
    if(!c || c._hdTb) return;
    c._hdTb = 1;
    ['input','change','click'].forEach(function(ev){
      c.addEventListener(ev, function(){ if(!_textLive()) return; try{ _textPreview(); _textSync(); }catch(_e){} }, true);
    });
  });
  /* 2026-10-01（甲·第二批）：格式键（粗/斜/下划/删除/底色）—— 切 `.sel` 后**必须自己重画**。
     🔴🔴 踩过的坑：卡片容器的委托（input/change/click）注册在**捕获阶段**，而本 handler 在**冒泡阶段**
        ⇒ 委托先跑、此时 `.sel` 还没切 ⇒ 它重画的是**旧状态** ⇒ 效果**延迟一次点击**才出现。
        实测症状：点「粗体」预览像素 28206 → 28206（纹丝不动），而再点「斜体」时粗体才冒出来。 */
  ['pfmTextBold','pfmTextItalic','pfmTextUnderline','pfmTextStrike','pfmTextBg'].forEach(function(id){
    var btn = document.getElementById(id);
    if(!btn || btn._hdTf) return;
    btn._hdTf = 1;
    btn.addEventListener('click', function(ev){
      ev.preventDefault();
      this.classList.toggle('sel');
      _textPreview(); _textSync();
    });
  });
  /* 对齐：组内互斥（同 _symMode 的语义），始终恰好有一个选中 */
  var _tas = document.querySelectorAll('#pfmDrawTextOptions [data-ta]');
  for(i=0;i<_tas.length;i++){
    (function(btn){
      if(btn._hdTf) return;
      btn._hdTf = 1;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        for(var j=0;j<_tas.length;j++) _tas[j].classList.remove('sel');
        this.classList.add('sel');
        _textPreview(); _textSync();
      });
    })(_tas[i]);
  }
  /* 底色取色：把值记进 pfmDraw.textBgColor（引擎侧唯一取值入口是 _textBgVal()） */
  var _bgc = document.getElementById('pfmTextBgColor');
  if(_bgc && !_bgc._hdTf){
    _bgc._hdTf = 1;
    _bgc.addEventListener('input', function(){ pfmDraw.textBgColor = this.value; _textPreview(); _textSync(); });
  }
  /* 四角缩放（D）：拖角 = **等比改字号**，并**同步 Size 滑杆**（所见即所得，滑杆不会撒谎）。
     🔴 固定点是**对角**（拖右下角 ⇒ 左上角不动），这是画图软件的通用手感。
     🔴 全程只改字号 + 位置，**不碰画布**（预览层重画即可）。 */
  if(e.frame && !e.frame._hdTs){
    e.frame._hdTs = 1;
    var _hs = e.frame.querySelectorAll('[data-tscale]');
    for(i=0;i<_hs.length;i++){
      (function(h){
        h.addEventListener('pointerdown', function(ev){
          if(!_textLive()) return;
          ev.preventDefault(); ev.stopPropagation();       /* 🔴 必须拦，否则冒泡到 frame 变成「拖框移动」 */
          var t = pfmDraw.text, c = h.getAttribute('data-tscale');
          var cv = pfmDrawCanvas, r = cv.getBoundingClientRect();
          var kx = r.width ? cv.width/r.width : 1, ky = r.height ? cv.height/r.height : 1;
          var fixX = (c==='nw'||c==='sw') ? (t.x + t.w) : t.x;
          var fixY = (c==='nw'||c==='ne') ? (t.y + t.h) : t.y;
          var sx = r.left + fixX/kx, sy = r.top + fixY/ky;
          t.scl = { fs0:_textSizeRaw(), corner:c, fixX:fixX, fixY:fixY, sx:sx, sy:sy,
                    w0:t.w, h0:t.h,   /* 2026-10-02：起始包围盒 —— 供比例定位用（免掉一次重画） */
                    d0:Math.max(8, Math.sqrt((ev.clientX-sx)*(ev.clientX-sx) + (ev.clientY-sy)*(ev.clientY-sy))) };
          try{ h.setPointerCapture(ev.pointerId); }catch(_e){}
        });
        h.addEventListener('pointermove', function(ev){
          var t = pfmDraw.text; if(!t || !t.scl) return;
          ev.preventDefault();
          var dx = ev.clientX - t.scl.sx, dy = ev.clientY - t.scl.sy;
          var d = Math.sqrt(dx*dx + dy*dy);
          var ns = Math.max(8, Math.min(200, Math.round(t.scl.fs0 * (d / t.scl.d0))));
          var sl = q('pfmDrawTextSize');
          if(sl) sl.value = String(ns);
          var lab = q('pfmDrawTextSizeVal'); if(lab) lab.textContent = String(ns);
          /* 2026-10-02：**只画一次**。原来是 `_textPreview()` 量 w/h → 改 x/y → 再 `_textPreview()`，
             每帧两遍。字宽/字高与字号**严格成正比**（canvas 的 advance width 是线性的）
             ⇒ 用比例先算新包围盒来定位置，真实值由下面那一次绘制回填（下一帧即准，无累积误差）。 */
          var _r = t.scl.fs0 ? (ns / t.scl.fs0) : 1;
          if(t.scl.corner==='nw' || t.scl.corner==='sw') t.x = t.scl.fixX - t.scl.w0 * _r;
          if(t.scl.corner==='nw' || t.scl.corner==='ne') t.y = t.scl.fixY - t.scl.h0 * _r;
          _textPreview(); _textSync();
        });
        var _st = function(){ if(pfmDraw.text) pfmDraw.text.scl = null; };
        h.addEventListener('pointerup', _st);
        h.addEventListener('pointercancel', _st);
      })(_hs[i]);
    }
  }
  /* 2026-10-02（甲·③）：**点击浮动态以外的任何地方 = 默认打勾**（提交）。
     原行为实测（`_probe_textcard3.js`）：点画布**外**（顶栏 / 侧边）**什么都不发生**，字一直浮着
     ⇒ 用户以为点一下就走，结果还得回头找 ✓。现在与 Win11 画图一致：点框外即提交。
     🔴 必须走 `composedPath()` —— 本项目踩过 `e.target` 脱链（多处 handler 会 `innerHTML=''` 重画自己，
        被点元素当场 `parentNode = null`）⇒ `closest()` 恒 null、豁免集体失效的老坑。
     🔴 挂 **document 捕获**阶段：卡片容器自己的委托也是捕获、且更内层，本监听先跑
        ⇒ 提交之后后续逻辑读到的都是新状态（不会有人拿着旧 `pfmDraw.text` 继续画）。
     ⚠️ 下列容器算「正在编辑这段字」的操作面，**点到它们不提交**：
        浮动态框（拖拽）· 四角手柄（在框内）· ✓✕ 条 · 文字卡 · 颜色卡 · 独立取色窗 · 渐变搭建窗。
     ⚠️ **画布上的按下不在这里提交** —— 交给 `drawMouseDown` 的 text 分支（它自己会「提交且不新建」），
        否则本监听先提交、那边看不见浮动态，就又开一个新框（把 ③ 的那条语义弄坏）。 */
  if(!document._hdTextOut){
    document._hdTextOut = 1;
    var TEXT_OWN_UI = ['pfmTextFrame','pfmTextBar','pfmDrawTextOptions','pfmDrawColors',
                       'pfmWheelModal','pfmGradCustomPanel'];
    document.addEventListener('pointerdown', function(ev){
      if(!_textLive()) return;
      var path = (ev.composedPath && ev.composedPath()) || [], k, n;
      for(k=0;k<path.length;k++){
        n = path[k];
        if(n && n.tagName && n.id && TEXT_OWN_UI.indexOf(n.id) >= 0) return;   /* 自己的 UI ⇒ 不动 */
      }
      /* 画布上的按下**不在这里提交** —— 交给 `drawMouseDown` 的 text 分支
         （它自己会「提交且不新建」）。判据用**几何**而非 DOM 路径：
         画布上方还有棋盘格 / 网格 / 预览层等覆盖层，路径法会被它们挡掉（命中目标不是 canvas）。 */
      var cv = pfmDrawCanvas;
      if(cv && pfmDraw.tool === 'text'){
        var r = cv.getBoundingClientRect();
        if(ev.clientX >= r.left && ev.clientX <= r.right && ev.clientY >= r.top && ev.clientY <= r.bottom) return;
      }
      textCommit();
    }, true);
  }
  /* Esc = 丢弃浮动文字。**必须捕获阶段**（同色轮 / 渐变窗的理由）：画板自身的 Esc 在冒泡阶段，
     不拦的话按一次 Esc 会把浮动文字和整个画板一起关掉。 */
  if(!document._hdTextEsc){
    document._hdTextEsc = 1;
    document.addEventListener('keydown', function(ev){
      if(ev.key !== 'Escape' || !_textLive()) return;
      textCancel();
      ev.stopImmediatePropagation(); ev.stopPropagation(); ev.preventDefault();
    }, true);
  }
}

  /* ===== 出口 —— 原段外 10 处引用改走这里（section 侧已改为 window.__hdDraw.*）===== */
  /* 2026-10-01（甲）：snippet 的「落笔即收」需要知道浮动文字是否活着（拖框时别收面板） */
  window.__pfmTextLive = _textLive;
  /* 2026-10-02（甲·③）：snippet 的「文字卡 ✕」要按**默认打勾**语义先提交再收卡 ⇒ 暴露一个薄桥
     （同 `__pfmTextLive` 的跨 IIFE 口径；snippet 拿不到 `textCommit`）。 */
  window.__pfmTextCommit = textCommit;
  window.__hdDraw = {
    debug: _drawDebug,
    init: initDrawBoard,
    show: showDrawModal,
    hide: hideDrawModal,
    /* 2026-09-22: 只重算**显示尺寸**（不碰 canvas.width ⇒ 内容与撤销栈都保留）。
       手机端「Colour」tab 展开/收起颜色区后必须调它，否则画布不跟着适应。 */
    resize: resizeDrawCanvas,
    /* 2026-10-01（甲）：浮动文字对象（调试出口 / 探针） */
    textLive: _textLive,
    textBegin: textBegin,
    textCommit: textCommit,
    textCancel: textCancel,
    textState: function(){ return pfmDraw.text; },
    textRepaint: function(){ _textPreview(); _textSync(); },
    fitToPrintArea: pfmFitToPrintArea,
    fontLoad: hdFontLoad,
    fontReady: hdFontReady,
    fontsReady: hdFontsReady,
    fontVal: hdFontVal,
    fontSyncUI: hdFontSyncUI,
    /* 2026-09-21 第 4 批：公开出口（探针用） */
    exportPng: selExportPng,
    /* 2026-09-26（甲）：导出确认（探针用） */
    exportConfirmOpen: _exportConfirmOpen, exportConfirmClose: _exportConfirmClose,
    selAll: selAll, selInvert: selInvert,
    selCut: selCutClip, selPaste: selPasteClip, selCopy: selCopyClip,
    /* 2026-09-21 第 5 批：形状约束 / 对称求值 / 轴位置 */
    shapeEnd: _shapeEnd,
    symPts: _symPts,
    symAxis: function(){ return { x: _symAxisX(), y: _symAxisY(), rx: pfmDraw.symX, ry: pfmDraw.symY }; },
    hollow: _shapeHollowOn,
    shapeHollow: _shapeHollowOn,
    shapeFill: _shapeHollowOn,
    /* 2026-09-21 第 6 批：形状系统补完的出口 */
    paintShape: _paintShape,
    shapeStrokeW: _shapeStrokeW,
    shapeStrokeColor: _shapeStrokeColor,
    shapeFillColor: _shapeFillColor,
    isShapeTool: _isShapeTool,
    /* 2026-09-21 第 7 批：混合模式 */
    blend: _blendMode,
    isBlendTool: _isBlendTool
  };
  /* 自检：出口齐全（缺任何一个说明搬迁有遗漏） */
  try {
    var _miss = [];
    var _o = window.__hdDraw;
    ['init', 'show', 'hide', 'fitToPrintArea', 'fontLoad', 'fontReady', 'fontsReady', 'fontVal', 'fontSyncUI']
      .forEach(function (k) { if (typeof _o[k] !== 'function') _miss.push(k); });
    if (_miss.length) console.error('[hd-draw] missing exports: ' + _miss.join(','));
  } catch (e) { }
})();
